/* eslint-disable */
import { getLocale, experimentalStaticLocale } from "../runtime.js"

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Agents_Agent_LabelInputs */
/** @typedef {{ name: NonNullable<unknown>, title: NonNullable<unknown> }} Agents_Answer_By_ParentInputs */
/** @typedef {{}} Agents_Answer_Raised_FromInputs */
/** @typedef {{}} Agents_ArchiveInputs */
/** @typedef {{}} Agents_Archived_EmptyInputs */
/** @typedef {{}} Agents_AttachInputs */
/** @typedef {{ name: NonNullable<unknown>, reason: NonNullable<unknown> }} Agents_Attachment_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Attachment_RemoveInputs */
/** @typedef {{}} Agents_AttachmentsInputs */
/** @typedef {{}} Agents_Bookmark_AddInputs */
/** @typedef {{}} Agents_Bookmark_RemoveInputs */
/** @typedef {{}} Agents_Browser_Read_OnlyInputs */
/** @typedef {{}} Agents_CancelInputs */
/** @typedef {{}} Agents_Case_ChatInputs */
/** @typedef {{}} Agents_Case_Chat_FailedInputs */
/** @typedef {{}} Agents_Change_ActionInputs */
/** @typedef {{}} Agents_Change_Agent_BodyInputs */
/** @typedef {{ agent: NonNullable<unknown> }} Agents_Change_Agent_TitleInputs */
/** @typedef {{}} Agents_Change_CompletedInputs */
/** @typedef {{}} Agents_Change_CreatedInputs */
/** @typedef {{}} Agents_Change_DelegatedInputs */
/** @typedef {{}} Agents_Change_DeletedInputs */
/** @typedef {{}} Agents_Change_DroppedInputs */
/** @typedef {{}} Agents_Change_Next_ReplyInputs */
/** @typedef {{}} Agents_Change_Obj_ActionInputs */
/** @typedef {{}} Agents_Change_Obj_CaseInputs */
/** @typedef {{}} Agents_Change_Obj_ChatInputs */
/** @typedef {{}} Agents_Change_Obj_OtherInputs */
/** @typedef {{}} Agents_Change_Obj_PageInputs */
/** @typedef {{}} Agents_Change_Obj_PersonInputs */
/** @typedef {{}} Agents_Change_Obj_WaitingInputs */
/** @typedef {{}} Agents_Change_PostedInputs */
/** @typedef {{}} Agents_Change_ReopenedInputs */
/** @typedef {{}} Agents_Change_UpdatedInputs */
/** @typedef {{}} Agents_ChangesInputs */
/** @typedef {{}} Agents_Child_QueuedInputs */
/** @typedef {{}} Agents_Child_RunningInputs */
/** @typedef {{}} Agents_Child_WaitingInputs */
/** @typedef {{}} Agents_ChildrenInputs */
/** @typedef {{}} Agents_Col_AgentInputs */
/** @typedef {{}} Agents_Col_CaseInputs */
/** @typedef {{}} Agents_Col_CostInputs */
/** @typedef {{}} Agents_Col_CreatedInputs */
/** @typedef {{}} Agents_Col_NameInputs */
/** @typedef {{}} Agents_Col_UpdatedInputs */
/** @typedef {{}} Agents_Composer_ShrinkInputs */
/** @typedef {{}} Agents_Conditions_CloseInputs */
/** @typedef {{}} Agents_Conditions_DrawerInputs */
/** @typedef {{}} Agents_Conditions_OpenInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Conditions_Open_DeviceInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Conditions_Open_Device_WarningInputs */
/** @typedef {{}} Agents_Conditions_Open_WarningInputs */
/** @typedef {{}} Agents_CopiedInputs */
/** @typedef {{}} Agents_CopyInputs */
/** @typedef {{}} Agents_Cwd_LabelInputs */
/** @typedef {{ value: NonNullable<unknown> }} Agents_Cwd_MissingInputs */
/** @typedef {{}} Agents_Cwd_Missing_NoteInputs */
/** @typedef {{}} Agents_Cwd_NoneInputs */
/** @typedef {{}} Agents_Cwd_None_NoteInputs */
/** @typedef {{}} Agents_Cwd_OtherInputs */
/** @typedef {{}} Agents_Cwd_OutsideInputs */
/** @typedef {{}} Agents_Delegate_StepInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Delegate_Step_FailedInputs */
/** @typedef {{}} Agents_Delegate_Step_OpenInputs */
/** @typedef {{}} Agents_DeleteInputs */
/** @typedef {{}} Agents_Delete_BodyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Agents_Delete_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Agents_Delete_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Delete_TitleInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_AwayInputs */
/** @typedef {{}} Agents_Device_Away_ShortInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_ComingInputs */
/** @typedef {{}} Agents_Device_LabelInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_OfflineInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_Offline_PickInputs */
/** @typedef {{}} Agents_Device_ReadyInputs */
/** @typedef {{ self: NonNullable<unknown>, device: NonNullable<unknown> }} Agents_Device_Unreachable_LineInputs */
/** @typedef {{}} Agents_Devices_AddInputs */
/** @typedef {{}} Agents_Devices_Never_SeenInputs */
/** @typedef {{}} Agents_Draft_Ask_In_ChatInputs */
/** @typedef {{}} Agents_Draft_Copy_OriginalInputs */
/** @typedef {{}} Agents_Draft_Copy_SubjectInputs */
/** @typedef {{}} Agents_Draft_OpenInputs */
/** @typedef {{}} Agents_Draft_Open_OriginalInputs */
/** @typedef {{}} Agents_Draft_OriginalInputs */
/** @typedef {{}} Agents_Draft_Reason_PlaceholderInputs */
/** @typedef {{}} Agents_Draft_Reply_ToInputs */
/** @typedef {{}} Agents_Draft_Save_FailedInputs */
/** @typedef {{}} Agents_Draft_SideInputs */
/** @typedef {{}} Agents_Draft_Side_SourceInputs */
/** @typedef {{ lang: NonNullable<unknown> }} Agents_Draft_Side_TextInputs */
/** @typedef {{}} Agents_Draft_SlackInputs */
/** @typedef {{}} Agents_Draft_Slack_AgainInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Draft_Slack_FailedInputs */
/** @typedef {{}} Agents_Draft_Slack_PlacedInputs */
/** @typedef {{}} Agents_Draft_Slack_PlacingInputs */
/** @typedef {{}} Agents_Draft_Slack_Request_FailedInputs */
/** @typedef {{}} Agents_Draft_Slack_StaleInputs */
/** @typedef {{}} Agents_Draft_StaleInputs */
/** @typedef {{}} Agents_Draft_SubjectInputs */
/** @typedef {{}} Agents_Draft_TextInputs */
/** @typedef {{}} Agents_Draft_ThreadInputs */
/** @typedef {{}} Agents_Draft_To_UnknownInputs */
/** @typedef {{}} Agents_Draft_TranslationInputs */
/** @typedef {{}} Agents_Effort_LabelInputs */
/** @typedef {{}} Agents_EmptyInputs */
/** @typedef {{}} Agents_Empty_ActiveInputs */
/** @typedef {{}} Agents_FilterInputs */
/** @typedef {{}} Agents_Filter_ActiveInputs */
/** @typedef {{}} Agents_Filter_AllInputs */
/** @typedef {{}} Agents_Filter_ArchivedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_From_ParentInputs */
/** @typedef {{}} Agents_GoInputs */
/** @typedef {{ h: NonNullable<unknown>, m: NonNullable<unknown> }} Agents_Hours_MinutesInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Image_NInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Limit_DaysInputs */
/** @typedef {{ error: NonNullable<unknown>, at: NonNullable<unknown> }} Agents_Limit_ErrorInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Limit_HoursInputs */
/** @typedef {{ model: NonNullable<unknown> }} Agents_Limit_ModelInputs */
/** @typedef {{}} Agents_Limit_NoneInputs */
/** @typedef {{}} Agents_Limit_OffInputs */
/** @typedef {{ when: NonNullable<unknown> }} Agents_Limit_ResetsInputs */
/** @typedef {{}} Agents_Limit_TitleInputs */
/** @typedef {{}} Agents_Limit_WeekInputs */
/** @typedef {{}} Agents_ListInputs */
/** @typedef {{}} Agents_Load_FailedInputs */
/** @typedef {{}} Agents_Loading_OlderInputs */
/** @typedef {{}} Agents_Mark_CompactedInputs */
/** @typedef {{}} Agents_Mark_ReadInputs */
/** @typedef {{}} Agents_Mark_RewoundInputs */
/** @typedef {{}} Agents_Mark_StoppedInputs */
/** @typedef {{}} Agents_Mark_WithdrawnInputs */
/** @typedef {{}} Agents_MenuInputs */
/** @typedef {{}} Agents_Message_EditedInputs */
/** @typedef {{}} Agents_Message_RemovedInputs */
/** @typedef {{ m: NonNullable<unknown>, s: NonNullable<unknown> }} Agents_Minutes_SecondsInputs */
/** @typedef {{}} Agents_Model_Cli_DefaultInputs */
/** @typedef {{}} Agents_Model_LabelInputs */
/** @typedef {{}} Agents_More_ConditionsInputs */
/** @typedef {{}} Agents_NavInputs */
/** @typedef {{}} Agents_NewInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_New_HintInputs */
/** @typedef {{}} Agents_No_Agent_YetInputs */
/** @typedef {{}} Agents_No_DeviceInputs */
/** @typedef {{}} Agents_Not_FoundInputs */
/** @typedef {{}} Agents_Notice_AnsweredInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_AskedInputs */
/** @typedef {{}} Agents_Notice_EndedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Notice_FailedInputs */
/** @typedef {{}} Agents_Notice_InstructedInputs */
/** @typedef {{}} Agents_Notice_OtherInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_RaisedInputs */
/** @typedef {{}} Agents_Notice_ReadInputs */
/** @typedef {{}} Agents_Notice_RetriedInputs */
/** @typedef {{}} Agents_Notice_StartedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_Step_ClosedInputs */
/** @typedef {{}} Agents_Notice_StoppedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_Turn_AddedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Notices_CountInputs */
/** @typedef {{}} Agents_Open_SettingsInputs */
/** @typedef {{}} Agents_Other_McpInputs */
/** @typedef {{}} Agents_Other_Mcp_ShortInputs */
/** @typedef {{}} Agents_Other_Mcp_WarningInputs */
/** @typedef {{}} Agents_OutlineInputs */
/** @typedef {{}} Agents_Outline_SideInputs */
/** @typedef {{}} Agents_Parent_ChatInputs */
/** @typedef {{}} Agents_Pc_AgentsInputs */
/** @typedef {{}} Agents_Pc_Auth_OkInputs */
/** @typedef {{ account: NonNullable<unknown> }} Agents_Pc_Auth_Ok_AccountInputs */
/** @typedef {{}} Agents_Pc_Auth_OutInputs */
/** @typedef {{}} Agents_Pc_Auth_UnknownInputs */
/** @typedef {{ agent: NonNullable<unknown> }} Agents_Pc_CompactInputs */
/** @typedef {{}} Agents_Pc_Compact_NoteInputs */
/** @typedef {{}} Agents_Pc_ConcurrencyInputs */
/** @typedef {{}} Agents_Pc_Concurrency_NoteInputs */
/** @typedef {{}} Agents_Pc_Default_AgentInputs */
/** @typedef {{}} Agents_Pc_Default_CwdInputs */
/** @typedef {{}} Agents_Pc_Default_Cwd_NoteInputs */
/** @typedef {{}} Agents_Pc_Default_ModelInputs */
/** @typedef {{}} Agents_Pc_DefaultsInputs */
/** @typedef {{}} Agents_Pc_DescriptionInputs */
/** @typedef {{}} Agents_Pc_LoginInputs */
/** @typedef {{}} Agents_Pc_Login_AgainInputs */
/** @typedef {{}} Agents_Pc_Login_CodeInputs */
/** @typedef {{}} Agents_Pc_Login_Code_HintInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Pc_Login_ErrorInputs */
/** @typedef {{}} Agents_Pc_Login_FailedInputs */
/** @typedef {{}} Agents_Pc_Login_OpenInputs */
/** @typedef {{}} Agents_Pc_Login_Open_CopyInputs */
/** @typedef {{}} Agents_Pc_Login_Paste_HintInputs */
/** @typedef {{}} Agents_Pc_Login_PreparingInputs */
/** @typedef {{}} Agents_Pc_Login_SentInputs */
/** @typedef {{}} Agents_Pc_Login_VerifyingInputs */
/** @typedef {{}} Agents_Pc_NameInputs */
/** @typedef {{}} Agents_Pc_Other_McpInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_AllInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_NoneInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_NoteInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_ReadInputs */
/** @typedef {{}} Agents_Pc_ParallelInputs */
/** @typedef {{}} Agents_Pc_QuietInputs */
/** @typedef {{}} Agents_Pc_Quiet_NoteInputs */
/** @typedef {{}} Agents_Pc_SerialInputs */
/** @typedef {{}} Agents_Pc_TitleInputs */
/** @typedef {{}} Agents_Pc_Usage_LimitsInputs */
/** @typedef {{}} Agents_Pc_Usage_Limits_NoteInputs */
/** @typedef {{}} Agents_Pc_WorkdirsInputs */
/** @typedef {{}} Agents_Pc_Workdirs_NoneInputs */
/** @typedef {{}} Agents_Pc_Workdirs_NoteInputs */
/** @typedef {{}} Agents_Pending_AfterInputs */
/** @typedef {{}} Agents_Pending_NextInputs */
/** @typedef {{}} Agents_Pending_Reading_NowInputs */
/** @typedef {{}} Agents_Pending_WithdrawingInputs */
/** @typedef {{}} Agents_Post_LabelInputs */
/** @typedef {{}} Agents_Post_PlaceholderInputs */
/** @typedef {{}} Agents_Post_Placeholder_RunningInputs */
/** @typedef {{}} Agents_Reach_No_SignerInputs */
/** @typedef {{ device: NonNullable<unknown>, self: NonNullable<unknown> }} Agents_Reach_Not_TrustedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Reach_Not_Trusted_UnnamedInputs */
/** @typedef {{ self: NonNullable<unknown>, device: NonNullable<unknown> }} Agents_Reach_Own_OnlyInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Reach_Self_OnlyInputs */
/** @typedef {{}} Agents_Read_NowInputs */
/** @typedef {{}} Agents_Related_ChangedInputs */
/** @typedef {{}} Agents_RenameInputs */
/** @typedef {{}} Agents_Rename_ActionInputs */
/** @typedef {{}} Agents_Request_FailedInputs */
/** @typedef {{}} Agents_RetryInputs */
/** @typedef {{}} Agents_Rewind_ActionInputs */
/** @typedef {{}} Agents_Rewind_CheckingInputs */
/** @typedef {{}} Agents_Rewind_ConversationInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Conversation_NInputs */
/** @typedef {{}} Agents_Rewind_Conversation_OneInputs */
/** @typedef {{}} Agents_Rewind_FailedInputs */
/** @typedef {{}} Agents_Rewind_FilesInputs */
/** @typedef {{}} Agents_Rewind_Files_BashInputs */
/** @typedef {{}} Agents_Rewind_Files_CodexInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Files_NInputs */
/** @typedef {{}} Agents_Rewind_Files_NoneInputs */
/** @typedef {{}} Agents_Rewind_Files_OffInputs */
/** @typedef {{}} Agents_Rewind_HereInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_MoreInputs */
/** @typedef {{}} Agents_Rewind_TitleInputs */
/** @typedef {{}} Agents_Rewind_TrameriaInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Trameria_NInputs */
/** @typedef {{}} Agents_Rewind_Trameria_NoneInputs */
/** @typedef {{}} Agents_Row_AskingInputs */
/** @typedef {{}} Agents_Row_DelegatingInputs */
/** @typedef {{}} Agents_Row_QueuedInputs */
/** @typedef {{}} Agents_Row_UnreadInputs */
/** @typedef {{}} Agents_Row_WorkingInputs */
/** @typedef {{}} Agents_Save_FailedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_SecondsInputs */
/** @typedef {{}} Agents_SendInputs */
/** @typedef {{}} Agents_Send_FailedInputs */
/** @typedef {{}} Agents_Send_Hint_EnterInputs */
/** @typedef {{ mod: NonNullable<unknown> }} Agents_Send_Hint_ModInputs */
/** @typedef {{}} Agents_SendingInputs */
/** @typedef {{}} Agents_Side_CloseInputs */
/** @typedef {{}} Agents_Side_Composer_PlaceholderInputs */
/** @typedef {{}} Agents_Side_FromInputs */
/** @typedef {{}} Agents_Side_LabelInputs */
/** @typedef {{}} Agents_Side_NewInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Side_OpenInputs */
/** @typedef {{}} Agents_Side_Open_PageInputs */
/** @typedef {{}} Agents_Side_PlaceholderInputs */
/** @typedef {{}} Agents_Side_Reply_GoneInputs */
/** @typedef {{}} Agents_Side_StartInputs */
/** @typedef {{}} Agents_Signal_Slack_DraftInputs */
/** @typedef {{ caseTitle: NonNullable<unknown>, steps: NonNullable<unknown> }} Agents_Signal_Step_ReadyInputs */
/** @typedef {{}} Agents_Signal_Turn_AwaitingInputs */
/** @typedef {{}} Agents_Signal_Turn_DeclinedInputs */
/** @typedef {{}} Agents_Signal_Turn_WithdrawnInputs */
/** @typedef {{ caseTitle: NonNullable<unknown>, title: NonNullable<unknown> }} Agents_Signal_Wait_TargetInputs */
/** @typedef {{}} Agents_SomeoneInputs */
/** @typedef {{}} Agents_StartInputs */
/** @typedef {{}} Agents_Status_CompactingInputs */
/** @typedef {{}} Agents_Status_StartingInputs */
/** @typedef {{}} Agents_Status_StoppingInputs */
/** @typedef {{}} Agents_Status_ThinkingInputs */
/** @typedef {{}} Agents_Status_WaitingInputs */
/** @typedef {{}} Agents_Status_WritingInputs */
/** @typedef {{}} Agents_StopInputs */
/** @typedef {{}} Agents_Stop_FailedInputs */
/** @typedef {{}} Agents_Suggest_LoadingInputs */
/** @typedef {{}} Agents_Tap_To_WithdrawInputs */
/** @typedef {{}} Agents_This_Pc_NameInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Agents_Time_RangeInputs */
/** @typedef {{}} Agents_TitleInputs */
/** @typedef {{}} Agents_Title_LabelInputs */
/** @typedef {{}} Agents_Title_PlaceholderInputs */
/** @typedef {{}} Agents_To_EndInputs */
/** @typedef {{}} Agents_Turn_AfterInputs */
/** @typedef {{}} Agents_Turn_AnswerInputs */
/** @typedef {{}} Agents_Turn_Answer_FailedInputs */
/** @typedef {{}} Agents_Turn_BeforeInputs */
/** @typedef {{}} Agents_Turn_Browser_Read_OnlyInputs */
/** @typedef {{}} Agents_Turn_Cause_ApprovedInputs */
/** @typedef {{}} Agents_Turn_Cause_ConversationInputs */
/** @typedef {{}} Agents_Turn_Cause_HumanInputs */
/** @typedef {{}} Agents_Turn_ChangedInputs */
/** @typedef {{}} Agents_Turn_Check_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_Choice_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_ChosenInputs */
/** @typedef {{}} Agents_Turn_CloseInputs */
/** @typedef {{}} Agents_Turn_Closed_AlreadyInputs */
/** @typedef {{}} Agents_Turn_CommentInputs */
/** @typedef {{}} Agents_Turn_Comment_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Agents_Turn_CountInputs */
/** @typedef {{}} Agents_Turn_Current_AboveInputs */
/** @typedef {{}} Agents_Turn_Date_ClearInputs */
/** @typedef {{}} Agents_Turn_Date_PickInputs */
/** @typedef {{}} Agents_Turn_Edited_By_YouInputs */
/** @typedef {{}} Agents_Turn_FoldInputs */
/** @typedef {{}} Agents_Turn_Form_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Turn_FromInputs */
/** @typedef {{}} Agents_Turn_Hand_OverInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Turn_Held_ByInputs */
/** @typedef {{}} Agents_Turn_HistoryInputs */
/** @typedef {{}} Agents_Turn_Kind_CheckInputs */
/** @typedef {{}} Agents_Turn_Kind_Draft_EmailInputs */
/** @typedef {{}} Agents_Turn_Kind_Draft_SlackInputs */
/** @typedef {{}} Agents_Turn_Kind_OperateInputs */
/** @typedef {{}} Agents_Turn_Kind_ProvideInputs */
/** @typedef {{}} Agents_Turn_LabelInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Turn_Line_DoneInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Turn_Line_WithdrawnInputs */
/** @typedef {{}} Agents_Turn_LinksInputs */
/** @typedef {{}} Agents_Turn_MultiInputs */
/** @typedef {{}} Agents_Turn_Need_FixInputs */
/** @typedef {{}} Agents_Turn_Need_ReasonInputs */
/** @typedef {{}} Agents_Turn_NoInputs */
/** @typedef {{}} Agents_Turn_Operate_PlaceholderInputs */
/** @typedef {{ at: NonNullable<unknown>, count: NonNullable<unknown> }} Agents_Turn_PlaceInputs */
/** @typedef {{}} Agents_Turn_ProposalInputs */
/** @typedef {{}} Agents_Turn_Proposal_AcceptInputs */
/** @typedef {{}} Agents_Turn_Proposal_CurrentInputs */
/** @typedef {{}} Agents_Turn_Proposal_KeepInputs */
/** @typedef {{}} Agents_Turn_Provide_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_RecommendedInputs */
/** @typedef {{}} Agents_Turn_Result_DoneInputs */
/** @typedef {{}} Agents_Turn_Result_FailedInputs */
/** @typedef {{}} Agents_Turn_Result_FixInputs */
/** @typedef {{}} Agents_Turn_Result_OkInputs */
/** @typedef {{}} Agents_Turn_Result_SentInputs */
/** @typedef {{}} Agents_Turn_Result_UnsentInputs */
/** @typedef {{}} Agents_Turn_RewrittenInputs */
/** @typedef {{}} Agents_Turn_Text_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_Ui_ConfirmInputs */
/** @typedef {{}} Agents_Turn_Ui_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_View_DraftInputs */
/** @typedef {{}} Agents_Turn_View_QuestionInputs */
/** @typedef {{}} Agents_Turn_View_RequestInputs */
/** @typedef {{}} Agents_Turn_YesInputs */
/** @typedef {{}} Agents_UnarchiveInputs */
/** @typedef {{}} Agents_UndoInputs */
/** @typedef {{}} Agents_Undo_AllInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Undo_All_TitleInputs */
/** @typedef {{}} Agents_Undo_ConflictInputs */
/** @typedef {{}} Agents_Undo_CreatedInputs */
/** @typedef {{}} Agents_Undo_DoneInputs */
/** @typedef {{}} Agents_Undo_FailedInputs */
/** @typedef {{ title: NonNullable<unknown>, op: NonNullable<unknown> }} Agents_Undo_TitleInputs */
/** @typedef {{}} Agents_Undo_UpdatedInputs */
/** @typedef {{}} Agents_Undo_WorkingInputs */
/** @typedef {{}} Agents_Unread_From_HereInputs */
/** @typedef {{}} Agents_UntitledInputs */
/** @typedef {{}} Agents_Usage_Cache_ReadInputs */
/** @typedef {{}} Agents_Usage_Cache_WriteInputs */
/** @typedef {{}} Agents_Usage_CompactInputs */
/** @typedef {{}} Agents_Usage_Compact_FailedInputs */
/** @typedef {{}} Agents_Usage_ContextInputs */
/** @typedef {{}} Agents_Usage_CostInputs */
/** @typedef {{}} Agents_Usage_EmptyInputs */
/** @typedef {{}} Agents_Usage_InputInputs */
/** @typedef {{}} Agents_Usage_LabelInputs */
/** @typedef {{}} Agents_Usage_OutputInputs */
/** @typedef {{}} Agents_Usage_SessionInputs */
/** @typedef {{ value: NonNullable<unknown> }} Agents_Value_MissingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_ViaInputs */
/** @typedef {{}} Agents_View_LabelInputs */
/** @typedef {{}} Agents_Wait_Turn_ClosedInputs */
/** @typedef {{}} Agents_Wait_Turn_OpenInputs */
/** @typedef {{}} Agents_WithdrawInputs */
/** @typedef {{}} Agents_Withdraw_FailedInputs */
/** @typedef {{}} Agents_Withdraw_Too_LateInputs */
/** @typedef {{}} Blocks_Callout_BlueInputs */
/** @typedef {{ color: NonNullable<unknown> }} Blocks_Callout_Change_ColorInputs */
/** @typedef {{}} Blocks_Callout_ColorInputs */
/** @typedef {{}} Blocks_Callout_GreenInputs */
/** @typedef {{}} Blocks_Callout_PurpleInputs */
/** @typedef {{}} Blocks_Callout_RedInputs */
/** @typedef {{}} Blocks_Callout_Title_PlaceholderInputs */
/** @typedef {{}} Blocks_Callout_YellowInputs */
/** @typedef {{}} Blocks_CloseInputs */
/** @typedef {{}} Blocks_Code_CopyInputs */
/** @typedef {{}} Blocks_CopiedInputs */
/** @typedef {{}} Blocks_Copy_FailedInputs */
/** @typedef {{}} Blocks_Fence_CancelInputs */
/** @typedef {{}} Blocks_Fence_Edit_SourceInputs */
/** @typedef {{}} Blocks_Fence_SaveInputs */
/** @typedef {{}} Blocks_Fence_SourceInputs */
/** @typedef {{}} Blocks_File_ActionsInputs */
/** @typedef {{}} Blocks_File_Copy_LinkInputs */
/** @typedef {{}} Blocks_File_DeleteInputs */
/** @typedef {{}} Blocks_File_DownloadInputs */
/** @typedef {{}} Blocks_File_EnlargeInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_File_Enlarge_NamedInputs */
/** @typedef {{}} Blocks_File_Reset_WidthInputs */
/** @typedef {{}} Blocks_File_ResizeInputs */
/** @typedef {{ heading: NonNullable<unknown> }} Blocks_Footnote_BodyInputs */
/** @typedef {{ label: NonNullable<unknown> }} Blocks_Footnote_CreateInputs */
/** @typedef {{}} Blocks_Footnote_GoneInputs */
/** @typedef {{ heading: NonNullable<unknown> }} Blocks_Footnote_HeadingInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Footnote_NamedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Footnote_To_DefInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Footnote_To_RefInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Footnote_UnreferencedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Blocks_Mermaid_FailedInputs */
/** @typedef {{}} Blocks_Table_Add_AboveInputs */
/** @typedef {{}} Blocks_Table_Add_BelowInputs */
/** @typedef {{}} Blocks_Table_Add_ColInputs */
/** @typedef {{}} Blocks_Table_Add_LeftInputs */
/** @typedef {{}} Blocks_Table_Add_RightInputs */
/** @typedef {{}} Blocks_Table_Add_RowInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Col_ActionsInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Col_ResizeInputs */
/** @typedef {{}} Blocks_Table_Delete_ColInputs */
/** @typedef {{}} Blocks_Table_Delete_RowInputs */
/** @typedef {{}} Blocks_Table_Freeze_HereInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Row_ActionsInputs */
/** @typedef {{}} Blocks_Table_UnfreezeInputs */
/** @typedef {{}} Blocks_Toggle_CloseInputs */
/** @typedef {{}} Blocks_Toggle_OpenInputs */
/** @typedef {{}} Blocks_Upload_AbortedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Upload_CancelInputs */
/** @typedef {{}} Blocks_Upload_FailedInputs */
/** @typedef {{}} Blocks_Upload_Failed_NetworkInputs */
/** @typedef {{ status: NonNullable<unknown> }} Blocks_Upload_Failed_StatusInputs */
/** @typedef {{}} Blocks_Upload_Too_LargeInputs */
/** @typedef {{}} Blocks_UploadsInputs */
/** @typedef {{}} Cases_Action_TitleInputs */
/** @typedef {{}} Cases_Action_Title_PlaceholderInputs */
/** @typedef {{}} Cases_AddInputs */
/** @typedef {{}} Cases_Add_ActionInputs */
/** @typedef {{}} Cases_Add_Action_ButtonInputs */
/** @typedef {{}} Cases_Add_Step_Needs_TitleInputs */
/** @typedef {{}} Cases_Add_WaitingInputs */
/** @typedef {{}} Cases_Add_Waiting_ButtonInputs */
/** @typedef {{}} Cases_Agent_MemoInputs */
/** @typedef {{}} Cases_BodyInputs */
/** @typedef {{}} Cases_Body_PlaceholderInputs */
/** @typedef {{}} Cases_Body_Write_PlaceholderInputs */
/** @typedef {{}} Cases_Case_TitleInputs */
/** @typedef {{}} Cases_ChainInputs */
/** @typedef {{}} Cases_Chain_DoneInputs */
/** @typedef {{}} Cases_Chain_EmptyInputs */
/** @typedef {{}} Cases_Chain_GraphInputs */
/** @typedef {{}} Cases_Chain_LaterInputs */
/** @typedef {{}} Cases_Chain_NowInputs */
/** @typedef {{}} Cases_Change_DueInputs */
/** @typedef {{}} Cases_Change_PlanInputs */
/** @typedef {{}} Cases_Change_Wait_UntilInputs */
/** @typedef {{}} Cases_Closed_EmptyInputs */
/** @typedef {{}} Cases_Col_CaseInputs */
/** @typedef {{}} Cases_Col_DueInputs */
/** @typedef {{}} Cases_Col_NameInputs */
/** @typedef {{}} Cases_Col_PlanInputs */
/** @typedef {{}} Cases_Col_UpdatedInputs */
/** @typedef {{}} Cases_Col_WaitInputs */
/** @typedef {{}} Cases_ContextInputs */
/** @typedef {{}} Cases_Context_PlaceholderInputs */
/** @typedef {{}} Cases_CreateInputs */
/** @typedef {{}} Cases_Create_Failed_KeptInputs */
/** @typedef {{}} Cases_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Delete_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Delete_TitleInputs */
/** @typedef {{}} Cases_DoneInputs */
/** @typedef {{}} Cases_DropInputs */
/** @typedef {{}} Cases_DueInputs */
/** @typedef {{}} Cases_Due_ClearInputs */
/** @typedef {{}} Cases_EmptyInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_BytesInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_KbInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_MbInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_File_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_File_Remove_FailedInputs */
/** @typedef {{}} Cases_FilesInputs */
/** @typedef {{}} Cases_GoInputs */
/** @typedef {{}} Cases_Graph_DelegatedInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Cases_Graph_ProgressInputs */
/** @typedef {{}} Cases_Kind_ActionInputs */
/** @typedef {{}} Cases_Kind_WaitingInputs */
/** @typedef {{}} Cases_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Label_ChangeInputs */
/** @typedef {{}} Cases_Label_FailedInputs */
/** @typedef {{}} Cases_Label_SetInputs */
/** @typedef {{}} Cases_ListInputs */
/** @typedef {{}} Cases_Load_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_MenuInputs */
/** @typedef {{}} Cases_NewInputs */
/** @typedef {{}} Cases_Not_FoundInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_OverdueInputs */
/** @typedef {{}} Cases_Panel_CloseInputs */
/** @typedef {{}} Cases_PlanInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Plan_CarriedInputs */
/** @typedef {{}} Cases_Plan_ClearInputs */
/** @typedef {{}} Cases_Plan_Pick_DateInputs */
/** @typedef {{}} Cases_Plan_SomedayInputs */
/** @typedef {{}} Cases_Plan_This_WeekInputs */
/** @typedef {{}} Cases_Plan_TodayInputs */
/** @typedef {{}} Cases_Plan_TomorrowInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Plan_Week_OfInputs */
/** @typedef {{}} Cases_RelatedInputs */
/** @typedef {{}} Cases_Related_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_Add_FailedInputs */
/** @typedef {{}} Cases_Related_CandidatesInputs */
/** @typedef {{}} Cases_Related_NoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_Remove_FailedInputs */
/** @typedef {{}} Cases_Related_SearchInputs */
/** @typedef {{}} Cases_Related_Search_PlaceholderInputs */
/** @typedef {{}} Cases_RenameInputs */
/** @typedef {{}} Cases_ReopenInputs */
/** @typedef {{}} Cases_ResultInputs */
/** @typedef {{}} Cases_Result_PlaceholderInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_BodyInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_ResultInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_WaitInputs */
/** @typedef {{}} Cases_Status_DoneInputs */
/** @typedef {{}} Cases_Status_DroppedInputs */
/** @typedef {{}} Cases_Status_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Add_FailedInputs */
/** @typedef {{}} Cases_Step_Auto_ClosedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Close_FailedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Step_CreatedInputs */
/** @typedef {{}} Cases_Step_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Delete_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Delete_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_DoneInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Step_DueInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Due_FailedInputs */
/** @typedef {{}} Cases_Step_KindInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_MenuInputs */
/** @typedef {{ label: NonNullable<unknown> }} Cases_Step_PlanInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Plan_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Rename_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Reopen_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_ResolveInputs */
/** @typedef {{}} Cases_Step_TitleInputs */
/** @typedef {{}} Cases_Step_UnplacedInputs */
/** @typedef {{}} Cases_Step_Unplaced_HintInputs */
/** @typedef {{}} Cases_Step_Wait_Target_DroppedInputs */
/** @typedef {{}} Cases_Tab_ClosedInputs */
/** @typedef {{}} Cases_Tab_NextInputs */
/** @typedef {{}} Cases_Tab_ReadyInputs */
/** @typedef {{}} Cases_Tab_WaitingInputs */
/** @typedef {{}} Cases_TabsInputs */
/** @typedef {{}} Cases_TitleInputs */
/** @typedef {{}} Cases_Title_FailedInputs */
/** @typedef {{}} Cases_Title_PlaceholderInputs */
/** @typedef {{}} Cases_Wait_UntilInputs */
/** @typedef {{}} Cases_Waiting_TitleInputs */
/** @typedef {{}} Cases_Waiting_Title_PlaceholderInputs */
/** @typedef {{}} Common_CancelInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Days_AgoInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Days_LaterInputs */
/** @typedef {{}} Common_DeleteInputs */
/** @typedef {{ lead: NonNullable<unknown>, message: NonNullable<unknown> }} Common_Error_With_LeadInputs */
/** @typedef {{}} Common_ForbiddenInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Hours_AgoInputs */
/** @typedef {{}} Common_Just_NowInputs */
/** @typedef {{}} Common_Load_More_FailedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Minutes_AgoInputs */
/** @typedef {{}} Common_Picture_ApplyInputs */
/** @typedef {{}} Common_Picture_ChooseInputs */
/** @typedef {{}} Common_Picture_Crop_HintInputs */
/** @typedef {{}} Common_Picture_FailedInputs */
/** @typedef {{}} Common_Picture_RemoveInputs */
/** @typedef {{}} Common_Picture_StageInputs */
/** @typedef {{}} Common_Picture_UnreadableInputs */
/** @typedef {{}} Common_Picture_ZoomInputs */
/** @typedef {{}} Common_RetryInputs */
/** @typedef {{}} Common_SaveInputs */
/** @typedef {{}} Common_TodayInputs */
/** @typedef {{}} Common_TomorrowInputs */
/** @typedef {{}} Common_YesterdayInputs */
/** @typedef {{}} Datasets_Add_RowInputs */
/** @typedef {{}} Datasets_Col_FieldInputs */
/** @typedef {{}} Datasets_Col_FilledInputs */
/** @typedef {{}} Datasets_Date_ClearInputs */
/** @typedef {{}} Datasets_Date_PickInputs */
/** @typedef {{}} Datasets_Delete_RowInputs */
/** @typedef {{}} Datasets_Delete_Row_BodyInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_DistributionInputs */
/** @typedef {{}} Datasets_Distribution_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Distribution_TopInputs */
/** @typedef {{}} Datasets_Edit_RowInputs */
/** @typedef {{}} Datasets_FieldsInputs */
/** @typedef {{}} Datasets_Fields_GuessedInputs */
/** @typedef {{}} Datasets_Fields_NoneInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Json_InvalidInputs */
/** @typedef {{}} Datasets_KeyInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Key_MissingInputs */
/** @typedef {{}} Datasets_LatestInputs */
/** @typedef {{ shown: NonNullable<unknown>, count: NonNullable<unknown> }} Datasets_Latest_NoteInputs */
/** @typedef {{}} Datasets_ListInputs */
/** @typedef {{}} Datasets_List_BackInputs */
/** @typedef {{}} Datasets_List_EmptyInputs */
/** @typedef {{}} Datasets_List_Load_FailedInputs */
/** @typedef {{}} Datasets_List_NewInputs */
/** @typedef {{}} Datasets_List_None_MatchInputs */
/** @typedef {{}} Datasets_Load_FailedInputs */
/** @typedef {{}} Datasets_New_CreateInputs */
/** @typedef {{}} Datasets_New_FailedInputs */
/** @typedef {{}} Datasets_New_NoteInputs */
/** @typedef {{}} Datasets_New_TitleInputs */
/** @typedef {{}} Datasets_No_RowsInputs */
/** @typedef {{}} Datasets_Not_FoundInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Number_InvalidInputs */
/** @typedef {{ days: NonNullable<unknown> }} Datasets_RetentionInputs */
/** @typedef {{}} Datasets_Row_ActionsInputs */
/** @typedef {{}} Datasets_Row_JsonInputs */
/** @typedef {{}} Datasets_Row_Json_InvalidInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_RowsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Stat_DistinctInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MaxInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MeanInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MinInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Stat_OnInputs */
/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown> }} Datasets_Stat_RangeInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_SumInputs */
/** @typedef {{}} Datasets_Token_CloseInputs */
/** @typedef {{ date: NonNullable<unknown> }} Datasets_Token_CreatedInputs */
/** @typedef {{}} Datasets_Token_EndpointInputs */
/** @typedef {{}} Datasets_Token_FailedInputs */
/** @typedef {{}} Datasets_Token_IssueInputs */
/** @typedef {{}} Datasets_Token_Issue_ActionInputs */
/** @typedef {{}} Datasets_Token_NameInputs */
/** @typedef {{}} Datasets_Token_Name_PlaceholderInputs */
/** @typedef {{}} Datasets_Token_RevokeInputs */
/** @typedef {{}} Datasets_Token_Revoke_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Datasets_Token_Revoke_LabelInputs */
/** @typedef {{}} Datasets_Token_Shown_OnceInputs */
/** @typedef {{}} Datasets_Token_UnusedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Datasets_Token_UsedInputs */
/** @typedef {{}} Datasets_TokensInputs */
/** @typedef {{}} Datasets_Tokens_FailedInputs */
/** @typedef {{}} Datasets_Tokens_LeftInputs */
/** @typedef {{}} Datasets_Tokens_Left_NextInputs */
/** @typedef {{}} Datasets_Tokens_NoneInputs */
/** @typedef {{}} Datasets_Tokens_NoteInputs */
/** @typedef {{}} Datasets_Tokens_VaultInputs */
/** @typedef {{}} Datasets_Type_BooleanInputs */
/** @typedef {{}} Datasets_Type_DateInputs */
/** @typedef {{}} Datasets_Type_DatetimeInputs */
/** @typedef {{}} Datasets_Type_JsonInputs */
/** @typedef {{}} Datasets_Type_NumberInputs */
/** @typedef {{}} Datasets_Type_StringInputs */
/** @typedef {{ time: NonNullable<unknown> }} Datasets_UpdatedInputs */
/** @typedef {{}} Datasets_Viewer_CloseInputs */
/** @typedef {{}} Datasets_Viewer_OpenInputs */
/** @typedef {{}} Datasets_Write_FailedInputs */
/** @typedef {{}} Datasets_Written_AtInputs */
/** @typedef {{}} Desktop_Action_StartInputs */
/** @typedef {{}} Desktop_Action_StopInputs */
/** @typedef {{ version: NonNullable<unknown> }} Desktop_Advanced_Agent_BundledInputs */
/** @typedef {{}} Desktop_App_Update_AvailableInputs */
/** @typedef {{ version: NonNullable<unknown> }} Desktop_App_Update_VersionInputs */
/** @typedef {{}} Desktop_Check_FlagsInputs */
/** @typedef {{}} Desktop_Check_Foreign_McpInputs */
/** @typedef {{}} Desktop_Check_LiveInputs */
/** @typedef {{ at: NonNullable<unknown>, version: NonNullable<unknown> }} Desktop_Check_Live_AtInputs */
/** @typedef {{ at: NonNullable<unknown>, version: NonNullable<unknown>, current: NonNullable<unknown> }} Desktop_Check_Live_At_StaleInputs */
/** @typedef {{}} Desktop_Check_Live_Not_RunInputs */
/** @typedef {{}} Desktop_Device_Add_HintInputs */
/** @typedef {{}} Desktop_Device_Needs_LoginInputs */
/** @typedef {{}} Desktop_Device_Not_RegisteredInputs */
/** @typedef {{}} Desktop_Device_RegisteredInputs */
/** @typedef {{}} Desktop_Device_Remove_HintInputs */
/** @typedef {{}} Desktop_Device_Removed_ElsewhereInputs */
/** @typedef {{}} Desktop_Find_CloseInputs */
/** @typedef {{}} Desktop_Find_NextInputs */
/** @typedef {{}} Desktop_Find_PlaceholderInputs */
/** @typedef {{}} Desktop_Find_PreviousInputs */
/** @typedef {{}} Desktop_Menubar_Agent_ToggleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Desktop_Menubar_Block_NextInputs */
/** @typedef {{}} Desktop_Notifications_BlockedInputs */
/** @typedef {{}} Desktop_Notifications_Blocked_NoteInputs */
/** @typedef {{}} Desktop_Notifications_Need_Signed_BuildInputs */
/** @typedef {{}} Desktop_Notifications_Open_SettingsInputs */
/** @typedef {{}} Desktop_Open_MainInputs */
/** @typedef {{}} Desktop_QuitInputs */
/** @typedef {{}} Desktop_Status_ConnectedInputs */
/** @typedef {{}} Desktop_Status_ErrorInputs */
/** @typedef {{}} Desktop_Status_ReconnectingInputs */
/** @typedef {{}} Desktop_Status_StartingInputs */
/** @typedef {{}} Desktop_Status_StoppedInputs */
/** @typedef {{}} Desktop_Status_StoppingInputs */
/** @typedef {{}} Desktop_Token_UnavailableInputs */
/** @typedef {{}} Desktop_Usage_LoadingInputs */
/** @typedef {{}} Desktop_Usage_Not_InstalledInputs */
/** @typedef {{}} Desktop_Usage_OffInputs */
/** @typedef {{}} Desktop_Usage_RefreshInputs */
/** @typedef {{}} Desktop_Usage_SettingsInputs */
/** @typedef {{ error: NonNullable<unknown> }} Desktop_Usage_Stale_ErrorInputs */
/** @typedef {{}} Desktop_Usage_TitleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Desktop_Usage_Updated_AtInputs */
/** @typedef {{ n: NonNullable<unknown> }} Desktop_Usage_Updated_Minutes_AgoInputs */
/** @typedef {{}} Documents_Agent_MemoInputs */
/** @typedef {{}} Documents_ArchiveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Archive_FailedInputs */
/** @typedef {{}} Documents_Block_Bullet_ListInputs */
/** @typedef {{}} Documents_Block_CalloutInputs */
/** @typedef {{}} Documents_Block_CodeInputs */
/** @typedef {{}} Documents_Block_CopiedInputs */
/** @typedef {{}} Documents_Block_Copy_FailedInputs */
/** @typedef {{}} Documents_Block_Copy_MarkdownInputs */
/** @typedef {{}} Documents_Block_DeleteInputs */
/** @typedef {{}} Documents_Block_DividerInputs */
/** @typedef {{}} Documents_Block_DuplicateInputs */
/** @typedef {{}} Documents_Block_FileInputs */
/** @typedef {{}} Documents_Block_File_HintInputs */
/** @typedef {{}} Documents_Block_FootnoteInputs */
/** @typedef {{}} Documents_Block_Heading1Inputs */
/** @typedef {{}} Documents_Block_Heading2Inputs */
/** @typedef {{}} Documents_Block_Heading3Inputs */
/** @typedef {{}} Documents_Block_InsertInputs */
/** @typedef {{}} Documents_Block_Lift_OutInputs */
/** @typedef {{}} Documents_Block_MenuInputs */
/** @typedef {{}} Documents_Block_Menu_Section_BlockInputs */
/** @typedef {{}} Documents_Block_Menu_Section_TypeInputs */
/** @typedef {{}} Documents_Block_MermaidInputs */
/** @typedef {{}} Documents_Block_Numbered_ListInputs */
/** @typedef {{}} Documents_Block_ParagraphInputs */
/** @typedef {{}} Documents_Block_QuoteInputs */
/** @typedef {{}} Documents_Block_TableInputs */
/** @typedef {{}} Documents_Block_Task_ListInputs */
/** @typedef {{}} Documents_Block_ToggleInputs */
/** @typedef {{}} Documents_Block_Unwrap_ListInputs */
/** @typedef {{}} Documents_Block_Unwrap_QuoteInputs */
/** @typedef {{}} Documents_BodyInputs */
/** @typedef {{}} Documents_Body_PlaceholderInputs */
/** @typedef {{}} Documents_CloseInputs */
/** @typedef {{}} Documents_Col_CreatedInputs */
/** @typedef {{}} Documents_Col_NameInputs */
/** @typedef {{}} Documents_Col_UpdatedInputs */
/** @typedef {{}} Documents_Copied_To_OwnInputs */
/** @typedef {{}} Documents_CopyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Copy_FailedInputs */
/** @typedef {{}} Documents_Copy_To_OwnInputs */
/** @typedef {{}} Documents_CreateInputs */
/** @typedef {{}} Documents_Create_FailedInputs */
/** @typedef {{}} Documents_DeleteInputs */
/** @typedef {{}} Documents_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Delete_FailedInputs */
/** @typedef {{ names: NonNullable<unknown> }} Documents_Delete_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_Delete_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Delete_TitleInputs */
/** @typedef {{}} Documents_EmptyInputs */
/** @typedef {{}} Documents_Empty_ArchivedInputs */
/** @typedef {{}} Documents_HistoryInputs */
/** @typedef {{ name: NonNullable<unknown>, connection: NonNullable<unknown> }} Documents_History_Actor_ViaInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_Change_CountInputs */
/** @typedef {{}} Documents_History_ChangesInputs */
/** @typedef {{}} Documents_History_EmptyInputs */
/** @typedef {{}} Documents_History_FailedInputs */
/** @typedef {{}} Documents_History_Is_LatestInputs */
/** @typedef {{}} Documents_History_LatestInputs */
/** @typedef {{}} Documents_History_No_BodyInputs */
/** @typedef {{}} Documents_History_No_ChangesInputs */
/** @typedef {{}} Documents_History_RestoredInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_SavesInputs */
/** @typedef {{}} Documents_History_SystemInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_UnchangedInputs */
/** @typedef {{}} Documents_History_VersionsInputs */
/** @typedef {{}} Documents_Index_AddInputs */
/** @typedef {{}} Documents_Index_Add_ExistingInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Add_FailedInputs */
/** @typedef {{}} Documents_Index_Add_NewInputs */
/** @typedef {{}} Documents_Index_ArchivedInputs */
/** @typedef {{}} Documents_Index_ButtonInputs */
/** @typedef {{}} Documents_Index_Create_FailedInputs */
/** @typedef {{}} Documents_Index_Create_WithInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Default_TitleInputs */
/** @typedef {{}} Documents_Index_Delete_BodyInputs */
/** @typedef {{}} Documents_Index_DetachInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Detach_FailedInputs */
/** @typedef {{}} Documents_Index_EmptyInputs */
/** @typedef {{}} Documents_Index_Existing_UnderInputs */
/** @typedef {{}} Documents_Index_FoldInputs */
/** @typedef {{}} Documents_Index_InInputs */
/** @typedef {{}} Documents_Index_In_NoneInputs */
/** @typedef {{}} Documents_Index_IndentInputs */
/** @typedef {{}} Documents_Index_Load_FailedInputs */
/** @typedef {{}} Documents_Index_MenuInputs */
/** @typedef {{}} Documents_Index_Move_DownInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Move_FailedInputs */
/** @typedef {{}} Documents_Index_Move_UpInputs */
/** @typedef {{}} Documents_Index_New_HintInputs */
/** @typedef {{}} Documents_Index_New_UnderInputs */
/** @typedef {{}} Documents_Index_OpenInputs */
/** @typedef {{}} Documents_Index_OutdentInputs */
/** @typedef {{}} Documents_Index_PickInputs */
/** @typedef {{}} Documents_Index_Pick_NoneInputs */
/** @typedef {{}} Documents_Index_Pick_SearchInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Put_FailedInputs */
/** @typedef {{}} Documents_Index_Put_InInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Remove_FromInputs */
/** @typedef {{}} Documents_Index_TitleInputs */
/** @typedef {{}} Documents_Index_Title_PlaceholderInputs */
/** @typedef {{}} Documents_Index_UnfoldInputs */
/** @typedef {{}} Documents_Kind_HtmlInputs */
/** @typedef {{}} Documents_Kind_IndexInputs */
/** @typedef {{}} Documents_Kind_MarkdownInputs */
/** @typedef {{}} Documents_Kind_SlideInputs */
/** @typedef {{}} Documents_Link_SuggestInputs */
/** @typedef {{}} Documents_List_FailedInputs */
/** @typedef {{}} Documents_Load_FailedInputs */
/** @typedef {{}} Documents_MenuInputs */
/** @typedef {{}} Documents_Mermaid_Default_PayloadInputs */
/** @typedef {{}} Documents_MissingInputs */
/** @typedef {{}} Documents_MoreInputs */
/** @typedef {{}} Documents_NavInputs */
/** @typedef {{}} Documents_NewInputs */
/** @typedef {{}} Documents_New_DocumentInputs */
/** @typedef {{}} Documents_New_IndexInputs */
/** @typedef {{}} Documents_New_Index_ItemInputs */
/** @typedef {{}} Documents_New_MenuInputs */
/** @typedef {{}} Documents_OfflineInputs */
/** @typedef {{}} Documents_OutlineInputs */
/** @typedef {{}} Documents_Outline_HeadingsInputs */
/** @typedef {{}} Documents_Read_Only_ArchivedInputs */
/** @typedef {{}} Documents_Read_Only_NewerInputs */
/** @typedef {{}} Documents_Read_Only_Not_WritableInputs */
/** @typedef {{}} Documents_ReloadInputs */
/** @typedef {{}} Documents_Reload_NeededInputs */
/** @typedef {{}} Documents_Rename_FailedInputs */
/** @typedef {{}} Documents_RestoreInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Restore_BodyInputs */
/** @typedef {{}} Documents_Restore_FailedInputs */
/** @typedef {{ time: NonNullable<unknown> }} Documents_Restore_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Row_MenuInputs */
/** @typedef {{}} Documents_Save_PdfInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_BoldInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_CodeInputs */
/** @typedef {{}} Documents_Selection_Edit_LinkInputs */
/** @typedef {{}} Documents_Selection_FormatInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_ItalicInputs */
/** @typedef {{}} Documents_Selection_LinkInputs */
/** @typedef {{}} Documents_Selection_Link_UrlInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_Open_LinkInputs */
/** @typedef {{}} Documents_Selection_Paste_UrlInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_StrikeInputs */
/** @typedef {{}} Documents_Selection_UnlinkInputs */
/** @typedef {{}} Documents_ShowInputs */
/** @typedef {{}} Documents_Show_ActiveInputs */
/** @typedef {{}} Documents_Show_ArchivedInputs */
/** @typedef {{}} Documents_Slide_NextInputs */
/** @typedef {{}} Documents_Slide_PreviousInputs */
/** @typedef {{}} Documents_SourceInputs */
/** @typedef {{}} Documents_Source_CloseInputs */
/** @typedef {{}} Documents_Source_ConflictInputs */
/** @typedef {{}} Documents_Source_EditInputs */
/** @typedef {{}} Documents_Source_QueryInputs */
/** @typedef {{}} Documents_Source_Query_FailedInputs */
/** @typedef {{}} Documents_Source_SaveInputs */
/** @typedef {{}} Documents_Source_Save_FailedInputs */
/** @typedef {{}} Documents_Source_SavedInputs */
/** @typedef {{}} Documents_Suggest_EmptyInputs */
/** @typedef {{}} Documents_TitleInputs */
/** @typedef {{}} Documents_Title_PlaceholderInputs */
/** @typedef {{}} Documents_UnarchiveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Unarchive_FailedInputs */
/** @typedef {{}} Documents_UntitledInputs */
/** @typedef {{ live: NonNullable<unknown>, candidate: NonNullable<unknown> }} Editor_Diff_Block_CountInputs */
/** @typedef {{}} Editor_Excerpt_CalloutInputs */
/** @typedef {{}} Editor_Excerpt_CodeInputs */
/** @typedef {{}} Editor_Excerpt_EmptyInputs */
/** @typedef {{}} Editor_Excerpt_HtmlInputs */
/** @typedef {{}} Editor_Excerpt_MermaidInputs */
/** @typedef {{}} Editor_Excerpt_RuleInputs */
/** @typedef {{}} Editor_Excerpt_TableInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Shape_Attr_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Block_Count_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Child_Count_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Type_DiffersInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_Fix_RangeInputs */
/** @typedef {{}} Editor_Table_Option_ShapeInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_TwiceInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_Unknown_KeyInputs */
/** @typedef {{}} Editor_Table_Option_WidthsInputs */
/** @typedef {{}} Editor_Toggle_Body_PlaceholderInputs */
/** @typedef {{}} Editor_Toggle_Summary_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Inbox_Answered_By_ParentInputs */
/** @typedef {{}} Inbox_CaseInputs */
/** @typedef {{}} Inbox_Case_AllInputs */
/** @typedef {{}} Inbox_ChatInputs */
/** @typedef {{}} Inbox_Chat_AllInputs */
/** @typedef {{}} Inbox_DoneInputs */
/** @typedef {{}} Inbox_Done_By_AgentInputs */
/** @typedef {{}} Inbox_Done_EmptyInputs */
/** @typedef {{}} Inbox_DotInputs */
/** @typedef {{ name: NonNullable<unknown> }} Inbox_FromInputs */
/** @typedef {{}} Inbox_GoInputs */
/** @typedef {{}} Inbox_Kind_DmInputs */
/** @typedef {{}} Inbox_Kind_MentionInputs */
/** @typedef {{}} Inbox_Kind_QuestionInputs */
/** @typedef {{}} Inbox_Kind_ReplyInputs */
/** @typedef {{}} Inbox_Load_FailedInputs */
/** @typedef {{}} Inbox_NarrowInputs */
/** @typedef {{}} Inbox_Narrow_PlaceholderInputs */
/** @typedef {{}} Inbox_NavInputs */
/** @typedef {{}} Inbox_No_MatchInputs */
/** @typedef {{}} Inbox_NowInputs */
/** @typedef {{}} Inbox_Now_EmptyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Inbox_UnreadInputs */
/** @typedef {{}} Inbox_WithdrawnInputs */
/** @typedef {{}} Inbox_Workspace_UnreachableInputs */
/** @typedef {{}} Inbox_Workspace_Unreachable_EmptyInputs */
/** @typedef {{}} Inbox_Workspace_Unreachable_WhyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_CustomInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_OfInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Create_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Create_NamedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_DeleteInputs */
/** @typedef {{}} Labels_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Delete_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Delete_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Move_DownInputs */
/** @typedef {{}} Labels_Move_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Move_UpInputs */
/** @typedef {{}} Labels_NameInputs */
/** @typedef {{}} Labels_NewInputs */
/** @typedef {{}} Labels_Pick_EmptyInputs */
/** @typedef {{}} Labels_Pick_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Rename_FailedInputs */
/** @typedef {{}} Labels_Settings_DescriptionInputs */
/** @typedef {{}} Labels_TitleInputs */
/** @typedef {{}} Local_Agent_DiagramInputs */
/** @typedef {{}} Local_Agent_Diagram_BrowserInputs */
/** @typedef {{}} Local_Agent_Diagram_CarrierInputs */
/** @typedef {{}} Local_Agent_Diagram_Carrier_NoteInputs */
/** @typedef {{}} Local_Agent_Diagram_DevicesInputs */
/** @typedef {{}} Local_Agent_Diagram_In_ListInputs */
/** @typedef {{}} Local_Agent_Diagram_RefusedInputs */
/** @typedef {{}} Local_Agent_Diagram_SignedInputs */
/** @typedef {{}} Local_Agent_Diagram_This_AppInputs */
/** @typedef {{}} Local_Agent_Help_BrowserInputs */
/** @typedef {{}} Local_Agent_Help_SignedInputs */
/** @typedef {{}} Local_Agent_Help_TitleInputs */
/** @typedef {{}} Local_Agent_OthersInputs */
/** @typedef {{}} Local_Agent_Others_NoteInputs */
/** @typedef {{}} Local_Agent_Others_Off_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Agent_Others_Vault_Off_NoteInputs */
/** @typedef {{}} Local_Agent_UseInputs */
/** @typedef {{}} Local_Agent_Use_NoteInputs */
/** @typedef {{}} Local_BackupInputs */
/** @typedef {{}} Local_Backup_ChooseInputs */
/** @typedef {{}} Local_Backup_DefaultInputs */
/** @typedef {{}} Local_Backup_DescriptionInputs */
/** @typedef {{}} Local_Backup_Error_FailedInputs */
/** @typedef {{}} Local_Backup_Error_Inside_DataInputs */
/** @typedef {{}} Local_Backup_Error_Not_AbsoluteInputs */
/** @typedef {{}} Local_Backup_Error_Not_WritableInputs */
/** @typedef {{}} Local_Backup_FailedInputs */
/** @typedef {{}} Local_Backup_FolderInputs */
/** @typedef {{}} Local_Backup_Folder_NoteInputs */
/** @typedef {{}} Local_Backup_LastInputs */
/** @typedef {{}} Local_Backup_MissingInputs */
/** @typedef {{}} Local_Backup_NoneInputs */
/** @typedef {{}} Local_Backup_Not_WritableInputs */
/** @typedef {{}} Local_Backup_PathInputs */
/** @typedef {{}} Local_Backup_ResetInputs */
/** @typedef {{}} Local_Backup_UseInputs */
/** @typedef {{}} Local_CloudInputs */
/** @typedef {{}} Local_Cloud_AccountInputs */
/** @typedef {{}} Local_Cloud_Account_SettingsInputs */
/** @typedef {{}} Local_Cloud_Account_Settings_DescriptionInputs */
/** @typedef {{}} Local_Cloud_Again_DoneInputs */
/** @typedef {{}} Local_Cloud_Agent_FailedInputs */
/** @typedef {{}} Local_Cloud_Agent_RemovedInputs */
/** @typedef {{}} Local_Cloud_Code_NoteInputs */
/** @typedef {{}} Local_Cloud_DeniedInputs */
/** @typedef {{}} Local_Cloud_DescriptionInputs */
/** @typedef {{}} Local_Cloud_DeviceInputs */
/** @typedef {{}} Local_Cloud_Device_DoneInputs */
/** @typedef {{}} Local_Cloud_Device_Hub_Not_TiedInputs */
/** @typedef {{}} Local_Cloud_Device_Hub_UnreachableInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Device_InInputs */
/** @typedef {{ hub: NonNullable<unknown>, mine: NonNullable<unknown> }} Local_Cloud_Device_MismatchInputs */
/** @typedef {{}} Local_Cloud_Device_Needs_HubInputs */
/** @typedef {{}} Local_Cloud_Device_NoneInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Cloud_Device_OtherInputs */
/** @typedef {{}} Local_Cloud_ExpiredInputs */
/** @typedef {{}} Local_Cloud_FrameInputs */
/** @typedef {{}} Local_Cloud_Frame_Signed_Out_BodyInputs */
/** @typedef {{ from: NonNullable<unknown> }} Local_Cloud_From_LoginInputs */
/** @typedef {{}} Local_Cloud_Hub_AwayInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Cloud_Hub_RowInputs */
/** @typedef {{}} Local_Cloud_Hub_TokenInputs */
/** @typedef {{}} Local_Cloud_LinkedInputs */
/** @typedef {{}} Local_Cloud_LoginInputs */
/** @typedef {{}} Local_Cloud_Login_AgainInputs */
/** @typedef {{}} Local_Cloud_LogoutInputs */
/** @typedef {{}} Local_Cloud_Logout_BodyInputs */
/** @typedef {{}} Local_Cloud_Logout_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Logout_TitleInputs */
/** @typedef {{}} Local_Cloud_NoneInputs */
/** @typedef {{}} Local_Cloud_OpenInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Cloud_OtherInputs */
/** @typedef {{}} Local_Cloud_RestartingInputs */
/** @typedef {{}} Local_Cloud_RetryInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_BodyInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_OpenInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_TiedInputs */
/** @typedef {{}} Local_Cloud_UnlinkInputs */
/** @typedef {{}} Local_Cloud_Unlink_BodyInputs */
/** @typedef {{}} Local_Cloud_Unlink_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Unlink_TitleInputs */
/** @typedef {{}} Local_Cloud_UnreachableInputs */
/** @typedef {{}} Local_Cloud_Unreached_BodyInputs */
/** @typedef {{}} Local_Cloud_Unreached_TitleInputs */
/** @typedef {{}} Local_Cloud_WaitingInputs */
/** @typedef {{}} Local_DmsInputs */
/** @typedef {{}} Local_Dms_UnreadInputs */
/** @typedef {{ dir: NonNullable<unknown> }} Local_Headless_Backup_DirInputs */
/** @typedef {{ dir: NonNullable<unknown>, reason: NonNullable<unknown> }} Local_Headless_Backup_Dir_RefusedInputs */
/** @typedef {{ addresses: NonNullable<unknown> }} Local_Headless_Connect_ToInputs */
/** @typedef {{ app: NonNullable<unknown>, error: NonNullable<unknown> }} Local_Headless_Could_Not_StartInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_LinkedInputs */
/** @typedef {{ account: NonNullable<unknown> }} Local_Headless_Login_AgainInputs */
/** @typedef {{ account: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_BoundInputs */
/** @typedef {{}} Local_Headless_Login_DeniedInputs */
/** @typedef {{}} Local_Headless_Login_ExpiredInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Headless_Login_FailedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_LinkedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_Not_RunningInputs */
/** @typedef {{ url: NonNullable<unknown>, code: NonNullable<unknown>, minutes: NonNullable<unknown> }} Local_Headless_Login_OpenInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Headless_Login_OtherInputs */
/** @typedef {{}} Local_Headless_Login_WaitingInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Others_Not_RunningInputs */
/** @typedef {{}} Local_Headless_Others_OffInputs */
/** @typedef {{}} Local_Headless_Others_OnInputs */
/** @typedef {{}} Local_Headless_Others_UsageInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Headless_Pair_FailedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_No_PairingInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_Not_RunningInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown>, port: NonNullable<unknown> }} Local_Headless_Pair_Port_In_UseInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_Remote_OffInputs */
/** @typedef {{ minutes: NonNullable<unknown>, code: NonNullable<unknown> }} Local_Headless_Pairing_CodeInputs */
/** @typedef {{ port: NonNullable<unknown> }} Local_Headless_PortInputs */
/** @typedef {{ port: NonNullable<unknown>, error: NonNullable<unknown> }} Local_Headless_Port_In_UseInputs */
/** @typedef {{ time: NonNullable<unknown> }} Local_Headless_RestoredInputs */
/** @typedef {{ app: NonNullable<unknown>, dir: NonNullable<unknown> }} Local_Headless_RunningInputs */
/** @typedef {{ account: NonNullable<unknown> }} Local_Headless_Unlink_DoneInputs */
/** @typedef {{}} Local_Headless_Unlink_NoneInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Unlink_Not_RunningInputs */
/** @typedef {{}} Local_Link_ConnectedInputs */
/** @typedef {{}} Local_Link_Connected_CloudInputs */
/** @typedef {{ where: NonNullable<unknown> }} Local_Link_Connected_ViaInputs */
/** @typedef {{}} Local_Link_ConnectingInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Hub_DoorInputs */
/** @typedef {{}} Local_Link_Hub_Door_AwayInputs */
/** @typedef {{}} Local_Link_Hub_Door_Not_TiedInputs */
/** @typedef {{}} Local_Link_Hub_Door_NoteInputs */
/** @typedef {{}} Local_Link_Hub_Door_Via_CloudInputs */
/** @typedef {{}} Local_Link_Invalid_CodeInputs */
/** @typedef {{}} Local_Link_Is_HubInputs */
/** @typedef {{}} Local_Link_JoinInputs */
/** @typedef {{}} Local_Link_Join_ButtonInputs */
/** @typedef {{}} Local_Link_Join_NoteInputs */
/** @typedef {{}} Local_Link_LeaveInputs */
/** @typedef {{}} Local_Link_Leave_BodyInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Leave_TitleInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_MainInputs */
/** @typedef {{}} Local_Link_Network_SettingsInputs */
/** @typedef {{}} Local_Link_Open_SettingsInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_ReconnectingInputs */
/** @typedef {{}} Local_Link_Reconnecting_Not_ListeningInputs */
/** @typedef {{}} Local_Link_Reconnecting_Sign_InInputs */
/** @typedef {{}} Local_Link_RefusedInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_RemovedInputs */
/** @typedef {{}} Local_Link_Removed_ShortInputs */
/** @typedef {{}} Local_Link_RoutesInputs */
/** @typedef {{}} Local_Link_Routes_Cloud_HomeInputs */
/** @typedef {{}} Local_Link_Routes_No_Sign_InInputs */
/** @typedef {{}} Local_Link_Routes_NoteInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Screen_App_OutdatedInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Screen_Hub_OutdatedInputs */
/** @typedef {{}} Local_Link_UnreachableInputs */
/** @typedef {{}} Local_Link_Unreachable_MacInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Unreachable_NowInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Write_FailedInputs */
/** @typedef {{}} Local_McpInputs */
/** @typedef {{}} Local_Mcp_Claude_Code_NoteInputs */
/** @typedef {{}} Local_Mcp_Claude_Desktop_NoteInputs */
/** @typedef {{}} Local_Mcp_Codex_NoteInputs */
/** @typedef {{}} Local_Mcp_CopiedInputs */
/** @typedef {{}} Local_Mcp_CopyInputs */
/** @typedef {{}} Local_Mcp_Copy_FailedInputs */
/** @typedef {{}} Local_Mcp_DescriptionInputs */
/** @typedef {{}} Local_Mcp_Load_FailedInputs */
/** @typedef {{}} Local_Mcp_RetryInputs */
/** @typedef {{}} Local_Mcp_UnavailableInputs */
/** @typedef {{}} Local_Me_CancelInputs */
/** @typedef {{}} Local_Me_Cancel_BodyInputs */
/** @typedef {{}} Local_Me_Cancel_TitleInputs */
/** @typedef {{}} Local_Me_CancelledInputs */
/** @typedef {{}} Local_Me_ChangesInputs */
/** @typedef {{}} Local_Me_Check_Far_NoteInputs */
/** @typedef {{}} Local_Me_Check_Far_TitleInputs */
/** @typedef {{}} Local_Me_Check_Google_NoteInputs */
/** @typedef {{}} Local_Me_Check_Google_TitleInputs */
/** @typedef {{}} Local_Me_Check_Hub_Agents_NoteInputs */
/** @typedef {{}} Local_Me_Check_Hub_Agents_TitleInputs */
/** @typedef {{}} Local_Me_Check_Phone_NoteInputs */
/** @typedef {{}} Local_Me_Check_Phone_TitleInputs */
/** @typedef {{}} Local_Me_Check_Published_NoteInputs */
/** @typedef {{}} Local_Me_Check_Published_TitleInputs */
/** @typedef {{}} Local_Me_Check_Sandbox_NoteInputs */
/** @typedef {{}} Local_Me_Check_Sandbox_TitleInputs */
/** @typedef {{}} Local_Me_Check_Web_GetsInputs */
/** @typedef {{}} Local_Me_Check_Web_LosesInputs */
/** @typedef {{}} Local_Me_Check_Web_TitleInputs */
/** @typedef {{}} Local_Me_Elsewhere_BodyInputs */
/** @typedef {{}} Local_Me_Elsewhere_TitleInputs */
/** @typedef {{ length: NonNullable<unknown> }} Local_Me_EstimateInputs */
/** @typedef {{}} Local_Me_Estimate_LongInputs */
/** @typedef {{}} Local_Me_Estimate_MinuteInputs */
/** @typedef {{}} Local_Me_Estimate_MinutesInputs */
/** @typedef {{}} Local_Me_Estimate_SecondsInputs */
/** @typedef {{ message: NonNullable<unknown> }} Local_Me_FailedInputs */
/** @typedef {{}} Local_Me_Failed_ChangedInputs */
/** @typedef {{}} Local_Me_Failed_LimitInputs */
/** @typedef {{}} Local_Me_Failed_UnreachableInputs */
/** @typedef {{ time: NonNullable<unknown>, place: NonNullable<unknown> }} Local_Me_FinishedInputs */
/** @typedef {{ time: NonNullable<unknown>, what: NonNullable<unknown>, place: NonNullable<unknown> }} Local_Me_Finished_MergeInputs */
/** @typedef {{}} Local_Me_Finished_Place_CloudInputs */
/** @typedef {{}} Local_Me_Finished_Place_HubInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Local_Me_Finished_WhatInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Local_Me_Finished_What_MoreInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Me_Item_CreatedInputs */
/** @typedef {{}} Local_Me_MergeInputs */
/** @typedef {{}} Local_Me_Merge_BodyInputs */
/** @typedef {{}} Local_Me_Merge_From_CloudInputs */
/** @typedef {{}} Local_Me_Merge_From_HubInputs */
/** @typedef {{}} Local_Me_Merge_KeptInputs */
/** @typedef {{}} Local_Me_Merge_LabelsInputs */
/** @typedef {{}} Local_Me_Merge_NoneInputs */
/** @typedef {{}} Local_Me_Merge_PersonsInputs */
/** @typedef {{}} Local_Me_Merge_Persons_NoteInputs */
/** @typedef {{}} Local_Me_Merge_To_CloudInputs */
/** @typedef {{}} Local_Me_Merge_To_Cloud_TitleInputs */
/** @typedef {{}} Local_Me_Merge_To_HubInputs */
/** @typedef {{}} Local_Me_Merge_To_Hub_TitleInputs */
/** @typedef {{}} Local_Me_Move_BodyInputs */
/** @typedef {{}} Local_Me_MovesInputs */
/** @typedef {{}} Local_Me_Moving_DigestInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Local_Me_Moving_Digest_OfInputs */
/** @typedef {{}} Local_Me_Moving_FilesInputs */
/** @typedef {{}} Local_Me_Moving_MergeInputs */
/** @typedef {{}} Local_Me_Moving_NoteInputs */
/** @typedef {{}} Local_Me_Moving_SendInputs */
/** @typedef {{}} Local_Me_Moving_VerifyInputs */
/** @typedef {{}} Local_Me_PlaceInputs */
/** @typedef {{}} Local_Me_Place_Both_NowInputs */
/** @typedef {{}} Local_Me_Place_CloudInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Me_Place_Cloud_CopyInputs */
/** @typedef {{}} Local_Me_Place_Cloud_OnlyInputs */
/** @typedef {{}} Local_Me_Place_HubInputs */
/** @typedef {{}} Local_Me_Place_Other_HubInputs */
/** @typedef {{}} Local_Me_Place_UnreachableInputs */
/** @typedef {{}} Local_Me_Place_UpdateInputs */
/** @typedef {{}} Local_Me_Queue_CancelInputs */
/** @typedef {{ ahead: NonNullable<unknown>, minutes: NonNullable<unknown> }} Local_Me_QueuedInputs */
/** @typedef {{}} Local_Me_Queued_NoteInputs */
/** @typedef {{ ahead: NonNullable<unknown> }} Local_Me_Queued_SoonInputs */
/** @typedef {{}} Local_Me_RetryInputs */
/** @typedef {{}} Local_Me_Side_CloudInputs */
/** @typedef {{}} Local_Me_Side_HubInputs */
/** @typedef {{}} Local_Me_StoppedInputs */
/** @typedef {{ minutes: NonNullable<unknown>, seconds: NonNullable<unknown> }} Local_Me_Time_MinutesInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Local_Me_Time_SecondsInputs */
/** @typedef {{}} Local_Me_To_CloudInputs */
/** @typedef {{}} Local_Me_To_Cloud_TitleInputs */
/** @typedef {{}} Local_Me_To_HubInputs */
/** @typedef {{}} Local_Me_To_Hub_TitleInputs */
/** @typedef {{}} Local_Me_UntitledInputs */
/** @typedef {{}} Local_MenubarInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Menubar_AgentInputs */
/** @typedef {{}} Local_Menubar_Agent_Cloud_OffInputs */
/** @typedef {{}} Local_Menubar_Agent_Cloud_OnInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Agent_Hub_OnInputs */
/** @typedef {{}} Local_Menubar_Agent_UnusedInputs */
/** @typedef {{}} Local_Menubar_Cloud_Signed_InInputs */
/** @typedef {{}} Local_Menubar_DescriptionInputs */
/** @typedef {{ count: NonNullable<unknown> }} Local_Menubar_Hub_DevicesInputs */
/** @typedef {{}} Local_Menubar_Hub_ListeningInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_OffInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_OnInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_On_CloudInputs */
/** @typedef {{ main: NonNullable<unknown>, where: NonNullable<unknown> }} Local_Menubar_Hub_On_WhereInputs */
/** @typedef {{}} Local_Menubar_Hub_Port_In_UseInputs */
/** @typedef {{}} Local_Menubar_IconInputs */
/** @typedef {{}} Local_Menubar_Icon_LogoInputs */
/** @typedef {{}} Local_Menubar_Icon_NoteInputs */
/** @typedef {{}} Local_Menubar_Icon_UsageInputs */
/** @typedef {{}} Local_Menubar_ProviderInputs */
/** @typedef {{}} Local_Menubar_Provider_NoteInputs */
/** @typedef {{}} Local_Menubar_Provider_Note_UnusedInputs */
/** @typedef {{}} Local_Menubar_ShowInputs */
/** @typedef {{}} Local_Menubar_Show_NoteInputs */
/** @typedef {{}} Local_Notice_Cloud_LoginInputs */
/** @typedef {{ from: NonNullable<unknown>, name: NonNullable<unknown> }} Local_Notice_Cloud_Login_BodyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_FailedInputs */
/** @typedef {{}} Local_Notice_Failed_BodyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_ReplyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_TurnInputs */
/** @typedef {{}} Local_Open_In_New_WindowInputs */
/** @typedef {{}} Local_RailInputs */
/** @typedef {{}} Local_Rail_NewInputs */
/** @typedef {{}} Local_ReleaseInputs */
/** @typedef {{}} Local_Release_ActionInputs */
/** @typedef {{}} Local_Release_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Local_Release_FailedInputs */
/** @typedef {{}} Local_Release_No_SpaceInputs */
/** @typedef {{}} Local_Release_NoneInputs */
/** @typedef {{}} Local_Release_SpaceInputs */
/** @typedef {{ title: NonNullable<unknown> }} Local_Release_TitleInputs */
/** @typedef {{}} Local_Release_UnavailableInputs */
/** @typedef {{}} Local_Release_WorkspaceInputs */
/** @typedef {{ title: NonNullable<unknown>, workspace: NonNullable<unknown> }} Local_ReleasedInputs */
/** @typedef {{}} Local_RemoteInputs */
/** @typedef {{}} Local_Remote_AddInputs */
/** @typedef {{}} Local_Remote_Add_NoteInputs */
/** @typedef {{}} Local_Remote_CloudInputs */
/** @typedef {{}} Local_Remote_Cloud_ConnectingInputs */
/** @typedef {{}} Local_Remote_Cloud_Needs_TieInputs */
/** @typedef {{}} Local_Remote_Cloud_NoteInputs */
/** @typedef {{}} Local_Remote_Cloud_OpenInputs */
/** @typedef {{}} Local_Remote_Cloud_RefusedInputs */
/** @typedef {{}} Local_Remote_CodeInputs */
/** @typedef {{}} Local_Remote_ConnectedInputs */
/** @typedef {{ where: NonNullable<unknown> }} Local_Remote_Connected_FromInputs */
/** @typedef {{}} Local_Remote_DescriptionInputs */
/** @typedef {{}} Local_Remote_DevicesInputs */
/** @typedef {{}} Local_Remote_Devices_NoneInputs */
/** @typedef {{}} Local_Remote_FailedInputs */
/** @typedef {{}} Local_Remote_LinkedInputs */
/** @typedef {{}} Local_Remote_ListenInputs */
/** @typedef {{}} Local_Remote_Listen_NoteInputs */
/** @typedef {{ port: NonNullable<unknown> }} Local_Remote_Port_In_UseInputs */
/** @typedef {{}} Local_Remote_RemoveInputs */
/** @typedef {{}} Local_Remote_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Remote_Remove_TitleInputs */
/** @typedef {{}} Local_Remote_RetryInputs */
/** @typedef {{}} Local_Route_AnywhereInputs */
/** @typedef {{}} Local_Route_Client_Cloud_HomeInputs */
/** @typedef {{}} Local_Route_Client_DiagramInputs */
/** @typedef {{}} Local_Route_Client_NeedsInputs */
/** @typedef {{}} Local_Route_Client_TitleInputs */
/** @typedef {{}} Local_Route_DevicesInputs */
/** @typedef {{}} Local_Route_DirectInputs */
/** @typedef {{}} Local_Route_Direct_FirstInputs */
/** @typedef {{}} Local_Route_HelpInputs */
/** @typedef {{}} Local_Route_Help_CloseInputs */
/** @typedef {{}} Local_Route_HubInputs */
/** @typedef {{}} Local_Route_Hub_Cloud_HomeInputs */
/** @typedef {{}} Local_Route_Hub_CopyInputs */
/** @typedef {{}} Local_Route_Hub_DiagramInputs */
/** @typedef {{}} Local_Route_Hub_First_DirectInputs */
/** @typedef {{}} Local_Route_Hub_Paired_OnlyInputs */
/** @typedef {{}} Local_Route_Hub_TitleInputs */
/** @typedef {{}} Local_Route_NetworkInputs */
/** @typedef {{}} Local_Route_Network_NoteInputs */
/** @typedef {{}} Local_Route_OffInputs */
/** @typedef {{}} Local_Route_OutsideInputs */
/** @typedef {{}} Local_Route_Personal_DataInputs */
/** @typedef {{}} Local_Route_RelayInputs */
/** @typedef {{}} Local_Route_Relay_NoteInputs */
/** @typedef {{}} Local_Route_SealedInputs */
/** @typedef {{}} Local_Route_This_AgentInputs */
/** @typedef {{}} Local_Route_This_HubInputs */
/** @typedef {{}} Local_Route_This_Hub_NoteInputs */
/** @typedef {{}} Local_Route_This_PcInputs */
/** @typedef {{}} Local_Setting_Change_FailedInputs */
/** @typedef {{}} Local_TrustInputs */
/** @typedef {{}} Local_Trust_AcceptInputs */
/** @typedef {{ name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Accept_BodyInputs */
/** @typedef {{}} Local_Trust_Accept_ButtonInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Accept_FirstInputs */
/** @typedef {{}} Local_Trust_Accept_NoteInputs */
/** @typedef {{}} Local_Trust_Accept_TitleInputs */
/** @typedef {{}} Local_Trust_AddInputs */
/** @typedef {{}} Local_Trust_Add_AnotherInputs */
/** @typedef {{}} Local_Trust_Add_ButtonInputs */
/** @typedef {{}} Local_Trust_Add_NoteInputs */
/** @typedef {{}} Local_Trust_Agent_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Agent_SettingsInputs */
/** @typedef {{}} Local_Trust_Already_MemberInputs */
/** @typedef {{}} Local_Trust_Approve_AddingInputs */
/** @typedef {{}} Local_Trust_Approve_ButtonInputs */
/** @typedef {{}} Local_Trust_Approve_CompareInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Approve_DoneInputs */
/** @typedef {{}} Local_Trust_Approve_FindingInputs */
/** @typedef {{}} Local_Trust_CandidatesInputs */
/** @typedef {{}} Local_Trust_Candidates_NoteInputs */
/** @typedef {{}} Local_Trust_Cli_AcceptedInputs */
/** @typedef {{}} Local_Trust_Cli_Agent_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Approve_DoneInputs */
/** @typedef {{}} Local_Trust_Cli_Approve_FindingInputs */
/** @typedef {{ name: NonNullable<unknown>, kind: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Cli_Approve_PeerInputs */
/** @typedef {{ list: NonNullable<unknown>, name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Cli_AvailableInputs */
/** @typedef {{ fingerprint: NonNullable<unknown> }} Local_Trust_Cli_CompareInputs */
/** @typedef {{}} Local_Trust_Cli_CreatedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Trust_Cli_FailedInputs */
/** @typedef {{ fingerprint: NonNullable<unknown> }} Local_Trust_Cli_FingerprintInputs */
/** @typedef {{ minutes: NonNullable<unknown>, code: NonNullable<unknown> }} Local_Trust_Cli_InviteInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_ApprovedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_DeclinedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_ExpiredInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Invite_ProvedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_RefusedInputs */
/** @typedef {{}} Local_Trust_Cli_Keys_MadeInputs */
/** @typedef {{ n: NonNullable<unknown> }} Local_Trust_Cli_ListInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Trust_Cli_MadeInputs */
/** @typedef {{}} Local_Trust_Cli_No_ListInputs */
/** @typedef {{}} Local_Trust_Cli_No_ListsInputs */
/** @typedef {{ what: NonNullable<unknown> }} Local_Trust_Cli_Not_FoundInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Trust_Cli_Not_RunningInputs */
/** @typedef {{ app: NonNullable<unknown> }} Local_Trust_Cli_OthersInputs */
/** @typedef {{}} Local_Trust_Cli_Pair_NoteInputs */
/** @typedef {{}} Local_Trust_Cli_PassphraseInputs */
/** @typedef {{}} Local_Trust_Cli_Passphrase_AgainInputs */
/** @typedef {{}} Local_Trust_Cli_Passphrase_MismatchInputs */
/** @typedef {{ min: NonNullable<unknown> }} Local_Trust_Cli_Passphrase_NewInputs */
/** @typedef {{ place: NonNullable<unknown> }} Local_Trust_Cli_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Remove_DoneInputs */
/** @typedef {{}} Local_Trust_Cli_SwitchInputs */
/** @typedef {{}} Local_Trust_Cli_SwitchedInputs */
/** @typedef {{ app: NonNullable<unknown> }} Local_Trust_Cli_UsageInputs */
/** @typedef {{}} Local_Trust_Cli_WaitingInputs */
/** @typedef {{}} Local_Trust_Cli_Wrong_PassphraseInputs */
/** @typedef {{}} Local_Trust_CloudInputs */
/** @typedef {{}} Local_Trust_Cloud_AddInputs */
/** @typedef {{}} Local_Trust_Cloud_Add_When_ReadyInputs */
/** @typedef {{}} Local_Trust_Cloud_AddingInputs */
/** @typedef {{}} Local_Trust_Cloud_CreateInputs */
/** @typedef {{}} Local_Trust_Cloud_Create_LimitInputs */
/** @typedef {{}} Local_Trust_Cloud_DeleteInputs */
/** @typedef {{}} Local_Trust_Cloud_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Delete_TitleInputs */
/** @typedef {{}} Local_Trust_Cloud_FailedInputs */
/** @typedef {{}} Local_Trust_Cloud_Name_DevInputs */
/** @typedef {{}} Local_Trust_Cloud_Name_GeneralInputs */
/** @typedef {{}} Local_Trust_Cloud_NoneInputs */
/** @typedef {{}} Local_Trust_Cloud_NoteInputs */
/** @typedef {{}} Local_Trust_Cloud_Other_ListInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_AsleepInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_DeletingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_ErrorInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_PreparingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_QueuedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Local_Trust_Cloud_Phase_Queued_AtInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_RemakingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_RunningInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_StartingInputs */
/** @typedef {{}} Local_Trust_Cloud_RemakeInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Remake_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Remake_TitleInputs */
/** @typedef {{}} Local_Trust_Cloud_UnlistedInputs */
/** @typedef {{}} Local_Trust_Cloud_Update_ClisInputs */
/** @typedef {{}} Local_Trust_Cloud_UpdatingInputs */
/** @typedef {{}} Local_Trust_Cloud_WakeInputs */
/** @typedef {{}} Local_Trust_Cloud_Wake_To_AddInputs */
/** @typedef {{}} Local_Trust_CodeInputs */
/** @typedef {{}} Local_Trust_Code_ExpiredInputs */
/** @typedef {{}} Local_Trust_CreateInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Create_Again_BodyInputs */
/** @typedef {{}} Local_Trust_Create_Again_NoteInputs */
/** @typedef {{}} Local_Trust_Create_Again_TitleInputs */
/** @typedef {{}} Local_Trust_Create_ButtonInputs */
/** @typedef {{}} Local_Trust_Create_NoteInputs */
/** @typedef {{}} Local_Trust_DeclineInputs */
/** @typedef {{}} Local_Trust_DescriptionInputs */
/** @typedef {{}} Local_Trust_Device_Not_FoundInputs */
/** @typedef {{}} Local_Trust_FailedInputs */
/** @typedef {{}} Local_Trust_GuideInputs */
/** @typedef {{}} Local_Trust_Guide_AddInputs */
/** @typedef {{}} Local_Trust_Guide_Add_ThisInputs */
/** @typedef {{}} Local_Trust_Guide_AgentInputs */
/** @typedef {{}} Local_Trust_Guide_Agent_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_By_VaultInputs */
/** @typedef {{}} Local_Trust_Guide_By_Vault_LinkedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_By_Vault_SelfInputs */
/** @typedef {{}} Local_Trust_Guide_Code_GoesInputs */
/** @typedef {{}} Local_Trust_Guide_Create_MadeInputs */
/** @typedef {{}} Local_Trust_Guide_Create_NextInputs */
/** @typedef {{}} Local_Trust_Guide_Create_OnceInputs */
/** @typedef {{}} Local_Trust_Guide_Create_PassphraseInputs */
/** @typedef {{}} Local_Trust_Guide_Create_PressInputs */
/** @typedef {{}} Local_Trust_Guide_Example_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Example_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_CheckInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_FromInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_ResultInputs */
/** @typedef {{}} Local_Trust_Guide_FoundInputs */
/** @typedef {{}} Local_Trust_Guide_Found_TrustInputs */
/** @typedef {{}} Local_Trust_Guide_HereInputs */
/** @typedef {{}} Local_Trust_Guide_Here_NameInputs */
/** @typedef {{}} Local_Trust_Guide_In_ListInputs */
/** @typedef {{}} Local_Trust_Guide_Join_FirstInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Headless_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Pc_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Phone_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_QuestionInputs */
/** @typedef {{}} Local_Trust_Guide_Member_ScreenInputs */
/** @typedef {{}} Local_Trust_Guide_More_AddInputs */
/** @typedef {{}} Local_Trust_Guide_More_Add_ThisInputs */
/** @typedef {{}} Local_Trust_Guide_More_StartInputs */
/** @typedef {{}} Local_Trust_Guide_New_PcInputs */
/** @typedef {{}} Local_Trust_Guide_New_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_OthersInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_CloudInputs */
/** @typedef {{}} Local_Trust_Guide_Reach_NoneInputs */
/** @typedef {{}} Local_Trust_Guide_Reach_OutsideInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_SelfInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_Self_CloudInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_VaultInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_Vault_CloudInputs */
/** @typedef {{}} Local_Trust_Guide_RefusedInputs */
/** @typedef {{}} Local_Trust_Guide_RunsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Screen_OfInputs */
/** @typedef {{}} Local_Trust_Guide_StartInputs */
/** @typedef {{}} Local_Trust_Guide_Start_CreateInputs */
/** @typedef {{}} Local_Trust_Guide_Start_Create_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Start_JoinInputs */
/** @typedef {{}} Local_Trust_Guide_Start_Join_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Start_NoneInputs */
/** @typedef {{}} Local_Trust_Guide_Start_QuestionInputs */
/** @typedef {{}} Local_Trust_Guide_Start_UnreachedInputs */
/** @typedef {{}} Local_Trust_Guide_Step_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_CompareInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_Compare_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Compare_MemberInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_EnterInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Enter_MemberInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_HereInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_PhoneInputs */
/** @typedef {{ code: NonNullable<unknown> }} Local_Trust_Guide_Term_CodeInputs */
/** @typedef {{}} Local_Trust_Guide_WhatInputs */
/** @typedef {{}} Local_Trust_Guide_What_BodyInputs */
/** @typedef {{}} Local_Trust_Guide_WhereInputs */
/** @typedef {{}} Local_Trust_Invalid_CodeInputs */
/** @typedef {{}} Local_Trust_InviteInputs */
/** @typedef {{}} Local_Trust_Invite_ApprovedInputs */
/** @typedef {{}} Local_Trust_Invite_ButtonInputs */
/** @typedef {{}} Local_Trust_Invite_DeclinedInputs */
/** @typedef {{}} Local_Trust_Invite_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Invite_ProvedInputs */
/** @typedef {{}} Local_Trust_Invite_RefusedInputs */
/** @typedef {{}} Local_Trust_Invite_WaitingInputs */
/** @typedef {{}} Local_Trust_Kind_CloudInputs */
/** @typedef {{}} Local_Trust_Kind_PcInputs */
/** @typedef {{}} Local_Trust_Kind_PhoneInputs */
/** @typedef {{}} Local_Trust_Last_ApproverInputs */
/** @typedef {{}} Local_Trust_LeftInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Trust_List_MadeInputs */
/** @typedef {{}} Local_Trust_MembersInputs */
/** @typedef {{}} Local_Trust_Members_NoteInputs */
/** @typedef {{}} Local_Trust_Members_Note_OutsideInputs */
/** @typedef {{}} Local_Trust_Members_Note_ReceiverInputs */
/** @typedef {{}} Local_Trust_No_KeysInputs */
/** @typedef {{}} Local_Trust_No_PlaceInputs */
/** @typedef {{}} Local_Trust_No_Place_FailedInputs */
/** @typedef {{}} Local_Trust_OutsideInputs */
/** @typedef {{}} Local_Trust_Outside_Not_TakingInputs */
/** @typedef {{}} Local_Trust_Outside_NoteInputs */
/** @typedef {{}} Local_Trust_Outside_Page_NoteInputs */
/** @typedef {{}} Local_Trust_PassphraseInputs */
/** @typedef {{}} Local_Trust_Passphrase_AgainInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_BodyInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_ButtonInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_TitleInputs */
/** @typedef {{}} Local_Trust_Passphrase_MismatchInputs */
/** @typedef {{}} Local_Trust_Passphrase_New_NoteInputs */
/** @typedef {{}} Local_Trust_Passphrase_Set_TitleInputs */
/** @typedef {{}} Local_Trust_Passphrase_ShortInputs */
/** @typedef {{}} Local_Trust_ProblemInputs */
/** @typedef {{}} Local_Trust_Receiver_MarkInputs */
/** @typedef {{}} Local_Trust_RemoveInputs */
/** @typedef {{}} Local_Trust_Remove_BodyInputs */
/** @typedef {{}} Local_Trust_Remove_Self_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Remove_TitleInputs */
/** @typedef {{}} Local_Trust_SwitchInputs */
/** @typedef {{ name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Switch_BodyInputs */
/** @typedef {{}} Local_Trust_Switch_ButtonInputs */
/** @typedef {{}} Local_Trust_Switch_NoteInputs */
/** @typedef {{}} Local_Trust_Switch_TitleInputs */
/** @typedef {{}} Local_Trust_This_DeviceInputs */
/** @typedef {{}} Local_Trust_This_Device_MarkInputs */
/** @typedef {{}} Local_Trust_This_Device_NoteInputs */
/** @typedef {{}} Local_Trust_UnreachableInputs */
/** @typedef {{}} Local_Trust_Wrong_PassphraseInputs */
/** @typedef {{}} Local_Trust_Wrong_ProofInputs */
/** @typedef {{}} Local_Via_Cloud_RefusedInputs */
/** @typedef {{}} Local_Where_CloudInputs */
/** @typedef {{}} Media_CloseInputs */
/** @typedef {{}} Media_DownloadInputs */
/** @typedef {{}} Media_Image_ActionsInputs */
/** @typedef {{}} Media_Image_NextInputs */
/** @typedef {{ count: NonNullable<unknown>, n: NonNullable<unknown> }} Media_Image_PositionInputs */
/** @typedef {{}} Media_Image_PreviousInputs */
/** @typedef {{}} Media_More_ActionsInputs */
/** @typedef {{}} Media_Open_In_TabInputs */
/** @typedef {{}} Media_Video_Exit_FullscreenInputs */
/** @typedef {{}} Media_Video_FullscreenInputs */
/** @typedef {{ name: NonNullable<unknown> }} Media_Video_LabelInputs */
/** @typedef {{}} Media_Video_MuteInputs */
/** @typedef {{}} Media_Video_Native_FullscreenInputs */
/** @typedef {{}} Media_Video_PauseInputs */
/** @typedef {{}} Media_Video_PlayInputs */
/** @typedef {{ name: NonNullable<unknown> }} Media_Video_Play_NamedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Media_Video_SecondsInputs */
/** @typedef {{}} Media_Video_SeekInputs */
/** @typedef {{}} Media_Video_SpeedInputs */
/** @typedef {{}} Media_Video_Speed_NormalInputs */
/** @typedef {{}} Media_Video_UnmuteInputs */
/** @typedef {{}} Media_Video_UnplayableInputs */
/** @typedef {{}} Media_Video_VolumeInputs */
/** @typedef {{}} Media_Zoom_InInputs */
/** @typedef {{}} Media_Zoom_OutInputs */
/** @typedef {{}} Memos_CloseInputs */
/** @typedef {{}} Memos_HandoverInputs */
/** @typedef {{}} Memos_Handover_PlaceholderInputs */
/** @typedef {{}} Memos_Load_FailedInputs */
/** @typedef {{}} Memos_LogInputs */
/** @typedef {{}} Memos_Log_DeleteInputs */
/** @typedef {{}} Memos_Log_Delete_FailedInputs */
/** @typedef {{}} Memos_Log_EmptyInputs */
/** @typedef {{}} Memos_Log_MoreInputs */
/** @typedef {{}} Memos_Save_FailedInputs */
/** @typedef {{}} Memos_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Notices_Agent_TitleInputs */
/** @typedef {{ device: NonNullable<unknown> }} Notices_App_DeniedInputs */
/** @typedef {{}} Notices_App_DestinationsInputs */
/** @typedef {{}} Notices_App_FailedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Notices_App_LabelInputs */
/** @typedef {{}} Notices_App_Open_SettingsInputs */
/** @typedef {{}} Notices_App_ReceiveInputs */
/** @typedef {{}} Notices_App_This_DeviceInputs */
/** @typedef {{}} Notices_App_UntiedInputs */
/** @typedef {{}} Notices_File_OnlyInputs */
/** @typedef {{}} Notices_Settings_DeniedInputs */
/** @typedef {{}} Notices_Settings_DescriptionInputs */
/** @typedef {{}} Notices_Settings_OsInputs */
/** @typedef {{}} Notices_Settings_Os_BlockedInputs */
/** @typedef {{}} Notices_Settings_Os_DescriptionInputs */
/** @typedef {{}} Notices_Settings_Os_Open_SettingsInputs */
/** @typedef {{}} Notices_Settings_Os_UnsignedInputs */
/** @typedef {{}} Notices_Settings_TitleInputs */
/** @typedef {{}} Notices_Settings_UnsupportedInputs */
/** @typedef {{}} Notices_Test_BodyInputs */
/** @typedef {{}} Notices_Test_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Notices_Trust_Added_BodyInputs */
/** @typedef {{}} Notices_Trust_Added_TitleInputs */
/** @typedef {{}} Notices_Turn_Edited_PrefixInputs */
/** @typedef {{}} Notices_Turn_Proposal_PrefixInputs */
/** @typedef {{}} Persons_Agent_MemoInputs */
/** @typedef {{}} Persons_Alias_AddInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_Add_FailedInputs */
/** @typedef {{}} Persons_Alias_PlaceholderInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_RemoveInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_Remove_FailedInputs */
/** @typedef {{}} Persons_AliasesInputs */
/** @typedef {{}} Persons_Aliases_IdsInputs */
/** @typedef {{}} Persons_ContextInputs */
/** @typedef {{}} Persons_Context_PlaceholderInputs */
/** @typedef {{}} Persons_CreateInputs */
/** @typedef {{}} Persons_Create_FailedInputs */
/** @typedef {{}} Persons_Create_Failed_KeptInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Create_NamedInputs */
/** @typedef {{}} Persons_CreatingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_TitleInputs */
/** @typedef {{}} Persons_EmptyInputs */
/** @typedef {{}} Persons_External_IdsInputs */
/** @typedef {{}} Persons_GoInputs */
/** @typedef {{}} Persons_HistoryInputs */
/** @typedef {{}} Persons_Id_AddInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_Add_FailedInputs */
/** @typedef {{}} Persons_Id_KindInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_RemoveInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_Remove_FailedInputs */
/** @typedef {{}} Persons_Id_ValueInputs */
/** @typedef {{}} Persons_Id_Value_PlaceholderInputs */
/** @typedef {{}} Persons_Kind_EmailInputs */
/** @typedef {{}} Persons_Kind_GithubInputs */
/** @typedef {{}} Persons_Kind_PhoneInputs */
/** @typedef {{}} Persons_Kind_SlackInputs */
/** @typedef {{}} Persons_Kind_UrlInputs */
/** @typedef {{}} Persons_Link_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Link_FailedInputs */
/** @typedef {{}} Persons_Link_LabelInputs */
/** @typedef {{}} Persons_Link_MenuInputs */
/** @typedef {{}} Persons_Link_SearchInputs */
/** @typedef {{}} Persons_Link_Search_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Link_TitleInputs */
/** @typedef {{}} Persons_Linked_FormerInputs */
/** @typedef {{}} Persons_ListInputs */
/** @typedef {{}} Persons_Load_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_MenuInputs */
/** @typedef {{}} Persons_Merge_ActionInputs */
/** @typedef {{ keep: NonNullable<unknown>, from: NonNullable<unknown> }} Persons_Merge_BodyInputs */
/** @typedef {{ from: NonNullable<unknown>, keep: NonNullable<unknown> }} Persons_Merge_FailedInputs */
/** @typedef {{}} Persons_Merge_LabelInputs */
/** @typedef {{}} Persons_Merge_MenuInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Merge_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Merge_Pick_TitleInputs */
/** @typedef {{}} Persons_Merge_SearchInputs */
/** @typedef {{ from: NonNullable<unknown>, keep: NonNullable<unknown> }} Persons_Merge_TitleInputs */
/** @typedef {{}} Persons_NameInputs */
/** @typedef {{}} Persons_Name_FailedInputs */
/** @typedef {{}} Persons_NarrowInputs */
/** @typedef {{}} Persons_Narrow_PlaceholderInputs */
/** @typedef {{}} Persons_NewInputs */
/** @typedef {{}} Persons_No_MatchInputs */
/** @typedef {{}} Persons_Not_FoundInputs */
/** @typedef {{}} Persons_NowInputs */
/** @typedef {{}} Persons_Now_EmptyInputs */
/** @typedef {{}} Persons_Open_EmailInputs */
/** @typedef {{}} Persons_Open_GithubInputs */
/** @typedef {{}} Persons_Open_PhoneInputs */
/** @typedef {{}} Persons_Open_SlackInputs */
/** @typedef {{}} Persons_Open_UrlInputs */
/** @typedef {{}} Persons_Pick_ActionInputs */
/** @typedef {{}} Persons_Pick_CandidatesInputs */
/** @typedef {{}} Persons_Pick_ClearInputs */
/** @typedef {{}} Persons_Pick_NoneInputs */
/** @typedef {{}} Persons_Pick_PlaceholderInputs */
/** @typedef {{}} Persons_Pick_SearchInputs */
/** @typedef {{}} Persons_Pick_Search_Or_CreateInputs */
/** @typedef {{}} Persons_Pick_Search_PlaceholderInputs */
/** @typedef {{}} Persons_Slack_WorkspaceInputs */
/** @typedef {{}} Persons_Slack_Workspace_PlaceholderInputs */
/** @typedef {{}} Persons_SummaryInputs */
/** @typedef {{}} Persons_Summary_FailedInputs */
/** @typedef {{}} Persons_Summary_PlaceholderInputs */
/** @typedef {{}} Persons_TitleInputs */
/** @typedef {{}} Persons_UnlinkInputs */
/** @typedef {{}} Persons_Unlink_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Persons_Waiting_CountInputs */
/** @typedef {{}} Phone_Doc_RedoInputs */
/** @typedef {{}} Phone_Doc_UndoInputs */
/** @typedef {{}} Phone_Dock_SettingsInputs */
/** @typedef {{}} Phone_Dock_Settings_CutoffInputs */
/** @typedef {{}} Phone_Dock_Settings_DescriptionInputs */
/** @typedef {{}} Phone_Dock_Settings_MeInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Dock_Settings_MoveInputs */
/** @typedef {{}} Phone_Dock_Settings_No_PlaceInputs */
/** @typedef {{}} Phone_Dock_Settings_NoteInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Dock_Settings_ShowInputs */
/** @typedef {{}} Phone_MenuInputs */
/** @typedef {{}} Phone_Menu_AllInputs */
/** @typedef {{}} Phone_Menu_ArrangeInputs */
/** @typedef {{}} Phone_Menu_OpenInputs */
/** @typedef {{}} Phone_MoreInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_More_CurrentInputs */
/** @typedef {{ name: NonNullable<unknown> }} Phone_Place_MenuInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Unread_NamedInputs */
/** @typedef {{}} Publishing_ActionInputs */
/** @typedef {{}} Publishing_BuildingInputs */
/** @typedef {{}} Publishing_CloseInputs */
/** @typedef {{}} Publishing_CopiedInputs */
/** @typedef {{}} Publishing_CopyInputs */
/** @typedef {{}} Publishing_Copy_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Dataset_More_FieldsInputs */
/** @typedef {{}} Publishing_Dataset_Not_AllowedInputs */
/** @typedef {{}} Publishing_Dataset_Not_WritableInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Dataset_RowsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_BlockedInputs */
/** @typedef {{}} Publishing_Datasets_Confirm_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_Confirm_TitleInputs */
/** @typedef {{}} Publishing_Datasets_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_HiddenInputs */
/** @typedef {{}} Publishing_Datasets_IntroInputs */
/** @typedef {{}} Publishing_Datasets_PendingInputs */
/** @typedef {{}} Publishing_Datasets_PublishInputs */
/** @typedef {{}} Publishing_Datasets_PublishedInputs */
/** @typedef {{}} Publishing_Datasets_TitleInputs */
/** @typedef {{}} Publishing_FailedInputs */
/** @typedef {{}} Publishing_FailingInputs */
/** @typedef {{}} Publishing_Html_ScriptsInputs */
/** @typedef {{}} Publishing_IntroInputs */
/** @typedef {{}} Publishing_MenuInputs */
/** @typedef {{}} Publishing_OpenInputs */
/** @typedef {{}} Publishing_PreviewInputs */
/** @typedef {{}} Publishing_Preview_FailedInputs */
/** @typedef {{}} Publishing_PublishedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Publishing_Published_AtInputs */
/** @typedef {{}} Publishing_Published_PendingInputs */
/** @typedef {{}} Publishing_StopInputs */
/** @typedef {{}} Publishing_Stop_BodyInputs */
/** @typedef {{}} Publishing_Stop_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Publishing_Stop_TitleInputs */
/** @typedef {{}} Publishing_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Unpublished_LinksInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Unpublished_RefsInputs */
/** @typedef {{}} Publishing_UrlInputs */
/** @typedef {{}} Refs_Cannot_Open_HereInputs */
/** @typedef {{}} Refs_In_CloudInputs */
/** @typedef {{ label: NonNullable<unknown>, why: NonNullable<unknown> }} Refs_Missing_LabelInputs */
/** @typedef {{}} Refs_Not_FoundInputs */
/** @typedef {{}} Refs_Note_ConflictInputs */
/** @typedef {{}} Refs_Note_Conflict_DropInputs */
/** @typedef {{}} Refs_Note_Conflict_Use_MineInputs */
/** @typedef {{}} Refs_Note_Conflict_YoursInputs */
/** @typedef {{}} Refs_Save_Failed_KeptInputs */
/** @typedef {{}} Refs_UnreachableInputs */
/** @typedef {{}} Settings_App_OpenInputs */
/** @typedef {{}} Settings_App_Open_DescriptionInputs */
/** @typedef {{}} Settings_App_Open_Description_DeviceInputs */
/** @typedef {{}} Settings_App_Window_DescriptionInputs */
/** @typedef {{}} Settings_AppearanceInputs */
/** @typedef {{}} Settings_Appearance_DescriptionInputs */
/** @typedef {{}} Settings_Back_To_IndexInputs */
/** @typedef {{}} Settings_GeneralInputs */
/** @typedef {{}} Settings_General_DescriptionInputs */
/** @typedef {{}} Settings_General_Description_AccountInputs */
/** @typedef {{}} Settings_Group_AppInputs */
/** @typedef {{}} Settings_InputInputs */
/** @typedef {{}} Settings_Input_DescriptionInputs */
/** @typedef {{}} Settings_LanguageInputs */
/** @typedef {{}} Settings_Language_BrowserInputs */
/** @typedef {{}} Settings_Language_NoteInputs */
/** @typedef {{}} Settings_NameInputs */
/** @typedef {{}} Settings_PictureInputs */
/** @typedef {{}} Settings_Save_FailedInputs */
/** @typedef {{}} Settings_Send_KeyInputs */
/** @typedef {{}} Settings_Send_Key_EnterInputs */
/** @typedef {{}} Settings_Send_Key_ModInputs */
/** @typedef {{}} Settings_Send_Key_NoteInputs */
/** @typedef {{}} Settings_ThemeInputs */
/** @typedef {{}} Settings_Theme_AutoInputs */
/** @typedef {{}} Settings_Theme_DarkInputs */
/** @typedef {{}} Settings_Theme_LightInputs */
/** @typedef {{}} Settings_Theme_NoteInputs */
/** @typedef {{}} Settings_Time_ZoneInputs */
/** @typedef {{ zone: NonNullable<unknown> }} Settings_Time_Zone_BrowserInputs */
/** @typedef {{}} Settings_Time_Zone_NoteInputs */
/** @typedef {{}} Shell_Account_MenuInputs */
/** @typedef {{}} Shell_BackInputs */
/** @typedef {{}} Shell_Back_To_ListInputs */
/** @typedef {{}} Shell_Clear_PicksInputs */
/** @typedef {{}} Shell_CopiedInputs */
/** @typedef {{}} Shell_Copy_FailedInputs */
/** @typedef {{}} Shell_Copy_LinkInputs */
/** @typedef {{}} Shell_Error_BodyInputs */
/** @typedef {{}} Shell_Error_ReloadInputs */
/** @typedef {{}} Shell_Error_TitleInputs */
/** @typedef {{}} Shell_FavoritesInputs */
/** @typedef {{}} Shell_Favorites_AddInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Favorites_Add_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Create_Folder_FailedInputs */
/** @typedef {{}} Shell_Favorites_Delete_FolderInputs */
/** @typedef {{}} Shell_Favorites_Delete_Folder_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Delete_Folder_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Delete_Folder_TitleInputs */
/** @typedef {{}} Shell_Favorites_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Folder_MenuInputs */
/** @typedef {{}} Shell_Favorites_Folder_NameInputs */
/** @typedef {{}} Shell_Favorites_Move_FailedInputs */
/** @typedef {{}} Shell_Favorites_New_FolderInputs */
/** @typedef {{}} Shell_Favorites_RemoveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Favorites_Remove_FailedInputs */
/** @typedef {{}} Shell_Favorites_RenameInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Rename_FailedInputs */
/** @typedef {{}} Shell_Fold_SidebarInputs */
/** @typedef {{}} Shell_Hub_AwayInputs */
/** @typedef {{}} Shell_Keep_Sidebar_OpenInputs */
/** @typedef {{}} Shell_Language_AutoInputs */
/** @typedef {{}} Shell_List_FoldInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shell_List_Fold_RestInputs */
/** @typedef {{}} Shell_List_NarrowInputs */
/** @typedef {{}} Shell_List_Narrow_TitleInputs */
/** @typedef {{}} Shell_List_No_MatchInputs */
/** @typedef {{}} Shell_MeInputs */
/** @typedef {{}} Shell_Me_Away_SettingsInputs */
/** @typedef {{}} Shell_Me_EmptyInputs */
/** @typedef {{}} Shell_Me_Moving_AlmostInputs */
/** @typedef {{ percent: NonNullable<unknown>, left: NonNullable<unknown> }} Shell_Me_Moving_DoneInputs */
/** @typedef {{}} Shell_Me_Moving_MeasuringInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Shell_Me_Moving_MinutesInputs */
/** @typedef {{}} Shell_Me_Moving_ProgressInputs */
/** @typedef {{}} Shell_Me_Moving_Under_MinuteInputs */
/** @typedef {{}} Shell_Not_Found_BodyInputs */
/** @typedef {{}} Shell_Not_Found_TitleInputs */
/** @typedef {{}} Shell_Open_SidebarInputs */
/** @typedef {{}} Shell_Personal_Data_Not_WorkspaceInputs */
/** @typedef {{}} Shell_Personal_DocumentsInputs */
/** @typedef {{}} Shell_Personal_In_CloudInputs */
/** @typedef {{}} Shell_Personal_In_VaultInputs */
/** @typedef {{}} Shell_Personal_OnlyInputs */
/** @typedef {{}} Shell_Pick_ActionsInputs */
/** @typedef {{ base: NonNullable<unknown>, n: NonNullable<unknown> }} Shell_Pick_Count_LabelInputs */
/** @typedef {{}} Shell_Pick_Names_JoinInputs */
/** @typedef {{ head: NonNullable<unknown>, rest: NonNullable<unknown> }} Shell_Pick_Names_MoreInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Pick_QuotedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Pick_RowInputs */
/** @typedef {{}} Shell_Picked_ActionsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shell_Picked_CountInputs */
/** @typedef {{}} Shell_Rail_PersonalInputs */
/** @typedef {{}} Shell_Resize_SidebarInputs */
/** @typedef {{}} Shell_Route_PendingInputs */
/** @typedef {{}} Shell_SettingsInputs */
/** @typedef {{}} Shell_Settings_BackInputs */
/** @typedef {{}} Shell_Settings_DescriptionInputs */
/** @typedef {{}} Shell_Settings_No_MatchInputs */
/** @typedef {{}} Shell_Settings_SearchInputs */
/** @typedef {{}} Shell_ShortcutsInputs */
/** @typedef {{}} Shell_Shortcuts_Group_CreateInputs */
/** @typedef {{}} Shell_Shortcuts_Group_GeneralInputs */
/** @typedef {{}} Shell_Shortcuts_Group_NavigateInputs */
/** @typedef {{}} Shell_Shortcuts_Group_ViewInputs */
/** @typedef {{}} Shell_Side_CloseInputs */
/** @typedef {{}} Shell_Side_Open_FullInputs */
/** @typedef {{}} Shell_Toggle_SidebarInputs */
/** @typedef {{}} Shell_Unreachable_Cannot_OpenInputs */
/** @typedef {{}} Shell_WideInputs */
/** @typedef {{}} Shell_Wide_OffInputs */
/** @typedef {{}} Shell_Wide_ToggleInputs */
/** @typedef {{}} Shell_Window_CloseInputs */
/** @typedef {{}} Shell_Window_MaximizeInputs */
/** @typedef {{}} Shell_Window_MinimizeInputs */
/** @typedef {{}} Shell_Window_RestoreInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Workspace_ChangeInputs */
/** @typedef {{ names: NonNullable<unknown> }} Shell_Workspace_Change_ManyInputs */
/** @typedef {{}} Shell_Workspace_ColInputs */
/** @typedef {{}} Shell_Workspace_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Workspace_LeftInputs */
/** @typedef {{}} Shell_Workspace_OfflineInputs */
/** @typedef {{}} Shell_Workspace_RemoveInputs */
/** @typedef {{}} Shell_Workspace_SetInputs */
/** @typedef {{}} Timeblocker_AccountsInputs */
/** @typedef {{}} Timeblocker_Activity_Agent_RunInputs */
/** @typedef {{}} Timeblocker_Activity_Case_ClosedInputs */
/** @typedef {{}} Timeblocker_Activity_Step_ClosedInputs */
/** @typedef {{}} Timeblocker_Add_BlockInputs */
/** @typedef {{}} Timeblocker_Add_LaneInputs */
/** @typedef {{}} Timeblocker_All_DayInputs */
/** @typedef {{}} Timeblocker_Block_EndedInputs */
/** @typedef {{ title: NonNullable<unknown>, start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeblocker_Block_LabelInputs */
/** @typedef {{}} Timeblocker_Block_RemoveInputs */
/** @typedef {{}} Timeblocker_CalendarInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Calendar_ErrorInputs */
/** @typedef {{}} Timeblocker_Calendar_SettingsInputs */
/** @typedef {{}} Timeblocker_CalendarsInputs */
/** @typedef {{}} Timeblocker_CancelInputs */
/** @typedef {{}} Timeblocker_Case_Add_WholeInputs */
/** @typedef {{}} Timeblocker_Case_WholeInputs */
/** @typedef {{}} Timeblocker_CasesInputs */
/** @typedef {{}} Timeblocker_Change_DeferredInputs */
/** @typedef {{}} Timeblocker_Change_MovedInputs */
/** @typedef {{}} Timeblocker_CloseInputs */
/** @typedef {{}} Timeblocker_ColorInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Color_OfInputs */
/** @typedef {{}} Timeblocker_Connect_DescriptionInputs */
/** @typedef {{}} Timeblocker_Connect_FailedInputs */
/** @typedef {{}} Timeblocker_Connect_GoogleInputs */
/** @typedef {{}} Timeblocker_Connect_MoreInputs */
/** @typedef {{}} Timeblocker_Create_EventInputs */
/** @typedef {{}} Timeblocker_DateInputs */
/** @typedef {{}} Timeblocker_Delete_EventInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Delete_Event_ConfirmInputs */
/** @typedef {{}} Timeblocker_Delete_LaneInputs */
/** @typedef {{}} Timeblocker_DetailInputs */
/** @typedef {{}} Timeblocker_Did_ActivityInputs */
/** @typedef {{}} Timeblocker_Did_NoneInputs */
/** @typedef {{}} Timeblocker_Did_StartedInputs */
/** @typedef {{}} Timeblocker_Did_UpcomingInputs */
/** @typedef {{}} Timeblocker_DisconnectInputs */
/** @typedef {{}} Timeblocker_Disconnect_BodyInputs */
/** @typedef {{ email: NonNullable<unknown> }} Timeblocker_Disconnect_FailedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Timeblocker_Disconnect_TitleInputs */
/** @typedef {{}} Timeblocker_DoneInputs */
/** @typedef {{}} Timeblocker_Empty_DoneInputs */
/** @typedef {{}} Timeblocker_Empty_TodoInputs */
/** @typedef {{}} Timeblocker_EndInputs */
/** @typedef {{}} Timeblocker_End_BlockInputs */
/** @typedef {{}} Timeblocker_End_DateInputs */
/** @typedef {{}} Timeblocker_Event_Bad_DatesInputs */
/** @typedef {{}} Timeblocker_Event_ConflictInputs */
/** @typedef {{}} Timeblocker_Event_DetailInputs */
/** @typedef {{}} Timeblocker_Event_TitleInputs */
/** @typedef {{}} Timeblocker_Event_Too_ShortInputs */
/** @typedef {{}} Timeblocker_GoInputs */
/** @typedef {{}} Timeblocker_Go_TodayInputs */
/** @typedef {{}} Timeblocker_Google_ConnectedInputs */
/** @typedef {{}} Timeblocker_Google_DeniedInputs */
/** @typedef {{}} Timeblocker_Google_FailedInputs */
/** @typedef {{}} Timeblocker_Google_Not_GrantedInputs */
/** @typedef {{}} Timeblocker_Google_UnavailableInputs */
/** @typedef {{}} Timeblocker_Google_Wrong_AccountInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_Group_AfterInputs */
/** @typedef {{}} Timeblocker_Group_After_TodayInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_Group_BeforeInputs */
/** @typedef {{}} Timeblocker_Group_Before_TodayInputs */
/** @typedef {{}} Timeblocker_Group_TodayInputs */
/** @typedef {{}} Timeblocker_Group_UndatedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Item_StartInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Item_StopInputs */
/** @typedef {{}} Timeblocker_Item_WorkingInputs */
/** @typedef {{}} Timeblocker_Join_HereInputs */
/** @typedef {{}} Timeblocker_Join_MeetingInputs */
/** @typedef {{}} Timeblocker_Kind_ActionInputs */
/** @typedef {{}} Timeblocker_Kind_CaseInputs */
/** @typedef {{}} Timeblocker_Lane_MeInputs */
/** @typedef {{}} Timeblocker_Lane_NameInputs */
/** @typedef {{}} Timeblocker_Lane_NoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Lane_OfInputs */
/** @typedef {{}} Timeblocker_LanesInputs */
/** @typedef {{}} Timeblocker_Lanes_NoteInputs */
/** @typedef {{}} Timeblocker_Link_EmptyInputs */
/** @typedef {{}} Timeblocker_Link_SearchInputs */
/** @typedef {{}} Timeblocker_ListsInputs */
/** @typedef {{}} Timeblocker_Load_FailedInputs */
/** @typedef {{}} Timeblocker_Mark_DoneInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Mark_Done_OfInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_MoreInputs */
/** @typedef {{}} Timeblocker_New_EventInputs */
/** @typedef {{}} Timeblocker_Next_DayInputs */
/** @typedef {{}} Timeblocker_Next_WeekInputs */
/** @typedef {{}} Timeblocker_No_AccountsInputs */
/** @typedef {{}} Timeblocker_No_ActionsInputs */
/** @typedef {{}} Timeblocker_No_WritableInputs */
/** @typedef {{}} Timeblocker_Open_CaseInputs */
/** @typedef {{}} Timeblocker_Open_GoogleInputs */
/** @typedef {{}} Timeblocker_Pick_ActionInputs */
/** @typedef {{}} Timeblocker_Pick_DateInputs */
/** @typedef {{}} Timeblocker_PlanInputs */
/** @typedef {{}} Timeblocker_Prev_DayInputs */
/** @typedef {{}} Timeblocker_Prev_WeekInputs */
/** @typedef {{}} Timeblocker_Read_OnlyInputs */
/** @typedef {{}} Timeblocker_Recurring_OneInputs */
/** @typedef {{}} Timeblocker_RedoInputs */
/** @typedef {{}} Timeblocker_Redo_FailedInputs */
/** @typedef {{}} Timeblocker_ReopenInputs */
/** @typedef {{}} Timeblocker_Reset_ColorInputs */
/** @typedef {{}} Timeblocker_Resume_BlockInputs */
/** @typedef {{}} Timeblocker_ResyncInputs */
/** @typedef {{}} Timeblocker_ReviewInputs */
/** @typedef {{}} Timeblocker_Review_ActualInputs */
/** @typedef {{}} Timeblocker_Review_ChangesInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_DeferredInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_MovedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_ShortenedInputs */
/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Timeblocker_Review_Deferred_FromInputs */
/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Timeblocker_Review_Deferred_ToInputs */
/** @typedef {{}} Timeblocker_Review_DoneInputs */
/** @typedef {{}} Timeblocker_Review_Done_OfInputs */
/** @typedef {{}} Timeblocker_Review_EmptyInputs */
/** @typedef {{}} Timeblocker_Review_LinkInputs */
/** @typedef {{}} Timeblocker_Review_LinkedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_MovedInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timeblocker_Review_Moved_ToInputs */
/** @typedef {{ range: NonNullable<unknown> }} Timeblocker_Review_OfInputs */
/** @typedef {{}} Timeblocker_Review_PlannedInputs */
/** @typedef {{}} Timeblocker_Review_Planned_CommittedInputs */
/** @typedef {{}} Timeblocker_Review_Planned_OfInputs */
/** @typedef {{}} Timeblocker_Review_RateInputs */
/** @typedef {{ did: NonNullable<unknown>, all: NonNullable<unknown> }} Timeblocker_Review_Rate_OfInputs */
/** @typedef {{}} Timeblocker_Review_RatioInputs */
/** @typedef {{ planned: NonNullable<unknown> }} Timeblocker_Review_Ratio_OfInputs */
/** @typedef {{}} Timeblocker_Review_Unlinked_BlockInputs */
/** @typedef {{}} Timeblocker_Review_Untitled_ChatInputs */
/** @typedef {{}} Timeblocker_Save_FailedInputs */
/** @typedef {{}} Timeblocker_Settings_DescriptionInputs */
/** @typedef {{}} Timeblocker_Settings_TitleInputs */
/** @typedef {{}} Timeblocker_Show_ActionsInputs */
/** @typedef {{}} Timeblocker_StartInputs */
/** @typedef {{}} Timeblocker_Start_BlockInputs */
/** @typedef {{}} Timeblocker_Start_DateInputs */
/** @typedef {{}} Timeblocker_TabsInputs */
/** @typedef {{}} Timeblocker_This_WeekInputs */
/** @typedef {{}} Timeblocker_TimeInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_TimelineInputs */
/** @typedef {{}} Timeblocker_TitleInputs */
/** @typedef {{}} Timeblocker_Title_LabelInputs */
/** @typedef {{}} Timeblocker_TodoInputs */
/** @typedef {{}} Timeblocker_Undated_DropInputs */
/** @typedef {{}} Timeblocker_UndoInputs */
/** @typedef {{}} Timeblocker_Undo_FailedInputs */
/** @typedef {{}} Timeblocker_UnlinkInputs */
/** @typedef {{}} Timeblocker_UntitledInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Timeblocker_Week_RangeInputs */
/** @typedef {{}} Timeblocker_Work_LabelInputs */
/** @typedef {{}} Timeblocker_Work_LogInputs */
/** @typedef {{}} Timeblocker_Work_Log_DeleteInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeblocker_Work_Log_LabelInputs */
/** @typedef {{}} Timeblocker_Work_Log_NowInputs */
/** @typedef {{ elapsed: NonNullable<unknown> }} Timeblocker_Work_RunningInputs */
/** @typedef {{ title: NonNullable<unknown>, elapsed: NonNullable<unknown> }} Timeblocker_Work_Running_OfInputs */
/** @typedef {{}} Timeblocker_Work_StartInputs */
/** @typedef {{}} Timeblocker_Work_Start_ShortInputs */
/** @typedef {{}} Timeblocker_Work_StopInputs */
/** @typedef {{}} Timeblocker_Work_Stop_ShortInputs */
/** @typedef {{ total: NonNullable<unknown> }} Timeblocker_Work_TotalInputs */
/** @typedef {{}} Uifence_AnswerInputs */
/** @typedef {{}} Uifence_Answer_DetailInputs */
/** @typedef {{}} Uifence_Answer_TitleInputs */
/** @typedef {{}} Uifence_BuildingInputs */
/** @typedef {{}} Uifence_Calendar_Next_MonthInputs */
/** @typedef {{}} Uifence_Calendar_PickInputs */
/** @typedef {{}} Uifence_Calendar_Prev_MonthInputs */
/** @typedef {{}} Uifence_Calendar_TodayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Chart_OthersInputs */
/** @typedef {{}} Uifence_ChooseInputs */
/** @typedef {{}} Uifence_Copy_SourceInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Count_LeftInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Count_RightInputs */
/** @typedef {{}} Uifence_Data_All_RowsInputs */
/** @typedef {{}} Uifence_Data_ButtonInputs */
/** @typedef {{}} Uifence_Data_Not_FoundInputs */
/** @typedef {{}} Uifence_Data_Not_Found_DetailInputs */
/** @typedef {{}} Uifence_Data_QueryInputs */
/** @typedef {{}} Uifence_DateInputs */
/** @typedef {{}} Uifence_EndInputs */
/** @typedef {{}} Uifence_FailedInputs */
/** @typedef {{}} Uifence_Funnel_From_FirstInputs */
/** @typedef {{}} Uifence_Funnel_From_PreviousInputs */
/** @typedef {{}} Uifence_HeatmapInputs */
/** @typedef {{}} Uifence_Hide_SourceInputs */
/** @typedef {{}} Uifence_InsertInputs */
/** @typedef {{}} Uifence_LabelInputs */
/** @typedef {{}} Uifence_More_LeftInputs */
/** @typedef {{}} Uifence_More_RightInputs */
/** @typedef {{}} Uifence_Next_ImageInputs */
/** @typedef {{}} Uifence_NoInputs */
/** @typedef {{}} Uifence_No_DataInputs */
/** @typedef {{}} Uifence_No_EventsInputs */
/** @typedef {{}} Uifence_Open_LinkInputs */
/** @typedef {{}} Uifence_Open_Link_DetailInputs */
/** @typedef {{}} Uifence_Open_Link_TitleInputs */
/** @typedef {{}} Uifence_Picker_ClearInputs */
/** @typedef {{}} Uifence_Prev_ImageInputs */
/** @typedef {{}} Uifence_Quiz_CorrectInputs */
/** @typedef {{}} Uifence_Quiz_HintInputs */
/** @typedef {{}} Uifence_Quiz_Hint_ExplainedInputs */
/** @typedef {{}} Uifence_Quiz_Picked_WrongInputs */
/** @typedef {{}} Uifence_Quiz_WrongInputs */
/** @typedef {{}} Uifence_Range_Next_DayInputs */
/** @typedef {{}} Uifence_Range_ReversedInputs */
/** @typedef {{}} Uifence_Range_SameInputs */
/** @typedef {{}} Uifence_Range_SepInputs */
/** @typedef {{}} Uifence_SendInputs */
/** @typedef {{}} Uifence_Send_DetailInputs */
/** @typedef {{}} Uifence_Send_TitleInputs */
/** @typedef {{}} Uifence_Show_SourceInputs */
/** @typedef {{}} Uifence_SourceInputs */
/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown>, min: NonNullable<unknown>, max: NonNullable<unknown> }} Uifence_Spark_RangeInputs */
/** @typedef {{}} Uifence_StaleInputs */
/** @typedef {{}} Uifence_StartInputs */
/** @typedef {{}} Uifence_TimeInputs */
/** @typedef {{}} Uifence_Time_HourInputs */
/** @typedef {{}} Uifence_Time_MinuteInputs */
/** @typedef {{}} Uifence_Time_NowInputs */
/** @typedef {{}} Uifence_Time_PickInputs */
/** @typedef {{}} Uifence_TotalInputs */
/** @typedef {{}} Uifence_Waterfall_DownInputs */
/** @typedef {{}} Uifence_Waterfall_RunningInputs */
/** @typedef {{}} Uifence_Waterfall_UpInputs */
/** @typedef {{}} Uifence_YesInputs */
import * as __ja from "./ja.js"
import * as __en from "./en.js"
/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Agents_Agent_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_agent_label = /** @type {((inputs?: Agents_Agent_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Agent_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_agent_label(inputs)
	return __ja.agents_agent_label(inputs)
});
/**
* | output |
* | --- |
* | "“{name}” answered: {title}" |
*
* @param {Agents_Answer_By_ParentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_answer_by_parent = /** @type {((inputs: Agents_Answer_By_ParentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Answer_By_ParentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_answer_by_parent(inputs)
	return __ja.agents_answer_by_parent(inputs)
});
/**
* | output |
* | --- |
* | "From a child chat:" |
*
* @param {Agents_Answer_Raised_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_answer_raised_from = /** @type {((inputs?: Agents_Answer_Raised_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Answer_Raised_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_answer_raised_from(inputs)
	return __ja.agents_answer_raised_from(inputs)
});
/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Agents_ArchiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_archive = /** @type {((inputs?: Agents_ArchiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_ArchiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_archive(inputs)
	return __ja.agents_archive(inputs)
});
/**
* | output |
* | --- |
* | "No archived chats" |
*
* @param {Agents_Archived_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_archived_empty = /** @type {((inputs?: Agents_Archived_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Archived_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_archived_empty(inputs)
	return __ja.agents_archived_empty(inputs)
});
/**
* | output |
* | --- |
* | "Attach files" |
*
* @param {Agents_AttachInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_attach = /** @type {((inputs?: Agents_AttachInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_AttachInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_attach(inputs)
	return __ja.agents_attach(inputs)
});
/**
* | output |
* | --- |
* | "Could not upload {name}: {reason}" |
*
* @param {Agents_Attachment_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_attachment_failed = /** @type {((inputs: Agents_Attachment_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Attachment_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_attachment_failed(inputs)
	return __ja.agents_attachment_failed(inputs)
});
/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Agents_Attachment_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_attachment_remove = /** @type {((inputs: Agents_Attachment_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Attachment_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_attachment_remove(inputs)
	return __ja.agents_attachment_remove(inputs)
});
/**
* | output |
* | --- |
* | "Files to attach" |
*
* @param {Agents_AttachmentsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_attachments = /** @type {((inputs?: Agents_AttachmentsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_AttachmentsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_attachments(inputs)
	return __ja.agents_attachments(inputs)
});
/**
* | output |
* | --- |
* | "Bookmark" |
*
* @param {Agents_Bookmark_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_bookmark_add = /** @type {((inputs?: Agents_Bookmark_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Bookmark_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_bookmark_add(inputs)
	return __ja.agents_bookmark_add(inputs)
});
/**
* | output |
* | --- |
* | "Remove bookmark" |
*
* @param {Agents_Bookmark_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_bookmark_remove = /** @type {((inputs?: Agents_Bookmark_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Bookmark_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_bookmark_remove(inputs)
	return __ja.agents_bookmark_remove(inputs)
});
/**
* | output |
* | --- |
* | "In a browser you can only read the chat. Send instructions to the Agent from the trameria app." |
*
* @param {Agents_Browser_Read_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_browser_read_only = /** @type {((inputs?: Agents_Browser_Read_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Browser_Read_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_browser_read_only(inputs)
	return __ja.agents_browser_read_only(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Agents_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cancel = /** @type {((inputs?: Agents_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cancel(inputs)
	return __ja.agents_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Chat about this Case" |
*
* @param {Agents_Case_ChatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_case_chat = /** @type {((inputs?: Agents_Case_ChatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Case_ChatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_case_chat(inputs)
	return __ja.agents_case_chat(inputs)
});
/**
* | output |
* | --- |
* | "Could not open the chat about this Case" |
*
* @param {Agents_Case_Chat_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_case_chat_failed = /** @type {((inputs?: Agents_Case_Chat_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Case_Chat_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_case_chat_failed(inputs)
	return __ja.agents_case_chat_failed(inputs)
});
/**
* | output |
* | --- |
* | "Switch" |
*
* @param {Agents_Change_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_action = /** @type {((inputs?: Agents_Change_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_action(inputs)
	return __ja.agents_change_action(inputs)
});
/**
* | output |
* | --- |
* | "The conversation so far is handed to the new agent" |
*
* @param {Agents_Change_Agent_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_agent_body = /** @type {((inputs?: Agents_Change_Agent_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Agent_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_agent_body(inputs)
	return __ja.agents_change_agent_body(inputs)
});
/**
* | output |
* | --- |
* | "Switch the agent to {agent}?" |
*
* @param {Agents_Change_Agent_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_agent_title = /** @type {((inputs: Agents_Change_Agent_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Agent_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_agent_title(inputs)
	return __ja.agents_change_agent_title(inputs)
});
/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Agents_Change_CompletedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_completed = /** @type {((inputs?: Agents_Change_CompletedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_CompletedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_completed(inputs)
	return __ja.agents_change_completed(inputs)
});
/**
* | output |
* | --- |
* | "Created" |
*
* @param {Agents_Change_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_created = /** @type {((inputs?: Agents_Change_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_created(inputs)
	return __ja.agents_change_created(inputs)
});
/**
* | output |
* | --- |
* | "Delegated" |
*
* @param {Agents_Change_DelegatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_delegated = /** @type {((inputs?: Agents_Change_DelegatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_DelegatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_delegated(inputs)
	return __ja.agents_change_delegated(inputs)
});
/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {Agents_Change_DeletedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_deleted = /** @type {((inputs?: Agents_Change_DeletedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_DeletedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_deleted(inputs)
	return __ja.agents_change_deleted(inputs)
});
/**
* | output |
* | --- |
* | "Dropped" |
*
* @param {Agents_Change_DroppedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_dropped = /** @type {((inputs?: Agents_Change_DroppedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_DroppedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_dropped(inputs)
	return __ja.agents_change_dropped(inputs)
});
/**
* | output |
* | --- |
* | "Not for the reply being written; it changes from the next reply" |
*
* @param {Agents_Change_Next_ReplyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_next_reply = /** @type {((inputs?: Agents_Change_Next_ReplyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Next_ReplyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_next_reply(inputs)
	return __ja.agents_change_next_reply(inputs)
});
/**
* | output |
* | --- |
* | "Action" |
*
* @param {Agents_Change_Obj_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_obj_action = /** @type {((inputs?: Agents_Change_Obj_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Obj_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_obj_action(inputs)
	return __ja.agents_change_obj_action(inputs)
});
/**
* | output |
* | --- |
* | "Case" |
*
* @param {Agents_Change_Obj_CaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_obj_case = /** @type {((inputs?: Agents_Change_Obj_CaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Obj_CaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_obj_case(inputs)
	return __ja.agents_change_obj_case(inputs)
});
/**
* | output |
* | --- |
* | "chat" |
*
* @param {Agents_Change_Obj_ChatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_obj_chat = /** @type {((inputs?: Agents_Change_Obj_ChatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Obj_ChatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_obj_chat(inputs)
	return __ja.agents_change_obj_chat(inputs)
});
/**
* | output |
* | --- |
* | "item" |
*
* @param {Agents_Change_Obj_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_obj_other = /** @type {((inputs?: Agents_Change_Obj_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Obj_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_obj_other(inputs)
	return __ja.agents_change_obj_other(inputs)
});
/**
* | output |
* | --- |
* | "document" |
*
* @param {Agents_Change_Obj_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_obj_page = /** @type {((inputs?: Agents_Change_Obj_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Obj_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_obj_page(inputs)
	return __ja.agents_change_obj_page(inputs)
});
/**
* | output |
* | --- |
* | "person" |
*
* @param {Agents_Change_Obj_PersonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_obj_person = /** @type {((inputs?: Agents_Change_Obj_PersonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Obj_PersonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_obj_person(inputs)
	return __ja.agents_change_obj_person(inputs)
});
/**
* | output |
* | --- |
* | "Waiting" |
*
* @param {Agents_Change_Obj_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_obj_waiting = /** @type {((inputs?: Agents_Change_Obj_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_Obj_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_obj_waiting(inputs)
	return __ja.agents_change_obj_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Posted" |
*
* @param {Agents_Change_PostedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_posted = /** @type {((inputs?: Agents_Change_PostedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_PostedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_posted(inputs)
	return __ja.agents_change_posted(inputs)
});
/**
* | output |
* | --- |
* | "Reopened" |
*
* @param {Agents_Change_ReopenedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_reopened = /** @type {((inputs?: Agents_Change_ReopenedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_ReopenedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_reopened(inputs)
	return __ja.agents_change_reopened(inputs)
});
/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Agents_Change_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_change_updated = /** @type {((inputs?: Agents_Change_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Change_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_change_updated(inputs)
	return __ja.agents_change_updated(inputs)
});
/**
* | output |
* | --- |
* | "Changed by this reply" |
*
* @param {Agents_ChangesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_changes = /** @type {((inputs?: Agents_ChangesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_ChangesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_changes(inputs)
	return __ja.agents_changes(inputs)
});
/**
* | output |
* | --- |
* | "waiting its turn" |
*
* @param {Agents_Child_QueuedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_child_queued = /** @type {((inputs?: Agents_Child_QueuedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Child_QueuedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_child_queued(inputs)
	return __ja.agents_child_queued(inputs)
});
/**
* | output |
* | --- |
* | "working" |
*
* @param {Agents_Child_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_child_running = /** @type {((inputs?: Agents_Child_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Child_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_child_running(inputs)
	return __ja.agents_child_running(inputs)
});
/**
* | output |
* | --- |
* | "waiting for a decision" |
*
* @param {Agents_Child_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_child_waiting = /** @type {((inputs?: Agents_Child_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Child_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_child_waiting(inputs)
	return __ja.agents_child_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Child chats at work" |
*
* @param {Agents_ChildrenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_children = /** @type {((inputs?: Agents_ChildrenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_ChildrenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_children(inputs)
	return __ja.agents_children(inputs)
});
/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Agents_Col_AgentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_col_agent = /** @type {((inputs?: Agents_Col_AgentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Col_AgentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_col_agent(inputs)
	return __ja.agents_col_agent(inputs)
});
/**
* | output |
* | --- |
* | "Case" |
*
* @param {Agents_Col_CaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_col_case = /** @type {((inputs?: Agents_Col_CaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Col_CaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_col_case(inputs)
	return __ja.agents_col_case(inputs)
});
/**
* | output |
* | --- |
* | "Cost" |
*
* @param {Agents_Col_CostInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_col_cost = /** @type {((inputs?: Agents_Col_CostInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Col_CostInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_col_cost(inputs)
	return __ja.agents_col_cost(inputs)
});
/**
* | output |
* | --- |
* | "Created" |
*
* @param {Agents_Col_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_col_created = /** @type {((inputs?: Agents_Col_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Col_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_col_created(inputs)
	return __ja.agents_col_created(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Agents_Col_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_col_name = /** @type {((inputs?: Agents_Col_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Col_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_col_name(inputs)
	return __ja.agents_col_name(inputs)
});
/**
* | output |
* | --- |
* | "Last updated" |
*
* @param {Agents_Col_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_col_updated = /** @type {((inputs?: Agents_Col_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Col_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_col_updated(inputs)
	return __ja.agents_col_updated(inputs)
});
/**
* | output |
* | --- |
* | "Collapse" |
*
* @param {Agents_Composer_ShrinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_composer_shrink = /** @type {((inputs?: Agents_Composer_ShrinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Composer_ShrinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_composer_shrink(inputs)
	return __ja.agents_composer_shrink(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Agents_Conditions_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_conditions_close = /** @type {((inputs?: Agents_Conditions_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Conditions_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_conditions_close(inputs)
	return __ja.agents_conditions_close(inputs)
});
/**
* | output |
* | --- |
* | "Agent settings" |
*
* @param {Agents_Conditions_DrawerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_conditions_drawer = /** @type {((inputs?: Agents_Conditions_DrawerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Conditions_DrawerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_conditions_drawer(inputs)
	return __ja.agents_conditions_drawer(inputs)
});
/**
* | output |
* | --- |
* | "Open Agent settings" |
*
* @param {Agents_Conditions_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_conditions_open = /** @type {((inputs?: Agents_Conditions_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Conditions_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_conditions_open(inputs)
	return __ja.agents_conditions_open(inputs)
});
/**
* | output |
* | --- |
* | "Open Agent settings (device: {device})" |
*
* @param {Agents_Conditions_Open_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_conditions_open_device = /** @type {((inputs: Agents_Conditions_Open_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Conditions_Open_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_conditions_open_device(inputs)
	return __ja.agents_conditions_open_device(inputs)
});
/**
* | output |
* | --- |
* | "Open Agent settings (device: {device}, needs attention)" |
*
* @param {Agents_Conditions_Open_Device_WarningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_conditions_open_device_warning = /** @type {((inputs: Agents_Conditions_Open_Device_WarningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Conditions_Open_Device_WarningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_conditions_open_device_warning(inputs)
	return __ja.agents_conditions_open_device_warning(inputs)
});
/**
* | output |
* | --- |
* | "Open Agent settings (needs attention)" |
*
* @param {Agents_Conditions_Open_WarningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_conditions_open_warning = /** @type {((inputs?: Agents_Conditions_Open_WarningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Conditions_Open_WarningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_conditions_open_warning(inputs)
	return __ja.agents_conditions_open_warning(inputs)
});
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Agents_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_copied = /** @type {((inputs?: Agents_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_copied(inputs)
	return __ja.agents_copied(inputs)
});
/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Agents_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_copy = /** @type {((inputs?: Agents_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_copy(inputs)
	return __ja.agents_copy(inputs)
});
/**
* | output |
* | --- |
* | "Working directory" |
*
* @param {Agents_Cwd_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cwd_label = /** @type {((inputs?: Agents_Cwd_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Cwd_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cwd_label(inputs)
	return __ja.agents_cwd_label(inputs)
});
/**
* | output |
* | --- |
* | "{value} (not found)" |
*
* @param {Agents_Cwd_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cwd_missing = /** @type {((inputs: Agents_Cwd_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Cwd_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cwd_missing(inputs)
	return __ja.agents_cwd_missing(inputs)
});
/**
* | output |
* | --- |
* | "This place is not on the device. Pick another" |
*
* @param {Agents_Cwd_Missing_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cwd_missing_note = /** @type {((inputs?: Agents_Cwd_Missing_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Cwd_Missing_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cwd_missing_note(inputs)
	return __ja.agents_cwd_missing_note(inputs)
});
/**
* | output |
* | --- |
* | "No working directory" |
*
* @param {Agents_Cwd_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cwd_none = /** @type {((inputs?: Agents_Cwd_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Cwd_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cwd_none(inputs)
	return __ja.agents_cwd_none(inputs)
});
/**
* | output |
* | --- |
* | "Does not touch files" |
*
* @param {Agents_Cwd_None_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cwd_none_note = /** @type {((inputs?: Agents_Cwd_None_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Cwd_None_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cwd_none_note(inputs)
	return __ja.agents_cwd_none_note(inputs)
});
/**
* | output |
* | --- |
* | "Another directory…" |
*
* @param {Agents_Cwd_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cwd_other = /** @type {((inputs?: Agents_Cwd_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Cwd_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cwd_other(inputs)
	return __ja.agents_cwd_other(inputs)
});
/**
* | output |
* | --- |
* | "Enter a path under an allowed directory" |
*
* @param {Agents_Cwd_OutsideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_cwd_outside = /** @type {((inputs?: Agents_Cwd_OutsideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Cwd_OutsideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_cwd_outside(inputs)
	return __ja.agents_cwd_outside(inputs)
});
/**
* | output |
* | --- |
* | "Hand off to Agent" |
*
* @param {Agents_Delegate_StepInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delegate_step = /** @type {((inputs?: Agents_Delegate_StepInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Delegate_StepInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delegate_step(inputs)
	return __ja.agents_delegate_step(inputs)
});
/**
* | output |
* | --- |
* | "Could not hand \"{title}\" off to Agent" |
*
* @param {Agents_Delegate_Step_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delegate_step_failed = /** @type {((inputs: Agents_Delegate_Step_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Delegate_Step_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delegate_step_failed(inputs)
	return __ja.agents_delegate_step_failed(inputs)
});
/**
* | output |
* | --- |
* | "Open the handed-off chat" |
*
* @param {Agents_Delegate_Step_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delegate_step_open = /** @type {((inputs?: Agents_Delegate_Step_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Delegate_Step_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delegate_step_open(inputs)
	return __ja.agents_delegate_step_open(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Agents_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delete = /** @type {((inputs?: Agents_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delete(inputs)
	return __ja.agents_delete(inputs)
});
/**
* | output |
* | --- |
* | "Its messages, run records and your-turn items go too. This cannot be undone" |
*
* @param {Agents_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delete_body = /** @type {((inputs?: Agents_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delete_body(inputs)
	return __ja.agents_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "The messages, run records and your-turn items of {names} go too. This cannot be undone" |
*
* @param {Agents_Delete_Many_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delete_many_body = /** @type {((inputs: Agents_Delete_Many_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Delete_Many_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delete_many_body(inputs)
	return __ja.agents_delete_many_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete {count} chats?" |
*
* @param {Agents_Delete_Many_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delete_many_title = /** @type {((inputs: Agents_Delete_Many_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Delete_Many_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delete_many_title(inputs)
	return __ja.agents_delete_many_title(inputs)
});
/**
* | output |
* | --- |
* | "Delete “{title}”?" |
*
* @param {Agents_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_delete_title = /** @type {((inputs: Agents_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_delete_title(inputs)
	return __ja.agents_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "The agent on {device} is not connected now. What you send is answered once it connects again" |
*
* @param {Agents_Device_AwayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_away = /** @type {((inputs: Agents_Device_AwayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_AwayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_away(inputs)
	return __ja.agents_device_away(inputs)
});
/**
* | output |
* | --- |
* | "Not connected now" |
*
* @param {Agents_Device_Away_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_away_short = /** @type {((inputs?: Agents_Device_Away_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_Away_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_away_short(inputs)
	return __ja.agents_device_away_short(inputs)
});
/**
* | output |
* | --- |
* | "Getting {device} ready. What you send arrives once it's ready" |
*
* @param {Agents_Device_ComingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_coming = /** @type {((inputs: Agents_Device_ComingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_ComingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_coming(inputs)
	return __ja.agents_device_coming(inputs)
});
/**
* | output |
* | --- |
* | "Device" |
*
* @param {Agents_Device_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_label = /** @type {((inputs?: Agents_Device_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_label(inputs)
	return __ja.agents_device_label(inputs)
});
/**
* | output |
* | --- |
* | "{device} has not connected to trameria yet, so nothing would answer. Start the trameria app or agent on {device}" |
*
* @param {Agents_Device_OfflineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_offline = /** @type {((inputs: Agents_Device_OfflineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_OfflineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_offline(inputs)
	return __ja.agents_device_offline(inputs)
});
/**
* | output |
* | --- |
* | "{device} has not connected to trameria yet, so nothing would answer. Pick a connected device under the box, or start the trameria app or agent on {device}" |
*
* @param {Agents_Device_Offline_PickInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_offline_pick = /** @type {((inputs: Agents_Device_Offline_PickInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_Offline_PickInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_offline_pick(inputs)
	return __ja.agents_device_offline_pick(inputs)
});
/**
* | output |
* | --- |
* | "Connected and can answer" |
*
* @param {Agents_Device_ReadyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_ready = /** @type {((inputs?: Agents_Device_ReadyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_ReadyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_ready(inputs)
	return __ja.agents_device_ready(inputs)
});
/**
* | output |
* | --- |
* | "Instructions cannot be sent from {self} to {device}. Add {self} to {device}'s device list." |
*
* @param {Agents_Device_Unreachable_LineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_device_unreachable_line = /** @type {((inputs: Agents_Device_Unreachable_LineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Device_Unreachable_LineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_device_unreachable_line(inputs)
	return __ja.agents_device_unreachable_line(inputs)
});
/**
* | output |
* | --- |
* | "Add a device" |
*
* @param {Agents_Devices_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_devices_add = /** @type {((inputs?: Agents_Devices_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Devices_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_devices_add(inputs)
	return __ja.agents_devices_add(inputs)
});
/**
* | output |
* | --- |
* | "Not connected yet" |
*
* @param {Agents_Devices_Never_SeenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_devices_never_seen = /** @type {((inputs?: Agents_Devices_Never_SeenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Devices_Never_SeenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_devices_never_seen(inputs)
	return __ja.agents_devices_never_seen(inputs)
});
/**
* | output |
* | --- |
* | "To bring this into the text to send, ask in the chat" |
*
* @param {Agents_Draft_Ask_In_ChatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_ask_in_chat = /** @type {((inputs?: Agents_Draft_Ask_In_ChatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Ask_In_ChatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_ask_in_chat(inputs)
	return __ja.agents_draft_ask_in_chat(inputs)
});
/**
* | output |
* | --- |
* | "Copy original" |
*
* @param {Agents_Draft_Copy_OriginalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_copy_original = /** @type {((inputs?: Agents_Draft_Copy_OriginalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Copy_OriginalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_copy_original(inputs)
	return __ja.agents_draft_copy_original(inputs)
});
/**
* | output |
* | --- |
* | "Copy subject" |
*
* @param {Agents_Draft_Copy_SubjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_copy_subject = /** @type {((inputs?: Agents_Draft_Copy_SubjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Copy_SubjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_copy_subject(inputs)
	return __ja.agents_draft_copy_subject(inputs)
});
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Agents_Draft_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_open = /** @type {((inputs?: Agents_Draft_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_open(inputs)
	return __ja.agents_draft_open(inputs)
});
/**
* | output |
* | --- |
* | "Open the original message" |
*
* @param {Agents_Draft_Open_OriginalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_open_original = /** @type {((inputs?: Agents_Draft_Open_OriginalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Open_OriginalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_open_original(inputs)
	return __ja.agents_draft_open_original(inputs)
});
/**
* | output |
* | --- |
* | "Original" |
*
* @param {Agents_Draft_OriginalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_original = /** @type {((inputs?: Agents_Draft_OriginalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_OriginalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_original(inputs)
	return __ja.agents_draft_original(inputs)
});
/**
* | output |
* | --- |
* | "Reason for not sending (optional)" |
*
* @param {Agents_Draft_Reason_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_reason_placeholder = /** @type {((inputs?: Agents_Draft_Reason_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Reason_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_reason_placeholder(inputs)
	return __ja.agents_draft_reason_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Original message" |
*
* @param {Agents_Draft_Reply_ToInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_reply_to = /** @type {((inputs?: Agents_Draft_Reply_ToInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Reply_ToInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_reply_to(inputs)
	return __ja.agents_draft_reply_to(inputs)
});
/**
* | output |
* | --- |
* | "Could not save the text" |
*
* @param {Agents_Draft_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_save_failed = /** @type {((inputs?: Agents_Draft_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_save_failed(inputs)
	return __ja.agents_draft_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "Text shown" |
*
* @param {Agents_Draft_SideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_side = /** @type {((inputs?: Agents_Draft_SideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_SideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_side(inputs)
	return __ja.agents_draft_side(inputs)
});
/**
* | output |
* | --- |
* | "Your language (to check)" |
*
* @param {Agents_Draft_Side_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_side_source = /** @type {((inputs?: Agents_Draft_Side_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Side_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_side_source(inputs)
	return __ja.agents_draft_side_source(inputs)
});
/**
* | output |
* | --- |
* | "{lang} (to send)" |
*
* @param {Agents_Draft_Side_TextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_side_text = /** @type {((inputs: Agents_Draft_Side_TextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Side_TextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_side_text(inputs)
	return __ja.agents_draft_side_text(inputs)
});
/**
* | output |
* | --- |
* | "Draft" |
*
* @param {Agents_Draft_SlackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_slack = /** @type {((inputs?: Agents_Draft_SlackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_SlackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_slack(inputs)
	return __ja.agents_draft_slack(inputs)
});
/**
* | output |
* | --- |
* | "Place again" |
*
* @param {Agents_Draft_Slack_AgainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_slack_again = /** @type {((inputs?: Agents_Draft_Slack_AgainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Slack_AgainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_slack_again(inputs)
	return __ja.agents_draft_slack_again(inputs)
});
/**
* | output |
* | --- |
* | "Could not place it: {error}" |
*
* @param {Agents_Draft_Slack_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_slack_failed = /** @type {((inputs: Agents_Draft_Slack_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Slack_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_slack_failed(inputs)
	return __ja.agents_draft_slack_failed(inputs)
});
/**
* | output |
* | --- |
* | "Placed as a draft" |
*
* @param {Agents_Draft_Slack_PlacedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_slack_placed = /** @type {((inputs?: Agents_Draft_Slack_PlacedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Slack_PlacedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_slack_placed(inputs)
	return __ja.agents_draft_slack_placed(inputs)
});
/**
* | output |
* | --- |
* | "Placing the draft" |
*
* @param {Agents_Draft_Slack_PlacingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_slack_placing = /** @type {((inputs?: Agents_Draft_Slack_PlacingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Slack_PlacingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_slack_placing(inputs)
	return __ja.agents_draft_slack_placing(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't ask to put it in drafts" |
*
* @param {Agents_Draft_Slack_Request_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_slack_request_failed = /** @type {((inputs?: Agents_Draft_Slack_Request_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Slack_Request_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_slack_request_failed(inputs)
	return __ja.agents_draft_slack_request_failed(inputs)
});
/**
* | output |
* | --- |
* | "The text changed after it was placed" |
*
* @param {Agents_Draft_Slack_StaleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_slack_stale = /** @type {((inputs?: Agents_Draft_Slack_StaleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_Slack_StaleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_slack_stale(inputs)
	return __ja.agents_draft_slack_stale(inputs)
});
/**
* | output |
* | --- |
* | "Previous content" |
*
* @param {Agents_Draft_StaleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_stale = /** @type {((inputs?: Agents_Draft_StaleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_StaleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_stale(inputs)
	return __ja.agents_draft_stale(inputs)
});
/**
* | output |
* | --- |
* | "Subject" |
*
* @param {Agents_Draft_SubjectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_subject = /** @type {((inputs?: Agents_Draft_SubjectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_SubjectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_subject(inputs)
	return __ja.agents_draft_subject(inputs)
});
/**
* | output |
* | --- |
* | "Text to send" |
*
* @param {Agents_Draft_TextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_text = /** @type {((inputs?: Agents_Draft_TextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_TextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_text(inputs)
	return __ja.agents_draft_text(inputs)
});
/**
* | output |
* | --- |
* | "/thread" |
*
* @param {Agents_Draft_ThreadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_thread = /** @type {((inputs?: Agents_Draft_ThreadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_ThreadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_thread(inputs)
	return __ja.agents_draft_thread(inputs)
});
/**
* | output |
* | --- |
* | "No destination yet" |
*
* @param {Agents_Draft_To_UnknownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_to_unknown = /** @type {((inputs?: Agents_Draft_To_UnknownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_To_UnknownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_to_unknown(inputs)
	return __ja.agents_draft_to_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Translation" |
*
* @param {Agents_Draft_TranslationInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_draft_translation = /** @type {((inputs?: Agents_Draft_TranslationInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Draft_TranslationInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_draft_translation(inputs)
	return __ja.agents_draft_translation(inputs)
});
/**
* | output |
* | --- |
* | "Thinking effort" |
*
* @param {Agents_Effort_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_effort_label = /** @type {((inputs?: Agents_Effort_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Effort_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_effort_label(inputs)
	return __ja.agents_effort_label(inputs)
});
/**
* | output |
* | --- |
* | "No chats yet" |
*
* @param {Agents_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_empty = /** @type {((inputs?: Agents_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_empty(inputs)
	return __ja.agents_empty(inputs)
});
/**
* | output |
* | --- |
* | "No active chats" |
*
* @param {Agents_Empty_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_empty_active = /** @type {((inputs?: Agents_Empty_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Empty_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_empty_active(inputs)
	return __ja.agents_empty_active(inputs)
});
/**
* | output |
* | --- |
* | "Filter chats" |
*
* @param {Agents_FilterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_filter = /** @type {((inputs?: Agents_FilterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_FilterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_filter(inputs)
	return __ja.agents_filter(inputs)
});
/**
* | output |
* | --- |
* | "Active" |
*
* @param {Agents_Filter_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_filter_active = /** @type {((inputs?: Agents_Filter_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Filter_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_filter_active(inputs)
	return __ja.agents_filter_active(inputs)
});
/**
* | output |
* | --- |
* | "All" |
*
* @param {Agents_Filter_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_filter_all = /** @type {((inputs?: Agents_Filter_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Filter_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_filter_all(inputs)
	return __ja.agents_filter_all(inputs)
});
/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Agents_Filter_ArchivedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_filter_archived = /** @type {((inputs?: Agents_Filter_ArchivedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Filter_ArchivedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_filter_archived(inputs)
	return __ja.agents_filter_archived(inputs)
});
/**
* | output |
* | --- |
* | "Instruction from the parent chat “{name}”" |
*
* @param {Agents_From_ParentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_from_parent = /** @type {((inputs: Agents_From_ParentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_From_ParentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_from_parent(inputs)
	return __ja.agents_from_parent(inputs)
});
/**
* | output |
* | --- |
* | "Go to Agents" |
*
* @param {Agents_GoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_go = /** @type {((inputs?: Agents_GoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_GoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_go(inputs)
	return __ja.agents_go(inputs)
});
/**
* | output |
* | --- |
* | "{h}h {m}m" |
*
* @param {Agents_Hours_MinutesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_hours_minutes = /** @type {((inputs: Agents_Hours_MinutesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Hours_MinutesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_hours_minutes(inputs)
	return __ja.agents_hours_minutes(inputs)
});
/**
* | output |
* | --- |
* | "image {n}" |
*
* @param {Agents_Image_NInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_image_n = /** @type {((inputs: Agents_Image_NInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Image_NInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_image_n(inputs)
	return __ja.agents_image_n(inputs)
});
/**
* | output |
* | --- |
* | "{n} days" |
*
* @param {Agents_Limit_DaysInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_days = /** @type {((inputs: Agents_Limit_DaysInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_DaysInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_days(inputs)
	return __ja.agents_limit_days(inputs)
});
/**
* | output |
* | --- |
* | "{error} (values as of {at})" |
*
* @param {Agents_Limit_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_error = /** @type {((inputs: Agents_Limit_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_error(inputs)
	return __ja.agents_limit_error(inputs)
});
/**
* | output |
* | --- |
* | "{n} hours" |
*
* @param {Agents_Limit_HoursInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_hours = /** @type {((inputs: Agents_Limit_HoursInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_HoursInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_hours(inputs)
	return __ja.agents_limit_hours(inputs)
});
/**
* | output |
* | --- |
* | "Week · {model}" |
*
* @param {Agents_Limit_ModelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_model = /** @type {((inputs: Agents_Limit_ModelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_ModelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_model(inputs)
	return __ja.agents_limit_model(inputs)
});
/**
* | output |
* | --- |
* | "Not fetched yet" |
*
* @param {Agents_Limit_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_none = /** @type {((inputs?: Agents_Limit_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_none(inputs)
	return __ja.agents_limit_none(inputs)
});
/**
* | output |
* | --- |
* | "Fetching usage limits is turned off" |
*
* @param {Agents_Limit_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_off = /** @type {((inputs?: Agents_Limit_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_off(inputs)
	return __ja.agents_limit_off(inputs)
});
/**
* | output |
* | --- |
* | "resets {when}" |
*
* @param {Agents_Limit_ResetsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_resets = /** @type {((inputs: Agents_Limit_ResetsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_ResetsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_resets(inputs)
	return __ja.agents_limit_resets(inputs)
});
/**
* | output |
* | --- |
* | "Usage limits" |
*
* @param {Agents_Limit_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_title = /** @type {((inputs?: Agents_Limit_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_title(inputs)
	return __ja.agents_limit_title(inputs)
});
/**
* | output |
* | --- |
* | "Week" |
*
* @param {Agents_Limit_WeekInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_limit_week = /** @type {((inputs?: Agents_Limit_WeekInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Limit_WeekInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_limit_week(inputs)
	return __ja.agents_limit_week(inputs)
});
/**
* | output |
* | --- |
* | "Chats" |
*
* @param {Agents_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_list = /** @type {((inputs?: Agents_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_list(inputs)
	return __ja.agents_list(inputs)
});
/**
* | output |
* | --- |
* | "Could not load" |
*
* @param {Agents_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_load_failed = /** @type {((inputs?: Agents_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_load_failed(inputs)
	return __ja.agents_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Loading" |
*
* @param {Agents_Loading_OlderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_loading_older = /** @type {((inputs?: Agents_Loading_OlderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Loading_OlderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_loading_older(inputs)
	return __ja.agents_loading_older(inputs)
});
/**
* | output |
* | --- |
* | "The conversation up to here was compacted" |
*
* @param {Agents_Mark_CompactedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_mark_compacted = /** @type {((inputs?: Agents_Mark_CompactedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Mark_CompactedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_mark_compacted(inputs)
	return __ja.agents_mark_compacted(inputs)
});
/**
* | output |
* | --- |
* | "Mark as read" |
*
* @param {Agents_Mark_ReadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_mark_read = /** @type {((inputs?: Agents_Mark_ReadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Mark_ReadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_mark_read(inputs)
	return __ja.agents_mark_read(inputs)
});
/**
* | output |
* | --- |
* | "Rewound here" |
*
* @param {Agents_Mark_RewoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_mark_rewound = /** @type {((inputs?: Agents_Mark_RewoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Mark_RewoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_mark_rewound(inputs)
	return __ja.agents_mark_rewound(inputs)
});
/**
* | output |
* | --- |
* | "Stopped" |
*
* @param {Agents_Mark_StoppedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_mark_stopped = /** @type {((inputs?: Agents_Mark_StoppedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Mark_StoppedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_mark_stopped(inputs)
	return __ja.agents_mark_stopped(inputs)
});
/**
* | output |
* | --- |
* | "Taken back" |
*
* @param {Agents_Mark_WithdrawnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_mark_withdrawn = /** @type {((inputs?: Agents_Mark_WithdrawnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Mark_WithdrawnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_mark_withdrawn(inputs)
	return __ja.agents_mark_withdrawn(inputs)
});
/**
* | output |
* | --- |
* | "Chat menu" |
*
* @param {Agents_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_menu = /** @type {((inputs?: Agents_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_menu(inputs)
	return __ja.agents_menu(inputs)
});
/**
* | output |
* | --- |
* | "(edited)" |
*
* @param {Agents_Message_EditedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_message_edited = /** @type {((inputs?: Agents_Message_EditedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Message_EditedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_message_edited(inputs)
	return __ja.agents_message_edited(inputs)
});
/**
* | output |
* | --- |
* | "This message was removed" |
*
* @param {Agents_Message_RemovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_message_removed = /** @type {((inputs?: Agents_Message_RemovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Message_RemovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_message_removed(inputs)
	return __ja.agents_message_removed(inputs)
});
/**
* | output |
* | --- |
* | "{m}m {s}s" |
*
* @param {Agents_Minutes_SecondsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_minutes_seconds = /** @type {((inputs: Agents_Minutes_SecondsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Minutes_SecondsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_minutes_seconds(inputs)
	return __ja.agents_minutes_seconds(inputs)
});
/**
* | output |
* | --- |
* | "CLI default" |
*
* @param {Agents_Model_Cli_DefaultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_model_cli_default = /** @type {((inputs?: Agents_Model_Cli_DefaultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Model_Cli_DefaultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_model_cli_default(inputs)
	return __ja.agents_model_cli_default(inputs)
});
/**
* | output |
* | --- |
* | "Model" |
*
* @param {Agents_Model_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_model_label = /** @type {((inputs?: Agents_Model_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Model_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_model_label(inputs)
	return __ja.agents_model_label(inputs)
});
/**
* | output |
* | --- |
* | "Working directory and other MCP" |
*
* @param {Agents_More_ConditionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_more_conditions = /** @type {((inputs?: Agents_More_ConditionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_More_ConditionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_more_conditions(inputs)
	return __ja.agents_more_conditions(inputs)
});
/**
* | output |
* | --- |
* | "Agents" |
*
* @param {Agents_NavInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_nav = /** @type {((inputs?: Agents_NavInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_NavInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_nav(inputs)
	return __ja.agents_nav(inputs)
});
/**
* | output |
* | --- |
* | "New chat" |
*
* @param {Agents_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_new = /** @type {((inputs?: Agents_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_new(inputs)
	return __ja.agents_new(inputs)
});
/**
* | output |
* | --- |
* | "Write below and send; the agent on {device} answers. Pick the model and working directory under the box" |
*
* @param {Agents_New_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_new_hint = /** @type {((inputs: Agents_New_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_New_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_new_hint(inputs)
	return __ja.agents_new_hint(inputs)
});
/**
* | output |
* | --- |
* | "Still checking which of Claude Code / Codex this PC has. Wait a moment before sending" |
*
* @param {Agents_No_Agent_YetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_no_agent_yet = /** @type {((inputs?: Agents_No_Agent_YetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_No_Agent_YetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_no_agent_yet(inputs)
	return __ja.agents_no_agent_yet(inputs)
});
/**
* | output |
* | --- |
* | "No agent is registered on this PC yet" |
*
* @param {Agents_No_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_no_device = /** @type {((inputs?: Agents_No_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_No_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_no_device(inputs)
	return __ja.agents_no_device(inputs)
});
/**
* | output |
* | --- |
* | "This chat was not found" |
*
* @param {Agents_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_not_found = /** @type {((inputs?: Agents_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_not_found(inputs)
	return __ja.agents_not_found(inputs)
});
/**
* | output |
* | --- |
* | "got an answer" |
*
* @param {Agents_Notice_AnsweredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_answered = /** @type {((inputs?: Agents_Notice_AnsweredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_AnsweredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_answered(inputs)
	return __ja.agents_notice_answered(inputs)
});
/**
* | output |
* | --- |
* | "is asking: {title}" |
*
* @param {Agents_Notice_AskedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_asked = /** @type {((inputs: Agents_Notice_AskedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_AskedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_asked(inputs)
	return __ja.agents_notice_asked(inputs)
});
/**
* | output |
* | --- |
* | "finished" |
*
* @param {Agents_Notice_EndedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_ended = /** @type {((inputs?: Agents_Notice_EndedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_EndedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_ended(inputs)
	return __ja.agents_notice_ended(inputs)
});
/**
* | output |
* | --- |
* | "failed: {error}" |
*
* @param {Agents_Notice_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_failed = /** @type {((inputs: Agents_Notice_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_failed(inputs)
	return __ja.agents_notice_failed(inputs)
});
/**
* | output |
* | --- |
* | "was instructed" |
*
* @param {Agents_Notice_InstructedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_instructed = /** @type {((inputs?: Agents_Notice_InstructedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_InstructedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_instructed(inputs)
	return __ja.agents_notice_instructed(inputs)
});
/**
* | output |
* | --- |
* | "had something happen" |
*
* @param {Agents_Notice_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_other = /** @type {((inputs?: Agents_Notice_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_other(inputs)
	return __ja.agents_notice_other(inputs)
});
/**
* | output |
* | --- |
* | "item raised to you: {title}" |
*
* @param {Agents_Notice_RaisedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_raised = /** @type {((inputs: Agents_Notice_RaisedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_RaisedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_raised(inputs)
	return __ja.agents_notice_raised(inputs)
});
/**
* | output |
* | --- |
* | "was read" |
*
* @param {Agents_Notice_ReadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_read = /** @type {((inputs?: Agents_Notice_ReadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_ReadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_read(inputs)
	return __ja.agents_notice_read(inputs)
});
/**
* | output |
* | --- |
* | "was retried" |
*
* @param {Agents_Notice_RetriedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_retried = /** @type {((inputs?: Agents_Notice_RetriedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_RetriedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_retried(inputs)
	return __ja.agents_notice_retried(inputs)
});
/**
* | output |
* | --- |
* | "started" |
*
* @param {Agents_Notice_StartedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_started = /** @type {((inputs?: Agents_Notice_StartedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_StartedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_started(inputs)
	return __ja.agents_notice_started(inputs)
});
/**
* | output |
* | --- |
* | "closed the Action “{title}”" |
*
* @param {Agents_Notice_Step_ClosedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_step_closed = /** @type {((inputs: Agents_Notice_Step_ClosedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_Step_ClosedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_step_closed(inputs)
	return __ja.agents_notice_step_closed(inputs)
});
/**
* | output |
* | --- |
* | "stopped" |
*
* @param {Agents_Notice_StoppedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_stopped = /** @type {((inputs?: Agents_Notice_StoppedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_StoppedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_stopped(inputs)
	return __ja.agents_notice_stopped(inputs)
});
/**
* | output |
* | --- |
* | "added an item: {title}" |
*
* @param {Agents_Notice_Turn_AddedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notice_turn_added = /** @type {((inputs: Agents_Notice_Turn_AddedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notice_Turn_AddedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notice_turn_added(inputs)
	return __ja.agents_notice_turn_added(inputs)
});
/**
* | output |
* | --- |
* | "{n} behind the scenes" |
*
* @param {Agents_Notices_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_notices_count = /** @type {((inputs: Agents_Notices_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Notices_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_notices_count(inputs)
	return __ja.agents_notices_count(inputs)
});
/**
* | output |
* | --- |
* | "Open settings" |
*
* @param {Agents_Open_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_open_settings = /** @type {((inputs?: Agents_Open_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Open_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_open_settings(inputs)
	return __ja.agents_open_settings(inputs)
});
/**
* | output |
* | --- |
* | "Other MCPs" |
*
* @param {Agents_Other_McpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_other_mcp = /** @type {((inputs?: Agents_Other_McpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Other_McpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_other_mcp(inputs)
	return __ja.agents_other_mcp(inputs)
});
/**
* | output |
* | --- |
* | "Other" |
*
* @param {Agents_Other_Mcp_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_other_mcp_short = /** @type {((inputs?: Agents_Other_Mcp_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Other_Mcp_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_other_mcp_short(inputs)
	return __ja.agents_other_mcp_short(inputs)
});
/**
* | output |
* | --- |
* | "With other MCPs, it can reach whatever those MCPs reach, even without a working directory." |
*
* @param {Agents_Other_Mcp_WarningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_other_mcp_warning = /** @type {((inputs?: Agents_Other_Mcp_WarningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Other_Mcp_WarningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_other_mcp_warning(inputs)
	return __ja.agents_other_mcp_warning(inputs)
});
/**
* | output |
* | --- |
* | "Outline of the chat" |
*
* @param {Agents_OutlineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_outline = /** @type {((inputs?: Agents_OutlineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_OutlineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_outline(inputs)
	return __ja.agents_outline(inputs)
});
/**
* | output |
* | --- |
* | "Open the side chat" |
*
* @param {Agents_Outline_SideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_outline_side = /** @type {((inputs?: Agents_Outline_SideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Outline_SideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_outline_side(inputs)
	return __ja.agents_outline_side(inputs)
});
/**
* | output |
* | --- |
* | "Parent chat" |
*
* @param {Agents_Parent_ChatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_parent_chat = /** @type {((inputs?: Agents_Parent_ChatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Parent_ChatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_parent_chat(inputs)
	return __ja.agents_parent_chat(inputs)
});
/**
* | output |
* | --- |
* | "Agents found" |
*
* @param {Agents_Pc_AgentsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_agents = /** @type {((inputs?: Agents_Pc_AgentsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_AgentsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_agents(inputs)
	return __ja.agents_pc_agents(inputs)
});
/**
* | output |
* | --- |
* | "Logged in" |
*
* @param {Agents_Pc_Auth_OkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_auth_ok = /** @type {((inputs?: Agents_Pc_Auth_OkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Auth_OkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_auth_ok(inputs)
	return __ja.agents_pc_auth_ok(inputs)
});
/**
* | output |
* | --- |
* | "Logged in ({account})" |
*
* @param {Agents_Pc_Auth_Ok_AccountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_auth_ok_account = /** @type {((inputs: Agents_Pc_Auth_Ok_AccountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Auth_Ok_AccountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_auth_ok_account(inputs)
	return __ja.agents_pc_auth_ok_account(inputs)
});
/**
* | output |
* | --- |
* | "Not logged in" |
*
* @param {Agents_Pc_Auth_OutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_auth_out = /** @type {((inputs?: Agents_Pc_Auth_OutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Auth_OutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_auth_out(inputs)
	return __ja.agents_pc_auth_out(inputs)
});
/**
* | output |
* | --- |
* | "Could not tell whether it is logged in" |
*
* @param {Agents_Pc_Auth_UnknownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_auth_unknown = /** @type {((inputs?: Agents_Pc_Auth_UnknownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Auth_UnknownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_auth_unknown(inputs)
	return __ja.agents_pc_auth_unknown(inputs)
});
/**
* | output |
* | --- |
* | "Auto compact (%) · {agent}" |
*
* @param {Agents_Pc_CompactInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_compact = /** @type {((inputs: Agents_Pc_CompactInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_CompactInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_compact(inputs)
	return __ja.agents_pc_compact(inputs)
});
/**
* | output |
* | --- |
* | "Compact after a reply when the context reaches this share. 100 never compacts" |
*
* @param {Agents_Pc_Compact_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_compact_note = /** @type {((inputs?: Agents_Pc_Compact_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Compact_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_compact_note(inputs)
	return __ja.agents_pc_compact_note(inputs)
});
/**
* | output |
* | --- |
* | "Run chats at the same time" |
*
* @param {Agents_Pc_ConcurrencyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_concurrency = /** @type {((inputs?: Agents_Pc_ConcurrencyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_ConcurrencyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_concurrency(inputs)
	return __ja.agents_pc_concurrency(inputs)
});
/**
* | output |
* | --- |
* | "Whether chats with a working directory run at the same time or one at a time" |
*
* @param {Agents_Pc_Concurrency_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_concurrency_note = /** @type {((inputs?: Agents_Pc_Concurrency_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Concurrency_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_concurrency_note(inputs)
	return __ja.agents_pc_concurrency_note(inputs)
});
/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Agents_Pc_Default_AgentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_default_agent = /** @type {((inputs?: Agents_Pc_Default_AgentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Default_AgentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_default_agent(inputs)
	return __ja.agents_pc_default_agent(inputs)
});
/**
* | output |
* | --- |
* | "Working directory" |
*
* @param {Agents_Pc_Default_CwdInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_default_cwd = /** @type {((inputs?: Agents_Pc_Default_CwdInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Default_CwdInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_default_cwd(inputs)
	return __ja.agents_pc_default_cwd(inputs)
});
/**
* | output |
* | --- |
* | "Each chat can change it under its post box" |
*
* @param {Agents_Pc_Default_Cwd_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_default_cwd_note = /** @type {((inputs?: Agents_Pc_Default_Cwd_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Default_Cwd_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_default_cwd_note(inputs)
	return __ja.agents_pc_default_cwd_note(inputs)
});
/**
* | output |
* | --- |
* | "Model" |
*
* @param {Agents_Pc_Default_ModelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_default_model = /** @type {((inputs?: Agents_Pc_Default_ModelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Default_ModelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_default_model(inputs)
	return __ja.agents_pc_default_model(inputs)
});
/**
* | output |
* | --- |
* | "Defaults of a new chat" |
*
* @param {Agents_Pc_DefaultsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_defaults = /** @type {((inputs?: Agents_Pc_DefaultsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_DefaultsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_defaults(inputs)
	return __ja.agents_pc_defaults(inputs)
});
/**
* | output |
* | --- |
* | "Login, usage limits and working directories of Claude Code / Codex on this PC, and the defaults of a new chat" |
*
* @param {Agents_Pc_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_description = /** @type {((inputs?: Agents_Pc_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_description(inputs)
	return __ja.agents_pc_description(inputs)
});
/**
* | output |
* | --- |
* | "Log in" |
*
* @param {Agents_Pc_LoginInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login = /** @type {((inputs?: Agents_Pc_LoginInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_LoginInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login(inputs)
	return __ja.agents_pc_login(inputs)
});
/**
* | output |
* | --- |
* | "Log in again" |
*
* @param {Agents_Pc_Login_AgainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_again = /** @type {((inputs?: Agents_Pc_Login_AgainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_AgainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_again(inputs)
	return __ja.agents_pc_login_again(inputs)
});
/**
* | output |
* | --- |
* | "Login code" |
*
* @param {Agents_Pc_Login_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_code = /** @type {((inputs?: Agents_Pc_Login_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_code(inputs)
	return __ja.agents_pc_login_code(inputs)
});
/**
* | output |
* | --- |
* | "Enter this code on the page that opened. It finishes by itself" |
*
* @param {Agents_Pc_Login_Code_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_code_hint = /** @type {((inputs?: Agents_Pc_Login_Code_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_Code_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_code_hint(inputs)
	return __ja.agents_pc_login_code_hint(inputs)
});
/**
* | output |
* | --- |
* | "Could not log in: {error}" |
*
* @param {Agents_Pc_Login_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_error = /** @type {((inputs: Agents_Pc_Login_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_error(inputs)
	return __ja.agents_pc_login_error(inputs)
});
/**
* | output |
* | --- |
* | "Could not start the login" |
*
* @param {Agents_Pc_Login_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_failed = /** @type {((inputs?: Agents_Pc_Login_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_failed(inputs)
	return __ja.agents_pc_login_failed(inputs)
});
/**
* | output |
* | --- |
* | "Open the login page" |
*
* @param {Agents_Pc_Login_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_open = /** @type {((inputs?: Agents_Pc_Login_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_open(inputs)
	return __ja.agents_pc_login_open(inputs)
});
/**
* | output |
* | --- |
* | "Copy the code and open the login page" |
*
* @param {Agents_Pc_Login_Open_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_open_copy = /** @type {((inputs?: Agents_Pc_Login_Open_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_Open_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_open_copy(inputs)
	return __ja.agents_pc_login_open_copy(inputs)
});
/**
* | output |
* | --- |
* | "Log in on the page that opened and paste the code it shows here" |
*
* @param {Agents_Pc_Login_Paste_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_paste_hint = /** @type {((inputs?: Agents_Pc_Login_Paste_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_Paste_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_paste_hint(inputs)
	return __ja.agents_pc_login_paste_hint(inputs)
});
/**
* | output |
* | --- |
* | "Preparing on the PC…" |
*
* @param {Agents_Pc_Login_PreparingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_preparing = /** @type {((inputs?: Agents_Pc_Login_PreparingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_PreparingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_preparing(inputs)
	return __ja.agents_pc_login_preparing(inputs)
});
/**
* | output |
* | --- |
* | "Sent. Checking…" |
*
* @param {Agents_Pc_Login_SentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_sent = /** @type {((inputs?: Agents_Pc_Login_SentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_SentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_sent(inputs)
	return __ja.agents_pc_login_sent(inputs)
});
/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Agents_Pc_Login_VerifyingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_login_verifying = /** @type {((inputs?: Agents_Pc_Login_VerifyingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Login_VerifyingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_login_verifying(inputs)
	return __ja.agents_pc_login_verifying(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Agents_Pc_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_name = /** @type {((inputs?: Agents_Pc_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_name(inputs)
	return __ja.agents_pc_name(inputs)
});
/**
* | output |
* | --- |
* | "Other MCP" |
*
* @param {Agents_Pc_Other_McpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_other_mcp = /** @type {((inputs?: Agents_Pc_Other_McpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Other_McpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_other_mcp(inputs)
	return __ja.agents_pc_other_mcp(inputs)
});
/**
* | output |
* | --- |
* | "Use" |
*
* @param {Agents_Pc_Other_Mcp_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_other_mcp_all = /** @type {((inputs?: Agents_Pc_Other_Mcp_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Other_Mcp_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_other_mcp_all(inputs)
	return __ja.agents_pc_other_mcp_all(inputs)
});
/**
* | output |
* | --- |
* | "Don't use" |
*
* @param {Agents_Pc_Other_Mcp_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_other_mcp_none = /** @type {((inputs?: Agents_Pc_Other_Mcp_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Other_Mcp_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_other_mcp_none(inputs)
	return __ja.agents_pc_other_mcp_none(inputs)
});
/**
* | output |
* | --- |
* | "Whether chats use the other MCP servers registered on this PC" |
*
* @param {Agents_Pc_Other_Mcp_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_other_mcp_note = /** @type {((inputs?: Agents_Pc_Other_Mcp_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Other_Mcp_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_other_mcp_note(inputs)
	return __ja.agents_pc_other_mcp_note(inputs)
});
/**
* | output |
* | --- |
* | "Read only" |
*
* @param {Agents_Pc_Other_Mcp_ReadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_other_mcp_read = /** @type {((inputs?: Agents_Pc_Other_Mcp_ReadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Other_Mcp_ReadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_other_mcp_read(inputs)
	return __ja.agents_pc_other_mcp_read(inputs)
});
/**
* | output |
* | --- |
* | "Together" |
*
* @param {Agents_Pc_ParallelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_parallel = /** @type {((inputs?: Agents_Pc_ParallelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_ParallelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_parallel(inputs)
	return __ja.agents_pc_parallel(inputs)
});
/**
* | output |
* | --- |
* | "Wait before replying (s)" |
*
* @param {Agents_Pc_QuietInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_quiet = /** @type {((inputs?: Agents_Pc_QuietInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_QuietInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_quiet(inputs)
	return __ja.agents_pc_quiet(inputs)
});
/**
* | output |
* | --- |
* | "How long to wait to read posts sent in a row together" |
*
* @param {Agents_Pc_Quiet_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_quiet_note = /** @type {((inputs?: Agents_Pc_Quiet_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Quiet_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_quiet_note(inputs)
	return __ja.agents_pc_quiet_note(inputs)
});
/**
* | output |
* | --- |
* | "One at a time" |
*
* @param {Agents_Pc_SerialInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_serial = /** @type {((inputs?: Agents_Pc_SerialInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_SerialInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_serial(inputs)
	return __ja.agents_pc_serial(inputs)
});
/**
* | output |
* | --- |
* | "Agents on this PC" |
*
* @param {Agents_Pc_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_title = /** @type {((inputs?: Agents_Pc_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_title(inputs)
	return __ja.agents_pc_title(inputs)
});
/**
* | output |
* | --- |
* | "Fetch usage limits" |
*
* @param {Agents_Pc_Usage_LimitsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_usage_limits = /** @type {((inputs?: Agents_Pc_Usage_LimitsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Usage_LimitsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_usage_limits(inputs)
	return __ja.agents_pc_usage_limits(inputs)
});
/**
* | output |
* | --- |
* | "Asks Anthropic (with Claude Code's sign-in) and Codex how much of each usage window is left. Off: nothing is fetched and no usage is shown" |
*
* @param {Agents_Pc_Usage_Limits_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_usage_limits_note = /** @type {((inputs?: Agents_Pc_Usage_Limits_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Usage_Limits_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_usage_limits_note(inputs)
	return __ja.agents_pc_usage_limits_note(inputs)
});
/**
* | output |
* | --- |
* | "Working directories" |
*
* @param {Agents_Pc_WorkdirsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_workdirs = /** @type {((inputs?: Agents_Pc_WorkdirsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_WorkdirsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_workdirs(inputs)
	return __ja.agents_pc_workdirs(inputs)
});
/**
* | output |
* | --- |
* | "None yet" |
*
* @param {Agents_Pc_Workdirs_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_workdirs_none = /** @type {((inputs?: Agents_Pc_Workdirs_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Workdirs_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_workdirs_none(inputs)
	return __ja.agents_pc_workdirs_none(inputs)
});
/**
* | output |
* | --- |
* | "Places the agent on this PC reported it may use. They cannot be added here" |
*
* @param {Agents_Pc_Workdirs_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pc_workdirs_note = /** @type {((inputs?: Agents_Pc_Workdirs_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pc_Workdirs_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pc_workdirs_note(inputs)
	return __ja.agents_pc_workdirs_note(inputs)
});
/**
* | output |
* | --- |
* | "Read after this reply" |
*
* @param {Agents_Pending_AfterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pending_after = /** @type {((inputs?: Agents_Pending_AfterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pending_AfterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pending_after(inputs)
	return __ja.agents_pending_after(inputs)
});
/**
* | output |
* | --- |
* | "Read at the next break" |
*
* @param {Agents_Pending_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pending_next = /** @type {((inputs?: Agents_Pending_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pending_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pending_next(inputs)
	return __ja.agents_pending_next(inputs)
});
/**
* | output |
* | --- |
* | "Having it read now…" |
*
* @param {Agents_Pending_Reading_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pending_reading_now = /** @type {((inputs?: Agents_Pending_Reading_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pending_Reading_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pending_reading_now(inputs)
	return __ja.agents_pending_reading_now(inputs)
});
/**
* | output |
* | --- |
* | "Taking back…" |
*
* @param {Agents_Pending_WithdrawingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_pending_withdrawing = /** @type {((inputs?: Agents_Pending_WithdrawingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Pending_WithdrawingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_pending_withdrawing(inputs)
	return __ja.agents_pending_withdrawing(inputs)
});
/**
* | output |
* | --- |
* | "Message to the agent" |
*
* @param {Agents_Post_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_post_label = /** @type {((inputs?: Agents_Post_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Post_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_post_label(inputs)
	return __ja.agents_post_label(inputs)
});
/**
* | output |
* | --- |
* | "Message" |
*
* @param {Agents_Post_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_post_placeholder = /** @type {((inputs?: Agents_Post_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Post_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_post_placeholder(inputs)
	return __ja.agents_post_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "You can keep sending instructions" |
*
* @param {Agents_Post_Placeholder_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_post_placeholder_running = /** @type {((inputs?: Agents_Post_Placeholder_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Post_Placeholder_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_post_placeholder_running(inputs)
	return __ja.agents_post_placeholder_running(inputs)
});
/**
* | output |
* | --- |
* | "Instructions cannot be sent from a browser. Send them from the trameria app." |
*
* @param {Agents_Reach_No_SignerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_reach_no_signer = /** @type {((inputs?: Agents_Reach_No_SignerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Reach_No_SignerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_reach_no_signer(inputs)
	return __ja.agents_reach_no_signer(inputs)
});
/**
* | output |
* | --- |
* | "To send instructions to {device}, add {self} to {device}'s device list." |
*
* @param {Agents_Reach_Not_TrustedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_reach_not_trusted = /** @type {((inputs: Agents_Reach_Not_TrustedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Reach_Not_TrustedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_reach_not_trusted(inputs)
	return __ja.agents_reach_not_trusted(inputs)
});
/**
* | output |
* | --- |
* | "To send instructions to {device}, add the device you are using to {device}'s device list." |
*
* @param {Agents_Reach_Not_Trusted_UnnamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_reach_not_trusted_unnamed = /** @type {((inputs: Agents_Reach_Not_Trusted_UnnamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Reach_Not_Trusted_UnnamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_reach_not_trusted_unnamed(inputs)
	return __ja.agents_reach_not_trusted_unnamed(inputs)
});
/**
* | output |
* | --- |
* | "From {self}, instructions can be sent to {self}'s own Agent only. To send to {device}, use the trameria app on a phone or a mac." |
*
* @param {Agents_Reach_Own_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_reach_own_only = /** @type {((inputs: Agents_Reach_Own_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Reach_Own_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_reach_own_only(inputs)
	return __ja.agents_reach_own_only(inputs)
});
/**
* | output |
* | --- |
* | "{device} can be used from its own app only. This can be changed in {device}'s app settings." |
*
* @param {Agents_Reach_Self_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_reach_self_only = /** @type {((inputs: Agents_Reach_Self_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Reach_Self_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_reach_self_only(inputs)
	return __ja.agents_reach_self_only(inputs)
});
/**
* | output |
* | --- |
* | "Read now" |
*
* @param {Agents_Read_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_read_now = /** @type {((inputs?: Agents_Read_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Read_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_read_now(inputs)
	return __ja.agents_read_now(inputs)
});
/**
* | output |
* | --- |
* | "Related objects" |
*
* @param {Agents_Related_ChangedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_related_changed = /** @type {((inputs?: Agents_Related_ChangedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Related_ChangedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_related_changed(inputs)
	return __ja.agents_related_changed(inputs)
});
/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Agents_RenameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rename = /** @type {((inputs?: Agents_RenameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_RenameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rename(inputs)
	return __ja.agents_rename(inputs)
});
/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Agents_Rename_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rename_action = /** @type {((inputs?: Agents_Rename_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rename_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rename_action(inputs)
	return __ja.agents_rename_action(inputs)
});
/**
* | output |
* | --- |
* | "Could not do it" |
*
* @param {Agents_Request_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_request_failed = /** @type {((inputs?: Agents_Request_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Request_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_request_failed(inputs)
	return __ja.agents_request_failed(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Agents_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_retry = /** @type {((inputs?: Agents_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_retry(inputs)
	return __ja.agents_retry(inputs)
});
/**
* | output |
* | --- |
* | "Go back" |
*
* @param {Agents_Rewind_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_action = /** @type {((inputs?: Agents_Rewind_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_action(inputs)
	return __ja.agents_rewind_action(inputs)
});
/**
* | output |
* | --- |
* | "Checking…" |
*
* @param {Agents_Rewind_CheckingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_checking = /** @type {((inputs?: Agents_Rewind_CheckingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_CheckingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_checking(inputs)
	return __ja.agents_rewind_checking(inputs)
});
/**
* | output |
* | --- |
* | "Conversation" |
*
* @param {Agents_Rewind_ConversationInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_conversation = /** @type {((inputs?: Agents_Rewind_ConversationInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_ConversationInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_conversation(inputs)
	return __ja.agents_rewind_conversation(inputs)
});
/**
* | output |
* | --- |
* | "Removes this post and the {n} after it, and puts this post back in the box" |
*
* @param {Agents_Rewind_Conversation_NInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_conversation_n = /** @type {((inputs: Agents_Rewind_Conversation_NInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Conversation_NInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_conversation_n(inputs)
	return __ja.agents_rewind_conversation_n(inputs)
});
/**
* | output |
* | --- |
* | "Removes this post and puts it back in the box" |
*
* @param {Agents_Rewind_Conversation_OneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_conversation_one = /** @type {((inputs?: Agents_Rewind_Conversation_OneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Conversation_OneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_conversation_one(inputs)
	return __ja.agents_rewind_conversation_one(inputs)
});
/**
* | output |
* | --- |
* | "Could not go back" |
*
* @param {Agents_Rewind_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_failed = /** @type {((inputs?: Agents_Rewind_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_failed(inputs)
	return __ja.agents_rewind_failed(inputs)
});
/**
* | output |
* | --- |
* | "Files on this PC" |
*
* @param {Agents_Rewind_FilesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_files = /** @type {((inputs?: Agents_Rewind_FilesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_FilesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_files(inputs)
	return __ja.agents_rewind_files(inputs)
});
/**
* | output |
* | --- |
* | "Files changed by Bash and the like do not go back" |
*
* @param {Agents_Rewind_Files_BashInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_files_bash = /** @type {((inputs?: Agents_Rewind_Files_BashInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Files_BashInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_files_bash(inputs)
	return __ja.agents_rewind_files_bash(inputs)
});
/**
* | output |
* | --- |
* | "Files cannot go back in a Codex chat" |
*
* @param {Agents_Rewind_Files_CodexInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_files_codex = /** @type {((inputs?: Agents_Rewind_Files_CodexInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Files_CodexInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_files_codex(inputs)
	return __ja.agents_rewind_files_codex(inputs)
});
/**
* | output |
* | --- |
* | "Puts {n} files back as they were" |
*
* @param {Agents_Rewind_Files_NInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_files_n = /** @type {((inputs: Agents_Rewind_Files_NInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Files_NInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_files_n(inputs)
	return __ja.agents_rewind_files_n(inputs)
});
/**
* | output |
* | --- |
* | "No files to put back" |
*
* @param {Agents_Rewind_Files_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_files_none = /** @type {((inputs?: Agents_Rewind_Files_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Files_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_files_none(inputs)
	return __ja.agents_rewind_files_none(inputs)
});
/**
* | output |
* | --- |
* | "No checkpoint of the files, so they cannot go back" |
*
* @param {Agents_Rewind_Files_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_files_off = /** @type {((inputs?: Agents_Rewind_Files_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Files_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_files_off(inputs)
	return __ja.agents_rewind_files_off(inputs)
});
/**
* | output |
* | --- |
* | "Go back to here" |
*
* @param {Agents_Rewind_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_here = /** @type {((inputs?: Agents_Rewind_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_here(inputs)
	return __ja.agents_rewind_here(inputs)
});
/**
* | output |
* | --- |
* | "{n} more" |
*
* @param {Agents_Rewind_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_more = /** @type {((inputs: Agents_Rewind_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_more(inputs)
	return __ja.agents_rewind_more(inputs)
});
/**
* | output |
* | --- |
* | "Go back to before this post" |
*
* @param {Agents_Rewind_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_title = /** @type {((inputs?: Agents_Rewind_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_title(inputs)
	return __ja.agents_rewind_title(inputs)
});
/**
* | output |
* | --- |
* | "trameria" |
*
* @param {Agents_Rewind_TrameriaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_trameria = /** @type {((inputs?: Agents_Rewind_TrameriaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_TrameriaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_trameria(inputs)
	return __ja.agents_rewind_trameria(inputs)
});
/**
* | output |
* | --- |
* | "Undoes the agent's changes after this post ({n})" |
*
* @param {Agents_Rewind_Trameria_NInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_trameria_n = /** @type {((inputs: Agents_Rewind_Trameria_NInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Trameria_NInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_trameria_n(inputs)
	return __ja.agents_rewind_trameria_n(inputs)
});
/**
* | output |
* | --- |
* | "No changes to undo" |
*
* @param {Agents_Rewind_Trameria_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_rewind_trameria_none = /** @type {((inputs?: Agents_Rewind_Trameria_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Rewind_Trameria_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_rewind_trameria_none(inputs)
	return __ja.agents_rewind_trameria_none(inputs)
});
/**
* | output |
* | --- |
* | "Has a question" |
*
* @param {Agents_Row_AskingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_row_asking = /** @type {((inputs?: Agents_Row_AskingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Row_AskingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_row_asking(inputs)
	return __ja.agents_row_asking(inputs)
});
/**
* | output |
* | --- |
* | "Delegated to a child" |
*
* @param {Agents_Row_DelegatingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_row_delegating = /** @type {((inputs?: Agents_Row_DelegatingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Row_DelegatingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_row_delegating(inputs)
	return __ja.agents_row_delegating(inputs)
});
/**
* | output |
* | --- |
* | "Waiting its turn" |
*
* @param {Agents_Row_QueuedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_row_queued = /** @type {((inputs?: Agents_Row_QueuedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Row_QueuedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_row_queued(inputs)
	return __ja.agents_row_queued(inputs)
});
/**
* | output |
* | --- |
* | "Unread" |
*
* @param {Agents_Row_UnreadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_row_unread = /** @type {((inputs?: Agents_Row_UnreadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Row_UnreadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_row_unread(inputs)
	return __ja.agents_row_unread(inputs)
});
/**
* | output |
* | --- |
* | "Working" |
*
* @param {Agents_Row_WorkingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_row_working = /** @type {((inputs?: Agents_Row_WorkingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Row_WorkingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_row_working(inputs)
	return __ja.agents_row_working(inputs)
});
/**
* | output |
* | --- |
* | "Could not save" |
*
* @param {Agents_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_save_failed = /** @type {((inputs?: Agents_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_save_failed(inputs)
	return __ja.agents_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "{n}s" |
*
* @param {Agents_SecondsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_seconds = /** @type {((inputs: Agents_SecondsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_SecondsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_seconds(inputs)
	return __ja.agents_seconds(inputs)
});
/**
* | output |
* | --- |
* | "Send" |
*
* @param {Agents_SendInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_send = /** @type {((inputs?: Agents_SendInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_SendInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_send(inputs)
	return __ja.agents_send(inputs)
});
/**
* | output |
* | --- |
* | "Could not send (your text is back in the box)" |
*
* @param {Agents_Send_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_send_failed = /** @type {((inputs?: Agents_Send_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Send_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_send_failed(inputs)
	return __ja.agents_send_failed(inputs)
});
/**
* | output |
* | --- |
* | "Send (Enter). Shift+Enter for a new line" |
*
* @param {Agents_Send_Hint_EnterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_send_hint_enter = /** @type {((inputs?: Agents_Send_Hint_EnterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Send_Hint_EnterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_send_hint_enter(inputs)
	return __ja.agents_send_hint_enter(inputs)
});
/**
* | output |
* | --- |
* | "Send ({mod}+Enter). Enter for a new line" |
*
* @param {Agents_Send_Hint_ModInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_send_hint_mod = /** @type {((inputs: Agents_Send_Hint_ModInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Send_Hint_ModInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_send_hint_mod(inputs)
	return __ja.agents_send_hint_mod(inputs)
});
/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Agents_SendingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_sending = /** @type {((inputs?: Agents_SendingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_SendingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_sending(inputs)
	return __ja.agents_sending(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Agents_Side_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_close = /** @type {((inputs?: Agents_Side_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_close(inputs)
	return __ja.agents_side_close(inputs)
});
/**
* | output |
* | --- |
* | "Write in the side chat…" |
*
* @param {Agents_Side_Composer_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_composer_placeholder = /** @type {((inputs?: Agents_Side_Composer_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_Composer_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_composer_placeholder(inputs)
	return __ja.agents_side_composer_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Branched off a message of the main chat" |
*
* @param {Agents_Side_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_from = /** @type {((inputs?: Agents_Side_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_from(inputs)
	return __ja.agents_side_from(inputs)
});
/**
* | output |
* | --- |
* | "Side chat" |
*
* @param {Agents_Side_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_label = /** @type {((inputs?: Agents_Side_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_label(inputs)
	return __ja.agents_side_label(inputs)
});
/**
* | output |
* | --- |
* | "Branching off this reply" |
*
* @param {Agents_Side_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_new = /** @type {((inputs?: Agents_Side_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_new(inputs)
	return __ja.agents_side_new(inputs)
});
/**
* | output |
* | --- |
* | "Open the side chat “{title}”" |
*
* @param {Agents_Side_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_open = /** @type {((inputs: Agents_Side_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_open(inputs)
	return __ja.agents_side_open(inputs)
});
/**
* | output |
* | --- |
* | "Open as a page" |
*
* @param {Agents_Side_Open_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_open_page = /** @type {((inputs?: Agents_Side_Open_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_Open_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_open_page(inputs)
	return __ja.agents_side_open_page(inputs)
});
/**
* | output |
* | --- |
* | "Ask something apart from the main chat…" |
*
* @param {Agents_Side_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_placeholder = /** @type {((inputs?: Agents_Side_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_placeholder(inputs)
	return __ja.agents_side_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "The reply of the main chat is not loaded" |
*
* @param {Agents_Side_Reply_GoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_reply_gone = /** @type {((inputs?: Agents_Side_Reply_GoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_Reply_GoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_reply_gone(inputs)
	return __ja.agents_side_reply_gone(inputs)
});
/**
* | output |
* | --- |
* | "Open side chat" |
*
* @param {Agents_Side_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_side_start = /** @type {((inputs?: Agents_Side_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Side_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_side_start(inputs)
	return __ja.agents_side_start(inputs)
});
/**
* | output |
* | --- |
* | "Asked to place a Slack draft" |
*
* @param {Agents_Signal_Slack_DraftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_signal_slack_draft = /** @type {((inputs?: Agents_Signal_Slack_DraftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Signal_Slack_DraftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_signal_slack_draft(inputs)
	return __ja.agents_signal_slack_draft(inputs)
});
/**
* | output |
* | --- |
* | "{steps} of “{caseTitle}” became current" |
*
* @param {Agents_Signal_Step_ReadyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_signal_step_ready = /** @type {((inputs: Agents_Signal_Step_ReadyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Signal_Step_ReadyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_signal_step_ready(inputs)
	return __ja.agents_signal_step_ready(inputs)
});
/**
* | output |
* | --- |
* | "A child chat's item was still not handled, so it was sent again" |
*
* @param {Agents_Signal_Turn_AwaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_signal_turn_awaiting = /** @type {((inputs?: Agents_Signal_Turn_AwaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Signal_Turn_AwaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_signal_turn_awaiting(inputs)
	return __ja.agents_signal_turn_awaiting(inputs)
});
/**
* | output |
* | --- |
* | "A your-turn item was declined" |
*
* @param {Agents_Signal_Turn_DeclinedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_signal_turn_declined = /** @type {((inputs?: Agents_Signal_Turn_DeclinedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Signal_Turn_DeclinedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_signal_turn_declined(inputs)
	return __ja.agents_signal_turn_declined(inputs)
});
/**
* | output |
* | --- |
* | "The parent chat withdrew a your-turn item" |
*
* @param {Agents_Signal_Turn_WithdrawnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_signal_turn_withdrawn = /** @type {((inputs?: Agents_Signal_Turn_WithdrawnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Signal_Turn_WithdrawnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_signal_turn_withdrawn(inputs)
	return __ja.agents_signal_turn_withdrawn(inputs)
});
/**
* | output |
* | --- |
* | "“{title}”, waited on in “{caseTitle}”, changed" |
*
* @param {Agents_Signal_Wait_TargetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_signal_wait_target = /** @type {((inputs: Agents_Signal_Wait_TargetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Signal_Wait_TargetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_signal_wait_target(inputs)
	return __ja.agents_signal_wait_target(inputs)
});
/**
* | output |
* | --- |
* | "(a user who left)" |
*
* @param {Agents_SomeoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_someone = /** @type {((inputs?: Agents_SomeoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_SomeoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_someone(inputs)
	return __ja.agents_someone(inputs)
});
/**
* | output |
* | --- |
* | "Start a chat" |
*
* @param {Agents_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_start = /** @type {((inputs?: Agents_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_start(inputs)
	return __ja.agents_start(inputs)
});
/**
* | output |
* | --- |
* | "Compacting the conversation so far" |
*
* @param {Agents_Status_CompactingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_status_compacting = /** @type {((inputs?: Agents_Status_CompactingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Status_CompactingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_status_compacting(inputs)
	return __ja.agents_status_compacting(inputs)
});
/**
* | output |
* | --- |
* | "Waiting to be read" |
*
* @param {Agents_Status_StartingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_status_starting = /** @type {((inputs?: Agents_Status_StartingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Status_StartingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_status_starting(inputs)
	return __ja.agents_status_starting(inputs)
});
/**
* | output |
* | --- |
* | "Stopping…" |
*
* @param {Agents_Status_StoppingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_status_stopping = /** @type {((inputs?: Agents_Status_StoppingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Status_StoppingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_status_stopping(inputs)
	return __ja.agents_status_stopping(inputs)
});
/**
* | output |
* | --- |
* | "Thinking" |
*
* @param {Agents_Status_ThinkingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_status_thinking = /** @type {((inputs?: Agents_Status_ThinkingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Status_ThinkingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_status_thinking(inputs)
	return __ja.agents_status_thinking(inputs)
});
/**
* | output |
* | --- |
* | "Waiting its turn (another chat is writing)" |
*
* @param {Agents_Status_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_status_waiting = /** @type {((inputs?: Agents_Status_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Status_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_status_waiting(inputs)
	return __ja.agents_status_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Writing" |
*
* @param {Agents_Status_WritingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_status_writing = /** @type {((inputs?: Agents_Status_WritingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Status_WritingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_status_writing(inputs)
	return __ja.agents_status_writing(inputs)
});
/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Agents_StopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_stop = /** @type {((inputs?: Agents_StopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_StopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_stop(inputs)
	return __ja.agents_stop(inputs)
});
/**
* | output |
* | --- |
* | "Could not stop" |
*
* @param {Agents_Stop_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_stop_failed = /** @type {((inputs?: Agents_Stop_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Stop_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_stop_failed(inputs)
	return __ja.agents_stop_failed(inputs)
});
/**
* | output |
* | --- |
* | "Looking…" |
*
* @param {Agents_Suggest_LoadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_suggest_loading = /** @type {((inputs?: Agents_Suggest_LoadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Suggest_LoadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_suggest_loading(inputs)
	return __ja.agents_suggest_loading(inputs)
});
/**
* | output |
* | --- |
* | "Click to take it back into the input field" |
*
* @param {Agents_Tap_To_WithdrawInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_tap_to_withdraw = /** @type {((inputs?: Agents_Tap_To_WithdrawInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Tap_To_WithdrawInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_tap_to_withdraw(inputs)
	return __ja.agents_tap_to_withdraw(inputs)
});
/**
* | output |
* | --- |
* | "This PC" |
*
* @param {Agents_This_Pc_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_this_pc_name = /** @type {((inputs?: Agents_This_Pc_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_This_Pc_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_this_pc_name(inputs)
	return __ja.agents_this_pc_name(inputs)
});
/**
* | output |
* | --- |
* | "{from}–{to}" |
*
* @param {Agents_Time_RangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_time_range = /** @type {((inputs: Agents_Time_RangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Time_RangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_time_range(inputs)
	return __ja.agents_time_range(inputs)
});
/**
* | output |
* | --- |
* | "Agents" |
*
* @param {Agents_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_title = /** @type {((inputs?: Agents_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_title(inputs)
	return __ja.agents_title(inputs)
});
/**
* | output |
* | --- |
* | "Chat name" |
*
* @param {Agents_Title_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_title_label = /** @type {((inputs?: Agents_Title_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Title_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_title_label(inputs)
	return __ja.agents_title_label(inputs)
});
/**
* | output |
* | --- |
* | "Enter a name" |
*
* @param {Agents_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_title_placeholder = /** @type {((inputs?: Agents_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_title_placeholder(inputs)
	return __ja.agents_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Go to latest" |
*
* @param {Agents_To_EndInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_to_end = /** @type {((inputs?: Agents_To_EndInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_To_EndInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_to_end(inputs)
	return __ja.agents_to_end(inputs)
});
/**
* | output |
* | --- |
* | "Next" |
*
* @param {Agents_Turn_AfterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_after = /** @type {((inputs?: Agents_Turn_AfterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_AfterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_after(inputs)
	return __ja.agents_turn_after(inputs)
});
/**
* | output |
* | --- |
* | "Answer" |
*
* @param {Agents_Turn_AnswerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_answer = /** @type {((inputs?: Agents_Turn_AnswerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_AnswerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_answer(inputs)
	return __ja.agents_turn_answer(inputs)
});
/**
* | output |
* | --- |
* | "Could not send" |
*
* @param {Agents_Turn_Answer_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_answer_failed = /** @type {((inputs?: Agents_Turn_Answer_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Answer_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_answer_failed(inputs)
	return __ja.agents_turn_answer_failed(inputs)
});
/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Agents_Turn_BeforeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_before = /** @type {((inputs?: Agents_Turn_BeforeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_BeforeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_before(inputs)
	return __ja.agents_turn_before(inputs)
});
/**
* | output |
* | --- |
* | "This cannot be answered in a browser. Answer it in the trameria app." |
*
* @param {Agents_Turn_Browser_Read_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_browser_read_only = /** @type {((inputs?: Agents_Turn_Browser_Read_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Browser_Read_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_browser_read_only(inputs)
	return __ja.agents_turn_browser_read_only(inputs)
});
/**
* | output |
* | --- |
* | "you allowed it" |
*
* @param {Agents_Turn_Cause_ApprovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_cause_approved = /** @type {((inputs?: Agents_Turn_Cause_ApprovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Cause_ApprovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_cause_approved(inputs)
	return __ja.agents_turn_cause_approved(inputs)
});
/**
* | output |
* | --- |
* | "after talking" |
*
* @param {Agents_Turn_Cause_ConversationInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_cause_conversation = /** @type {((inputs?: Agents_Turn_Cause_ConversationInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Cause_ConversationInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_cause_conversation(inputs)
	return __ja.agents_turn_cause_conversation(inputs)
});
/**
* | output |
* | --- |
* | "edited by you" |
*
* @param {Agents_Turn_Cause_HumanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_cause_human = /** @type {((inputs?: Agents_Turn_Cause_HumanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Cause_HumanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_cause_human(inputs)
	return __ja.agents_turn_cause_human(inputs)
});
/**
* | output |
* | --- |
* | "The content changed. Read the new content before answering" |
*
* @param {Agents_Turn_ChangedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_changed = /** @type {((inputs?: Agents_Turn_ChangedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_ChangedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_changed(inputs)
	return __ja.agents_turn_changed(inputs)
});
/**
* | output |
* | --- |
* | "Comment (for NG, what needs fixing; you can paste images)" |
*
* @param {Agents_Turn_Check_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_check_placeholder = /** @type {((inputs?: Agents_Turn_Check_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Check_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_check_placeholder(inputs)
	return __ja.agents_turn_check_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Comment or other answer (you can paste images)" |
*
* @param {Agents_Turn_Choice_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_choice_placeholder = /** @type {((inputs?: Agents_Turn_Choice_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Choice_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_choice_placeholder(inputs)
	return __ja.agents_turn_choice_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Chosen" |
*
* @param {Agents_Turn_ChosenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_chosen = /** @type {((inputs?: Agents_Turn_ChosenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_ChosenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_chosen(inputs)
	return __ja.agents_turn_chosen(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Agents_Turn_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_close = /** @type {((inputs?: Agents_Turn_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_close(inputs)
	return __ja.agents_turn_close(inputs)
});
/**
* | output |
* | --- |
* | "This item was already closed" |
*
* @param {Agents_Turn_Closed_AlreadyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_closed_already = /** @type {((inputs?: Agents_Turn_Closed_AlreadyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Closed_AlreadyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_closed_already(inputs)
	return __ja.agents_turn_closed_already(inputs)
});
/**
* | output |
* | --- |
* | "Comment" |
*
* @param {Agents_Turn_CommentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_comment = /** @type {((inputs?: Agents_Turn_CommentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_CommentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_comment(inputs)
	return __ja.agents_turn_comment(inputs)
});
/**
* | output |
* | --- |
* | "Comment (optional, you can paste images)" |
*
* @param {Agents_Turn_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_comment_placeholder = /** @type {((inputs?: Agents_Turn_Comment_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Comment_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_comment_placeholder(inputs)
	return __ja.agents_turn_comment_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Your turn: {count}" |
*
* @param {Agents_Turn_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_count = /** @type {((inputs: Agents_Turn_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_count(inputs)
	return __ja.agents_turn_count(inputs)
});
/**
* | output |
* | --- |
* | "Current content (above)" |
*
* @param {Agents_Turn_Current_AboveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_current_above = /** @type {((inputs?: Agents_Turn_Current_AboveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Current_AboveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_current_above(inputs)
	return __ja.agents_turn_current_above(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Agents_Turn_Date_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_date_clear = /** @type {((inputs?: Agents_Turn_Date_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Date_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_date_clear(inputs)
	return __ja.agents_turn_date_clear(inputs)
});
/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Agents_Turn_Date_PickInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_date_pick = /** @type {((inputs?: Agents_Turn_Date_PickInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Date_PickInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_date_pick(inputs)
	return __ja.agents_turn_date_pick(inputs)
});
/**
* | output |
* | --- |
* | "Edited by you" |
*
* @param {Agents_Turn_Edited_By_YouInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_edited_by_you = /** @type {((inputs?: Agents_Turn_Edited_By_YouInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Edited_By_YouInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_edited_by_you(inputs)
	return __ja.agents_turn_edited_by_you(inputs)
});
/**
* | output |
* | --- |
* | "Fold" |
*
* @param {Agents_Turn_FoldInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_fold = /** @type {((inputs?: Agents_Turn_FoldInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_FoldInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_fold(inputs)
	return __ja.agents_turn_fold(inputs)
});
/**
* | output |
* | --- |
* | "Comment, or what the fields do not cover (you can paste images)" |
*
* @param {Agents_Turn_Form_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_form_placeholder = /** @type {((inputs?: Agents_Turn_Form_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Form_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_form_placeholder(inputs)
	return __ja.agents_turn_form_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "From “{name}”" |
*
* @param {Agents_Turn_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_from = /** @type {((inputs: Agents_Turn_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_from(inputs)
	return __ja.agents_turn_from(inputs)
});
/**
* | output |
* | --- |
* | "Hand over" |
*
* @param {Agents_Turn_Hand_OverInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_hand_over = /** @type {((inputs?: Agents_Turn_Hand_OverInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Hand_OverInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_hand_over(inputs)
	return __ja.agents_turn_hand_over(inputs)
});
/**
* | output |
* | --- |
* | "Held by “{name}”" |
*
* @param {Agents_Turn_Held_ByInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_held_by = /** @type {((inputs: Agents_Turn_Held_ByInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Held_ByInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_held_by(inputs)
	return __ja.agents_turn_held_by(inputs)
});
/**
* | output |
* | --- |
* | "Revision history (oldest first)" |
*
* @param {Agents_Turn_HistoryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_history = /** @type {((inputs?: Agents_Turn_HistoryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_HistoryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_history(inputs)
	return __ja.agents_turn_history(inputs)
});
/**
* | output |
* | --- |
* | "Please check" |
*
* @param {Agents_Turn_Kind_CheckInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_kind_check = /** @type {((inputs?: Agents_Turn_Kind_CheckInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Kind_CheckInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_kind_check(inputs)
	return __ja.agents_turn_kind_check(inputs)
});
/**
* | output |
* | --- |
* | "Text to send by email" |
*
* @param {Agents_Turn_Kind_Draft_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_kind_draft_email = /** @type {((inputs?: Agents_Turn_Kind_Draft_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Kind_Draft_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_kind_draft_email(inputs)
	return __ja.agents_turn_kind_draft_email(inputs)
});
/**
* | output |
* | --- |
* | "Text to send on Slack" |
*
* @param {Agents_Turn_Kind_Draft_SlackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_kind_draft_slack = /** @type {((inputs?: Agents_Turn_Kind_Draft_SlackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Kind_Draft_SlackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_kind_draft_slack(inputs)
	return __ja.agents_turn_kind_draft_slack(inputs)
});
/**
* | output |
* | --- |
* | "Action request" |
*
* @param {Agents_Turn_Kind_OperateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_kind_operate = /** @type {((inputs?: Agents_Turn_Kind_OperateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Kind_OperateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_kind_operate(inputs)
	return __ja.agents_turn_kind_operate(inputs)
});
/**
* | output |
* | --- |
* | "File request" |
*
* @param {Agents_Turn_Kind_ProvideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_kind_provide = /** @type {((inputs?: Agents_Turn_Kind_ProvideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Kind_ProvideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_kind_provide(inputs)
	return __ja.agents_turn_kind_provide(inputs)
});
/**
* | output |
* | --- |
* | "Your turn" |
*
* @param {Agents_Turn_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_label = /** @type {((inputs?: Agents_Turn_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_label(inputs)
	return __ja.agents_turn_label(inputs)
});
/**
* | output |
* | --- |
* | "Done: {title}" |
*
* @param {Agents_Turn_Line_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_line_done = /** @type {((inputs: Agents_Turn_Line_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Line_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_line_done(inputs)
	return __ja.agents_turn_line_done(inputs)
});
/**
* | output |
* | --- |
* | "Withdrawn: {title}" |
*
* @param {Agents_Turn_Line_WithdrawnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_line_withdrawn = /** @type {((inputs: Agents_Turn_Line_WithdrawnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Line_WithdrawnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_line_withdrawn(inputs)
	return __ja.agents_turn_line_withdrawn(inputs)
});
/**
* | output |
* | --- |
* | "Places to look at" |
*
* @param {Agents_Turn_LinksInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_links = /** @type {((inputs?: Agents_Turn_LinksInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_LinksInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_links(inputs)
	return __ja.agents_turn_links(inputs)
});
/**
* | output |
* | --- |
* | "Select all that apply" |
*
* @param {Agents_Turn_MultiInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_multi = /** @type {((inputs?: Agents_Turn_MultiInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_MultiInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_multi(inputs)
	return __ja.agents_turn_multi(inputs)
});
/**
* | output |
* | --- |
* | "Write what should be fixed" |
*
* @param {Agents_Turn_Need_FixInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_need_fix = /** @type {((inputs?: Agents_Turn_Need_FixInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Need_FixInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_need_fix(inputs)
	return __ja.agents_turn_need_fix(inputs)
});
/**
* | output |
* | --- |
* | "Write why it could not be done" |
*
* @param {Agents_Turn_Need_ReasonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_need_reason = /** @type {((inputs?: Agents_Turn_Need_ReasonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Need_ReasonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_need_reason(inputs)
	return __ja.agents_turn_need_reason(inputs)
});
/**
* | output |
* | --- |
* | "No" |
*
* @param {Agents_Turn_NoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_no = /** @type {((inputs?: Agents_Turn_NoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_NoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_no(inputs)
	return __ja.agents_turn_no(inputs)
});
/**
* | output |
* | --- |
* | "Comment (for a problem, what went wrong; you can paste images)" |
*
* @param {Agents_Turn_Operate_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_operate_placeholder = /** @type {((inputs?: Agents_Turn_Operate_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Operate_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_operate_placeholder(inputs)
	return __ja.agents_turn_operate_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "{at}/{count}" |
*
* @param {Agents_Turn_PlaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_place = /** @type {((inputs: Agents_Turn_PlaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_PlaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_place(inputs)
	return __ja.agents_turn_place(inputs)
});
/**
* | output |
* | --- |
* | "Wants to change this" |
*
* @param {Agents_Turn_ProposalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_proposal = /** @type {((inputs?: Agents_Turn_ProposalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_ProposalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_proposal(inputs)
	return __ja.agents_turn_proposal(inputs)
});
/**
* | output |
* | --- |
* | "Allow the change" |
*
* @param {Agents_Turn_Proposal_AcceptInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_proposal_accept = /** @type {((inputs?: Agents_Turn_Proposal_AcceptInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Proposal_AcceptInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_proposal_accept(inputs)
	return __ja.agents_turn_proposal_accept(inputs)
});
/**
* | output |
* | --- |
* | "See the current content" |
*
* @param {Agents_Turn_Proposal_CurrentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_proposal_current = /** @type {((inputs?: Agents_Turn_Proposal_CurrentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Proposal_CurrentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_proposal_current(inputs)
	return __ja.agents_turn_proposal_current(inputs)
});
/**
* | output |
* | --- |
* | "Keep it as is" |
*
* @param {Agents_Turn_Proposal_KeepInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_proposal_keep = /** @type {((inputs?: Agents_Turn_Proposal_KeepInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Proposal_KeepInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_proposal_keep(inputs)
	return __ja.agents_turn_proposal_keep(inputs)
});
/**
* | output |
* | --- |
* | "Write what to submit (you can paste files)" |
*
* @param {Agents_Turn_Provide_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_provide_placeholder = /** @type {((inputs?: Agents_Turn_Provide_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Provide_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_provide_placeholder(inputs)
	return __ja.agents_turn_provide_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Agents_Turn_RecommendedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_recommended = /** @type {((inputs?: Agents_Turn_RecommendedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_RecommendedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_recommended(inputs)
	return __ja.agents_turn_recommended(inputs)
});
/**
* | output |
* | --- |
* | "Done" |
*
* @param {Agents_Turn_Result_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_result_done = /** @type {((inputs?: Agents_Turn_Result_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Result_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_result_done(inputs)
	return __ja.agents_turn_result_done(inputs)
});
/**
* | output |
* | --- |
* | "A problem" |
*
* @param {Agents_Turn_Result_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_result_failed = /** @type {((inputs?: Agents_Turn_Result_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Result_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_result_failed(inputs)
	return __ja.agents_turn_result_failed(inputs)
});
/**
* | output |
* | --- |
* | "Not OK" |
*
* @param {Agents_Turn_Result_FixInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_result_fix = /** @type {((inputs?: Agents_Turn_Result_FixInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Result_FixInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_result_fix(inputs)
	return __ja.agents_turn_result_fix(inputs)
});
/**
* | output |
* | --- |
* | "OK" |
*
* @param {Agents_Turn_Result_OkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_result_ok = /** @type {((inputs?: Agents_Turn_Result_OkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Result_OkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_result_ok(inputs)
	return __ja.agents_turn_result_ok(inputs)
});
/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Agents_Turn_Result_SentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_result_sent = /** @type {((inputs?: Agents_Turn_Result_SentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Result_SentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_result_sent(inputs)
	return __ja.agents_turn_result_sent(inputs)
});
/**
* | output |
* | --- |
* | "Not sending" |
*
* @param {Agents_Turn_Result_UnsentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_result_unsent = /** @type {((inputs?: Agents_Turn_Result_UnsentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Result_UnsentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_result_unsent(inputs)
	return __ja.agents_turn_result_unsent(inputs)
});
/**
* | output |
* | --- |
* | "Rewritten" |
*
* @param {Agents_Turn_RewrittenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_rewritten = /** @type {((inputs?: Agents_Turn_RewrittenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_RewrittenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_rewritten(inputs)
	return __ja.agents_turn_rewritten(inputs)
});
/**
* | output |
* | --- |
* | "Write an answer" |
*
* @param {Agents_Turn_Text_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_text_placeholder = /** @type {((inputs?: Agents_Turn_Text_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Text_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_text_placeholder(inputs)
	return __ja.agents_turn_text_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Answer with this?" |
*
* @param {Agents_Turn_Ui_ConfirmInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_ui_confirm = /** @type {((inputs?: Agents_Turn_Ui_ConfirmInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Ui_ConfirmInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_ui_confirm(inputs)
	return __ja.agents_turn_ui_confirm(inputs)
});
/**
* | output |
* | --- |
* | "Comment (sent with the UI's answer)" |
*
* @param {Agents_Turn_Ui_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_ui_placeholder = /** @type {((inputs?: Agents_Turn_Ui_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_Ui_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_ui_placeholder(inputs)
	return __ja.agents_turn_ui_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "See the text" |
*
* @param {Agents_Turn_View_DraftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_view_draft = /** @type {((inputs?: Agents_Turn_View_DraftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_View_DraftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_view_draft(inputs)
	return __ja.agents_turn_view_draft(inputs)
});
/**
* | output |
* | --- |
* | "See the question" |
*
* @param {Agents_Turn_View_QuestionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_view_question = /** @type {((inputs?: Agents_Turn_View_QuestionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_View_QuestionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_view_question(inputs)
	return __ja.agents_turn_view_question(inputs)
});
/**
* | output |
* | --- |
* | "See the request" |
*
* @param {Agents_Turn_View_RequestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_view_request = /** @type {((inputs?: Agents_Turn_View_RequestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_View_RequestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_view_request(inputs)
	return __ja.agents_turn_view_request(inputs)
});
/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Agents_Turn_YesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_turn_yes = /** @type {((inputs?: Agents_Turn_YesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Turn_YesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_turn_yes(inputs)
	return __ja.agents_turn_yes(inputs)
});
/**
* | output |
* | --- |
* | "Unarchive" |
*
* @param {Agents_UnarchiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_unarchive = /** @type {((inputs?: Agents_UnarchiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_UnarchiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_unarchive(inputs)
	return __ja.agents_unarchive(inputs)
});
/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Agents_UndoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo = /** @type {((inputs?: Agents_UndoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_UndoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo(inputs)
	return __ja.agents_undo(inputs)
});
/**
* | output |
* | --- |
* | "Undo all" |
*
* @param {Agents_Undo_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_all = /** @type {((inputs?: Agents_Undo_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_all(inputs)
	return __ja.agents_undo_all(inputs)
});
/**
* | output |
* | --- |
* | "Undo all {n} changes made by this reply?" |
*
* @param {Agents_Undo_All_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_all_title = /** @type {((inputs: Agents_Undo_All_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_All_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_all_title(inputs)
	return __ja.agents_undo_all_title(inputs)
});
/**
* | output |
* | --- |
* | "What changed again afterwards was not undone" |
*
* @param {Agents_Undo_ConflictInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_conflict = /** @type {((inputs?: Agents_Undo_ConflictInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_ConflictInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_conflict(inputs)
	return __ja.agents_undo_conflict(inputs)
});
/**
* | output |
* | --- |
* | "creation" |
*
* @param {Agents_Undo_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_created = /** @type {((inputs?: Agents_Undo_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_created(inputs)
	return __ja.agents_undo_created(inputs)
});
/**
* | output |
* | --- |
* | "Undone" |
*
* @param {Agents_Undo_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_done = /** @type {((inputs?: Agents_Undo_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_done(inputs)
	return __ja.agents_undo_done(inputs)
});
/**
* | output |
* | --- |
* | "Could not undo. Press again" |
*
* @param {Agents_Undo_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_failed = /** @type {((inputs?: Agents_Undo_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_failed(inputs)
	return __ja.agents_undo_failed(inputs)
});
/**
* | output |
* | --- |
* | "Undo the {op} of “{title}”?" |
*
* @param {Agents_Undo_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_title = /** @type {((inputs: Agents_Undo_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_title(inputs)
	return __ja.agents_undo_title(inputs)
});
/**
* | output |
* | --- |
* | "change" |
*
* @param {Agents_Undo_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_updated = /** @type {((inputs?: Agents_Undo_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_updated(inputs)
	return __ja.agents_undo_updated(inputs)
});
/**
* | output |
* | --- |
* | "Undoing…" |
*
* @param {Agents_Undo_WorkingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_undo_working = /** @type {((inputs?: Agents_Undo_WorkingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Undo_WorkingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_undo_working(inputs)
	return __ja.agents_undo_working(inputs)
});
/**
* | output |
* | --- |
* | "Unread from here" |
*
* @param {Agents_Unread_From_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_unread_from_here = /** @type {((inputs?: Agents_Unread_From_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Unread_From_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_unread_from_here(inputs)
	return __ja.agents_unread_from_here(inputs)
});
/**
* | output |
* | --- |
* | "New chat" |
*
* @param {Agents_UntitledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_untitled = /** @type {((inputs?: Agents_UntitledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_UntitledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_untitled(inputs)
	return __ja.agents_untitled(inputs)
});
/**
* | output |
* | --- |
* | "Cache read" |
*
* @param {Agents_Usage_Cache_ReadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_cache_read = /** @type {((inputs?: Agents_Usage_Cache_ReadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_Cache_ReadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_cache_read(inputs)
	return __ja.agents_usage_cache_read(inputs)
});
/**
* | output |
* | --- |
* | "Cache write" |
*
* @param {Agents_Usage_Cache_WriteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_cache_write = /** @type {((inputs?: Agents_Usage_Cache_WriteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_Cache_WriteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_cache_write(inputs)
	return __ja.agents_usage_cache_write(inputs)
});
/**
* | output |
* | --- |
* | "Compact" |
*
* @param {Agents_Usage_CompactInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_compact = /** @type {((inputs?: Agents_Usage_CompactInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_CompactInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_compact(inputs)
	return __ja.agents_usage_compact(inputs)
});
/**
* | output |
* | --- |
* | "Could not compact" |
*
* @param {Agents_Usage_Compact_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_compact_failed = /** @type {((inputs?: Agents_Usage_Compact_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_Compact_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_compact_failed(inputs)
	return __ja.agents_usage_compact_failed(inputs)
});
/**
* | output |
* | --- |
* | "Context" |
*
* @param {Agents_Usage_ContextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_context = /** @type {((inputs?: Agents_Usage_ContextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_ContextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_context(inputs)
	return __ja.agents_usage_context(inputs)
});
/**
* | output |
* | --- |
* | "Cost" |
*
* @param {Agents_Usage_CostInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_cost = /** @type {((inputs?: Agents_Usage_CostInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_CostInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_cost(inputs)
	return __ja.agents_usage_cost(inputs)
});
/**
* | output |
* | --- |
* | "Once a run starts, its usage shows here" |
*
* @param {Agents_Usage_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_empty = /** @type {((inputs?: Agents_Usage_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_empty(inputs)
	return __ja.agents_usage_empty(inputs)
});
/**
* | output |
* | --- |
* | "Input" |
*
* @param {Agents_Usage_InputInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_input = /** @type {((inputs?: Agents_Usage_InputInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_InputInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_input(inputs)
	return __ja.agents_usage_input(inputs)
});
/**
* | output |
* | --- |
* | "Usage of this session" |
*
* @param {Agents_Usage_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_label = /** @type {((inputs?: Agents_Usage_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_label(inputs)
	return __ja.agents_usage_label(inputs)
});
/**
* | output |
* | --- |
* | "Output" |
*
* @param {Agents_Usage_OutputInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_output = /** @type {((inputs?: Agents_Usage_OutputInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_OutputInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_output(inputs)
	return __ja.agents_usage_output(inputs)
});
/**
* | output |
* | --- |
* | "This session" |
*
* @param {Agents_Usage_SessionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_usage_session = /** @type {((inputs?: Agents_Usage_SessionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Usage_SessionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_usage_session(inputs)
	return __ja.agents_usage_session(inputs)
});
/**
* | output |
* | --- |
* | "{value} (not on this PC)" |
*
* @param {Agents_Value_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_value_missing = /** @type {((inputs: Agents_Value_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Value_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_value_missing(inputs)
	return __ja.agents_value_missing(inputs)
});
/**
* | output |
* | --- |
* | "via {name}" |
*
* @param {Agents_ViaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_via = /** @type {((inputs: Agents_ViaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_ViaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_via(inputs)
	return __ja.agents_via(inputs)
});
/**
* | output |
* | --- |
* | "Side view" |
*
* @param {Agents_View_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_view_label = /** @type {((inputs?: Agents_View_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_View_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_view_label(inputs)
	return __ja.agents_view_label(inputs)
});
/**
* | output |
* | --- |
* | "In the chat" |
*
* @param {Agents_Wait_Turn_ClosedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_wait_turn_closed = /** @type {((inputs?: Agents_Wait_Turn_ClosedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Wait_Turn_ClosedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_wait_turn_closed(inputs)
	return __ja.agents_wait_turn_closed(inputs)
});
/**
* | output |
* | --- |
* | "Answer in the chat" |
*
* @param {Agents_Wait_Turn_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_wait_turn_open = /** @type {((inputs?: Agents_Wait_Turn_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Wait_Turn_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_wait_turn_open(inputs)
	return __ja.agents_wait_turn_open(inputs)
});
/**
* | output |
* | --- |
* | "Take back" |
*
* @param {Agents_WithdrawInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_withdraw = /** @type {((inputs?: Agents_WithdrawInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_WithdrawInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_withdraw(inputs)
	return __ja.agents_withdraw(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't take it back. The device didn't answer." |
*
* @param {Agents_Withdraw_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_withdraw_failed = /** @type {((inputs?: Agents_Withdraw_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Withdraw_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_withdraw_failed(inputs)
	return __ja.agents_withdraw_failed(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't take it back. It had already been read." |
*
* @param {Agents_Withdraw_Too_LateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const agents_withdraw_too_late = /** @type {((inputs?: Agents_Withdraw_Too_LateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Withdraw_Too_LateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.agents_withdraw_too_late(inputs)
	return __ja.agents_withdraw_too_late(inputs)
});
/**
* | output |
* | --- |
* | "Blue" |
*
* @param {Blocks_Callout_BlueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_blue = /** @type {((inputs?: Blocks_Callout_BlueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_BlueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_blue(inputs)
	return __ja.blocks_callout_blue(inputs)
});
/**
* | output |
* | --- |
* | "Change color (now: {color})" |
*
* @param {Blocks_Callout_Change_ColorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_change_color = /** @type {((inputs: Blocks_Callout_Change_ColorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_Change_ColorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_change_color(inputs)
	return __ja.blocks_callout_change_color(inputs)
});
/**
* | output |
* | --- |
* | "Color" |
*
* @param {Blocks_Callout_ColorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_color = /** @type {((inputs?: Blocks_Callout_ColorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_ColorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_color(inputs)
	return __ja.blocks_callout_color(inputs)
});
/**
* | output |
* | --- |
* | "Green" |
*
* @param {Blocks_Callout_GreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_green = /** @type {((inputs?: Blocks_Callout_GreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_GreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_green(inputs)
	return __ja.blocks_callout_green(inputs)
});
/**
* | output |
* | --- |
* | "Purple" |
*
* @param {Blocks_Callout_PurpleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_purple = /** @type {((inputs?: Blocks_Callout_PurpleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_PurpleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_purple(inputs)
	return __ja.blocks_callout_purple(inputs)
});
/**
* | output |
* | --- |
* | "Red" |
*
* @param {Blocks_Callout_RedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_red = /** @type {((inputs?: Blocks_Callout_RedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_RedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_red(inputs)
	return __ja.blocks_callout_red(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Blocks_Callout_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_title_placeholder = /** @type {((inputs?: Blocks_Callout_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_title_placeholder(inputs)
	return __ja.blocks_callout_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Yellow" |
*
* @param {Blocks_Callout_YellowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_callout_yellow = /** @type {((inputs?: Blocks_Callout_YellowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Callout_YellowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_callout_yellow(inputs)
	return __ja.blocks_callout_yellow(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Blocks_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_close = /** @type {((inputs?: Blocks_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_close(inputs)
	return __ja.blocks_close(inputs)
});
/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Blocks_Code_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_code_copy = /** @type {((inputs?: Blocks_Code_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Code_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_code_copy(inputs)
	return __ja.blocks_code_copy(inputs)
});
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Blocks_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_copied = /** @type {((inputs?: Blocks_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_copied(inputs)
	return __ja.blocks_copied(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't copy. Try again." |
*
* @param {Blocks_Copy_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_copy_failed = /** @type {((inputs?: Blocks_Copy_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Copy_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_copy_failed(inputs)
	return __ja.blocks_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Blocks_Fence_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_fence_cancel = /** @type {((inputs?: Blocks_Fence_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Fence_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_fence_cancel(inputs)
	return __ja.blocks_fence_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Edit source" |
*
* @param {Blocks_Fence_Edit_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_fence_edit_source = /** @type {((inputs?: Blocks_Fence_Edit_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Fence_Edit_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_fence_edit_source(inputs)
	return __ja.blocks_fence_edit_source(inputs)
});
/**
* | output |
* | --- |
* | "Save" |
*
* @param {Blocks_Fence_SaveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_fence_save = /** @type {((inputs?: Blocks_Fence_SaveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Fence_SaveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_fence_save(inputs)
	return __ja.blocks_fence_save(inputs)
});
/**
* | output |
* | --- |
* | "Diagram source" |
*
* @param {Blocks_Fence_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_fence_source = /** @type {((inputs?: Blocks_Fence_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Fence_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_fence_source(inputs)
	return __ja.blocks_fence_source(inputs)
});
/**
* | output |
* | --- |
* | "File actions" |
*
* @param {Blocks_File_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_actions = /** @type {((inputs?: Blocks_File_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_actions(inputs)
	return __ja.blocks_file_actions(inputs)
});
/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Blocks_File_Copy_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_copy_link = /** @type {((inputs?: Blocks_File_Copy_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_Copy_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_copy_link(inputs)
	return __ja.blocks_file_copy_link(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Blocks_File_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_delete = /** @type {((inputs?: Blocks_File_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_delete(inputs)
	return __ja.blocks_file_delete(inputs)
});
/**
* | output |
* | --- |
* | "Download" |
*
* @param {Blocks_File_DownloadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_download = /** @type {((inputs?: Blocks_File_DownloadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_DownloadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_download(inputs)
	return __ja.blocks_file_download(inputs)
});
/**
* | output |
* | --- |
* | "Enlarge" |
*
* @param {Blocks_File_EnlargeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_enlarge = /** @type {((inputs?: Blocks_File_EnlargeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_EnlargeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_enlarge(inputs)
	return __ja.blocks_file_enlarge(inputs)
});
/**
* | output |
* | --- |
* | "Enlarge {name}" |
*
* @param {Blocks_File_Enlarge_NamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_enlarge_named = /** @type {((inputs: Blocks_File_Enlarge_NamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_Enlarge_NamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_enlarge_named(inputs)
	return __ja.blocks_file_enlarge_named(inputs)
});
/**
* | output |
* | --- |
* | "Reset width" |
*
* @param {Blocks_File_Reset_WidthInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_reset_width = /** @type {((inputs?: Blocks_File_Reset_WidthInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_Reset_WidthInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_reset_width(inputs)
	return __ja.blocks_file_reset_width(inputs)
});
/**
* | output |
* | --- |
* | "Resize image" |
*
* @param {Blocks_File_ResizeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_file_resize = /** @type {((inputs?: Blocks_File_ResizeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_File_ResizeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_file_resize(inputs)
	return __ja.blocks_file_resize(inputs)
});
/**
* | output |
* | --- |
* | "Body of footnote {heading}" |
*
* @param {Blocks_Footnote_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_body = /** @type {((inputs: Blocks_Footnote_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_body(inputs)
	return __ja.blocks_footnote_body(inputs)
});
/**
* | output |
* | --- |
* | "Create footnote {label}" |
*
* @param {Blocks_Footnote_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_create = /** @type {((inputs: Blocks_Footnote_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_create(inputs)
	return __ja.blocks_footnote_create(inputs)
});
/**
* | output |
* | --- |
* | "This footnote was removed from the body. It won't be written back." |
*
* @param {Blocks_Footnote_GoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_gone = /** @type {((inputs?: Blocks_Footnote_GoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_GoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_gone(inputs)
	return __ja.blocks_footnote_gone(inputs)
});
/**
* | output |
* | --- |
* | "Footnote {heading}" |
*
* @param {Blocks_Footnote_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_heading = /** @type {((inputs: Blocks_Footnote_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_heading(inputs)
	return __ja.blocks_footnote_heading(inputs)
});
/**
* | output |
* | --- |
* | "Footnote {n}" |
*
* @param {Blocks_Footnote_NamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_named = /** @type {((inputs: Blocks_Footnote_NamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_NamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_named(inputs)
	return __ja.blocks_footnote_named(inputs)
});
/**
* | output |
* | --- |
* | "Go to the definition of footnote {n}" |
*
* @param {Blocks_Footnote_To_DefInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_to_def = /** @type {((inputs: Blocks_Footnote_To_DefInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_To_DefInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_to_def(inputs)
	return __ja.blocks_footnote_to_def(inputs)
});
/**
* | output |
* | --- |
* | "Go to the reference of footnote {name}" |
*
* @param {Blocks_Footnote_To_RefInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_to_ref = /** @type {((inputs: Blocks_Footnote_To_RefInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_To_RefInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_to_ref(inputs)
	return __ja.blocks_footnote_to_ref(inputs)
});
/**
* | output |
* | --- |
* | "Footnote {name} (not referenced)" |
*
* @param {Blocks_Footnote_UnreferencedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_footnote_unreferenced = /** @type {((inputs: Blocks_Footnote_UnreferencedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Footnote_UnreferencedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_footnote_unreferenced(inputs)
	return __ja.blocks_footnote_unreferenced(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't draw the diagram: {error}" |
*
* @param {Blocks_Mermaid_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_mermaid_failed = /** @type {((inputs: Blocks_Mermaid_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Mermaid_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_mermaid_failed(inputs)
	return __ja.blocks_mermaid_failed(inputs)
});
/**
* | output |
* | --- |
* | "Add above" |
*
* @param {Blocks_Table_Add_AboveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_add_above = /** @type {((inputs?: Blocks_Table_Add_AboveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Add_AboveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_add_above(inputs)
	return __ja.blocks_table_add_above(inputs)
});
/**
* | output |
* | --- |
* | "Add below" |
*
* @param {Blocks_Table_Add_BelowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_add_below = /** @type {((inputs?: Blocks_Table_Add_BelowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Add_BelowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_add_below(inputs)
	return __ja.blocks_table_add_below(inputs)
});
/**
* | output |
* | --- |
* | "Add column" |
*
* @param {Blocks_Table_Add_ColInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_add_col = /** @type {((inputs?: Blocks_Table_Add_ColInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Add_ColInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_add_col(inputs)
	return __ja.blocks_table_add_col(inputs)
});
/**
* | output |
* | --- |
* | "Add left" |
*
* @param {Blocks_Table_Add_LeftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_add_left = /** @type {((inputs?: Blocks_Table_Add_LeftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Add_LeftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_add_left(inputs)
	return __ja.blocks_table_add_left(inputs)
});
/**
* | output |
* | --- |
* | "Add right" |
*
* @param {Blocks_Table_Add_RightInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_add_right = /** @type {((inputs?: Blocks_Table_Add_RightInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Add_RightInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_add_right(inputs)
	return __ja.blocks_table_add_right(inputs)
});
/**
* | output |
* | --- |
* | "Add row" |
*
* @param {Blocks_Table_Add_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_add_row = /** @type {((inputs?: Blocks_Table_Add_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Add_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_add_row(inputs)
	return __ja.blocks_table_add_row(inputs)
});
/**
* | output |
* | --- |
* | "Column {n} actions" |
*
* @param {Blocks_Table_Col_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_col_actions = /** @type {((inputs: Blocks_Table_Col_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Col_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_col_actions(inputs)
	return __ja.blocks_table_col_actions(inputs)
});
/**
* | output |
* | --- |
* | "Resize column {n}" |
*
* @param {Blocks_Table_Col_ResizeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_col_resize = /** @type {((inputs: Blocks_Table_Col_ResizeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Col_ResizeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_col_resize(inputs)
	return __ja.blocks_table_col_resize(inputs)
});
/**
* | output |
* | --- |
* | "Delete this column" |
*
* @param {Blocks_Table_Delete_ColInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_delete_col = /** @type {((inputs?: Blocks_Table_Delete_ColInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Delete_ColInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_delete_col(inputs)
	return __ja.blocks_table_delete_col(inputs)
});
/**
* | output |
* | --- |
* | "Delete this row" |
*
* @param {Blocks_Table_Delete_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_delete_row = /** @type {((inputs?: Blocks_Table_Delete_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Delete_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_delete_row(inputs)
	return __ja.blocks_table_delete_row(inputs)
});
/**
* | output |
* | --- |
* | "Freeze up to here" |
*
* @param {Blocks_Table_Freeze_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_freeze_here = /** @type {((inputs?: Blocks_Table_Freeze_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Freeze_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_freeze_here(inputs)
	return __ja.blocks_table_freeze_here(inputs)
});
/**
* | output |
* | --- |
* | "Row {n} actions" |
*
* @param {Blocks_Table_Row_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_row_actions = /** @type {((inputs: Blocks_Table_Row_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_Row_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_row_actions(inputs)
	return __ja.blocks_table_row_actions(inputs)
});
/**
* | output |
* | --- |
* | "Unfreeze" |
*
* @param {Blocks_Table_UnfreezeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_table_unfreeze = /** @type {((inputs?: Blocks_Table_UnfreezeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Table_UnfreezeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_table_unfreeze(inputs)
	return __ja.blocks_table_unfreeze(inputs)
});
/**
* | output |
* | --- |
* | "Collapse toggle" |
*
* @param {Blocks_Toggle_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_toggle_close = /** @type {((inputs?: Blocks_Toggle_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Toggle_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_toggle_close(inputs)
	return __ja.blocks_toggle_close(inputs)
});
/**
* | output |
* | --- |
* | "Expand toggle" |
*
* @param {Blocks_Toggle_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_toggle_open = /** @type {((inputs?: Blocks_Toggle_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Toggle_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_toggle_open(inputs)
	return __ja.blocks_toggle_open(inputs)
});
/**
* | output |
* | --- |
* | "Upload canceled" |
*
* @param {Blocks_Upload_AbortedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_upload_aborted = /** @type {((inputs?: Blocks_Upload_AbortedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Upload_AbortedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_upload_aborted(inputs)
	return __ja.blocks_upload_aborted(inputs)
});
/**
* | output |
* | --- |
* | "Cancel upload of {name}" |
*
* @param {Blocks_Upload_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_upload_cancel = /** @type {((inputs: Blocks_Upload_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Upload_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_upload_cancel(inputs)
	return __ja.blocks_upload_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Upload failed. Try again." |
*
* @param {Blocks_Upload_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_upload_failed = /** @type {((inputs?: Blocks_Upload_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Upload_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_upload_failed(inputs)
	return __ja.blocks_upload_failed(inputs)
});
/**
* | output |
* | --- |
* | "Upload failed (network error). Try again." |
*
* @param {Blocks_Upload_Failed_NetworkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_upload_failed_network = /** @type {((inputs?: Blocks_Upload_Failed_NetworkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Upload_Failed_NetworkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_upload_failed_network(inputs)
	return __ja.blocks_upload_failed_network(inputs)
});
/**
* | output |
* | --- |
* | "Upload failed ({status}). Try again." |
*
* @param {Blocks_Upload_Failed_StatusInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_upload_failed_status = /** @type {((inputs: Blocks_Upload_Failed_StatusInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Upload_Failed_StatusInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_upload_failed_status(inputs)
	return __ja.blocks_upload_failed_status(inputs)
});
/**
* | output |
* | --- |
* | "This file is too large to upload." |
*
* @param {Blocks_Upload_Too_LargeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_upload_too_large = /** @type {((inputs?: Blocks_Upload_Too_LargeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_Upload_Too_LargeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_upload_too_large(inputs)
	return __ja.blocks_upload_too_large(inputs)
});
/**
* | output |
* | --- |
* | "Files uploading" |
*
* @param {Blocks_UploadsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const blocks_uploads = /** @type {((inputs?: Blocks_UploadsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blocks_UploadsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.blocks_uploads(inputs)
	return __ja.blocks_uploads(inputs)
});
/**
* | output |
* | --- |
* | "Action title" |
*
* @param {Cases_Action_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_action_title = /** @type {((inputs?: Cases_Action_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Action_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_action_title(inputs)
	return __ja.cases_action_title(inputs)
});
/**
* | output |
* | --- |
* | "Next action" |
*
* @param {Cases_Action_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_action_title_placeholder = /** @type {((inputs?: Cases_Action_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Action_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_action_title_placeholder(inputs)
	return __ja.cases_action_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Cases_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_add = /** @type {((inputs?: Cases_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_add(inputs)
	return __ja.cases_add(inputs)
});
/**
* | output |
* | --- |
* | "Add Action" |
*
* @param {Cases_Add_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_add_action = /** @type {((inputs?: Cases_Add_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Add_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_add_action(inputs)
	return __ja.cases_add_action(inputs)
});
/**
* | output |
* | --- |
* | "+ Add Action" |
*
* @param {Cases_Add_Action_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_add_action_button = /** @type {((inputs?: Cases_Add_Action_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Add_Action_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_add_action_button(inputs)
	return __ja.cases_add_action_button(inputs)
});
/**
* | output |
* | --- |
* | "Write the Case's title first" |
*
* @param {Cases_Add_Step_Needs_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_add_step_needs_title = /** @type {((inputs?: Cases_Add_Step_Needs_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Add_Step_Needs_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_add_step_needs_title(inputs)
	return __ja.cases_add_step_needs_title(inputs)
});
/**
* | output |
* | --- |
* | "Add Waiting" |
*
* @param {Cases_Add_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_add_waiting = /** @type {((inputs?: Cases_Add_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Add_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_add_waiting(inputs)
	return __ja.cases_add_waiting(inputs)
});
/**
* | output |
* | --- |
* | "+ Add Waiting" |
*
* @param {Cases_Add_Waiting_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_add_waiting_button = /** @type {((inputs?: Cases_Add_Waiting_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Add_Waiting_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_add_waiting_button(inputs)
	return __ja.cases_add_waiting_button(inputs)
});
/**
* | output |
* | --- |
* | "AI memo" |
*
* @param {Cases_Agent_MemoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_agent_memo = /** @type {((inputs?: Cases_Agent_MemoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Agent_MemoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_agent_memo(inputs)
	return __ja.cases_agent_memo(inputs)
});
/**
* | output |
* | --- |
* | "Details" |
*
* @param {Cases_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_body = /** @type {((inputs?: Cases_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_body(inputs)
	return __ja.cases_body(inputs)
});
/**
* | output |
* | --- |
* | "Details" |
*
* @param {Cases_Body_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_body_placeholder = /** @type {((inputs?: Cases_Body_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Body_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_body_placeholder(inputs)
	return __ja.cases_body_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Write the details…" |
*
* @param {Cases_Body_Write_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_body_write_placeholder = /** @type {((inputs?: Cases_Body_Write_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Body_Write_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_body_write_placeholder(inputs)
	return __ja.cases_body_write_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Case title" |
*
* @param {Cases_Case_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_case_title = /** @type {((inputs?: Cases_Case_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Case_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_case_title(inputs)
	return __ja.cases_case_title(inputs)
});
/**
* | output |
* | --- |
* | "Chain" |
*
* @param {Cases_ChainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_chain = /** @type {((inputs?: Cases_ChainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_ChainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_chain(inputs)
	return __ja.cases_chain(inputs)
});
/**
* | output |
* | --- |
* | "Done" |
*
* @param {Cases_Chain_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_chain_done = /** @type {((inputs?: Cases_Chain_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Chain_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_chain_done(inputs)
	return __ja.cases_chain_done(inputs)
});
/**
* | output |
* | --- |
* | "No Action or Waiting yet" |
*
* @param {Cases_Chain_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_chain_empty = /** @type {((inputs?: Cases_Chain_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Chain_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_chain_empty(inputs)
	return __ja.cases_chain_empty(inputs)
});
/**
* | output |
* | --- |
* | "Chain diagram" |
*
* @param {Cases_Chain_GraphInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_chain_graph = /** @type {((inputs?: Cases_Chain_GraphInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Chain_GraphInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_chain_graph(inputs)
	return __ja.cases_chain_graph(inputs)
});
/**
* | output |
* | --- |
* | "Later" |
*
* @param {Cases_Chain_LaterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_chain_later = /** @type {((inputs?: Cases_Chain_LaterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Chain_LaterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_chain_later(inputs)
	return __ja.cases_chain_later(inputs)
});
/**
* | output |
* | --- |
* | "Now" |
*
* @param {Cases_Chain_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_chain_now = /** @type {((inputs?: Cases_Chain_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Chain_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_chain_now(inputs)
	return __ja.cases_chain_now(inputs)
});
/**
* | output |
* | --- |
* | "Change the due date" |
*
* @param {Cases_Change_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_change_due = /** @type {((inputs?: Cases_Change_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Change_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_change_due(inputs)
	return __ja.cases_change_due(inputs)
});
/**
* | output |
* | --- |
* | "Change the day to do it" |
*
* @param {Cases_Change_PlanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_change_plan = /** @type {((inputs?: Cases_Change_PlanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Change_PlanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_change_plan(inputs)
	return __ja.cases_change_plan(inputs)
});
/**
* | output |
* | --- |
* | "Change how long to wait" |
*
* @param {Cases_Change_Wait_UntilInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_change_wait_until = /** @type {((inputs?: Cases_Change_Wait_UntilInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Change_Wait_UntilInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_change_wait_until(inputs)
	return __ja.cases_change_wait_until(inputs)
});
/**
* | output |
* | --- |
* | "No closed Cases" |
*
* @param {Cases_Closed_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_closed_empty = /** @type {((inputs?: Cases_Closed_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Closed_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_closed_empty(inputs)
	return __ja.cases_closed_empty(inputs)
});
/**
* | output |
* | --- |
* | "Case" |
*
* @param {Cases_Col_CaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_col_case = /** @type {((inputs?: Cases_Col_CaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_CaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_col_case(inputs)
	return __ja.cases_col_case(inputs)
});
/**
* | output |
* | --- |
* | "Due" |
*
* @param {Cases_Col_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_col_due = /** @type {((inputs?: Cases_Col_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_col_due(inputs)
	return __ja.cases_col_due(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Cases_Col_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_col_name = /** @type {((inputs?: Cases_Col_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_col_name(inputs)
	return __ja.cases_col_name(inputs)
});
/**
* | output |
* | --- |
* | "Do on" |
*
* @param {Cases_Col_PlanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_col_plan = /** @type {((inputs?: Cases_Col_PlanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_PlanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_col_plan(inputs)
	return __ja.cases_col_plan(inputs)
});
/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Cases_Col_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_col_updated = /** @type {((inputs?: Cases_Col_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_col_updated(inputs)
	return __ja.cases_col_updated(inputs)
});
/**
* | output |
* | --- |
* | "Waiting on" |
*
* @param {Cases_Col_WaitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_col_wait = /** @type {((inputs?: Cases_Col_WaitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Col_WaitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_col_wait(inputs)
	return __ja.cases_col_wait(inputs)
});
/**
* | output |
* | --- |
* | "Context" |
*
* @param {Cases_ContextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_context = /** @type {((inputs?: Cases_ContextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_ContextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_context(inputs)
	return __ja.cases_context(inputs)
});
/**
* | output |
* | --- |
* | "How it got here" |
*
* @param {Cases_Context_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_context_placeholder = /** @type {((inputs?: Cases_Context_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Context_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_context_placeholder(inputs)
	return __ja.cases_context_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Create Case" |
*
* @param {Cases_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_create = /** @type {((inputs?: Cases_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_create(inputs)
	return __ja.cases_create(inputs)
});
/**
* | output |
* | --- |
* | "Could not create it (what you wrote is kept)" |
*
* @param {Cases_Create_Failed_KeptInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_create_failed_kept = /** @type {((inputs?: Cases_Create_Failed_KeptInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Create_Failed_KeptInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_create_failed_kept(inputs)
	return __ja.cases_create_failed_kept(inputs)
});
/**
* | output |
* | --- |
* | "Its Actions, Waitings, links, files and AI memo go with it. This cannot be undone. To just finish it, complete or drop it." |
*
* @param {Cases_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_delete_body = /** @type {((inputs?: Cases_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_delete_body(inputs)
	return __ja.cases_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete \"{title}\"" |
*
* @param {Cases_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_delete_failed = /** @type {((inputs: Cases_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_delete_failed(inputs)
	return __ja.cases_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete \"{title}\"" |
*
* @param {Cases_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_delete_title = /** @type {((inputs: Cases_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_delete_title(inputs)
	return __ja.cases_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "Complete" |
*
* @param {Cases_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_done = /** @type {((inputs?: Cases_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_done(inputs)
	return __ja.cases_done(inputs)
});
/**
* | output |
* | --- |
* | "Drop" |
*
* @param {Cases_DropInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_drop = /** @type {((inputs?: Cases_DropInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_DropInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_drop(inputs)
	return __ja.cases_drop(inputs)
});
/**
* | output |
* | --- |
* | "Due" |
*
* @param {Cases_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_due = /** @type {((inputs?: Cases_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_due(inputs)
	return __ja.cases_due(inputs)
});
/**
* | output |
* | --- |
* | "Remove the due date" |
*
* @param {Cases_Due_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_due_clear = /** @type {((inputs?: Cases_Due_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Due_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_due_clear(inputs)
	return __ja.cases_due_clear(inputs)
});
/**
* | output |
* | --- |
* | "No Cases" |
*
* @param {Cases_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_empty = /** @type {((inputs?: Cases_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_empty(inputs)
	return __ja.cases_empty(inputs)
});
/**
* | output |
* | --- |
* | "{n} B" |
*
* @param {Cases_File_BytesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_file_bytes = /** @type {((inputs: Cases_File_BytesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_File_BytesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_file_bytes(inputs)
	return __ja.cases_file_bytes(inputs)
});
/**
* | output |
* | --- |
* | "{n} KB" |
*
* @param {Cases_File_KbInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_file_kb = /** @type {((inputs: Cases_File_KbInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_File_KbInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_file_kb(inputs)
	return __ja.cases_file_kb(inputs)
});
/**
* | output |
* | --- |
* | "{n} MB" |
*
* @param {Cases_File_MbInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_file_mb = /** @type {((inputs: Cases_File_MbInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_File_MbInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_file_mb(inputs)
	return __ja.cases_file_mb(inputs)
});
/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Cases_File_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_file_remove = /** @type {((inputs: Cases_File_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_File_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_file_remove(inputs)
	return __ja.cases_file_remove(inputs)
});
/**
* | output |
* | --- |
* | "Could not remove {name}" |
*
* @param {Cases_File_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_file_remove_failed = /** @type {((inputs: Cases_File_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_File_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_file_remove_failed(inputs)
	return __ja.cases_file_remove_failed(inputs)
});
/**
* | output |
* | --- |
* | "Files" |
*
* @param {Cases_FilesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_files = /** @type {((inputs?: Cases_FilesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_FilesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_files(inputs)
	return __ja.cases_files(inputs)
});
/**
* | output |
* | --- |
* | "Go to Cases" |
*
* @param {Cases_GoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_go = /** @type {((inputs?: Cases_GoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_GoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_go(inputs)
	return __ja.cases_go(inputs)
});
/**
* | output |
* | --- |
* | "Delegated to Agent" |
*
* @param {Cases_Graph_DelegatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_graph_delegated = /** @type {((inputs?: Cases_Graph_DelegatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Graph_DelegatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_graph_delegated(inputs)
	return __ja.cases_graph_delegated(inputs)
});
/**
* | output |
* | --- |
* | "{done} / {total}" |
*
* @param {Cases_Graph_ProgressInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_graph_progress = /** @type {((inputs: Cases_Graph_ProgressInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Graph_ProgressInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_graph_progress(inputs)
	return __ja.cases_graph_progress(inputs)
});
/**
* | output |
* | --- |
* | "Action" |
*
* @param {Cases_Kind_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_kind_action = /** @type {((inputs?: Cases_Kind_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Kind_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_kind_action(inputs)
	return __ja.cases_kind_action(inputs)
});
/**
* | output |
* | --- |
* | "Waiting" |
*
* @param {Cases_Kind_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_kind_waiting = /** @type {((inputs?: Cases_Kind_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Kind_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_kind_waiting(inputs)
	return __ja.cases_kind_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Label" |
*
* @param {Cases_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_label = /** @type {((inputs?: Cases_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_label(inputs)
	return __ja.cases_label(inputs)
});
/**
* | output |
* | --- |
* | "Change the label \"{name}\"" |
*
* @param {Cases_Label_ChangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_label_change = /** @type {((inputs: Cases_Label_ChangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Label_ChangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_label_change(inputs)
	return __ja.cases_label_change(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the label" |
*
* @param {Cases_Label_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_label_failed = /** @type {((inputs?: Cases_Label_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Label_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_label_failed(inputs)
	return __ja.cases_label_failed(inputs)
});
/**
* | output |
* | --- |
* | "Set a label" |
*
* @param {Cases_Label_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_label_set = /** @type {((inputs?: Cases_Label_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Label_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_label_set(inputs)
	return __ja.cases_label_set(inputs)
});
/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Cases_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_list = /** @type {((inputs?: Cases_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_list(inputs)
	return __ja.cases_list(inputs)
});
/**
* | output |
* | --- |
* | "Could not load" |
*
* @param {Cases_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_load_failed = /** @type {((inputs?: Cases_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_load_failed(inputs)
	return __ja.cases_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Actions for \"{title}\"" |
*
* @param {Cases_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_menu = /** @type {((inputs: Cases_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_menu(inputs)
	return __ja.cases_menu(inputs)
});
/**
* | output |
* | --- |
* | "New Case" |
*
* @param {Cases_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_new = /** @type {((inputs?: Cases_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_new(inputs)
	return __ja.cases_new(inputs)
});
/**
* | output |
* | --- |
* | "This Case was not found" |
*
* @param {Cases_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_not_found = /** @type {((inputs?: Cases_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_not_found(inputs)
	return __ja.cases_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Past due ({date})" |
*
* @param {Cases_OverdueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_overdue = /** @type {((inputs: Cases_OverdueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_OverdueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_overdue(inputs)
	return __ja.cases_overdue(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Cases_Panel_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_panel_close = /** @type {((inputs?: Cases_Panel_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Panel_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_panel_close(inputs)
	return __ja.cases_panel_close(inputs)
});
/**
* | output |
* | --- |
* | "Day to do it" |
*
* @param {Cases_PlanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan = /** @type {((inputs?: Cases_PlanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_PlanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan(inputs)
	return __ja.cases_plan(inputs)
});
/**
* | output |
* | --- |
* | "Carried over (from {date})" |
*
* @param {Cases_Plan_CarriedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_carried = /** @type {((inputs: Cases_Plan_CarriedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_CarriedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_carried(inputs)
	return __ja.cases_plan_carried(inputs)
});
/**
* | output |
* | --- |
* | "Remove the day" |
*
* @param {Cases_Plan_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_clear = /** @type {((inputs?: Cases_Plan_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_clear(inputs)
	return __ja.cases_plan_clear(inputs)
});
/**
* | output |
* | --- |
* | "Pick a date…" |
*
* @param {Cases_Plan_Pick_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_pick_date = /** @type {((inputs?: Cases_Plan_Pick_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_Pick_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_pick_date(inputs)
	return __ja.cases_plan_pick_date(inputs)
});
/**
* | output |
* | --- |
* | "Later" |
*
* @param {Cases_Plan_SomedayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_someday = /** @type {((inputs?: Cases_Plan_SomedayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_SomedayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_someday(inputs)
	return __ja.cases_plan_someday(inputs)
});
/**
* | output |
* | --- |
* | "This week" |
*
* @param {Cases_Plan_This_WeekInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_this_week = /** @type {((inputs?: Cases_Plan_This_WeekInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_This_WeekInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_this_week(inputs)
	return __ja.cases_plan_this_week(inputs)
});
/**
* | output |
* | --- |
* | "Today" |
*
* @param {Cases_Plan_TodayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_today = /** @type {((inputs?: Cases_Plan_TodayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_TodayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_today(inputs)
	return __ja.cases_plan_today(inputs)
});
/**
* | output |
* | --- |
* | "Tomorrow" |
*
* @param {Cases_Plan_TomorrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_tomorrow = /** @type {((inputs?: Cases_Plan_TomorrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_TomorrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_tomorrow(inputs)
	return __ja.cases_plan_tomorrow(inputs)
});
/**
* | output |
* | --- |
* | "Week of {date}" |
*
* @param {Cases_Plan_Week_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_plan_week_of = /** @type {((inputs: Cases_Plan_Week_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Plan_Week_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_plan_week_of(inputs)
	return __ja.cases_plan_week_of(inputs)
});
/**
* | output |
* | --- |
* | "Related" |
*
* @param {Cases_RelatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related = /** @type {((inputs?: Cases_RelatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_RelatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related(inputs)
	return __ja.cases_related(inputs)
});
/**
* | output |
* | --- |
* | "Add related" |
*
* @param {Cases_Related_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_add = /** @type {((inputs?: Cases_Related_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_add(inputs)
	return __ja.cases_related_add(inputs)
});
/**
* | output |
* | --- |
* | "Could not add \"{name}\"" |
*
* @param {Cases_Related_Add_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_add_failed = /** @type {((inputs: Cases_Related_Add_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_Add_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_add_failed(inputs)
	return __ja.cases_related_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "Suggestions" |
*
* @param {Cases_Related_CandidatesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_candidates = /** @type {((inputs?: Cases_Related_CandidatesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_CandidatesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_candidates(inputs)
	return __ja.cases_related_candidates(inputs)
});
/**
* | output |
* | --- |
* | "Nothing found" |
*
* @param {Cases_Related_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_none = /** @type {((inputs?: Cases_Related_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_none(inputs)
	return __ja.cases_related_none(inputs)
});
/**
* | output |
* | --- |
* | "Remove \"{name}\"" |
*
* @param {Cases_Related_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_remove = /** @type {((inputs: Cases_Related_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_remove(inputs)
	return __ja.cases_related_remove(inputs)
});
/**
* | output |
* | --- |
* | "Could not remove \"{name}\"" |
*
* @param {Cases_Related_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_remove_failed = /** @type {((inputs: Cases_Related_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_remove_failed(inputs)
	return __ja.cases_related_remove_failed(inputs)
});
/**
* | output |
* | --- |
* | "Search related" |
*
* @param {Cases_Related_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_search = /** @type {((inputs?: Cases_Related_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_search(inputs)
	return __ja.cases_related_search(inputs)
});
/**
* | output |
* | --- |
* | "Search Cases and people / paste a URL" |
*
* @param {Cases_Related_Search_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_related_search_placeholder = /** @type {((inputs?: Cases_Related_Search_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Related_Search_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_related_search_placeholder(inputs)
	return __ja.cases_related_search_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Cases_RenameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_rename = /** @type {((inputs?: Cases_RenameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_RenameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_rename(inputs)
	return __ja.cases_rename(inputs)
});
/**
* | output |
* | --- |
* | "Reopen" |
*
* @param {Cases_ReopenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_reopen = /** @type {((inputs?: Cases_ReopenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_ReopenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_reopen(inputs)
	return __ja.cases_reopen(inputs)
});
/**
* | output |
* | --- |
* | "Result" |
*
* @param {Cases_ResultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_result = /** @type {((inputs?: Cases_ResultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_ResultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_result(inputs)
	return __ja.cases_result(inputs)
});
/**
* | output |
* | --- |
* | "The result, if any" |
*
* @param {Cases_Result_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_result_placeholder = /** @type {((inputs?: Cases_Result_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Result_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_result_placeholder(inputs)
	return __ja.cases_result_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "details of {kind} \"{title}\"" |
*
* @param {Cases_Source_Step_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_source_step_body = /** @type {((inputs: Cases_Source_Step_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Source_Step_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_source_step_body(inputs)
	return __ja.cases_source_step_body(inputs)
});
/**
* | output |
* | --- |
* | "result of {kind} \"{title}\"" |
*
* @param {Cases_Source_Step_ResultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_source_step_result = /** @type {((inputs: Cases_Source_Step_ResultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Source_Step_ResultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_source_step_result(inputs)
	return __ja.cases_source_step_result(inputs)
});
/**
* | output |
* | --- |
* | "wait of {kind} \"{title}\"" |
*
* @param {Cases_Source_Step_WaitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_source_step_wait = /** @type {((inputs: Cases_Source_Step_WaitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Source_Step_WaitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_source_step_wait(inputs)
	return __ja.cases_source_step_wait(inputs)
});
/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Cases_Status_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_status_done = /** @type {((inputs?: Cases_Status_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Status_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_status_done(inputs)
	return __ja.cases_status_done(inputs)
});
/**
* | output |
* | --- |
* | "Dropped" |
*
* @param {Cases_Status_DroppedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_status_dropped = /** @type {((inputs?: Cases_Status_DroppedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Status_DroppedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_status_dropped(inputs)
	return __ja.cases_status_dropped(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the state" |
*
* @param {Cases_Status_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_status_failed = /** @type {((inputs?: Cases_Status_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Status_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_status_failed(inputs)
	return __ja.cases_status_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not add \"{title}\"" |
*
* @param {Cases_Step_Add_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_add_failed = /** @type {((inputs: Cases_Step_Add_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Add_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_add_failed(inputs)
	return __ja.cases_step_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "Closed automatically" |
*
* @param {Cases_Step_Auto_ClosedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_auto_closed = /** @type {((inputs?: Cases_Step_Auto_ClosedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Auto_ClosedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_auto_closed(inputs)
	return __ja.cases_step_auto_closed(inputs)
});
/**
* | output |
* | --- |
* | "Could not close \"{title}\"" |
*
* @param {Cases_Step_Close_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_close_failed = /** @type {((inputs: Cases_Step_Close_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Close_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_close_failed(inputs)
	return __ja.cases_step_close_failed(inputs)
});
/**
* | output |
* | --- |
* | "Created {date}" |
*
* @param {Cases_Step_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_created = /** @type {((inputs: Cases_Step_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_created(inputs)
	return __ja.cases_step_created(inputs)
});
/**
* | output |
* | --- |
* | "Its details, result, links and files go with it. This cannot be undone." |
*
* @param {Cases_Step_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_delete_body = /** @type {((inputs?: Cases_Step_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_delete_body(inputs)
	return __ja.cases_step_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete \"{title}\"" |
*
* @param {Cases_Step_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_delete_failed = /** @type {((inputs: Cases_Step_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_delete_failed(inputs)
	return __ja.cases_step_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete \"{title}\"" |
*
* @param {Cases_Step_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_delete_title = /** @type {((inputs: Cases_Step_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_delete_title(inputs)
	return __ja.cases_step_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "Complete \"{title}\"" |
*
* @param {Cases_Step_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_done = /** @type {((inputs: Cases_Step_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_done(inputs)
	return __ja.cases_step_done(inputs)
});
/**
* | output |
* | --- |
* | "Due {date}" |
*
* @param {Cases_Step_DueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_due = /** @type {((inputs: Cases_Step_DueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_DueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_due(inputs)
	return __ja.cases_step_due(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the due date of \"{title}\"" |
*
* @param {Cases_Step_Due_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_due_failed = /** @type {((inputs: Cases_Step_Due_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Due_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_due_failed(inputs)
	return __ja.cases_step_due_failed(inputs)
});
/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Cases_Step_KindInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_kind = /** @type {((inputs?: Cases_Step_KindInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_KindInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_kind(inputs)
	return __ja.cases_step_kind(inputs)
});
/**
* | output |
* | --- |
* | "Actions for \"{title}\"" |
*
* @param {Cases_Step_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_menu = /** @type {((inputs: Cases_Step_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_menu(inputs)
	return __ja.cases_step_menu(inputs)
});
/**
* | output |
* | --- |
* | "Do {label}" |
*
* @param {Cases_Step_PlanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_plan = /** @type {((inputs: Cases_Step_PlanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_PlanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_plan(inputs)
	return __ja.cases_step_plan(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the day of \"{title}\"" |
*
* @param {Cases_Step_Plan_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_plan_failed = /** @type {((inputs: Cases_Step_Plan_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Plan_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_plan_failed(inputs)
	return __ja.cases_step_plan_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not rename \"{title}\"" |
*
* @param {Cases_Step_Rename_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_rename_failed = /** @type {((inputs: Cases_Step_Rename_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Rename_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_rename_failed(inputs)
	return __ja.cases_step_rename_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not reopen \"{title}\"" |
*
* @param {Cases_Step_Reopen_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_reopen_failed = /** @type {((inputs: Cases_Step_Reopen_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Reopen_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_reopen_failed(inputs)
	return __ja.cases_step_reopen_failed(inputs)
});
/**
* | output |
* | --- |
* | "Resolve \"{title}\"" |
*
* @param {Cases_Step_ResolveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_resolve = /** @type {((inputs: Cases_Step_ResolveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_ResolveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_resolve(inputs)
	return __ja.cases_step_resolve(inputs)
});
/**
* | output |
* | --- |
* | "Action / Waiting title" |
*
* @param {Cases_Step_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_title = /** @type {((inputs?: Cases_Step_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_title(inputs)
	return __ja.cases_step_title(inputs)
});
/**
* | output |
* | --- |
* | "Placed for now" |
*
* @param {Cases_Step_UnplacedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_unplaced = /** @type {((inputs?: Cases_Step_UnplacedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_UnplacedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_unplaced(inputs)
	return __ja.cases_step_unplaced(inputs)
});
/**
* | output |
* | --- |
* | "Added from the screen. AI will decide where it goes in the Chain" |
*
* @param {Cases_Step_Unplaced_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_unplaced_hint = /** @type {((inputs?: Cases_Step_Unplaced_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Unplaced_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_unplaced_hint(inputs)
	return __ja.cases_step_unplaced_hint(inputs)
});
/**
* | output |
* | --- |
* | "What it waited on was dropped" |
*
* @param {Cases_Step_Wait_Target_DroppedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_step_wait_target_dropped = /** @type {((inputs?: Cases_Step_Wait_Target_DroppedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Step_Wait_Target_DroppedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_step_wait_target_dropped(inputs)
	return __ja.cases_step_wait_target_dropped(inputs)
});
/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Cases_Tab_ClosedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_tab_closed = /** @type {((inputs?: Cases_Tab_ClosedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Tab_ClosedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_tab_closed(inputs)
	return __ja.cases_tab_closed(inputs)
});
/**
* | output |
* | --- |
* | "Next" |
*
* @param {Cases_Tab_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_tab_next = /** @type {((inputs?: Cases_Tab_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Tab_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_tab_next(inputs)
	return __ja.cases_tab_next(inputs)
});
/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Cases_Tab_ReadyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_tab_ready = /** @type {((inputs?: Cases_Tab_ReadyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Tab_ReadyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_tab_ready(inputs)
	return __ja.cases_tab_ready(inputs)
});
/**
* | output |
* | --- |
* | "Waiting" |
*
* @param {Cases_Tab_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_tab_waiting = /** @type {((inputs?: Cases_Tab_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Tab_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_tab_waiting(inputs)
	return __ja.cases_tab_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Cases to show" |
*
* @param {Cases_TabsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_tabs = /** @type {((inputs?: Cases_TabsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_TabsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_tabs(inputs)
	return __ja.cases_tabs(inputs)
});
/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Cases_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_title = /** @type {((inputs?: Cases_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_title(inputs)
	return __ja.cases_title(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the title" |
*
* @param {Cases_Title_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_title_failed = /** @type {((inputs?: Cases_Title_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Title_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_title_failed(inputs)
	return __ja.cases_title_failed(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Cases_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_title_placeholder = /** @type {((inputs?: Cases_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_title_placeholder(inputs)
	return __ja.cases_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Wait until" |
*
* @param {Cases_Wait_UntilInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_wait_until = /** @type {((inputs?: Cases_Wait_UntilInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Wait_UntilInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_wait_until(inputs)
	return __ja.cases_wait_until(inputs)
});
/**
* | output |
* | --- |
* | "Waiting title" |
*
* @param {Cases_Waiting_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_waiting_title = /** @type {((inputs?: Cases_Waiting_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Waiting_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_waiting_title(inputs)
	return __ja.cases_waiting_title(inputs)
});
/**
* | output |
* | --- |
* | "What you are waiting for" |
*
* @param {Cases_Waiting_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const cases_waiting_title_placeholder = /** @type {((inputs?: Cases_Waiting_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Waiting_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.cases_waiting_title_placeholder(inputs)
	return __ja.cases_waiting_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Common_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_cancel = /** @type {((inputs?: Common_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_cancel(inputs)
	return __ja.common_cancel(inputs)
});
/**
* | output |
* | --- |
* | "{n} days ago" |
*
* @param {Common_Days_AgoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_days_ago = /** @type {((inputs: Common_Days_AgoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Days_AgoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_days_ago(inputs)
	return __ja.common_days_ago(inputs)
});
/**
* | output |
* | --- |
* | "in {n} days" |
*
* @param {Common_Days_LaterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_days_later = /** @type {((inputs: Common_Days_LaterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Days_LaterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_days_later(inputs)
	return __ja.common_days_later(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Common_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_delete = /** @type {((inputs?: Common_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_delete(inputs)
	return __ja.common_delete(inputs)
});
/**
* | output |
* | --- |
* | "{lead}. {message}" |
*
* @param {Common_Error_With_LeadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_error_with_lead = /** @type {((inputs: Common_Error_With_LeadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_With_LeadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_error_with_lead(inputs)
	return __ja.common_error_with_lead(inputs)
});
/**
* | output |
* | --- |
* | "You do not have permission. Ask someone who has the role." |
*
* @param {Common_ForbiddenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_forbidden = /** @type {((inputs?: Common_ForbiddenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ForbiddenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_forbidden(inputs)
	return __ja.common_forbidden(inputs)
});
/**
* | output |
* | --- |
* | "{n} h ago" |
*
* @param {Common_Hours_AgoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_hours_ago = /** @type {((inputs: Common_Hours_AgoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Hours_AgoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_hours_ago(inputs)
	return __ja.common_hours_ago(inputs)
});
/**
* | output |
* | --- |
* | "just now" |
*
* @param {Common_Just_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_just_now = /** @type {((inputs?: Common_Just_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Just_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_just_now(inputs)
	return __ja.common_just_now(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't read more." |
*
* @param {Common_Load_More_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_load_more_failed = /** @type {((inputs?: Common_Load_More_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Load_More_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_load_more_failed(inputs)
	return __ja.common_load_more_failed(inputs)
});
/**
* | output |
* | --- |
* | "{n} min ago" |
*
* @param {Common_Minutes_AgoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_minutes_ago = /** @type {((inputs: Common_Minutes_AgoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Minutes_AgoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_minutes_ago(inputs)
	return __ja.common_minutes_ago(inputs)
});
/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Common_Picture_ApplyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_apply = /** @type {((inputs?: Common_Picture_ApplyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_ApplyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_apply(inputs)
	return __ja.common_picture_apply(inputs)
});
/**
* | output |
* | --- |
* | "Choose image" |
*
* @param {Common_Picture_ChooseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_choose = /** @type {((inputs?: Common_Picture_ChooseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_ChooseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_choose(inputs)
	return __ja.common_picture_choose(inputs)
});
/**
* | output |
* | --- |
* | "Drag to move it; use the slider, the wheel or a pinch to resize." |
*
* @param {Common_Picture_Crop_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_crop_hint = /** @type {((inputs?: Common_Picture_Crop_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_Crop_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_crop_hint(inputs)
	return __ja.common_picture_crop_hint(inputs)
});
/**
* | output |
* | --- |
* | "Could not save the image" |
*
* @param {Common_Picture_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_failed = /** @type {((inputs?: Common_Picture_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_failed(inputs)
	return __ja.common_picture_failed(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Common_Picture_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_remove = /** @type {((inputs?: Common_Picture_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_remove(inputs)
	return __ja.common_picture_remove(inputs)
});
/**
* | output |
* | --- |
* | "Crop position (arrow keys move it, + and - resize it)" |
*
* @param {Common_Picture_StageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_stage = /** @type {((inputs?: Common_Picture_StageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_StageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_stage(inputs)
	return __ja.common_picture_stage(inputs)
});
/**
* | output |
* | --- |
* | "This image could not be read. Choose a PNG, JPEG, GIF or WebP." |
*
* @param {Common_Picture_UnreadableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_unreadable = /** @type {((inputs?: Common_Picture_UnreadableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_UnreadableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_unreadable(inputs)
	return __ja.common_picture_unreadable(inputs)
});
/**
* | output |
* | --- |
* | "Size" |
*
* @param {Common_Picture_ZoomInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_picture_zoom = /** @type {((inputs?: Common_Picture_ZoomInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Picture_ZoomInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_picture_zoom(inputs)
	return __ja.common_picture_zoom(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Common_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_retry = /** @type {((inputs?: Common_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_retry(inputs)
	return __ja.common_retry(inputs)
});
/**
* | output |
* | --- |
* | "Save" |
*
* @param {Common_SaveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_save = /** @type {((inputs?: Common_SaveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SaveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_save(inputs)
	return __ja.common_save(inputs)
});
/**
* | output |
* | --- |
* | "today" |
*
* @param {Common_TodayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_today = /** @type {((inputs?: Common_TodayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_TodayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_today(inputs)
	return __ja.common_today(inputs)
});
/**
* | output |
* | --- |
* | "tomorrow" |
*
* @param {Common_TomorrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_tomorrow = /** @type {((inputs?: Common_TomorrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_TomorrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_tomorrow(inputs)
	return __ja.common_tomorrow(inputs)
});
/**
* | output |
* | --- |
* | "yesterday" |
*
* @param {Common_YesterdayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const common_yesterday = /** @type {((inputs?: Common_YesterdayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_YesterdayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.common_yesterday(inputs)
	return __ja.common_yesterday(inputs)
});
/**
* | output |
* | --- |
* | "Add row" |
*
* @param {Datasets_Add_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_add_row = /** @type {((inputs?: Datasets_Add_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Add_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_add_row(inputs)
	return __ja.datasets_add_row(inputs)
});
/**
* | output |
* | --- |
* | "Field" |
*
* @param {Datasets_Col_FieldInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_col_field = /** @type {((inputs?: Datasets_Col_FieldInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Col_FieldInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_col_field(inputs)
	return __ja.datasets_col_field(inputs)
});
/**
* | output |
* | --- |
* | "Rows with a value" |
*
* @param {Datasets_Col_FilledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_col_filled = /** @type {((inputs?: Datasets_Col_FilledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Col_FilledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_col_filled(inputs)
	return __ja.datasets_col_filled(inputs)
});
/**
* | output |
* | --- |
* | "Clear date" |
*
* @param {Datasets_Date_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_date_clear = /** @type {((inputs?: Datasets_Date_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Date_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_date_clear(inputs)
	return __ja.datasets_date_clear(inputs)
});
/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Datasets_Date_PickInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_date_pick = /** @type {((inputs?: Datasets_Date_PickInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Date_PickInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_date_pick(inputs)
	return __ja.datasets_date_pick(inputs)
});
/**
* | output |
* | --- |
* | "Delete row" |
*
* @param {Datasets_Delete_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_delete_row = /** @type {((inputs?: Datasets_Delete_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Delete_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_delete_row(inputs)
	return __ja.datasets_delete_row(inputs)
});
/**
* | output |
* | --- |
* | "This row will be deleted from the dataset. This can't be undone." |
*
* @param {Datasets_Delete_Row_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_delete_row_body = /** @type {((inputs?: Datasets_Delete_Row_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Delete_Row_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_delete_row_body(inputs)
	return __ja.datasets_delete_row_body(inputs)
});
/**
* | output |
* | --- |
* | "Distribution of {field}" |
*
* @param {Datasets_DistributionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_distribution = /** @type {((inputs: Datasets_DistributionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_DistributionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_distribution(inputs)
	return __ja.datasets_distribution(inputs)
});
/**
* | output |
* | --- |
* | "Distribution of values" |
*
* @param {Datasets_Distribution_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_distribution_title = /** @type {((inputs?: Datasets_Distribution_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Distribution_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_distribution_title(inputs)
	return __ja.datasets_distribution_title(inputs)
});
/**
* | output |
* | --- |
* | "Most {count} rows" |
*
* @param {Datasets_Distribution_TopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_distribution_top = /** @type {((inputs: Datasets_Distribution_TopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Distribution_TopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_distribution_top(inputs)
	return __ja.datasets_distribution_top(inputs)
});
/**
* | output |
* | --- |
* | "Edit row" |
*
* @param {Datasets_Edit_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_edit_row = /** @type {((inputs?: Datasets_Edit_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Edit_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_edit_row(inputs)
	return __ja.datasets_edit_row(inputs)
});
/**
* | output |
* | --- |
* | "Fields" |
*
* @param {Datasets_FieldsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_fields = /** @type {((inputs?: Datasets_FieldsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_FieldsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_fields(inputs)
	return __ja.datasets_fields(inputs)
});
/**
* | output |
* | --- |
* | "No fields are set yet. These are guessed from the rows received." |
*
* @param {Datasets_Fields_GuessedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_fields_guessed = /** @type {((inputs?: Datasets_Fields_GuessedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Fields_GuessedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_fields_guessed(inputs)
	return __ja.datasets_fields_guessed(inputs)
});
/**
* | output |
* | --- |
* | "No fields yet." |
*
* @param {Datasets_Fields_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_fields_none = /** @type {((inputs?: Datasets_Fields_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Fields_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_fields_none(inputs)
	return __ja.datasets_fields_none(inputs)
});
/**
* | output |
* | --- |
* | "Enter JSON for \"{field}\"" |
*
* @param {Datasets_Json_InvalidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_json_invalid = /** @type {((inputs: Datasets_Json_InvalidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Json_InvalidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_json_invalid(inputs)
	return __ja.datasets_json_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Key" |
*
* @param {Datasets_KeyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_key = /** @type {((inputs?: Datasets_KeyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_KeyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_key(inputs)
	return __ja.datasets_key(inputs)
});
/**
* | output |
* | --- |
* | "Enter the key field \"{field}\"" |
*
* @param {Datasets_Key_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_key_missing = /** @type {((inputs: Datasets_Key_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Key_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_key_missing(inputs)
	return __ja.datasets_key_missing(inputs)
});
/**
* | output |
* | --- |
* | "Rows" |
*
* @param {Datasets_LatestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_latest = /** @type {((inputs?: Datasets_LatestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_LatestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_latest(inputs)
	return __ja.datasets_latest(inputs)
});
/**
* | output |
* | --- |
* | "Newest write first · {shown} / {count} rows" |
*
* @param {Datasets_Latest_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_latest_note = /** @type {((inputs: Datasets_Latest_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Latest_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_latest_note(inputs)
	return __ja.datasets_latest_note(inputs)
});
/**
* | output |
* | --- |
* | "Dataset" |
*
* @param {Datasets_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_list = /** @type {((inputs?: Datasets_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_list(inputs)
	return __ja.datasets_list(inputs)
});
/**
* | output |
* | --- |
* | "Back to Documents" |
*
* @param {Datasets_List_BackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_list_back = /** @type {((inputs?: Datasets_List_BackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_List_BackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_list_back(inputs)
	return __ja.datasets_list_back(inputs)
});
/**
* | output |
* | --- |
* | "No datasets yet." |
*
* @param {Datasets_List_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_list_empty = /** @type {((inputs?: Datasets_List_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_List_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_list_empty(inputs)
	return __ja.datasets_list_empty(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load the datasets" |
*
* @param {Datasets_List_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_list_load_failed = /** @type {((inputs?: Datasets_List_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_List_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_list_load_failed(inputs)
	return __ja.datasets_list_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "New dataset" |
*
* @param {Datasets_List_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_list_new = /** @type {((inputs?: Datasets_List_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_List_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_list_new(inputs)
	return __ja.datasets_list_new(inputs)
});
/**
* | output |
* | --- |
* | "No datasets match." |
*
* @param {Datasets_List_None_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_list_none_match = /** @type {((inputs?: Datasets_List_None_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_List_None_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_list_none_match(inputs)
	return __ja.datasets_list_none_match(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load the dataset" |
*
* @param {Datasets_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_load_failed = /** @type {((inputs?: Datasets_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_load_failed(inputs)
	return __ja.datasets_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Create" |
*
* @param {Datasets_New_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_new_create = /** @type {((inputs?: Datasets_New_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_New_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_new_create(inputs)
	return __ja.datasets_new_create(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't create the dataset" |
*
* @param {Datasets_New_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_new_failed = /** @type {((inputs?: Datasets_New_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_New_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_new_failed(inputs)
	return __ja.datasets_new_failed(inputs)
});
/**
* | output |
* | --- |
* | "Keeps the JSON rows that scripts and agents send. Only you see this dataset, and your own documents' ui can read it. Fields are guessed from the rows receive..." |
*
* @param {Datasets_New_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_new_note = /** @type {((inputs?: Datasets_New_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_New_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_new_note(inputs)
	return __ja.datasets_new_note(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Datasets_New_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_new_title = /** @type {((inputs?: Datasets_New_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_New_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_new_title(inputs)
	return __ja.datasets_new_title(inputs)
});
/**
* | output |
* | --- |
* | "No rows yet." |
*
* @param {Datasets_No_RowsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_no_rows = /** @type {((inputs?: Datasets_No_RowsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_No_RowsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_no_rows(inputs)
	return __ja.datasets_no_rows(inputs)
});
/**
* | output |
* | --- |
* | "This dataset can't be found." |
*
* @param {Datasets_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_not_found = /** @type {((inputs?: Datasets_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_not_found(inputs)
	return __ja.datasets_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Enter a number for \"{field}\"" |
*
* @param {Datasets_Number_InvalidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_number_invalid = /** @type {((inputs: Datasets_Number_InvalidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Number_InvalidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_number_invalid(inputs)
	return __ja.datasets_number_invalid(inputs)
});
/**
* | output |
* | --- |
* | "Rows older than {days} days are deleted" |
*
* @param {Datasets_RetentionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_retention = /** @type {((inputs: Datasets_RetentionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_RetentionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_retention(inputs)
	return __ja.datasets_retention(inputs)
});
/**
* | output |
* | --- |
* | "Row actions" |
*
* @param {Datasets_Row_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_row_actions = /** @type {((inputs?: Datasets_Row_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Row_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_row_actions(inputs)
	return __ja.datasets_row_actions(inputs)
});
/**
* | output |
* | --- |
* | "Row (JSON)" |
*
* @param {Datasets_Row_JsonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_row_json = /** @type {((inputs?: Datasets_Row_JsonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Row_JsonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_row_json(inputs)
	return __ja.datasets_row_json(inputs)
});
/**
* | output |
* | --- |
* | "Enter a JSON object" |
*
* @param {Datasets_Row_Json_InvalidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_row_json_invalid = /** @type {((inputs?: Datasets_Row_Json_InvalidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Row_Json_InvalidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_row_json_invalid(inputs)
	return __ja.datasets_row_json_invalid(inputs)
});
/**
* | output |
* | --- |
* | "{count} rows" |
*
* @param {Datasets_RowsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_rows = /** @type {((inputs: Datasets_RowsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_RowsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_rows(inputs)
	return __ja.datasets_rows(inputs)
});
/**
* | output |
* | --- |
* | "{count} distinct" |
*
* @param {Datasets_Stat_DistinctInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_stat_distinct = /** @type {((inputs: Datasets_Stat_DistinctInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Stat_DistinctInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_stat_distinct(inputs)
	return __ja.datasets_stat_distinct(inputs)
});
/**
* | output |
* | --- |
* | "Max {value}" |
*
* @param {Datasets_Stat_MaxInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_stat_max = /** @type {((inputs: Datasets_Stat_MaxInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Stat_MaxInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_stat_max(inputs)
	return __ja.datasets_stat_max(inputs)
});
/**
* | output |
* | --- |
* | "Mean {value}" |
*
* @param {Datasets_Stat_MeanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_stat_mean = /** @type {((inputs: Datasets_Stat_MeanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Stat_MeanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_stat_mean(inputs)
	return __ja.datasets_stat_mean(inputs)
});
/**
* | output |
* | --- |
* | "Min {value}" |
*
* @param {Datasets_Stat_MinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_stat_min = /** @type {((inputs: Datasets_Stat_MinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Stat_MinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_stat_min(inputs)
	return __ja.datasets_stat_min(inputs)
});
/**
* | output |
* | --- |
* | "{count} checked" |
*
* @param {Datasets_Stat_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_stat_on = /** @type {((inputs: Datasets_Stat_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Stat_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_stat_on(inputs)
	return __ja.datasets_stat_on(inputs)
});
/**
* | output |
* | --- |
* | "{first} – {last}" |
*
* @param {Datasets_Stat_RangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_stat_range = /** @type {((inputs: Datasets_Stat_RangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Stat_RangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_stat_range(inputs)
	return __ja.datasets_stat_range(inputs)
});
/**
* | output |
* | --- |
* | "Total {value}" |
*
* @param {Datasets_Stat_SumInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_stat_sum = /** @type {((inputs: Datasets_Stat_SumInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Stat_SumInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_stat_sum(inputs)
	return __ja.datasets_stat_sum(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Datasets_Token_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_close = /** @type {((inputs?: Datasets_Token_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_close(inputs)
	return __ja.datasets_token_close(inputs)
});
/**
* | output |
* | --- |
* | "Issued {date}" |
*
* @param {Datasets_Token_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_created = /** @type {((inputs: Datasets_Token_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_created(inputs)
	return __ja.datasets_token_created(inputs)
});
/**
* | output |
* | --- |
* | "Endpoint" |
*
* @param {Datasets_Token_EndpointInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_endpoint = /** @type {((inputs?: Datasets_Token_EndpointInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_EndpointInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_endpoint(inputs)
	return __ja.datasets_token_endpoint(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't issue the token" |
*
* @param {Datasets_Token_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_failed = /** @type {((inputs?: Datasets_Token_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_failed(inputs)
	return __ja.datasets_token_failed(inputs)
});
/**
* | output |
* | --- |
* | "Issue token" |
*
* @param {Datasets_Token_IssueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_issue = /** @type {((inputs?: Datasets_Token_IssueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_IssueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_issue(inputs)
	return __ja.datasets_token_issue(inputs)
});
/**
* | output |
* | --- |
* | "Issue" |
*
* @param {Datasets_Token_Issue_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_issue_action = /** @type {((inputs?: Datasets_Token_Issue_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_Issue_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_issue_action(inputs)
	return __ja.datasets_token_issue_action(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Datasets_Token_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_name = /** @type {((inputs?: Datasets_Token_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_name(inputs)
	return __ja.datasets_token_name(inputs)
});
/**
* | output |
* | --- |
* | "e.g. Morning CI" |
*
* @param {Datasets_Token_Name_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_name_placeholder = /** @type {((inputs?: Datasets_Token_Name_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_Name_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_name_placeholder(inputs)
	return __ja.datasets_token_name_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Revoke" |
*
* @param {Datasets_Token_RevokeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_revoke = /** @type {((inputs?: Datasets_Token_RevokeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_RevokeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_revoke(inputs)
	return __ja.datasets_token_revoke(inputs)
});
/**
* | output |
* | --- |
* | "Scripts using this token will no longer be able to write to this dataset. This can't be undone." |
*
* @param {Datasets_Token_Revoke_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_revoke_body = /** @type {((inputs?: Datasets_Token_Revoke_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_Revoke_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_revoke_body(inputs)
	return __ja.datasets_token_revoke_body(inputs)
});
/**
* | output |
* | --- |
* | "Revoke \"{name}\"" |
*
* @param {Datasets_Token_Revoke_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_revoke_label = /** @type {((inputs: Datasets_Token_Revoke_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_Revoke_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_revoke_label(inputs)
	return __ja.datasets_token_revoke_label(inputs)
});
/**
* | output |
* | --- |
* | "This token is shown only now. Copy it into your script." |
*
* @param {Datasets_Token_Shown_OnceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_shown_once = /** @type {((inputs?: Datasets_Token_Shown_OnceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_Shown_OnceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_shown_once(inputs)
	return __ja.datasets_token_shown_once(inputs)
});
/**
* | output |
* | --- |
* | "Never used" |
*
* @param {Datasets_Token_UnusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_unused = /** @type {((inputs?: Datasets_Token_UnusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_UnusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_unused(inputs)
	return __ja.datasets_token_unused(inputs)
});
/**
* | output |
* | --- |
* | "Last used {date}" |
*
* @param {Datasets_Token_UsedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_token_used = /** @type {((inputs: Datasets_Token_UsedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Token_UsedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_token_used(inputs)
	return __ja.datasets_token_used(inputs)
});
/**
* | output |
* | --- |
* | "Write tokens" |
*
* @param {Datasets_TokensInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_tokens = /** @type {((inputs?: Datasets_TokensInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_TokensInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_tokens(inputs)
	return __ja.datasets_tokens(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load the tokens" |
*
* @param {Datasets_Tokens_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_tokens_failed = /** @type {((inputs?: Datasets_Tokens_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Tokens_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_tokens_failed(inputs)
	return __ja.datasets_tokens_failed(inputs)
});
/**
* | output |
* | --- |
* | "Your personal data moved, so tokens issued before the move no longer work." |
*
* @param {Datasets_Tokens_LeftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_tokens_left = /** @type {((inputs?: Datasets_Tokens_LeftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Tokens_LeftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_tokens_left(inputs)
	return __ja.datasets_tokens_left(inputs)
});
/**
* | output |
* | --- |
* | "To keep sending rows from a script, issue a new token and replace the one set in the script." |
*
* @param {Datasets_Tokens_Left_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_tokens_left_next = /** @type {((inputs?: Datasets_Tokens_Left_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Tokens_Left_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_tokens_left_next(inputs)
	return __ja.datasets_tokens_left_next(inputs)
});
/**
* | output |
* | --- |
* | "No tokens yet." |
*
* @param {Datasets_Tokens_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_tokens_none = /** @type {((inputs?: Datasets_Tokens_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Tokens_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_tokens_none(inputs)
	return __ja.datasets_tokens_none(inputs)
});
/**
* | output |
* | --- |
* | "Scripts use these to send rows. A token can only write rows of this dataset." |
*
* @param {Datasets_Tokens_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_tokens_note = /** @type {((inputs?: Datasets_Tokens_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Tokens_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_tokens_note(inputs)
	return __ja.datasets_tokens_note(inputs)
});
/**
* | output |
* | --- |
* | "While your personal data is in the Vault, write tokens can't be used. Add rows with \"Add row\" or through an agent." |
*
* @param {Datasets_Tokens_VaultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_tokens_vault = /** @type {((inputs?: Datasets_Tokens_VaultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Tokens_VaultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_tokens_vault(inputs)
	return __ja.datasets_tokens_vault(inputs)
});
/**
* | output |
* | --- |
* | "Checkbox" |
*
* @param {Datasets_Type_BooleanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_type_boolean = /** @type {((inputs?: Datasets_Type_BooleanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Type_BooleanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_type_boolean(inputs)
	return __ja.datasets_type_boolean(inputs)
});
/**
* | output |
* | --- |
* | "Date" |
*
* @param {Datasets_Type_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_type_date = /** @type {((inputs?: Datasets_Type_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Type_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_type_date(inputs)
	return __ja.datasets_type_date(inputs)
});
/**
* | output |
* | --- |
* | "Date & time" |
*
* @param {Datasets_Type_DatetimeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_type_datetime = /** @type {((inputs?: Datasets_Type_DatetimeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Type_DatetimeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_type_datetime(inputs)
	return __ja.datasets_type_datetime(inputs)
});
/**
* | output |
* | --- |
* | "JSON" |
*
* @param {Datasets_Type_JsonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_type_json = /** @type {((inputs?: Datasets_Type_JsonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Type_JsonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_type_json(inputs)
	return __ja.datasets_type_json(inputs)
});
/**
* | output |
* | --- |
* | "Number" |
*
* @param {Datasets_Type_NumberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_type_number = /** @type {((inputs?: Datasets_Type_NumberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Type_NumberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_type_number(inputs)
	return __ja.datasets_type_number(inputs)
});
/**
* | output |
* | --- |
* | "Text" |
*
* @param {Datasets_Type_StringInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_type_string = /** @type {((inputs?: Datasets_Type_StringInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Type_StringInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_type_string(inputs)
	return __ja.datasets_type_string(inputs)
});
/**
* | output |
* | --- |
* | "Updated {time}" |
*
* @param {Datasets_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_updated = /** @type {((inputs: Datasets_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_updated(inputs)
	return __ja.datasets_updated(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Datasets_Viewer_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_viewer_close = /** @type {((inputs?: Datasets_Viewer_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Viewer_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_viewer_close(inputs)
	return __ja.datasets_viewer_close(inputs)
});
/**
* | output |
* | --- |
* | "Open dataset" |
*
* @param {Datasets_Viewer_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_viewer_open = /** @type {((inputs?: Datasets_Viewer_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Viewer_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_viewer_open(inputs)
	return __ja.datasets_viewer_open(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't save the row" |
*
* @param {Datasets_Write_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_write_failed = /** @type {((inputs?: Datasets_Write_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Write_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_write_failed(inputs)
	return __ja.datasets_write_failed(inputs)
});
/**
* | output |
* | --- |
* | "Written" |
*
* @param {Datasets_Written_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const datasets_written_at = /** @type {((inputs?: Datasets_Written_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Written_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.datasets_written_at(inputs)
	return __ja.datasets_written_at(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Desktop_Action_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_action_start = /** @type {((inputs?: Desktop_Action_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Action_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_action_start(inputs)
	return __ja.desktop_action_start(inputs)
});
/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Desktop_Action_StopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_action_stop = /** @type {((inputs?: Desktop_Action_StopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Action_StopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_action_stop(inputs)
	return __ja.desktop_action_stop(inputs)
});
/**
* | output |
* | --- |
* | "{version} (bundled with the app)" |
*
* @param {Desktop_Advanced_Agent_BundledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_advanced_agent_bundled = /** @type {((inputs: Desktop_Advanced_Agent_BundledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Advanced_Agent_BundledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_advanced_agent_bundled(inputs)
	return __ja.desktop_advanced_agent_bundled(inputs)
});
/**
* | output |
* | --- |
* | "An app update is available" |
*
* @param {Desktop_App_Update_AvailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_app_update_available = /** @type {((inputs?: Desktop_App_Update_AvailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_App_Update_AvailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_app_update_available(inputs)
	return __ja.desktop_app_update_available(inputs)
});
/**
* | output |
* | --- |
* | "Version {version}" |
*
* @param {Desktop_App_Update_VersionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_app_update_version = /** @type {((inputs: Desktop_App_Update_VersionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_App_Update_VersionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_app_update_version(inputs)
	return __ja.desktop_app_update_version(inputs)
});
/**
* | output |
* | --- |
* | "Flags" |
*
* @param {Desktop_Check_FlagsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_check_flags = /** @type {((inputs?: Desktop_Check_FlagsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Check_FlagsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_check_flags(inputs)
	return __ja.desktop_check_flags(inputs)
});
/**
* | output |
* | --- |
* | "Other MCPs" |
*
* @param {Desktop_Check_Foreign_McpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_check_foreign_mcp = /** @type {((inputs?: Desktop_Check_Foreign_McpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Check_Foreign_McpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_check_foreign_mcp(inputs)
	return __ja.desktop_check_foreign_mcp(inputs)
});
/**
* | output |
* | --- |
* | "Connectivity check" |
*
* @param {Desktop_Check_LiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_check_live = /** @type {((inputs?: Desktop_Check_LiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Check_LiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_check_live(inputs)
	return __ja.desktop_check_live(inputs)
});
/**
* | output |
* | --- |
* | "As of {at} ({version})" |
*
* @param {Desktop_Check_Live_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_check_live_at = /** @type {((inputs: Desktop_Check_Live_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Check_Live_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_check_live_at(inputs)
	return __ja.desktop_check_live_at(inputs)
});
/**
* | output |
* | --- |
* | "As of {at} ({version}; now {current} — outdated result)" |
*
* @param {Desktop_Check_Live_At_StaleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_check_live_at_stale = /** @type {((inputs: Desktop_Check_Live_At_StaleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Check_Live_At_StaleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_check_live_at_stale(inputs)
	return __ja.desktop_check_live_at_stale(inputs)
});
/**
* | output |
* | --- |
* | "Connectivity check: not run" |
*
* @param {Desktop_Check_Live_Not_RunInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_check_live_not_run = /** @type {((inputs?: Desktop_Check_Live_Not_RunInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Check_Live_Not_RunInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_check_live_not_run(inputs)
	return __ja.desktop_check_live_not_run(inputs)
});
/**
* | output |
* | --- |
* | "Registers this Mac as a trameria device and starts the Agent" |
*
* @param {Desktop_Device_Add_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_device_add_hint = /** @type {((inputs?: Desktop_Device_Add_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Device_Add_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_device_add_hint(inputs)
	return __ja.desktop_device_add_hint(inputs)
});
/**
* | output |
* | --- |
* | "Log in in the trameria window first" |
*
* @param {Desktop_Device_Needs_LoginInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_device_needs_login = /** @type {((inputs?: Desktop_Device_Needs_LoginInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Device_Needs_LoginInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_device_needs_login(inputs)
	return __ja.desktop_device_needs_login(inputs)
});
/**
* | output |
* | --- |
* | "Not a trameria device" |
*
* @param {Desktop_Device_Not_RegisteredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_device_not_registered = /** @type {((inputs?: Desktop_Device_Not_RegisteredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Device_Not_RegisteredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_device_not_registered(inputs)
	return __ja.desktop_device_not_registered(inputs)
});
/**
* | output |
* | --- |
* | "Registered as a trameria device" |
*
* @param {Desktop_Device_RegisteredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_device_registered = /** @type {((inputs?: Desktop_Device_RegisteredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Device_RegisteredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_device_registered(inputs)
	return __ja.desktop_device_registered(inputs)
});
/**
* | output |
* | --- |
* | "Stops the Agent and removes this Mac from your trameria devices" |
*
* @param {Desktop_Device_Remove_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_device_remove_hint = /** @type {((inputs?: Desktop_Device_Remove_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Device_Remove_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_device_remove_hint(inputs)
	return __ja.desktop_device_remove_hint(inputs)
});
/**
* | output |
* | --- |
* | "This Mac was removed from your devices. To use it again, choose “Use this Mac as a device”" |
*
* @param {Desktop_Device_Removed_ElsewhereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_device_removed_elsewhere = /** @type {((inputs?: Desktop_Device_Removed_ElsewhereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Device_Removed_ElsewhereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_device_removed_elsewhere(inputs)
	return __ja.desktop_device_removed_elsewhere(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Desktop_Find_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_find_close = /** @type {((inputs?: Desktop_Find_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Find_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_find_close(inputs)
	return __ja.desktop_find_close(inputs)
});
/**
* | output |
* | --- |
* | "Next" |
*
* @param {Desktop_Find_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_find_next = /** @type {((inputs?: Desktop_Find_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Find_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_find_next(inputs)
	return __ja.desktop_find_next(inputs)
});
/**
* | output |
* | --- |
* | "Find in page" |
*
* @param {Desktop_Find_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_find_placeholder = /** @type {((inputs?: Desktop_Find_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Find_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_find_placeholder(inputs)
	return __ja.desktop_find_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Previous" |
*
* @param {Desktop_Find_PreviousInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_find_previous = /** @type {((inputs?: Desktop_Find_PreviousInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Find_PreviousInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_find_previous(inputs)
	return __ja.desktop_find_previous(inputs)
});
/**
* | output |
* | --- |
* | "Start or stop the Agent" |
*
* @param {Desktop_Menubar_Agent_ToggleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_menubar_agent_toggle = /** @type {((inputs?: Desktop_Menubar_Agent_ToggleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Menubar_Agent_ToggleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_menubar_agent_toggle(inputs)
	return __ja.desktop_menubar_agent_toggle(inputs)
});
/**
* | output |
* | --- |
* | "Next · {time}" |
*
* @param {Desktop_Menubar_Block_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_menubar_block_next = /** @type {((inputs: Desktop_Menubar_Block_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Menubar_Block_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_menubar_block_next(inputs)
	return __ja.desktop_menubar_block_next(inputs)
});
/**
* | output |
* | --- |
* | "macOS notifications are not allowed" |
*
* @param {Desktop_Notifications_BlockedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_notifications_blocked = /** @type {((inputs?: Desktop_Notifications_BlockedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Notifications_BlockedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_notifications_blocked(inputs)
	return __ja.desktop_notifications_blocked(inputs)
});
/**
* | output |
* | --- |
* | "macOS notifications are not allowed. Allow this app in System Settings > Notifications to get mentions and other updates as macOS notifications" |
*
* @param {Desktop_Notifications_Blocked_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_notifications_blocked_note = /** @type {((inputs?: Desktop_Notifications_Blocked_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Notifications_Blocked_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_notifications_blocked_note(inputs)
	return __ja.desktop_notifications_blocked_note(inputs)
});
/**
* | output |
* | --- |
* | "Notifications need a signed build. This build cannot show macOS notifications" |
*
* @param {Desktop_Notifications_Need_Signed_BuildInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_notifications_need_signed_build = /** @type {((inputs?: Desktop_Notifications_Need_Signed_BuildInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Notifications_Need_Signed_BuildInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_notifications_need_signed_build(inputs)
	return __ja.desktop_notifications_need_signed_build(inputs)
});
/**
* | output |
* | --- |
* | "Open System Settings" |
*
* @param {Desktop_Notifications_Open_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_notifications_open_settings = /** @type {((inputs?: Desktop_Notifications_Open_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Notifications_Open_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_notifications_open_settings(inputs)
	return __ja.desktop_notifications_open_settings(inputs)
});
/**
* | output |
* | --- |
* | "Open trameria" |
*
* @param {Desktop_Open_MainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_open_main = /** @type {((inputs?: Desktop_Open_MainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Open_MainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_open_main(inputs)
	return __ja.desktop_open_main(inputs)
});
/**
* | output |
* | --- |
* | "Quit" |
*
* @param {Desktop_QuitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_quit = /** @type {((inputs?: Desktop_QuitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_QuitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_quit(inputs)
	return __ja.desktop_quit(inputs)
});
/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Desktop_Status_ConnectedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_status_connected = /** @type {((inputs?: Desktop_Status_ConnectedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Status_ConnectedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_status_connected(inputs)
	return __ja.desktop_status_connected(inputs)
});
/**
* | output |
* | --- |
* | "Error" |
*
* @param {Desktop_Status_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_status_error = /** @type {((inputs?: Desktop_Status_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Status_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_status_error(inputs)
	return __ja.desktop_status_error(inputs)
});
/**
* | output |
* | --- |
* | "Reconnecting" |
*
* @param {Desktop_Status_ReconnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_status_reconnecting = /** @type {((inputs?: Desktop_Status_ReconnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Status_ReconnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_status_reconnecting(inputs)
	return __ja.desktop_status_reconnecting(inputs)
});
/**
* | output |
* | --- |
* | "Starting" |
*
* @param {Desktop_Status_StartingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_status_starting = /** @type {((inputs?: Desktop_Status_StartingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Status_StartingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_status_starting(inputs)
	return __ja.desktop_status_starting(inputs)
});
/**
* | output |
* | --- |
* | "Stopped" |
*
* @param {Desktop_Status_StoppedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_status_stopped = /** @type {((inputs?: Desktop_Status_StoppedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Status_StoppedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_status_stopped(inputs)
	return __ja.desktop_status_stopped(inputs)
});
/**
* | output |
* | --- |
* | "Stopping" |
*
* @param {Desktop_Status_StoppingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_status_stopping = /** @type {((inputs?: Desktop_Status_StoppingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Status_StoppingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_status_stopping(inputs)
	return __ja.desktop_status_stopping(inputs)
});
/**
* | output |
* | --- |
* | "This environment can't store the login" |
*
* @param {Desktop_Token_UnavailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_token_unavailable = /** @type {((inputs?: Desktop_Token_UnavailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Token_UnavailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_token_unavailable(inputs)
	return __ja.desktop_token_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Loading usage…" |
*
* @param {Desktop_Usage_LoadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_loading = /** @type {((inputs?: Desktop_Usage_LoadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_LoadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_loading(inputs)
	return __ja.desktop_usage_loading(inputs)
});
/**
* | output |
* | --- |
* | "Not found on this Mac" |
*
* @param {Desktop_Usage_Not_InstalledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_not_installed = /** @type {((inputs?: Desktop_Usage_Not_InstalledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_Not_InstalledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_not_installed(inputs)
	return __ja.desktop_usage_not_installed(inputs)
});
/**
* | output |
* | --- |
* | "Fetching usage limits is turned off in settings" |
*
* @param {Desktop_Usage_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_off = /** @type {((inputs?: Desktop_Usage_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_off(inputs)
	return __ja.desktop_usage_off(inputs)
});
/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Desktop_Usage_RefreshInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_refresh = /** @type {((inputs?: Desktop_Usage_RefreshInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_RefreshInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_refresh(inputs)
	return __ja.desktop_usage_refresh(inputs)
});
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Desktop_Usage_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_settings = /** @type {((inputs?: Desktop_Usage_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_settings(inputs)
	return __ja.desktop_usage_settings(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't refresh: {error}" |
*
* @param {Desktop_Usage_Stale_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_stale_error = /** @type {((inputs: Desktop_Usage_Stale_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_Stale_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_stale_error(inputs)
	return __ja.desktop_usage_stale_error(inputs)
});
/**
* | output |
* | --- |
* | "trameria usage" |
*
* @param {Desktop_Usage_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_title = /** @type {((inputs?: Desktop_Usage_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_title(inputs)
	return __ja.desktop_usage_title(inputs)
});
/**
* | output |
* | --- |
* | "As of {time}" |
*
* @param {Desktop_Usage_Updated_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_updated_at = /** @type {((inputs: Desktop_Usage_Updated_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_Updated_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_updated_at(inputs)
	return __ja.desktop_usage_updated_at(inputs)
});
/**
* | output |
* | --- |
* | "Updated {n} min ago" |
*
* @param {Desktop_Usage_Updated_Minutes_AgoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const desktop_usage_updated_minutes_ago = /** @type {((inputs: Desktop_Usage_Updated_Minutes_AgoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Usage_Updated_Minutes_AgoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.desktop_usage_updated_minutes_ago(inputs)
	return __ja.desktop_usage_updated_minutes_ago(inputs)
});
/**
* | output |
* | --- |
* | "AI memo" |
*
* @param {Documents_Agent_MemoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_agent_memo = /** @type {((inputs?: Documents_Agent_MemoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Agent_MemoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_agent_memo(inputs)
	return __ja.documents_agent_memo(inputs)
});
/**
* | output |
* | --- |
* | "Archive" |
*
* @param {Documents_ArchiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_archive = /** @type {((inputs?: Documents_ArchiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_ArchiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_archive(inputs)
	return __ja.documents_archive(inputs)
});
/**
* | output |
* | --- |
* | "Could not archive “{title}”" |
*
* @param {Documents_Archive_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_archive_failed = /** @type {((inputs: Documents_Archive_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Archive_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_archive_failed(inputs)
	return __ja.documents_archive_failed(inputs)
});
/**
* | output |
* | --- |
* | "Bulleted list" |
*
* @param {Documents_Block_Bullet_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_bullet_list = /** @type {((inputs?: Documents_Block_Bullet_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Bullet_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_bullet_list(inputs)
	return __ja.documents_block_bullet_list(inputs)
});
/**
* | output |
* | --- |
* | "Callout" |
*
* @param {Documents_Block_CalloutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_callout = /** @type {((inputs?: Documents_Block_CalloutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_CalloutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_callout(inputs)
	return __ja.documents_block_callout(inputs)
});
/**
* | output |
* | --- |
* | "Code" |
*
* @param {Documents_Block_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_code = /** @type {((inputs?: Documents_Block_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_code(inputs)
	return __ja.documents_block_code(inputs)
});
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Documents_Block_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_copied = /** @type {((inputs?: Documents_Block_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_copied(inputs)
	return __ja.documents_block_copied(inputs)
});
/**
* | output |
* | --- |
* | "Could not copy" |
*
* @param {Documents_Block_Copy_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_copy_failed = /** @type {((inputs?: Documents_Block_Copy_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Copy_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_copy_failed(inputs)
	return __ja.documents_block_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "Copy as Markdown" |
*
* @param {Documents_Block_Copy_MarkdownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_copy_markdown = /** @type {((inputs?: Documents_Block_Copy_MarkdownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Copy_MarkdownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_copy_markdown(inputs)
	return __ja.documents_block_copy_markdown(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Documents_Block_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_delete = /** @type {((inputs?: Documents_Block_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_delete(inputs)
	return __ja.documents_block_delete(inputs)
});
/**
* | output |
* | --- |
* | "Divider" |
*
* @param {Documents_Block_DividerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_divider = /** @type {((inputs?: Documents_Block_DividerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_DividerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_divider(inputs)
	return __ja.documents_block_divider(inputs)
});
/**
* | output |
* | --- |
* | "Duplicate" |
*
* @param {Documents_Block_DuplicateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_duplicate = /** @type {((inputs?: Documents_Block_DuplicateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_DuplicateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_duplicate(inputs)
	return __ja.documents_block_duplicate(inputs)
});
/**
* | output |
* | --- |
* | "File" |
*
* @param {Documents_Block_FileInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_file = /** @type {((inputs?: Documents_Block_FileInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_FileInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_file(inputs)
	return __ja.documents_block_file(inputs)
});
/**
* | output |
* | --- |
* | "Image, attachment" |
*
* @param {Documents_Block_File_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_file_hint = /** @type {((inputs?: Documents_Block_File_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_File_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_file_hint(inputs)
	return __ja.documents_block_file_hint(inputs)
});
/**
* | output |
* | --- |
* | "Footnote" |
*
* @param {Documents_Block_FootnoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_footnote = /** @type {((inputs?: Documents_Block_FootnoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_FootnoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_footnote(inputs)
	return __ja.documents_block_footnote(inputs)
});
/**
* | output |
* | --- |
* | "Heading 1" |
*
* @param {Documents_Block_Heading1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_heading1 = /** @type {((inputs?: Documents_Block_Heading1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Heading1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_heading1(inputs)
	return __ja.documents_block_heading1(inputs)
});
/**
* | output |
* | --- |
* | "Heading 2" |
*
* @param {Documents_Block_Heading2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_heading2 = /** @type {((inputs?: Documents_Block_Heading2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Heading2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_heading2(inputs)
	return __ja.documents_block_heading2(inputs)
});
/**
* | output |
* | --- |
* | "Heading 3" |
*
* @param {Documents_Block_Heading3Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_heading3 = /** @type {((inputs?: Documents_Block_Heading3Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Heading3Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_heading3(inputs)
	return __ja.documents_block_heading3(inputs)
});
/**
* | output |
* | --- |
* | "Insert a block" |
*
* @param {Documents_Block_InsertInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_insert = /** @type {((inputs?: Documents_Block_InsertInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_InsertInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_insert(inputs)
	return __ja.documents_block_insert(inputs)
});
/**
* | output |
* | --- |
* | "Move out of the quote" |
*
* @param {Documents_Block_Lift_OutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_lift_out = /** @type {((inputs?: Documents_Block_Lift_OutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Lift_OutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_lift_out(inputs)
	return __ja.documents_block_lift_out(inputs)
});
/**
* | output |
* | --- |
* | "Block actions" |
*
* @param {Documents_Block_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_menu = /** @type {((inputs?: Documents_Block_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_menu(inputs)
	return __ja.documents_block_menu(inputs)
});
/**
* | output |
* | --- |
* | "This block" |
*
* @param {Documents_Block_Menu_Section_BlockInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_menu_section_block = /** @type {((inputs?: Documents_Block_Menu_Section_BlockInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Menu_Section_BlockInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_menu_section_block(inputs)
	return __ja.documents_block_menu_section_block(inputs)
});
/**
* | output |
* | --- |
* | "Turn into" |
*
* @param {Documents_Block_Menu_Section_TypeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_menu_section_type = /** @type {((inputs?: Documents_Block_Menu_Section_TypeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Menu_Section_TypeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_menu_section_type(inputs)
	return __ja.documents_block_menu_section_type(inputs)
});
/**
* | output |
* | --- |
* | "Diagram (mermaid)" |
*
* @param {Documents_Block_MermaidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_mermaid = /** @type {((inputs?: Documents_Block_MermaidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_MermaidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_mermaid(inputs)
	return __ja.documents_block_mermaid(inputs)
});
/**
* | output |
* | --- |
* | "Numbered list" |
*
* @param {Documents_Block_Numbered_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_numbered_list = /** @type {((inputs?: Documents_Block_Numbered_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Numbered_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_numbered_list(inputs)
	return __ja.documents_block_numbered_list(inputs)
});
/**
* | output |
* | --- |
* | "Text" |
*
* @param {Documents_Block_ParagraphInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_paragraph = /** @type {((inputs?: Documents_Block_ParagraphInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_ParagraphInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_paragraph(inputs)
	return __ja.documents_block_paragraph(inputs)
});
/**
* | output |
* | --- |
* | "Quote" |
*
* @param {Documents_Block_QuoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_quote = /** @type {((inputs?: Documents_Block_QuoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_QuoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_quote(inputs)
	return __ja.documents_block_quote(inputs)
});
/**
* | output |
* | --- |
* | "Table" |
*
* @param {Documents_Block_TableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_table = /** @type {((inputs?: Documents_Block_TableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_TableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_table(inputs)
	return __ja.documents_block_table(inputs)
});
/**
* | output |
* | --- |
* | "Task list" |
*
* @param {Documents_Block_Task_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_task_list = /** @type {((inputs?: Documents_Block_Task_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Task_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_task_list(inputs)
	return __ja.documents_block_task_list(inputs)
});
/**
* | output |
* | --- |
* | "Toggle" |
*
* @param {Documents_Block_ToggleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_toggle = /** @type {((inputs?: Documents_Block_ToggleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_ToggleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_toggle(inputs)
	return __ja.documents_block_toggle(inputs)
});
/**
* | output |
* | --- |
* | "Remove the list" |
*
* @param {Documents_Block_Unwrap_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_unwrap_list = /** @type {((inputs?: Documents_Block_Unwrap_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Unwrap_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_unwrap_list(inputs)
	return __ja.documents_block_unwrap_list(inputs)
});
/**
* | output |
* | --- |
* | "Remove the quote" |
*
* @param {Documents_Block_Unwrap_QuoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_block_unwrap_quote = /** @type {((inputs?: Documents_Block_Unwrap_QuoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Block_Unwrap_QuoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_block_unwrap_quote(inputs)
	return __ja.documents_block_unwrap_quote(inputs)
});
/**
* | output |
* | --- |
* | "Body" |
*
* @param {Documents_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_body = /** @type {((inputs?: Documents_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_body(inputs)
	return __ja.documents_body(inputs)
});
/**
* | output |
* | --- |
* | "Start writing, or type “/” for blocks" |
*
* @param {Documents_Body_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_body_placeholder = /** @type {((inputs?: Documents_Body_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Body_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_body_placeholder(inputs)
	return __ja.documents_body_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Documents_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_close = /** @type {((inputs?: Documents_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_close(inputs)
	return __ja.documents_close(inputs)
});
/**
* | output |
* | --- |
* | "Created" |
*
* @param {Documents_Col_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_col_created = /** @type {((inputs?: Documents_Col_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Col_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_col_created(inputs)
	return __ja.documents_col_created(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Documents_Col_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_col_name = /** @type {((inputs?: Documents_Col_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Col_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_col_name(inputs)
	return __ja.documents_col_name(inputs)
});
/**
* | output |
* | --- |
* | "Updated" |
*
* @param {Documents_Col_UpdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_col_updated = /** @type {((inputs?: Documents_Col_UpdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Col_UpdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_col_updated(inputs)
	return __ja.documents_col_updated(inputs)
});
/**
* | output |
* | --- |
* | "Copied to your documents" |
*
* @param {Documents_Copied_To_OwnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_copied_to_own = /** @type {((inputs?: Documents_Copied_To_OwnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Copied_To_OwnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_copied_to_own(inputs)
	return __ja.documents_copied_to_own(inputs)
});
/**
* | output |
* | --- |
* | "Make a copy" |
*
* @param {Documents_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_copy = /** @type {((inputs?: Documents_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_copy(inputs)
	return __ja.documents_copy(inputs)
});
/**
* | output |
* | --- |
* | "Could not copy “{title}”" |
*
* @param {Documents_Copy_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_copy_failed = /** @type {((inputs: Documents_Copy_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Copy_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_copy_failed(inputs)
	return __ja.documents_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "Copy to my documents" |
*
* @param {Documents_Copy_To_OwnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_copy_to_own = /** @type {((inputs?: Documents_Copy_To_OwnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Copy_To_OwnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_copy_to_own(inputs)
	return __ja.documents_copy_to_own(inputs)
});
/**
* | output |
* | --- |
* | "Create a document" |
*
* @param {Documents_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_create = /** @type {((inputs?: Documents_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_create(inputs)
	return __ja.documents_create(inputs)
});
/**
* | output |
* | --- |
* | "Could not create the document" |
*
* @param {Documents_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_create_failed = /** @type {((inputs?: Documents_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_create_failed(inputs)
	return __ja.documents_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Documents_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_delete = /** @type {((inputs?: Documents_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_delete(inputs)
	return __ja.documents_delete(inputs)
});
/**
* | output |
* | --- |
* | "Its text and history go with it. This cannot be undone." |
*
* @param {Documents_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_delete_body = /** @type {((inputs?: Documents_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_delete_body(inputs)
	return __ja.documents_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete “{title}”" |
*
* @param {Documents_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_delete_failed = /** @type {((inputs: Documents_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_delete_failed(inputs)
	return __ja.documents_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "The text and history of {names} go with them. This cannot be undone." |
*
* @param {Documents_Delete_Many_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_delete_many_body = /** @type {((inputs: Documents_Delete_Many_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Delete_Many_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_delete_many_body(inputs)
	return __ja.documents_delete_many_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete {count} documents" |
*
* @param {Documents_Delete_Many_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_delete_many_title = /** @type {((inputs: Documents_Delete_Many_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Delete_Many_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_delete_many_title(inputs)
	return __ja.documents_delete_many_title(inputs)
});
/**
* | output |
* | --- |
* | "Delete “{title}”" |
*
* @param {Documents_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_delete_title = /** @type {((inputs: Documents_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_delete_title(inputs)
	return __ja.documents_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "No documents yet." |
*
* @param {Documents_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_empty = /** @type {((inputs?: Documents_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_empty(inputs)
	return __ja.documents_empty(inputs)
});
/**
* | output |
* | --- |
* | "No archived documents." |
*
* @param {Documents_Empty_ArchivedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_empty_archived = /** @type {((inputs?: Documents_Empty_ArchivedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Empty_ArchivedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_empty_archived(inputs)
	return __ja.documents_empty_archived(inputs)
});
/**
* | output |
* | --- |
* | "History" |
*
* @param {Documents_HistoryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history = /** @type {((inputs?: Documents_HistoryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_HistoryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history(inputs)
	return __ja.documents_history(inputs)
});
/**
* | output |
* | --- |
* | "{name} ({connection})" |
*
* @param {Documents_History_Actor_ViaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_actor_via = /** @type {((inputs: Documents_History_Actor_ViaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_Actor_ViaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_actor_via(inputs)
	return __ja.documents_history_actor_via(inputs)
});
/**
* | output |
* | --- |
* | "Changed places: {count}" |
*
* @param {Documents_History_Change_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_change_count = /** @type {((inputs: Documents_History_Change_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_Change_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_change_count(inputs)
	return __ja.documents_history_change_count(inputs)
});
/**
* | output |
* | --- |
* | "Changes" |
*
* @param {Documents_History_ChangesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_changes = /** @type {((inputs?: Documents_History_ChangesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_ChangesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_changes(inputs)
	return __ja.documents_history_changes(inputs)
});
/**
* | output |
* | --- |
* | "No history yet." |
*
* @param {Documents_History_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_empty = /** @type {((inputs?: Documents_History_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_empty(inputs)
	return __ja.documents_history_empty(inputs)
});
/**
* | output |
* | --- |
* | "Could not load the history" |
*
* @param {Documents_History_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_failed = /** @type {((inputs?: Documents_History_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_failed(inputs)
	return __ja.documents_history_failed(inputs)
});
/**
* | output |
* | --- |
* | "This is the latest version" |
*
* @param {Documents_History_Is_LatestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_is_latest = /** @type {((inputs?: Documents_History_Is_LatestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_Is_LatestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_is_latest(inputs)
	return __ja.documents_history_is_latest(inputs)
});
/**
* | output |
* | --- |
* | "latest" |
*
* @param {Documents_History_LatestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_latest = /** @type {((inputs?: Documents_History_LatestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_LatestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_latest(inputs)
	return __ja.documents_history_latest(inputs)
});
/**
* | output |
* | --- |
* | "No text" |
*
* @param {Documents_History_No_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_no_body = /** @type {((inputs?: Documents_History_No_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_No_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_no_body(inputs)
	return __ja.documents_history_no_body(inputs)
});
/**
* | output |
* | --- |
* | "No changes from the previous version" |
*
* @param {Documents_History_No_ChangesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_no_changes = /** @type {((inputs?: Documents_History_No_ChangesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_No_ChangesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_no_changes(inputs)
	return __ja.documents_history_no_changes(inputs)
});
/**
* | output |
* | --- |
* | "restored" |
*
* @param {Documents_History_RestoredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_restored = /** @type {((inputs?: Documents_History_RestoredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_RestoredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_restored(inputs)
	return __ja.documents_history_restored(inputs)
});
/**
* | output |
* | --- |
* | "{count} saves" |
*
* @param {Documents_History_SavesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_saves = /** @type {((inputs: Documents_History_SavesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_SavesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_saves(inputs)
	return __ja.documents_history_saves(inputs)
});
/**
* | output |
* | --- |
* | "Recorded automatically" |
*
* @param {Documents_History_SystemInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_system = /** @type {((inputs?: Documents_History_SystemInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_SystemInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_system(inputs)
	return __ja.documents_history_system(inputs)
});
/**
* | output |
* | --- |
* | "{count} unchanged lines" |
*
* @param {Documents_History_UnchangedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_unchanged = /** @type {((inputs: Documents_History_UnchangedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_UnchangedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_unchanged(inputs)
	return __ja.documents_history_unchanged(inputs)
});
/**
* | output |
* | --- |
* | "Versions" |
*
* @param {Documents_History_VersionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_history_versions = /** @type {((inputs?: Documents_History_VersionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_History_VersionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_history_versions(inputs)
	return __ja.documents_history_versions(inputs)
});
/**
* | output |
* | --- |
* | "Add a document" |
*
* @param {Documents_Index_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_add = /** @type {((inputs?: Documents_Index_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_add(inputs)
	return __ja.documents_index_add(inputs)
});
/**
* | output |
* | --- |
* | "Add a document you made…" |
*
* @param {Documents_Index_Add_ExistingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_add_existing = /** @type {((inputs?: Documents_Index_Add_ExistingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Add_ExistingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_add_existing(inputs)
	return __ja.documents_index_add_existing(inputs)
});
/**
* | output |
* | --- |
* | "Could not add “{title}”" |
*
* @param {Documents_Index_Add_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_add_failed = /** @type {((inputs: Documents_Index_Add_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Add_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_add_failed(inputs)
	return __ja.documents_index_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "New document" |
*
* @param {Documents_Index_Add_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_add_new = /** @type {((inputs?: Documents_Index_Add_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Add_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_add_new(inputs)
	return __ja.documents_index_add_new(inputs)
});
/**
* | output |
* | --- |
* | "This index is archived. It can be read but not rearranged." |
*
* @param {Documents_Index_ArchivedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_archived = /** @type {((inputs?: Documents_Index_ArchivedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_ArchivedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_archived(inputs)
	return __ja.documents_index_archived(inputs)
});
/**
* | output |
* | --- |
* | "Index" |
*
* @param {Documents_Index_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_button = /** @type {((inputs?: Documents_Index_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_button(inputs)
	return __ja.documents_index_button(inputs)
});
/**
* | output |
* | --- |
* | "Could not make the index" |
*
* @param {Documents_Index_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_create_failed = /** @type {((inputs?: Documents_Index_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_create_failed(inputs)
	return __ja.documents_index_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Make a new index with it" |
*
* @param {Documents_Index_Create_WithInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_create_with = /** @type {((inputs?: Documents_Index_Create_WithInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Create_WithInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_create_with(inputs)
	return __ja.documents_index_create_with(inputs)
});
/**
* | output |
* | --- |
* | "Index of {title}" |
*
* @param {Documents_Index_Default_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_default_title = /** @type {((inputs: Documents_Index_Default_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Default_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_default_title(inputs)
	return __ja.documents_index_default_title(inputs)
});
/**
* | output |
* | --- |
* | "Its order of documents goes with it; the documents in it stay. This cannot be undone." |
*
* @param {Documents_Index_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_delete_body = /** @type {((inputs?: Documents_Index_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_delete_body(inputs)
	return __ja.documents_index_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Take out of this index" |
*
* @param {Documents_Index_DetachInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_detach = /** @type {((inputs?: Documents_Index_DetachInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_DetachInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_detach(inputs)
	return __ja.documents_index_detach(inputs)
});
/**
* | output |
* | --- |
* | "Could not take out “{title}”" |
*
* @param {Documents_Index_Detach_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_detach_failed = /** @type {((inputs: Documents_Index_Detach_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Detach_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_detach_failed(inputs)
	return __ja.documents_index_detach_failed(inputs)
});
/**
* | output |
* | --- |
* | "No documents in it yet" |
*
* @param {Documents_Index_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_empty = /** @type {((inputs?: Documents_Index_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_empty(inputs)
	return __ja.documents_index_empty(inputs)
});
/**
* | output |
* | --- |
* | "Add a document you made under it…" |
*
* @param {Documents_Index_Existing_UnderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_existing_under = /** @type {((inputs?: Documents_Index_Existing_UnderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Existing_UnderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_existing_under(inputs)
	return __ja.documents_index_existing_under(inputs)
});
/**
* | output |
* | --- |
* | "Fold the documents under it" |
*
* @param {Documents_Index_FoldInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_fold = /** @type {((inputs?: Documents_Index_FoldInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_FoldInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_fold(inputs)
	return __ja.documents_index_fold(inputs)
});
/**
* | output |
* | --- |
* | "In these indexes" |
*
* @param {Documents_Index_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_in = /** @type {((inputs?: Documents_Index_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_in(inputs)
	return __ja.documents_index_in(inputs)
});
/**
* | output |
* | --- |
* | "Not in any index yet" |
*
* @param {Documents_Index_In_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_in_none = /** @type {((inputs?: Documents_Index_In_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_In_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_in_none(inputs)
	return __ja.documents_index_in_none(inputs)
});
/**
* | output |
* | --- |
* | "Down one level (under the one above)" |
*
* @param {Documents_Index_IndentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_indent = /** @type {((inputs?: Documents_Index_IndentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_IndentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_indent(inputs)
	return __ja.documents_index_indent(inputs)
});
/**
* | output |
* | --- |
* | "Could not load the index" |
*
* @param {Documents_Index_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_load_failed = /** @type {((inputs?: Documents_Index_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_load_failed(inputs)
	return __ja.documents_index_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Index actions" |
*
* @param {Documents_Index_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_menu = /** @type {((inputs?: Documents_Index_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_menu(inputs)
	return __ja.documents_index_menu(inputs)
});
/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Documents_Index_Move_DownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_move_down = /** @type {((inputs?: Documents_Index_Move_DownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Move_DownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_move_down(inputs)
	return __ja.documents_index_move_down(inputs)
});
/**
* | output |
* | --- |
* | "Could not move “{title}”" |
*
* @param {Documents_Index_Move_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_move_failed = /** @type {((inputs: Documents_Index_Move_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Move_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_move_failed(inputs)
	return __ja.documents_index_move_failed(inputs)
});
/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Documents_Index_Move_UpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_move_up = /** @type {((inputs?: Documents_Index_Move_UpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Move_UpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_move_up(inputs)
	return __ja.documents_index_move_up(inputs)
});
/**
* | output |
* | --- |
* | "Write a name and press Enter. Documents go in after it is made." |
*
* @param {Documents_Index_New_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_new_hint = /** @type {((inputs?: Documents_Index_New_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_New_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_new_hint(inputs)
	return __ja.documents_index_new_hint(inputs)
});
/**
* | output |
* | --- |
* | "New document under it" |
*
* @param {Documents_Index_New_UnderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_new_under = /** @type {((inputs?: Documents_Index_New_UnderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_New_UnderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_new_under(inputs)
	return __ja.documents_index_new_under(inputs)
});
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Documents_Index_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_open = /** @type {((inputs?: Documents_Index_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_open(inputs)
	return __ja.documents_index_open(inputs)
});
/**
* | output |
* | --- |
* | "Up one level" |
*
* @param {Documents_Index_OutdentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_outdent = /** @type {((inputs?: Documents_Index_OutdentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_OutdentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_outdent(inputs)
	return __ja.documents_index_outdent(inputs)
});
/**
* | output |
* | --- |
* | "Add a document you made" |
*
* @param {Documents_Index_PickInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_pick = /** @type {((inputs?: Documents_Index_PickInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_PickInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_pick(inputs)
	return __ja.documents_index_pick(inputs)
});
/**
* | output |
* | --- |
* | "No document to add" |
*
* @param {Documents_Index_Pick_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_pick_none = /** @type {((inputs?: Documents_Index_Pick_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Pick_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_pick_none(inputs)
	return __ja.documents_index_pick_none(inputs)
});
/**
* | output |
* | --- |
* | "Find by title or text" |
*
* @param {Documents_Index_Pick_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_pick_search = /** @type {((inputs?: Documents_Index_Pick_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Pick_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_pick_search(inputs)
	return __ja.documents_index_pick_search(inputs)
});
/**
* | output |
* | --- |
* | "Could not put it in “{title}”" |
*
* @param {Documents_Index_Put_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_put_failed = /** @type {((inputs: Documents_Index_Put_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Put_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_put_failed(inputs)
	return __ja.documents_index_put_failed(inputs)
});
/**
* | output |
* | --- |
* | "Put in an index" |
*
* @param {Documents_Index_Put_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_put_in = /** @type {((inputs?: Documents_Index_Put_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Put_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_put_in(inputs)
	return __ja.documents_index_put_in(inputs)
});
/**
* | output |
* | --- |
* | "Take out of “{title}”" |
*
* @param {Documents_Index_Remove_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_remove_from = /** @type {((inputs: Documents_Index_Remove_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Remove_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_remove_from(inputs)
	return __ja.documents_index_remove_from(inputs)
});
/**
* | output |
* | --- |
* | "Name of the index" |
*
* @param {Documents_Index_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_title = /** @type {((inputs?: Documents_Index_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_title(inputs)
	return __ja.documents_index_title(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Documents_Index_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_title_placeholder = /** @type {((inputs?: Documents_Index_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_title_placeholder(inputs)
	return __ja.documents_index_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Show the documents under it" |
*
* @param {Documents_Index_UnfoldInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_index_unfold = /** @type {((inputs?: Documents_Index_UnfoldInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Index_UnfoldInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_index_unfold(inputs)
	return __ja.documents_index_unfold(inputs)
});
/**
* | output |
* | --- |
* | "HTML document" |
*
* @param {Documents_Kind_HtmlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_kind_html = /** @type {((inputs?: Documents_Kind_HtmlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Kind_HtmlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_kind_html(inputs)
	return __ja.documents_kind_html(inputs)
});
/**
* | output |
* | --- |
* | "Index" |
*
* @param {Documents_Kind_IndexInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_kind_index = /** @type {((inputs?: Documents_Kind_IndexInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Kind_IndexInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_kind_index(inputs)
	return __ja.documents_kind_index(inputs)
});
/**
* | output |
* | --- |
* | "Markdown document" |
*
* @param {Documents_Kind_MarkdownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_kind_markdown = /** @type {((inputs?: Documents_Kind_MarkdownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Kind_MarkdownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_kind_markdown(inputs)
	return __ja.documents_kind_markdown(inputs)
});
/**
* | output |
* | --- |
* | "Slides" |
*
* @param {Documents_Kind_SlideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_kind_slide = /** @type {((inputs?: Documents_Kind_SlideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Kind_SlideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_kind_slide(inputs)
	return __ja.documents_kind_slide(inputs)
});
/**
* | output |
* | --- |
* | "Documents to link" |
*
* @param {Documents_Link_SuggestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_link_suggest = /** @type {((inputs?: Documents_Link_SuggestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Link_SuggestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_link_suggest(inputs)
	return __ja.documents_link_suggest(inputs)
});
/**
* | output |
* | --- |
* | "Could not load the documents" |
*
* @param {Documents_List_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_list_failed = /** @type {((inputs?: Documents_List_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_List_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_list_failed(inputs)
	return __ja.documents_list_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not load the document" |
*
* @param {Documents_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_load_failed = /** @type {((inputs?: Documents_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_load_failed(inputs)
	return __ja.documents_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Document menu" |
*
* @param {Documents_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_menu = /** @type {((inputs?: Documents_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_menu(inputs)
	return __ja.documents_menu(inputs)
});
/**
* | output |
* | --- |
* | "flowchart TD A[Start] --> B[End]" |
*
* @param {Documents_Mermaid_Default_PayloadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_mermaid_default_payload = /** @type {((inputs?: Documents_Mermaid_Default_PayloadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Mermaid_Default_PayloadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_mermaid_default_payload(inputs)
	return __ja.documents_mermaid_default_payload(inputs)
});
/**
* | output |
* | --- |
* | "This document cannot be found. It was deleted, or the URL is wrong." |
*
* @param {Documents_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_missing = /** @type {((inputs?: Documents_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_missing(inputs)
	return __ja.documents_missing(inputs)
});
/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Documents_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_more = /** @type {((inputs?: Documents_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_more(inputs)
	return __ja.documents_more(inputs)
});
/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Documents_NavInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_nav = /** @type {((inputs?: Documents_NavInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_NavInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_nav(inputs)
	return __ja.documents_nav(inputs)
});
/**
* | output |
* | --- |
* | "New document" |
*
* @param {Documents_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_new = /** @type {((inputs?: Documents_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_new(inputs)
	return __ja.documents_new(inputs)
});
/**
* | output |
* | --- |
* | "Document" |
*
* @param {Documents_New_DocumentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_new_document = /** @type {((inputs?: Documents_New_DocumentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_New_DocumentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_new_document(inputs)
	return __ja.documents_new_document(inputs)
});
/**
* | output |
* | --- |
* | "New index" |
*
* @param {Documents_New_IndexInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_new_index = /** @type {((inputs?: Documents_New_IndexInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_New_IndexInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_new_index(inputs)
	return __ja.documents_new_index(inputs)
});
/**
* | output |
* | --- |
* | "Index" |
*
* @param {Documents_New_Index_ItemInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_new_index_item = /** @type {((inputs?: Documents_New_Index_ItemInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_New_Index_ItemInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_new_index_item(inputs)
	return __ja.documents_new_index_item(inputs)
});
/**
* | output |
* | --- |
* | "New" |
*
* @param {Documents_New_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_new_menu = /** @type {((inputs?: Documents_New_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_New_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_new_menu(inputs)
	return __ja.documents_new_menu(inputs)
});
/**
* | output |
* | --- |
* | "Offline. What you write is sent when the connection is back." |
*
* @param {Documents_OfflineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_offline = /** @type {((inputs?: Documents_OfflineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_OfflineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_offline(inputs)
	return __ja.documents_offline(inputs)
});
/**
* | output |
* | --- |
* | "Outline" |
*
* @param {Documents_OutlineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_outline = /** @type {((inputs?: Documents_OutlineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_OutlineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_outline(inputs)
	return __ja.documents_outline(inputs)
});
/**
* | output |
* | --- |
* | "Headings" |
*
* @param {Documents_Outline_HeadingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_outline_headings = /** @type {((inputs?: Documents_Outline_HeadingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Outline_HeadingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_outline_headings(inputs)
	return __ja.documents_outline_headings(inputs)
});
/**
* | output |
* | --- |
* | "This document is archived. Unarchive it to write." |
*
* @param {Documents_Read_Only_ArchivedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_read_only_archived = /** @type {((inputs?: Documents_Read_Only_ArchivedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Read_Only_ArchivedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_read_only_archived(inputs)
	return __ja.documents_read_only_archived(inputs)
});
/**
* | output |
* | --- |
* | "Written by a newer version of the app, so it is read only. Update the app to write." |
*
* @param {Documents_Read_Only_NewerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_read_only_newer = /** @type {((inputs?: Documents_Read_Only_NewerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Read_Only_NewerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_read_only_newer(inputs)
	return __ja.documents_read_only_newer(inputs)
});
/**
* | output |
* | --- |
* | "You may read this document but not change it." |
*
* @param {Documents_Read_Only_Not_WritableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_read_only_not_writable = /** @type {((inputs?: Documents_Read_Only_Not_WritableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Read_Only_Not_WritableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_read_only_not_writable(inputs)
	return __ja.documents_read_only_not_writable(inputs)
});
/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Documents_ReloadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_reload = /** @type {((inputs?: Documents_ReloadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_ReloadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_reload(inputs)
	return __ja.documents_reload(inputs)
});
/**
* | output |
* | --- |
* | "The app was updated. Reload to keep writing." |
*
* @param {Documents_Reload_NeededInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_reload_needed = /** @type {((inputs?: Documents_Reload_NeededInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Reload_NeededInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_reload_needed(inputs)
	return __ja.documents_reload_needed(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the title" |
*
* @param {Documents_Rename_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_rename_failed = /** @type {((inputs?: Documents_Rename_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Rename_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_rename_failed(inputs)
	return __ja.documents_rename_failed(inputs)
});
/**
* | output |
* | --- |
* | "Restore this version" |
*
* @param {Documents_RestoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_restore = /** @type {((inputs?: Documents_RestoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_RestoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_restore(inputs)
	return __ja.documents_restore(inputs)
});
/**
* | output |
* | --- |
* | "The text of “{title}” becomes this version. The current text stays in the history, so you can go back to it." |
*
* @param {Documents_Restore_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_restore_body = /** @type {((inputs: Documents_Restore_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Restore_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_restore_body(inputs)
	return __ja.documents_restore_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not restore" |
*
* @param {Documents_Restore_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_restore_failed = /** @type {((inputs?: Documents_Restore_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Restore_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_restore_failed(inputs)
	return __ja.documents_restore_failed(inputs)
});
/**
* | output |
* | --- |
* | "Restore the version of {time}" |
*
* @param {Documents_Restore_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_restore_title = /** @type {((inputs: Documents_Restore_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Restore_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_restore_title(inputs)
	return __ja.documents_restore_title(inputs)
});
/**
* | output |
* | --- |
* | "Actions for “{title}”" |
*
* @param {Documents_Row_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_row_menu = /** @type {((inputs: Documents_Row_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Row_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_row_menu(inputs)
	return __ja.documents_row_menu(inputs)
});
/**
* | output |
* | --- |
* | "Save as PDF" |
*
* @param {Documents_Save_PdfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_save_pdf = /** @type {((inputs?: Documents_Save_PdfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Save_PdfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_save_pdf(inputs)
	return __ja.documents_save_pdf(inputs)
});
/**
* | output |
* | --- |
* | "Bold ({key})" |
*
* @param {Documents_Selection_BoldInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_bold = /** @type {((inputs: Documents_Selection_BoldInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_BoldInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_bold(inputs)
	return __ja.documents_selection_bold(inputs)
});
/**
* | output |
* | --- |
* | "Code ({key})" |
*
* @param {Documents_Selection_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_code = /** @type {((inputs: Documents_Selection_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_code(inputs)
	return __ja.documents_selection_code(inputs)
});
/**
* | output |
* | --- |
* | "Edit link" |
*
* @param {Documents_Selection_Edit_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_edit_link = /** @type {((inputs?: Documents_Selection_Edit_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_Edit_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_edit_link(inputs)
	return __ja.documents_selection_edit_link(inputs)
});
/**
* | output |
* | --- |
* | "Formatting" |
*
* @param {Documents_Selection_FormatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_format = /** @type {((inputs?: Documents_Selection_FormatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_FormatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_format(inputs)
	return __ja.documents_selection_format(inputs)
});
/**
* | output |
* | --- |
* | "Italic ({key})" |
*
* @param {Documents_Selection_ItalicInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_italic = /** @type {((inputs: Documents_Selection_ItalicInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_ItalicInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_italic(inputs)
	return __ja.documents_selection_italic(inputs)
});
/**
* | output |
* | --- |
* | "Link" |
*
* @param {Documents_Selection_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_link = /** @type {((inputs?: Documents_Selection_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_link(inputs)
	return __ja.documents_selection_link(inputs)
});
/**
* | output |
* | --- |
* | "Link URL" |
*
* @param {Documents_Selection_Link_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_link_url = /** @type {((inputs?: Documents_Selection_Link_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_Link_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_link_url(inputs)
	return __ja.documents_selection_link_url(inputs)
});
/**
* | output |
* | --- |
* | "Open ({key}+click)" |
*
* @param {Documents_Selection_Open_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_open_link = /** @type {((inputs: Documents_Selection_Open_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_Open_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_open_link(inputs)
	return __ja.documents_selection_open_link(inputs)
});
/**
* | output |
* | --- |
* | "Paste a URL" |
*
* @param {Documents_Selection_Paste_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_paste_url = /** @type {((inputs?: Documents_Selection_Paste_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_Paste_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_paste_url(inputs)
	return __ja.documents_selection_paste_url(inputs)
});
/**
* | output |
* | --- |
* | "Strikethrough ({key})" |
*
* @param {Documents_Selection_StrikeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_strike = /** @type {((inputs: Documents_Selection_StrikeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_StrikeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_strike(inputs)
	return __ja.documents_selection_strike(inputs)
});
/**
* | output |
* | --- |
* | "Remove link" |
*
* @param {Documents_Selection_UnlinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_selection_unlink = /** @type {((inputs?: Documents_Selection_UnlinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Selection_UnlinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_selection_unlink(inputs)
	return __ja.documents_selection_unlink(inputs)
});
/**
* | output |
* | --- |
* | "Documents to show" |
*
* @param {Documents_ShowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_show = /** @type {((inputs?: Documents_ShowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_ShowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_show(inputs)
	return __ja.documents_show(inputs)
});
/**
* | output |
* | --- |
* | "In use" |
*
* @param {Documents_Show_ActiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_show_active = /** @type {((inputs?: Documents_Show_ActiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Show_ActiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_show_active(inputs)
	return __ja.documents_show_active(inputs)
});
/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Documents_Show_ArchivedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_show_archived = /** @type {((inputs?: Documents_Show_ArchivedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Show_ArchivedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_show_archived(inputs)
	return __ja.documents_show_archived(inputs)
});
/**
* | output |
* | --- |
* | "Next slide" |
*
* @param {Documents_Slide_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_slide_next = /** @type {((inputs?: Documents_Slide_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Slide_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_slide_next(inputs)
	return __ja.documents_slide_next(inputs)
});
/**
* | output |
* | --- |
* | "Previous slide" |
*
* @param {Documents_Slide_PreviousInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_slide_previous = /** @type {((inputs?: Documents_Slide_PreviousInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Slide_PreviousInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_slide_previous(inputs)
	return __ja.documents_slide_previous(inputs)
});
/**
* | output |
* | --- |
* | "Source" |
*
* @param {Documents_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source = /** @type {((inputs?: Documents_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source(inputs)
	return __ja.documents_source(inputs)
});
/**
* | output |
* | --- |
* | "Back to the view" |
*
* @param {Documents_Source_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_close = /** @type {((inputs?: Documents_Source_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_close(inputs)
	return __ja.documents_source_close(inputs)
});
/**
* | output |
* | --- |
* | "The text changed elsewhere, so the current text was loaded. Apply your change again and save." |
*
* @param {Documents_Source_ConflictInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_conflict = /** @type {((inputs?: Documents_Source_ConflictInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_ConflictInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_conflict(inputs)
	return __ja.documents_source_conflict(inputs)
});
/**
* | output |
* | --- |
* | "Edit source" |
*
* @param {Documents_Source_EditInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_edit = /** @type {((inputs?: Documents_Source_EditInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_EditInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_edit(inputs)
	return __ja.documents_source_edit(inputs)
});
/**
* | output |
* | --- |
* | "Query when shown" |
*
* @param {Documents_Source_QueryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_query = /** @type {((inputs?: Documents_Source_QueryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_QueryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_query(inputs)
	return __ja.documents_source_query(inputs)
});
/**
* | output |
* | --- |
* | "Could not save the query" |
*
* @param {Documents_Source_Query_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_query_failed = /** @type {((inputs?: Documents_Source_Query_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_Query_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_query_failed(inputs)
	return __ja.documents_source_query_failed(inputs)
});
/**
* | output |
* | --- |
* | "Save" |
*
* @param {Documents_Source_SaveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_save = /** @type {((inputs?: Documents_Source_SaveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_SaveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_save(inputs)
	return __ja.documents_source_save(inputs)
});
/**
* | output |
* | --- |
* | "Could not save" |
*
* @param {Documents_Source_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_save_failed = /** @type {((inputs?: Documents_Source_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_save_failed(inputs)
	return __ja.documents_source_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Documents_Source_SavedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_source_saved = /** @type {((inputs?: Documents_Source_SavedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Source_SavedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_source_saved(inputs)
	return __ja.documents_source_saved(inputs)
});
/**
* | output |
* | --- |
* | "No matches" |
*
* @param {Documents_Suggest_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_suggest_empty = /** @type {((inputs?: Documents_Suggest_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Suggest_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_suggest_empty(inputs)
	return __ja.documents_suggest_empty(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Documents_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_title = /** @type {((inputs?: Documents_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_title(inputs)
	return __ja.documents_title(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Documents_Title_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_title_placeholder = /** @type {((inputs?: Documents_Title_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Title_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_title_placeholder(inputs)
	return __ja.documents_title_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Unarchive" |
*
* @param {Documents_UnarchiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_unarchive = /** @type {((inputs?: Documents_UnarchiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_UnarchiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_unarchive(inputs)
	return __ja.documents_unarchive(inputs)
});
/**
* | output |
* | --- |
* | "Could not unarchive “{title}”" |
*
* @param {Documents_Unarchive_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_unarchive_failed = /** @type {((inputs: Documents_Unarchive_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Unarchive_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_unarchive_failed(inputs)
	return __ja.documents_unarchive_failed(inputs)
});
/**
* | output |
* | --- |
* | "Untitled" |
*
* @param {Documents_UntitledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_untitled = /** @type {((inputs?: Documents_UntitledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_UntitledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.documents_untitled(inputs)
	return __ja.documents_untitled(inputs)
});
/**
* | output |
* | --- |
* | "Block count differs (live {live} / candidate {candidate})" |
*
* @param {Editor_Diff_Block_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_diff_block_count = /** @type {((inputs: Editor_Diff_Block_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Diff_Block_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_diff_block_count(inputs)
	return __ja.editor_diff_block_count(inputs)
});
/**
* | output |
* | --- |
* | "(Callout)" |
*
* @param {Editor_Excerpt_CalloutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_excerpt_callout = /** @type {((inputs?: Editor_Excerpt_CalloutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Excerpt_CalloutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_excerpt_callout(inputs)
	return __ja.editor_excerpt_callout(inputs)
});
/**
* | output |
* | --- |
* | "(Code)" |
*
* @param {Editor_Excerpt_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_excerpt_code = /** @type {((inputs?: Editor_Excerpt_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Excerpt_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_excerpt_code(inputs)
	return __ja.editor_excerpt_code(inputs)
});
/**
* | output |
* | --- |
* | "(Empty block)" |
*
* @param {Editor_Excerpt_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_excerpt_empty = /** @type {((inputs?: Editor_Excerpt_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Excerpt_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_excerpt_empty(inputs)
	return __ja.editor_excerpt_empty(inputs)
});
/**
* | output |
* | --- |
* | "(HTML)" |
*
* @param {Editor_Excerpt_HtmlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_excerpt_html = /** @type {((inputs?: Editor_Excerpt_HtmlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Excerpt_HtmlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_excerpt_html(inputs)
	return __ja.editor_excerpt_html(inputs)
});
/**
* | output |
* | --- |
* | "(mermaid)" |
*
* @param {Editor_Excerpt_MermaidInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_excerpt_mermaid = /** @type {((inputs?: Editor_Excerpt_MermaidInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Excerpt_MermaidInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_excerpt_mermaid(inputs)
	return __ja.editor_excerpt_mermaid(inputs)
});
/**
* | output |
* | --- |
* | "(Divider)" |
*
* @param {Editor_Excerpt_RuleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_excerpt_rule = /** @type {((inputs?: Editor_Excerpt_RuleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Excerpt_RuleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_excerpt_rule(inputs)
	return __ja.editor_excerpt_rule(inputs)
});
/**
* | output |
* | --- |
* | "(Table)" |
*
* @param {Editor_Excerpt_TableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_excerpt_table = /** @type {((inputs?: Editor_Excerpt_TableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Excerpt_TableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_excerpt_table(inputs)
	return __ja.editor_excerpt_table(inputs)
});
/**
* | output |
* | --- |
* | "{key} differs" |
*
* @param {Editor_Shape_Attr_DiffersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_shape_attr_differs = /** @type {((inputs: Editor_Shape_Attr_DiffersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Shape_Attr_DiffersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_shape_attr_differs(inputs)
	return __ja.editor_shape_attr_differs(inputs)
});
/**
* | output |
* | --- |
* | "Block count differs ({from} → {to})" |
*
* @param {Editor_Shape_Block_Count_DiffersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_shape_block_count_differs = /** @type {((inputs: Editor_Shape_Block_Count_DiffersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Shape_Block_Count_DiffersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_shape_block_count_differs(inputs)
	return __ja.editor_shape_block_count_differs(inputs)
});
/**
* | output |
* | --- |
* | "Child block count differs ({from} → {to})" |
*
* @param {Editor_Shape_Child_Count_DiffersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_shape_child_count_differs = /** @type {((inputs: Editor_Shape_Child_Count_DiffersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Shape_Child_Count_DiffersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_shape_child_count_differs(inputs)
	return __ja.editor_shape_child_count_differs(inputs)
});
/**
* | output |
* | --- |
* | "Type differs ({from} → {to})" |
*
* @param {Editor_Shape_Type_DiffersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_shape_type_differs = /** @type {((inputs: Editor_Shape_Type_DiffersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Shape_Type_DiffersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_shape_type_differs(inputs)
	return __ja.editor_shape_type_differs(inputs)
});
/**
* | output |
* | --- |
* | "{key} must be 0–2" |
*
* @param {Editor_Table_Option_Fix_RangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_table_option_fix_range = /** @type {((inputs: Editor_Table_Option_Fix_RangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Option_Fix_RangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_table_option_fix_range(inputs)
	return __ja.editor_table_option_fix_range(inputs)
});
/**
* | output |
* | --- |
* | "The option line has the wrong format" |
*
* @param {Editor_Table_Option_ShapeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_table_option_shape = /** @type {((inputs?: Editor_Table_Option_ShapeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Option_ShapeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_table_option_shape(inputs)
	return __ja.editor_table_option_shape(inputs)
});
/**
* | output |
* | --- |
* | "{key} appears twice" |
*
* @param {Editor_Table_Option_TwiceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_table_option_twice = /** @type {((inputs: Editor_Table_Option_TwiceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Option_TwiceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_table_option_twice(inputs)
	return __ja.editor_table_option_twice(inputs)
});
/**
* | output |
* | --- |
* | "Unknown key {key}" |
*
* @param {Editor_Table_Option_Unknown_KeyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_table_option_unknown_key = /** @type {((inputs: Editor_Table_Option_Unknown_KeyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Option_Unknown_KeyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_table_option_unknown_key(inputs)
	return __ja.editor_table_option_unknown_key(inputs)
});
/**
* | output |
* | --- |
* | "widths must be comma-separated positive numbers" |
*
* @param {Editor_Table_Option_WidthsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_table_option_widths = /** @type {((inputs?: Editor_Table_Option_WidthsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Table_Option_WidthsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_table_option_widths(inputs)
	return __ja.editor_table_option_widths(inputs)
});
/**
* | output |
* | --- |
* | "Content" |
*
* @param {Editor_Toggle_Body_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_toggle_body_placeholder = /** @type {((inputs?: Editor_Toggle_Body_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Toggle_Body_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_toggle_body_placeholder(inputs)
	return __ja.editor_toggle_body_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Toggle" |
*
* @param {Editor_Toggle_Summary_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const editor_toggle_summary_placeholder = /** @type {((inputs?: Editor_Toggle_Summary_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Toggle_Summary_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.editor_toggle_summary_placeholder(inputs)
	return __ja.editor_toggle_summary_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "{name} answered for you" |
*
* @param {Inbox_Answered_By_ParentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_answered_by_parent = /** @type {((inputs: Inbox_Answered_By_ParentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Answered_By_ParentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_answered_by_parent(inputs)
	return __ja.inbox_answered_by_parent(inputs)
});
/**
* | output |
* | --- |
* | "Narrow to a Case" |
*
* @param {Inbox_CaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_case = /** @type {((inputs?: Inbox_CaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_CaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_case(inputs)
	return __ja.inbox_case(inputs)
});
/**
* | output |
* | --- |
* | "All Cases" |
*
* @param {Inbox_Case_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_case_all = /** @type {((inputs?: Inbox_Case_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Case_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_case_all(inputs)
	return __ja.inbox_case_all(inputs)
});
/**
* | output |
* | --- |
* | "Narrow to a chat" |
*
* @param {Inbox_ChatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_chat = /** @type {((inputs?: Inbox_ChatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_ChatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_chat(inputs)
	return __ja.inbox_chat(inputs)
});
/**
* | output |
* | --- |
* | "All chats" |
*
* @param {Inbox_Chat_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_chat_all = /** @type {((inputs?: Inbox_Chat_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Chat_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_chat_all(inputs)
	return __ja.inbox_chat_all(inputs)
});
/**
* | output |
* | --- |
* | "Settled" |
*
* @param {Inbox_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_done = /** @type {((inputs?: Inbox_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_done(inputs)
	return __ja.inbox_done(inputs)
});
/**
* | output |
* | --- |
* | "Done by the agent" |
*
* @param {Inbox_Done_By_AgentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_done_by_agent = /** @type {((inputs?: Inbox_Done_By_AgentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Done_By_AgentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_done_by_agent(inputs)
	return __ja.inbox_done_by_agent(inputs)
});
/**
* | output |
* | --- |
* | "Nothing settled yet" |
*
* @param {Inbox_Done_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_done_empty = /** @type {((inputs?: Inbox_Done_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Done_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_done_empty(inputs)
	return __ja.inbox_done_empty(inputs)
});
/**
* | output |
* | --- |
* | "Something is waiting for you" |
*
* @param {Inbox_DotInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_dot = /** @type {((inputs?: Inbox_DotInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_DotInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_dot(inputs)
	return __ja.inbox_dot(inputs)
});
/**
* | output |
* | --- |
* | "from {name}" |
*
* @param {Inbox_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_from = /** @type {((inputs: Inbox_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_from(inputs)
	return __ja.inbox_from(inputs)
});
/**
* | output |
* | --- |
* | "Open the Inbox" |
*
* @param {Inbox_GoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_go = /** @type {((inputs?: Inbox_GoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_GoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_go(inputs)
	return __ja.inbox_go(inputs)
});
/**
* | output |
* | --- |
* | "DM" |
*
* @param {Inbox_Kind_DmInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_kind_dm = /** @type {((inputs?: Inbox_Kind_DmInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Kind_DmInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_kind_dm(inputs)
	return __ja.inbox_kind_dm(inputs)
});
/**
* | output |
* | --- |
* | "Mention" |
*
* @param {Inbox_Kind_MentionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_kind_mention = /** @type {((inputs?: Inbox_Kind_MentionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Kind_MentionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_kind_mention(inputs)
	return __ja.inbox_kind_mention(inputs)
});
/**
* | output |
* | --- |
* | "Question" |
*
* @param {Inbox_Kind_QuestionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_kind_question = /** @type {((inputs?: Inbox_Kind_QuestionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Kind_QuestionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_kind_question(inputs)
	return __ja.inbox_kind_question(inputs)
});
/**
* | output |
* | --- |
* | "Reply" |
*
* @param {Inbox_Kind_ReplyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_kind_reply = /** @type {((inputs?: Inbox_Kind_ReplyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Kind_ReplyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_kind_reply(inputs)
	return __ja.inbox_kind_reply(inputs)
});
/**
* | output |
* | --- |
* | "Could not read the Inbox" |
*
* @param {Inbox_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_load_failed = /** @type {((inputs?: Inbox_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_load_failed(inputs)
	return __ja.inbox_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Narrow the Inbox" |
*
* @param {Inbox_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_narrow = /** @type {((inputs?: Inbox_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_narrow(inputs)
	return __ja.inbox_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Search titles and answers" |
*
* @param {Inbox_Narrow_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_narrow_placeholder = /** @type {((inputs?: Inbox_Narrow_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Narrow_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_narrow_placeholder(inputs)
	return __ja.inbox_narrow_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Inbox" |
*
* @param {Inbox_NavInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_nav = /** @type {((inputs?: Inbox_NavInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_NavInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_nav(inputs)
	return __ja.inbox_nav(inputs)
});
/**
* | output |
* | --- |
* | "Nothing matches" |
*
* @param {Inbox_No_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_no_match = /** @type {((inputs?: Inbox_No_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_No_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_no_match(inputs)
	return __ja.inbox_no_match(inputs)
});
/**
* | output |
* | --- |
* | "Your move" |
*
* @param {Inbox_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_now = /** @type {((inputs?: Inbox_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_now(inputs)
	return __ja.inbox_now(inputs)
});
/**
* | output |
* | --- |
* | "Nothing is waiting for you" |
*
* @param {Inbox_Now_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_now_empty = /** @type {((inputs?: Inbox_Now_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Now_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_now_empty(inputs)
	return __ja.inbox_now_empty(inputs)
});
/**
* | output |
* | --- |
* | "{count} unread" |
*
* @param {Inbox_UnreadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_unread = /** @type {((inputs: Inbox_UnreadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_UnreadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_unread(inputs)
	return __ja.inbox_unread(inputs)
});
/**
* | output |
* | --- |
* | "Withdrawn" |
*
* @param {Inbox_WithdrawnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_withdrawn = /** @type {((inputs?: Inbox_WithdrawnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_WithdrawnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_withdrawn(inputs)
	return __ja.inbox_withdrawn(inputs)
});
/**
* | output |
* | --- |
* | "The Workspace's direct messages and mentions are as last read" |
*
* @param {Inbox_Workspace_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_workspace_unreachable = /** @type {((inputs?: Inbox_Workspace_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Workspace_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_workspace_unreachable(inputs)
	return __ja.inbox_workspace_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "The Workspace's direct messages and mentions cannot be read" |
*
* @param {Inbox_Workspace_Unreachable_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_workspace_unreachable_empty = /** @type {((inputs?: Inbox_Workspace_Unreachable_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Workspace_Unreachable_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_workspace_unreachable_empty(inputs)
	return __ja.inbox_workspace_unreachable_empty(inputs)
});
/**
* | output |
* | --- |
* | "Could not be read: the Cloud is not connected. They show once it is" |
*
* @param {Inbox_Workspace_Unreachable_WhyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const inbox_workspace_unreachable_why = /** @type {((inputs?: Inbox_Workspace_Unreachable_WhyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Workspace_Unreachable_WhyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.inbox_workspace_unreachable_why(inputs)
	return __ja.inbox_workspace_unreachable_why(inputs)
});
/**
* | output |
* | --- |
* | "Custom color of \"{name}\"" |
*
* @param {Labels_Color_CustomInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_color_custom = /** @type {((inputs: Labels_Color_CustomInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Color_CustomInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_color_custom(inputs)
	return __ja.labels_color_custom(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the color of \"{name}\"" |
*
* @param {Labels_Color_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_color_failed = /** @type {((inputs: Labels_Color_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Color_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_color_failed(inputs)
	return __ja.labels_color_failed(inputs)
});
/**
* | output |
* | --- |
* | "Color of \"{name}\"" |
*
* @param {Labels_Color_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_color_of = /** @type {((inputs: Labels_Color_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Color_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_color_of(inputs)
	return __ja.labels_color_of(inputs)
});
/**
* | output |
* | --- |
* | "Could not create the label \"{name}\"" |
*
* @param {Labels_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_create_failed = /** @type {((inputs: Labels_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_create_failed(inputs)
	return __ja.labels_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Create the label \"{name}\"" |
*
* @param {Labels_Create_NamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_create_named = /** @type {((inputs: Labels_Create_NamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Create_NamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_create_named(inputs)
	return __ja.labels_create_named(inputs)
});
/**
* | output |
* | --- |
* | "Delete \"{name}\"" |
*
* @param {Labels_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_delete = /** @type {((inputs: Labels_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_delete(inputs)
	return __ja.labels_delete(inputs)
});
/**
* | output |
* | --- |
* | "It comes off the Cases that carry it." |
*
* @param {Labels_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_delete_body = /** @type {((inputs?: Labels_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_delete_body(inputs)
	return __ja.labels_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete the label \"{name}\"" |
*
* @param {Labels_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_delete_failed = /** @type {((inputs: Labels_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_delete_failed(inputs)
	return __ja.labels_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete the label \"{name}\"?" |
*
* @param {Labels_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_delete_title = /** @type {((inputs: Labels_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_delete_title(inputs)
	return __ja.labels_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "Move \"{name}\" down" |
*
* @param {Labels_Move_DownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_move_down = /** @type {((inputs: Labels_Move_DownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Move_DownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_move_down(inputs)
	return __ja.labels_move_down(inputs)
});
/**
* | output |
* | --- |
* | "Could not reorder the labels" |
*
* @param {Labels_Move_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_move_failed = /** @type {((inputs?: Labels_Move_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Move_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_move_failed(inputs)
	return __ja.labels_move_failed(inputs)
});
/**
* | output |
* | --- |
* | "Move \"{name}\" up" |
*
* @param {Labels_Move_UpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_move_up = /** @type {((inputs: Labels_Move_UpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Move_UpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_move_up(inputs)
	return __ja.labels_move_up(inputs)
});
/**
* | output |
* | --- |
* | "Label name" |
*
* @param {Labels_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_name = /** @type {((inputs?: Labels_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_name(inputs)
	return __ja.labels_name(inputs)
});
/**
* | output |
* | --- |
* | "New label" |
*
* @param {Labels_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_new = /** @type {((inputs?: Labels_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_new(inputs)
	return __ja.labels_new(inputs)
});
/**
* | output |
* | --- |
* | "No labels yet. Type a name to create one" |
*
* @param {Labels_Pick_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_pick_empty = /** @type {((inputs?: Labels_Pick_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Pick_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_pick_empty(inputs)
	return __ja.labels_pick_empty(inputs)
});
/**
* | output |
* | --- |
* | "Find a label / a new label's name" |
*
* @param {Labels_Pick_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_pick_placeholder = /** @type {((inputs?: Labels_Pick_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Pick_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_pick_placeholder(inputs)
	return __ja.labels_pick_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Could not rename the label \"{name}\"" |
*
* @param {Labels_Rename_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_rename_failed = /** @type {((inputs: Labels_Rename_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Rename_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_rename_failed(inputs)
	return __ja.labels_rename_failed(inputs)
});
/**
* | output |
* | --- |
* | "Labels you put on Cases: their names, colors and order." |
*
* @param {Labels_Settings_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_settings_description = /** @type {((inputs?: Labels_Settings_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_Settings_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_settings_description(inputs)
	return __ja.labels_settings_description(inputs)
});
/**
* | output |
* | --- |
* | "Labels" |
*
* @param {Labels_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const labels_title = /** @type {((inputs?: Labels_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Labels_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.labels_title(inputs)
	return __ja.labels_title(inputs)
});
/**
* | output |
* | --- |
* | "Devices that can send instructions to this PC's Agent" |
*
* @param {Local_Agent_DiagramInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram = /** @type {((inputs?: Local_Agent_DiagramInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_DiagramInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram(inputs)
	return __ja.local_agent_diagram(inputs)
});
/**
* | output |
* | --- |
* | "Browser" |
*
* @param {Local_Agent_Diagram_BrowserInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_browser = /** @type {((inputs?: Local_Agent_Diagram_BrowserInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_BrowserInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_browser(inputs)
	return __ja.local_agent_diagram_browser(inputs)
});
/**
* | output |
* | --- |
* | "Cloud / Vault" |
*
* @param {Local_Agent_Diagram_CarrierInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_carrier = /** @type {((inputs?: Local_Agent_Diagram_CarrierInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_CarrierInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_carrier(inputs)
	return __ja.local_agent_diagram_carrier(inputs)
});
/**
* | output |
* | --- |
* | "Only delivers them" |
*
* @param {Local_Agent_Diagram_Carrier_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_carrier_note = /** @type {((inputs?: Local_Agent_Diagram_Carrier_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_Carrier_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_carrier_note(inputs)
	return __ja.local_agent_diagram_carrier_note(inputs)
});
/**
* | output |
* | --- |
* | "Phones, other PCs" |
*
* @param {Local_Agent_Diagram_DevicesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_devices = /** @type {((inputs?: Local_Agent_Diagram_DevicesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_DevicesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_devices(inputs)
	return __ja.local_agent_diagram_devices(inputs)
});
/**
* | output |
* | --- |
* | "Device list" |
*
* @param {Local_Agent_Diagram_In_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_in_list = /** @type {((inputs?: Local_Agent_Diagram_In_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_In_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_in_list(inputs)
	return __ja.local_agent_diagram_in_list(inputs)
});
/**
* | output |
* | --- |
* | "Not allowed" |
*
* @param {Local_Agent_Diagram_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_refused = /** @type {((inputs?: Local_Agent_Diagram_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_refused(inputs)
	return __ja.local_agent_diagram_refused(inputs)
});
/**
* | output |
* | --- |
* | "Signed" |
*
* @param {Local_Agent_Diagram_SignedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_signed = /** @type {((inputs?: Local_Agent_Diagram_SignedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_SignedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_signed(inputs)
	return __ja.local_agent_diagram_signed(inputs)
});
/**
* | output |
* | --- |
* | "The app on this PC" |
*
* @param {Local_Agent_Diagram_This_AppInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_diagram_this_app = /** @type {((inputs?: Local_Agent_Diagram_This_AppInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Diagram_This_AppInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_diagram_this_app(inputs)
	return __ja.local_agent_diagram_this_app(inputs)
});
/**
* | output |
* | --- |
* | "Browsers and devices not in your device list can't use it, even when on." |
*
* @param {Local_Agent_Help_BrowserInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_help_browser = /** @type {((inputs?: Local_Agent_Help_BrowserInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Help_BrowserInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_help_browser(inputs)
	return __ja.local_agent_help_browser(inputs)
});
/**
* | output |
* | --- |
* | "Instructions are signed on the device that sends them, and the Agent verifies them. Cloud and the Vault can't change them." |
*
* @param {Local_Agent_Help_SignedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_help_signed = /** @type {((inputs?: Local_Agent_Help_SignedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Help_SignedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_help_signed(inputs)
	return __ja.local_agent_help_signed(inputs)
});
/**
* | output |
* | --- |
* | "Use from other devices" |
*
* @param {Local_Agent_Help_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_help_title = /** @type {((inputs?: Local_Agent_Help_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Help_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_help_title(inputs)
	return __ja.local_agent_help_title(inputs)
});
/**
* | output |
* | --- |
* | "Allow use from other devices" |
*
* @param {Local_Agent_OthersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_others = /** @type {((inputs?: Local_Agent_OthersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_OthersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_others(inputs)
	return __ja.local_agent_others(inputs)
});
/**
* | output |
* | --- |
* | "It can also be used from phones and other PCs." |
*
* @param {Local_Agent_Others_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_others_note = /** @type {((inputs?: Local_Agent_Others_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Others_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_others_note(inputs)
	return __ja.local_agent_others_note(inputs)
});
/**
* | output |
* | --- |
* | "When off, it can be used from the app on this PC only." |
*
* @param {Local_Agent_Others_Off_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_others_off_note = /** @type {((inputs?: Local_Agent_Others_Off_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Others_Off_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_others_off_note(inputs)
	return __ja.local_agent_others_off_note(inputs)
});
/**
* | output |
* | --- |
* | "When off, it can be used from the app on {name} only." |
*
* @param {Local_Agent_Others_Vault_Off_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_others_vault_off_note = /** @type {((inputs: Local_Agent_Others_Vault_Off_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Others_Vault_Off_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_others_vault_off_note(inputs)
	return __ja.local_agent_others_vault_off_note(inputs)
});
/**
* | output |
* | --- |
* | "Use this PC's Agent" |
*
* @param {Local_Agent_UseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_use = /** @type {((inputs?: Local_Agent_UseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_UseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_use(inputs)
	return __ja.local_agent_use(inputs)
});
/**
* | output |
* | --- |
* | "When off, the Agent does not run on this PC." |
*
* @param {Local_Agent_Use_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_agent_use_note = /** @type {((inputs?: Local_Agent_Use_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Agent_Use_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_agent_use_note(inputs)
	return __ja.local_agent_use_note(inputs)
});
/**
* | output |
* | --- |
* | "Backup" |
*
* @param {Local_BackupInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup = /** @type {((inputs?: Local_BackupInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_BackupInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup(inputs)
	return __ja.local_backup(inputs)
});
/**
* | output |
* | --- |
* | "Choose folder…" |
*
* @param {Local_Backup_ChooseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_choose = /** @type {((inputs?: Local_Backup_ChooseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_ChooseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_choose(inputs)
	return __ja.local_backup_choose(inputs)
});
/**
* | output |
* | --- |
* | "Default (inside the data folder)" |
*
* @param {Local_Backup_DefaultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_default = /** @type {((inputs?: Local_Backup_DefaultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_DefaultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_default(inputs)
	return __ja.local_backup_default(inputs)
});
/**
* | output |
* | --- |
* | "Backs up the database and files when the app quits and every 3 hours. If the database cannot be opened, it is restored from here." |
*
* @param {Local_Backup_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_description = /** @type {((inputs?: Local_Backup_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_description(inputs)
	return __ja.local_backup_description(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the location." |
*
* @param {Local_Backup_Error_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_error_failed = /** @type {((inputs?: Local_Backup_Error_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_Error_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_error_failed(inputs)
	return __ja.local_backup_error_failed(inputs)
});
/**
* | output |
* | --- |
* | "The data folder itself, and the database and files inside it, cannot be chosen." |
*
* @param {Local_Backup_Error_Inside_DataInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_error_inside_data = /** @type {((inputs?: Local_Backup_Error_Inside_DataInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_Error_Inside_DataInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_error_inside_data(inputs)
	return __ja.local_backup_error_inside_data(inputs)
});
/**
* | output |
* | --- |
* | "Enter the folder's full path." |
*
* @param {Local_Backup_Error_Not_AbsoluteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_error_not_absolute = /** @type {((inputs?: Local_Backup_Error_Not_AbsoluteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_Error_Not_AbsoluteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_error_not_absolute(inputs)
	return __ja.local_backup_error_not_absolute(inputs)
});
/**
* | output |
* | --- |
* | "This folder cannot be written to." |
*
* @param {Local_Backup_Error_Not_WritableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_error_not_writable = /** @type {((inputs?: Local_Backup_Error_Not_WritableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_Error_Not_WritableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_error_not_writable(inputs)
	return __ja.local_backup_error_not_writable(inputs)
});
/**
* | output |
* | --- |
* | "Could not read the backup settings." |
*
* @param {Local_Backup_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_failed = /** @type {((inputs?: Local_Backup_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_failed(inputs)
	return __ja.local_backup_failed(inputs)
});
/**
* | output |
* | --- |
* | "Location" |
*
* @param {Local_Backup_FolderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_folder = /** @type {((inputs?: Local_Backup_FolderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_FolderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_folder(inputs)
	return __ja.local_backup_folder(inputs)
});
/**
* | output |
* | --- |
* | "Choose a folder on an external drive or NAS to keep the backup even if this PC or its disk fails. Changing the location does not delete the backup in the pre..." |
*
* @param {Local_Backup_Folder_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_folder_note = /** @type {((inputs?: Local_Backup_Folder_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_Folder_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_folder_note(inputs)
	return __ja.local_backup_folder_note(inputs)
});
/**
* | output |
* | --- |
* | "Last backup" |
*
* @param {Local_Backup_LastInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_last = /** @type {((inputs?: Local_Backup_LastInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_LastInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_last(inputs)
	return __ja.local_backup_last(inputs)
});
/**
* | output |
* | --- |
* | "This folder cannot be found, so backups go inside the data folder for now. Once the drive is connected, the next backup goes here again." |
*
* @param {Local_Backup_MissingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_missing = /** @type {((inputs?: Local_Backup_MissingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_MissingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_missing(inputs)
	return __ja.local_backup_missing(inputs)
});
/**
* | output |
* | --- |
* | "None yet" |
*
* @param {Local_Backup_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_none = /** @type {((inputs?: Local_Backup_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_none(inputs)
	return __ja.local_backup_none(inputs)
});
/**
* | output |
* | --- |
* | "This folder cannot be written to, so backups go inside the data folder for now." |
*
* @param {Local_Backup_Not_WritableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_not_writable = /** @type {((inputs?: Local_Backup_Not_WritableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_Not_WritableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_not_writable(inputs)
	return __ja.local_backup_not_writable(inputs)
});
/**
* | output |
* | --- |
* | "Folder path" |
*
* @param {Local_Backup_PathInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_path = /** @type {((inputs?: Local_Backup_PathInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_PathInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_path(inputs)
	return __ja.local_backup_path(inputs)
});
/**
* | output |
* | --- |
* | "Use default" |
*
* @param {Local_Backup_ResetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_reset = /** @type {((inputs?: Local_Backup_ResetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_ResetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_reset(inputs)
	return __ja.local_backup_reset(inputs)
});
/**
* | output |
* | --- |
* | "Use" |
*
* @param {Local_Backup_UseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_backup_use = /** @type {((inputs?: Local_Backup_UseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Backup_UseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_backup_use(inputs)
	return __ja.local_backup_use(inputs)
});
/**
* | output |
* | --- |
* | "Cloud" |
*
* @param {Local_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud = /** @type {((inputs?: Local_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud(inputs)
	return __ja.local_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Account" |
*
* @param {Local_Cloud_AccountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_account = /** @type {((inputs?: Local_Cloud_AccountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_AccountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_account(inputs)
	return __ja.local_cloud_account(inputs)
});
/**
* | output |
* | --- |
* | "Cloud account" |
*
* @param {Local_Cloud_Account_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_account_settings = /** @type {((inputs?: Local_Cloud_Account_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Account_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_account_settings(inputs)
	return __ja.local_cloud_account_settings(inputs)
});
/**
* | output |
* | --- |
* | "Opens your cloud account's settings: security, passkeys, connected apps." |
*
* @param {Local_Cloud_Account_Settings_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_account_settings_description = /** @type {((inputs?: Local_Cloud_Account_Settings_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Account_Settings_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_account_settings_description(inputs)
	return __ja.local_cloud_account_settings_description(inputs)
});
/**
* | output |
* | --- |
* | "Signed in again." |
*
* @param {Local_Cloud_Again_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_again_done = /** @type {((inputs?: Local_Cloud_Again_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Again_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_again_done(inputs)
	return __ja.local_cloud_again_done(inputs)
});
/**
* | output |
* | --- |
* | "Could not register this PC in Cloud. Turn it off, then on again." |
*
* @param {Local_Cloud_Agent_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_agent_failed = /** @type {((inputs?: Local_Cloud_Agent_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Agent_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_agent_failed(inputs)
	return __ja.local_cloud_agent_failed(inputs)
});
/**
* | output |
* | --- |
* | "This PC was removed in Cloud. To use it again, turn it off and then on." |
*
* @param {Local_Cloud_Agent_RemovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_agent_removed = /** @type {((inputs?: Local_Cloud_Agent_RemovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Agent_RemovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_agent_removed(inputs)
	return __ja.local_cloud_agent_removed(inputs)
});
/**
* | output |
* | --- |
* | "Check that the page you opened in the browser shows the same code, then link. If the page asks for a code, enter this one." |
*
* @param {Local_Cloud_Code_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_code_note = /** @type {((inputs?: Local_Cloud_Code_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Code_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_code_note(inputs)
	return __ja.local_cloud_code_note(inputs)
});
/**
* | output |
* | --- |
* | "Denied." |
*
* @param {Local_Cloud_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_denied = /** @type {((inputs?: Local_Cloud_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_denied(inputs)
	return __ja.local_cloud_denied(inputs)
});
/**
* | output |
* | --- |
* | "Link this PC to your trameria Cloud account. Until you sign in, this PC does not talk to the Cloud." |
*
* @param {Local_Cloud_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_description = /** @type {((inputs?: Local_Cloud_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_description(inputs)
	return __ja.local_cloud_description(inputs)
});
/**
* | output |
* | --- |
* | "This PC's sign-in" |
*
* @param {Local_Cloud_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device = /** @type {((inputs?: Local_Cloud_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device(inputs)
	return __ja.local_cloud_device(inputs)
});
/**
* | output |
* | --- |
* | "Signed in." |
*
* @param {Local_Cloud_Device_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_done = /** @type {((inputs?: Local_Cloud_Device_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_done(inputs)
	return __ja.local_cloud_device_done(inputs)
});
/**
* | output |
* | --- |
* | "Link the Vault to a Cloud account first." |
*
* @param {Local_Cloud_Device_Hub_Not_TiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_hub_not_tied = /** @type {((inputs?: Local_Cloud_Device_Hub_Not_TiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_Hub_Not_TiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_hub_not_tied(inputs)
	return __ja.local_cloud_device_hub_not_tied(inputs)
});
/**
* | output |
* | --- |
* | "The Vault is out of reach, so its account cannot be checked. Sign in once the Vault is connected." |
*
* @param {Local_Cloud_Device_Hub_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_hub_unreachable = /** @type {((inputs?: Local_Cloud_Device_Hub_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_Hub_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_hub_unreachable(inputs)
	return __ja.local_cloud_device_hub_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "Signed in as {name}. The token is kept by this PC alone and never given to the Vault." |
*
* @param {Local_Cloud_Device_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_in = /** @type {((inputs: Local_Cloud_Device_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_in(inputs)
	return __ja.local_cloud_device_in(inputs)
});
/**
* | output |
* | --- |
* | "The Vault is linked to {hub}, but this PC is signed in as {mine}. Sign out, then sign in as {hub}." |
*
* @param {Local_Cloud_Device_MismatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_mismatch = /** @type {((inputs: Local_Cloud_Device_MismatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_MismatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_mismatch(inputs)
	return __ja.local_cloud_device_mismatch(inputs)
});
/**
* | output |
* | --- |
* | "Once the Vault is linked, this PC can sign in as the same account." |
*
* @param {Local_Cloud_Device_Needs_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_needs_hub = /** @type {((inputs?: Local_Cloud_Device_Needs_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_Needs_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_needs_hub(inputs)
	return __ja.local_cloud_device_needs_hub(inputs)
});
/**
* | output |
* | --- |
* | "Not signed in. Signed in, this PC reaches the Cloud with a token of its own, even while the Vault is stopped." |
*
* @param {Local_Cloud_Device_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_none = /** @type {((inputs?: Local_Cloud_Device_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_none(inputs)
	return __ja.local_cloud_device_none(inputs)
});
/**
* | output |
* | --- |
* | "You cannot sign in as {account}. The Vault is linked to {tied}." |
*
* @param {Local_Cloud_Device_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_device_other = /** @type {((inputs: Local_Cloud_Device_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Device_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_device_other(inputs)
	return __ja.local_cloud_device_other(inputs)
});
/**
* | output |
* | --- |
* | "The code expired. Sign in again." |
*
* @param {Local_Cloud_ExpiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_expired = /** @type {((inputs?: Local_Cloud_ExpiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_ExpiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_expired(inputs)
	return __ja.local_cloud_expired(inputs)
});
/**
* | output |
* | --- |
* | "Cloud page" |
*
* @param {Local_Cloud_FrameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_frame = /** @type {((inputs?: Local_Cloud_FrameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_FrameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_frame(inputs)
	return __ja.local_cloud_frame(inputs)
});
/**
* | output |
* | --- |
* | "Sign in again under Cloud in the app's settings. You sign in in your browser." |
*
* @param {Local_Cloud_Frame_Signed_Out_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_frame_signed_out_body = /** @type {((inputs?: Local_Cloud_Frame_Signed_Out_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Frame_Signed_Out_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_frame_signed_out_body(inputs)
	return __ja.local_cloud_frame_signed_out_body(inputs)
});
/**
* | output |
* | --- |
* | "Signed in automatically when this PC was added to your device list on {from}." |
*
* @param {Local_Cloud_From_LoginInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_from_login = /** @type {((inputs: Local_Cloud_From_LoginInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_From_LoginInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_from_login(inputs)
	return __ja.local_cloud_from_login(inputs)
});
/**
* | output |
* | --- |
* | "The Vault is out of reach. This PC's sign-in works as it is." |
*
* @param {Local_Cloud_Hub_AwayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_hub_away = /** @type {((inputs?: Local_Cloud_Hub_AwayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Hub_AwayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_hub_away(inputs)
	return __ja.local_cloud_hub_away(inputs)
});
/**
* | output |
* | --- |
* | "Vault ({main})'s link" |
*
* @param {Local_Cloud_Hub_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_hub_row = /** @type {((inputs: Local_Cloud_Hub_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Hub_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_hub_row(inputs)
	return __ja.local_cloud_hub_row(inputs)
});
/**
* | output |
* | --- |
* | "Started from this PC, the token is still kept by the Vault alone." |
*
* @param {Local_Cloud_Hub_TokenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_hub_token = /** @type {((inputs?: Local_Cloud_Hub_TokenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Hub_TokenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_hub_token(inputs)
	return __ja.local_cloud_hub_token(inputs)
});
/**
* | output |
* | --- |
* | "You cannot sign in here while this PC uses a Vault." |
*
* @param {Local_Cloud_LinkedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_linked = /** @type {((inputs?: Local_Cloud_LinkedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_LinkedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_linked(inputs)
	return __ja.local_cloud_linked(inputs)
});
/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Local_Cloud_LoginInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_login = /** @type {((inputs?: Local_Cloud_LoginInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_LoginInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_login(inputs)
	return __ja.local_cloud_login(inputs)
});
/**
* | output |
* | --- |
* | "Sign in again" |
*
* @param {Local_Cloud_Login_AgainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_login_again = /** @type {((inputs?: Local_Cloud_Login_AgainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Login_AgainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_login_again(inputs)
	return __ja.local_cloud_login_again(inputs)
});
/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Local_Cloud_LogoutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_logout = /** @type {((inputs?: Local_Cloud_LogoutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_LogoutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_logout(inputs)
	return __ja.local_cloud_logout(inputs)
});
/**
* | output |
* | --- |
* | "This PC's token goes back to the Cloud and is removed here. The Vault's link and the data stay as they are." |
*
* @param {Local_Cloud_Logout_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_logout_body = /** @type {((inputs?: Local_Cloud_Logout_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Logout_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_logout_body(inputs)
	return __ja.local_cloud_logout_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not sign out" |
*
* @param {Local_Cloud_Logout_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_logout_failed = /** @type {((inputs?: Local_Cloud_Logout_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Logout_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_logout_failed(inputs)
	return __ja.local_cloud_logout_failed(inputs)
});
/**
* | output |
* | --- |
* | "Sign out of {name}?" |
*
* @param {Local_Cloud_Logout_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_logout_title = /** @type {((inputs: Local_Cloud_Logout_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Logout_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_logout_title(inputs)
	return __ja.local_cloud_logout_title(inputs)
});
/**
* | output |
* | --- |
* | "Not linked" |
*
* @param {Local_Cloud_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_none = /** @type {((inputs?: Local_Cloud_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_none(inputs)
	return __ja.local_cloud_none(inputs)
});
/**
* | output |
* | --- |
* | "Open in browser" |
*
* @param {Local_Cloud_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_open = /** @type {((inputs?: Local_Cloud_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_open(inputs)
	return __ja.local_cloud_open(inputs)
});
/**
* | output |
* | --- |
* | "You cannot sign in as {account}. This PC is linked to {tied}." |
*
* @param {Local_Cloud_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_other = /** @type {((inputs: Local_Cloud_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_other(inputs)
	return __ja.local_cloud_other(inputs)
});
/**
* | output |
* | --- |
* | "Linked. trameria is starting again…" |
*
* @param {Local_Cloud_RestartingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_restarting = /** @type {((inputs?: Local_Cloud_RestartingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_RestartingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_restarting(inputs)
	return __ja.local_cloud_restarting(inputs)
});
/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Local_Cloud_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_retry = /** @type {((inputs?: Local_Cloud_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_retry(inputs)
	return __ja.local_cloud_retry(inputs)
});
/**
* | output |
* | --- |
* | "Your personal data is in the cloud. Sign in again under Cloud in the app's settings to see it here." |
*
* @param {Local_Cloud_Signed_Out_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_signed_out_body = /** @type {((inputs?: Local_Cloud_Signed_Out_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Signed_Out_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_signed_out_body(inputs)
	return __ja.local_cloud_signed_out_body(inputs)
});
/**
* | output |
* | --- |
* | "Open app settings" |
*
* @param {Local_Cloud_Signed_Out_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_signed_out_open = /** @type {((inputs?: Local_Cloud_Signed_Out_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Signed_Out_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_signed_out_open(inputs)
	return __ja.local_cloud_signed_out_open(inputs)
});
/**
* | output |
* | --- |
* | "Signed out of the cloud" |
*
* @param {Local_Cloud_Signed_Out_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_signed_out_title = /** @type {((inputs?: Local_Cloud_Signed_Out_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Signed_Out_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_signed_out_title(inputs)
	return __ja.local_cloud_signed_out_title(inputs)
});
/**
* | output |
* | --- |
* | "Linked to {name}. Until you unlink it, it cannot be linked to another account." |
*
* @param {Local_Cloud_TiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_tied = /** @type {((inputs: Local_Cloud_TiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_TiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_tied(inputs)
	return __ja.local_cloud_tied(inputs)
});
/**
* | output |
* | --- |
* | "Unlink" |
*
* @param {Local_Cloud_UnlinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_unlink = /** @type {((inputs?: Local_Cloud_UnlinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_UnlinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_unlink(inputs)
	return __ja.local_cloud_unlink(inputs)
});
/**
* | output |
* | --- |
* | "This PC stops talking to the Cloud. Its data stays as it is. After unlinking, it can be linked to another account." |
*
* @param {Local_Cloud_Unlink_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_unlink_body = /** @type {((inputs?: Local_Cloud_Unlink_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Unlink_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_unlink_body(inputs)
	return __ja.local_cloud_unlink_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not unlink" |
*
* @param {Local_Cloud_Unlink_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_unlink_failed = /** @type {((inputs?: Local_Cloud_Unlink_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Unlink_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_unlink_failed(inputs)
	return __ja.local_cloud_unlink_failed(inputs)
});
/**
* | output |
* | --- |
* | "Unlink from {name}?" |
*
* @param {Local_Cloud_Unlink_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_unlink_title = /** @type {((inputs: Local_Cloud_Unlink_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Unlink_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_unlink_title(inputs)
	return __ja.local_cloud_unlink_title(inputs)
});
/**
* | output |
* | --- |
* | "Could not connect to Cloud" |
*
* @param {Local_Cloud_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_unreachable = /** @type {((inputs?: Local_Cloud_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_unreachable(inputs)
	return __ja.local_cloud_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "Check the network or the cloud, then try again. Personal still works as it is." |
*
* @param {Local_Cloud_Unreached_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_unreached_body = /** @type {((inputs?: Local_Cloud_Unreached_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Unreached_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_unreached_body(inputs)
	return __ja.local_cloud_unreached_body(inputs)
});
/**
* | output |
* | --- |
* | "Can't connect to the cloud" |
*
* @param {Local_Cloud_Unreached_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_unreached_title = /** @type {((inputs?: Local_Cloud_Unreached_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_Unreached_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_unreached_title(inputs)
	return __ja.local_cloud_unreached_title(inputs)
});
/**
* | output |
* | --- |
* | "Waiting for you to link in the browser…" |
*
* @param {Local_Cloud_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_cloud_waiting = /** @type {((inputs?: Local_Cloud_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Cloud_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_cloud_waiting(inputs)
	return __ja.local_cloud_waiting(inputs)
});
/**
* | output |
* | --- |
* | "DM" |
*
* @param {Local_DmsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_dms = /** @type {((inputs?: Local_DmsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_DmsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_dms(inputs)
	return __ja.local_dms(inputs)
});
/**
* | output |
* | --- |
* | "Unread" |
*
* @param {Local_Dms_UnreadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_dms_unread = /** @type {((inputs?: Local_Dms_UnreadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Dms_UnreadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_dms_unread(inputs)
	return __ja.local_dms_unread(inputs)
});
/**
* | output |
* | --- |
* | "Backup location: {dir}" |
*
* @param {Local_Headless_Backup_DirInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_backup_dir = /** @type {((inputs: Local_Headless_Backup_DirInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Backup_DirInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_backup_dir(inputs)
	return __ja.local_headless_backup_dir(inputs)
});
/**
* | output |
* | --- |
* | "--backup-dir {dir} cannot be used: {reason}" |
*
* @param {Local_Headless_Backup_Dir_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_backup_dir_refused = /** @type {((inputs: Local_Headless_Backup_Dir_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Backup_Dir_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_backup_dir_refused(inputs)
	return __ja.local_headless_backup_dir_refused(inputs)
});
/**
* | output |
* | --- |
* | "Other devices connect to: {addresses}" |
*
* @param {Local_Headless_Connect_ToInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_connect_to = /** @type {((inputs: Local_Headless_Connect_ToInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Connect_ToInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_connect_to(inputs)
	return __ja.local_headless_connect_to(inputs)
});
/**
* | output |
* | --- |
* | "{app} could not start: {error}" |
*
* @param {Local_Headless_Could_Not_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_could_not_start = /** @type {((inputs: Local_Headless_Could_Not_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Could_Not_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_could_not_start(inputs)
	return __ja.local_headless_could_not_start(inputs)
});
/**
* | output |
* | --- |
* | "{app} in {dir} uses a Vault, so it cannot run as one. Leave it in the settings (\"Vault\"), then start it again." |
*
* @param {Local_Headless_LinkedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_linked = /** @type {((inputs: Local_Headless_LinkedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_LinkedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_linked(inputs)
	return __ja.local_headless_linked(inputs)
});
/**
* | output |
* | --- |
* | "Signed in again as {account}." |
*
* @param {Local_Headless_Login_AgainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_again = /** @type {((inputs: Local_Headless_Login_AgainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_AgainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_again(inputs)
	return __ja.local_headless_login_again(inputs)
});
/**
* | output |
* | --- |
* | "Linked to {account}. {app} is starting again." |
*
* @param {Local_Headless_Login_BoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_bound = /** @type {((inputs: Local_Headless_Login_BoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_BoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_bound(inputs)
	return __ja.local_headless_login_bound(inputs)
});
/**
* | output |
* | --- |
* | "Denied. Not linked." |
*
* @param {Local_Headless_Login_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_denied = /** @type {((inputs?: Local_Headless_Login_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_denied(inputs)
	return __ja.local_headless_login_denied(inputs)
});
/**
* | output |
* | --- |
* | "The code expired. Run --headless --login again." |
*
* @param {Local_Headless_Login_ExpiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_expired = /** @type {((inputs?: Local_Headless_Login_ExpiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_ExpiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_expired(inputs)
	return __ja.local_headless_login_expired(inputs)
});
/**
* | output |
* | --- |
* | "Could not sign in to the Cloud: {error}" |
*
* @param {Local_Headless_Login_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_failed = /** @type {((inputs: Local_Headless_Login_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_failed(inputs)
	return __ja.local_headless_login_failed(inputs)
});
/**
* | output |
* | --- |
* | "{app} in {dir} uses a Vault, so it cannot sign in to the Cloud." |
*
* @param {Local_Headless_Login_LinkedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_linked = /** @type {((inputs: Local_Headless_Login_LinkedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_LinkedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_linked(inputs)
	return __ja.local_headless_login_linked(inputs)
});
/**
* | output |
* | --- |
* | "{app} is not running on {dir}. Start it first ({app} --headless, or the service), then run --headless --login again." |
*
* @param {Local_Headless_Login_Not_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_not_running = /** @type {((inputs: Local_Headless_Login_Not_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_Not_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_not_running(inputs)
	return __ja.local_headless_login_not_running(inputs)
});
/**
* | output |
* | --- |
* | "Open {url} in a browser and enter the code {code} to link (works for {minutes} more minutes)." |
*
* @param {Local_Headless_Login_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_open = /** @type {((inputs: Local_Headless_Login_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_open(inputs)
	return __ja.local_headless_login_open(inputs)
});
/**
* | output |
* | --- |
* | "You cannot sign in as {account}. This Vault is linked to {tied}." |
*
* @param {Local_Headless_Login_OtherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_other = /** @type {((inputs: Local_Headless_Login_OtherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_OtherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_other(inputs)
	return __ja.local_headless_login_other(inputs)
});
/**
* | output |
* | --- |
* | "Waiting for you to link…" |
*
* @param {Local_Headless_Login_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_login_waiting = /** @type {((inputs?: Local_Headless_Login_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Login_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_login_waiting(inputs)
	return __ja.local_headless_login_waiting(inputs)
});
/**
* | output |
* | --- |
* | "{app} is not running on {dir}. Start it first ({app} --headless, or as a service), then run --headless --other-devices again." |
*
* @param {Local_Headless_Others_Not_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_others_not_running = /** @type {((inputs: Local_Headless_Others_Not_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Others_Not_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_others_not_running(inputs)
	return __ja.local_headless_others_not_running(inputs)
});
/**
* | output |
* | --- |
* | "This PC's Agent does not allow use from other devices." |
*
* @param {Local_Headless_Others_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_others_off = /** @type {((inputs?: Local_Headless_Others_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Others_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_others_off(inputs)
	return __ja.local_headless_others_off(inputs)
});
/**
* | output |
* | --- |
* | "This PC's Agent allows use from other devices." |
*
* @param {Local_Headless_Others_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_others_on = /** @type {((inputs?: Local_Headless_Others_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Others_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_others_on(inputs)
	return __ja.local_headless_others_on(inputs)
});
/**
* | output |
* | --- |
* | "Write on or off after --other-devices." |
*
* @param {Local_Headless_Others_UsageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_others_usage = /** @type {((inputs?: Local_Headless_Others_UsageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Others_UsageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_others_usage(inputs)
	return __ja.local_headless_others_usage(inputs)
});
/**
* | output |
* | --- |
* | "No pairing code: {error}" |
*
* @param {Local_Headless_Pair_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_pair_failed = /** @type {((inputs: Local_Headless_Pair_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Pair_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_pair_failed(inputs)
	return __ja.local_headless_pair_failed(inputs)
});
/**
* | output |
* | --- |
* | "The {app} running on {dir} makes no pairing codes this way; update it and start it again." |
*
* @param {Local_Headless_Pair_No_PairingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_pair_no_pairing = /** @type {((inputs: Local_Headless_Pair_No_PairingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Pair_No_PairingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_pair_no_pairing(inputs)
	return __ja.local_headless_pair_no_pairing(inputs)
});
/**
* | output |
* | --- |
* | "{app} is not running on {dir}. Start it first ({app} --headless, or the service), then run --headless --pair again." |
*
* @param {Local_Headless_Pair_Not_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_pair_not_running = /** @type {((inputs: Local_Headless_Pair_Not_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Pair_Not_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_pair_not_running(inputs)
	return __ja.local_headless_pair_not_running(inputs)
});
/**
* | output |
* | --- |
* | "Other devices cannot connect to the {app} running on {dir}: port {port} is in use by another program. Free it and start {app} again." |
*
* @param {Local_Headless_Pair_Port_In_UseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_pair_port_in_use = /** @type {((inputs: Local_Headless_Pair_Port_In_UseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Pair_Port_In_UseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_pair_port_in_use(inputs)
	return __ja.local_headless_pair_port_in_use(inputs)
});
/**
* | output |
* | --- |
* | "Connections from other devices are off in the {app} running on {dir}." |
*
* @param {Local_Headless_Pair_Remote_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_pair_remote_off = /** @type {((inputs: Local_Headless_Pair_Remote_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Pair_Remote_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_pair_remote_off(inputs)
	return __ja.local_headless_pair_remote_off(inputs)
});
/**
* | output |
* | --- |
* | "Pairing code (works once, for {minutes} more minutes): {code}" |
*
* @param {Local_Headless_Pairing_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_pairing_code = /** @type {((inputs: Local_Headless_Pairing_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Pairing_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_pairing_code(inputs)
	return __ja.local_headless_pairing_code(inputs)
});
/**
* | output |
* | --- |
* | "port {port}" |
*
* @param {Local_Headless_PortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_port = /** @type {((inputs: Local_Headless_PortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_PortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_port(inputs)
	return __ja.local_headless_port(inputs)
});
/**
* | output |
* | --- |
* | "Other devices cannot connect: port {port} is in use ({error})" |
*
* @param {Local_Headless_Port_In_UseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_port_in_use = /** @type {((inputs: Local_Headless_Port_In_UseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Port_In_UseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_port_in_use(inputs)
	return __ja.local_headless_port_in_use(inputs)
});
/**
* | output |
* | --- |
* | "The database could not be opened, so it was restored from the backup taken at {time}. Changes after that time are lost." |
*
* @param {Local_Headless_RestoredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_restored = /** @type {((inputs: Local_Headless_RestoredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_RestoredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_restored(inputs)
	return __ja.local_headless_restored(inputs)
});
/**
* | output |
* | --- |
* | "{app} is running without windows (data: {dir})" |
*
* @param {Local_Headless_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_running = /** @type {((inputs: Local_Headless_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_running(inputs)
	return __ja.local_headless_running(inputs)
});
/**
* | output |
* | --- |
* | "Unlinked from {account}." |
*
* @param {Local_Headless_Unlink_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_unlink_done = /** @type {((inputs: Local_Headless_Unlink_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Unlink_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_unlink_done(inputs)
	return __ja.local_headless_unlink_done(inputs)
});
/**
* | output |
* | --- |
* | "Not linked." |
*
* @param {Local_Headless_Unlink_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_unlink_none = /** @type {((inputs?: Local_Headless_Unlink_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Unlink_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_unlink_none(inputs)
	return __ja.local_headless_unlink_none(inputs)
});
/**
* | output |
* | --- |
* | "{app} is not running on {dir}. Start it first ({app} --headless, or the service), then run --headless --unlink again." |
*
* @param {Local_Headless_Unlink_Not_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_headless_unlink_not_running = /** @type {((inputs: Local_Headless_Unlink_Not_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Headless_Unlink_Not_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_headless_unlink_not_running(inputs)
	return __ja.local_headless_unlink_not_running(inputs)
});
/**
* | output |
* | --- |
* | "Connected." |
*
* @param {Local_Link_ConnectedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_connected = /** @type {((inputs?: Local_Link_ConnectedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_ConnectedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_connected(inputs)
	return __ja.local_link_connected(inputs)
});
/**
* | output |
* | --- |
* | "Connected via Cloud." |
*
* @param {Local_Link_Connected_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_connected_cloud = /** @type {((inputs?: Local_Link_Connected_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Connected_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_connected_cloud(inputs)
	return __ja.local_link_connected_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Connected over {where}." |
*
* @param {Local_Link_Connected_ViaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_connected_via = /** @type {((inputs: Local_Link_Connected_ViaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Connected_ViaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_connected_via(inputs)
	return __ja.local_link_connected_via(inputs)
});
/**
* | output |
* | --- |
* | "Reconnecting." |
*
* @param {Local_Link_ConnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_connecting = /** @type {((inputs?: Local_Link_ConnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_ConnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_connecting(inputs)
	return __ja.local_link_connecting(inputs)
});
/**
* | output |
* | --- |
* | "Vault ({main}) accepts connections via Cloud" |
*
* @param {Local_Link_Hub_DoorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_hub_door = /** @type {((inputs: Local_Link_Hub_DoorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Hub_DoorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_hub_door(inputs)
	return __ja.local_link_hub_door(inputs)
});
/**
* | output |
* | --- |
* | "Not connected to the Vault, so this can't be changed." |
*
* @param {Local_Link_Hub_Door_AwayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_hub_door_away = /** @type {((inputs?: Local_Link_Hub_Door_AwayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Hub_Door_AwayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_hub_door_away(inputs)
	return __ja.local_link_hub_door_away(inputs)
});
/**
* | output |
* | --- |
* | "Available once the Vault is linked to Cloud." |
*
* @param {Local_Link_Hub_Door_Not_TiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_hub_door_not_tied = /** @type {((inputs?: Local_Link_Hub_Door_Not_TiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Hub_Door_Not_TiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_hub_door_not_tied(inputs)
	return __ja.local_link_hub_door_not_tied(inputs)
});
/**
* | output |
* | --- |
* | "A setting of the Vault. When on, devices outside the network can connect to the Vault via Cloud." |
*
* @param {Local_Link_Hub_Door_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_hub_door_note = /** @type {((inputs?: Local_Link_Hub_Door_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Hub_Door_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_hub_door_note(inputs)
	return __ja.local_link_hub_door_note(inputs)
});
/**
* | output |
* | --- |
* | "Can't be changed while connected via Cloud." |
*
* @param {Local_Link_Hub_Door_Via_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_hub_door_via_cloud = /** @type {((inputs?: Local_Link_Hub_Door_Via_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Hub_Door_Via_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_hub_door_via_cloud(inputs)
	return __ja.local_link_hub_door_via_cloud(inputs)
});
/**
* | output |
* | --- |
* | "That is not a pairing code." |
*
* @param {Local_Link_Invalid_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_invalid_code = /** @type {((inputs?: Local_Link_Invalid_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Invalid_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_invalid_code(inputs)
	return __ja.local_link_invalid_code(inputs)
});
/**
* | output |
* | --- |
* | "This PC is a Vault, so it cannot join one." |
*
* @param {Local_Link_Is_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_is_hub = /** @type {((inputs?: Local_Link_Is_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Is_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_is_hub(inputs)
	return __ja.local_link_is_hub(inputs)
});
/**
* | output |
* | --- |
* | "Join a Vault" |
*
* @param {Local_Link_JoinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_join = /** @type {((inputs?: Local_Link_JoinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_JoinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_join(inputs)
	return __ja.local_link_join(inputs)
});
/**
* | output |
* | --- |
* | "Join" |
*
* @param {Local_Link_Join_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_join_button = /** @type {((inputs?: Local_Link_Join_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Join_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_join_button(inputs)
	return __ja.local_link_join_button(inputs)
});
/**
* | output |
* | --- |
* | "Enter the code from \"Connect a device\" in the settings of the PC to use as the Vault. While joined, this app uses the Vault's data; this PC's own data is kep..." |
*
* @param {Local_Link_Join_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_join_note = /** @type {((inputs?: Local_Link_Join_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Join_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_join_note(inputs)
	return __ja.local_link_join_note(inputs)
});
/**
* | output |
* | --- |
* | "Leave" |
*
* @param {Local_Link_LeaveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_leave = /** @type {((inputs?: Local_Link_LeaveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_LeaveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_leave(inputs)
	return __ja.local_link_leave(inputs)
});
/**
* | output |
* | --- |
* | "This PC goes back to its own data. The Vault's data stays as it is." |
*
* @param {Local_Link_Leave_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_leave_body = /** @type {((inputs?: Local_Link_Leave_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Leave_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_leave_body(inputs)
	return __ja.local_link_leave_body(inputs)
});
/**
* | output |
* | --- |
* | "Stop using {main}?" |
*
* @param {Local_Link_Leave_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_leave_title = /** @type {((inputs: Local_Link_Leave_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Leave_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_leave_title(inputs)
	return __ja.local_link_leave_title(inputs)
});
/**
* | output |
* | --- |
* | "Using {main}'s data" |
*
* @param {Local_Link_MainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_main = /** @type {((inputs: Local_Link_MainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_MainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_main(inputs)
	return __ja.local_link_main(inputs)
});
/**
* | output |
* | --- |
* | "Open Local Network settings" |
*
* @param {Local_Link_Network_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_network_settings = /** @type {((inputs?: Local_Link_Network_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Network_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_network_settings(inputs)
	return __ja.local_link_network_settings(inputs)
});
/**
* | output |
* | --- |
* | "Open settings" |
*
* @param {Local_Link_Open_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_open_settings = /** @type {((inputs?: Local_Link_Open_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Open_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_open_settings(inputs)
	return __ja.local_link_open_settings(inputs)
});
/**
* | output |
* | --- |
* | "Reconnecting to {main}" |
*
* @param {Local_Link_ReconnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_reconnecting = /** @type {((inputs: Local_Link_ReconnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_ReconnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_reconnecting(inputs)
	return __ja.local_link_reconnecting(inputs)
});
/**
* | output |
* | --- |
* | "Reconnecting. The Vault does not accept connections via Cloud." |
*
* @param {Local_Link_Reconnecting_Not_ListeningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_reconnecting_not_listening = /** @type {((inputs?: Local_Link_Reconnecting_Not_ListeningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Reconnecting_Not_ListeningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_reconnecting_not_listening(inputs)
	return __ja.local_link_reconnecting_not_listening(inputs)
});
/**
* | output |
* | --- |
* | "Reconnecting. Sign in again from this PC under “Cloud”." |
*
* @param {Local_Link_Reconnecting_Sign_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_reconnecting_sign_in = /** @type {((inputs?: Local_Link_Reconnecting_Sign_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Reconnecting_Sign_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_reconnecting_sign_in(inputs)
	return __ja.local_link_reconnecting_sign_in(inputs)
});
/**
* | output |
* | --- |
* | "The code did not work. Make a new one on the Vault." |
*
* @param {Local_Link_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_refused = /** @type {((inputs?: Local_Link_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_refused(inputs)
	return __ja.local_link_refused(inputs)
});
/**
* | output |
* | --- |
* | "{main} removed this PC" |
*
* @param {Local_Link_RemovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_removed = /** @type {((inputs: Local_Link_RemovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_RemovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_removed(inputs)
	return __ja.local_link_removed(inputs)
});
/**
* | output |
* | --- |
* | "The Vault removed this PC. Leave, then join again." |
*
* @param {Local_Link_Removed_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_removed_short = /** @type {((inputs?: Local_Link_Removed_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Removed_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_removed_short(inputs)
	return __ja.local_link_removed_short(inputs)
});
/**
* | output |
* | --- |
* | "Connect to the Vault via Cloud outside the network" |
*
* @param {Local_Link_RoutesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_routes = /** @type {((inputs?: Local_Link_RoutesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_RoutesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_routes(inputs)
	return __ja.local_link_routes(inputs)
});
/**
* | output |
* | --- |
* | "Not used now, because Personal data is in Cloud." |
*
* @param {Local_Link_Routes_Cloud_HomeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_routes_cloud_home = /** @type {((inputs?: Local_Link_Routes_Cloud_HomeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Routes_Cloud_HomeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_routes_cloud_home(inputs)
	return __ja.local_link_routes_cloud_home(inputs)
});
/**
* | output |
* | --- |
* | "Available once this PC signs in under “Cloud”." |
*
* @param {Local_Link_Routes_No_Sign_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_routes_no_sign_in = /** @type {((inputs?: Local_Link_Routes_No_Sign_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Routes_No_Sign_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_routes_no_sign_in(inputs)
	return __ja.local_link_routes_no_sign_in(inputs)
});
/**
* | output |
* | --- |
* | "Use the Vault's Personal data via Cloud even where you can't connect to the Vault. The connection stays encrypted." |
*
* @param {Local_Link_Routes_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_routes_note = /** @type {((inputs?: Local_Link_Routes_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Routes_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_routes_note(inputs)
	return __ja.local_link_routes_note(inputs)
});
/**
* | output |
* | --- |
* | "This PC's app is older than {main}'s, so this PC's own screen is shown. Update the app to get the same screen as {main}." |
*
* @param {Local_Link_Screen_App_OutdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_screen_app_outdated = /** @type {((inputs: Local_Link_Screen_App_OutdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Screen_App_OutdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_screen_app_outdated(inputs)
	return __ja.local_link_screen_app_outdated(inputs)
});
/**
* | output |
* | --- |
* | "{main}'s app is older, so this PC's own screen is shown." |
*
* @param {Local_Link_Screen_Hub_OutdatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_screen_hub_outdated = /** @type {((inputs: Local_Link_Screen_Hub_OutdatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Screen_Hub_OutdatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_screen_hub_outdated(inputs)
	return __ja.local_link_screen_hub_outdated(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach the Vault. Check that it accepts connections and that both PCs are on the same network or Tailscale." |
*
* @param {Local_Link_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_unreachable = /** @type {((inputs?: Local_Link_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_unreachable(inputs)
	return __ja.local_link_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "If it is on the same network, also check that this app is allowed under Local Network in System Settings." |
*
* @param {Local_Link_Unreachable_MacInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_unreachable_mac = /** @type {((inputs?: Local_Link_Unreachable_MacInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Unreachable_MacInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_unreachable_mac(inputs)
	return __ja.local_link_unreachable_mac(inputs)
});
/**
* | output |
* | --- |
* | "{main} is out of reach" |
*
* @param {Local_Link_Unreachable_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_unreachable_now = /** @type {((inputs: Local_Link_Unreachable_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Unreachable_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_unreachable_now(inputs)
	return __ja.local_link_unreachable_now(inputs)
});
/**
* | output |
* | --- |
* | "Not saved: {main} is out of reach." |
*
* @param {Local_Link_Write_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_link_write_failed = /** @type {((inputs: Local_Link_Write_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Link_Write_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_link_write_failed(inputs)
	return __ja.local_link_write_failed(inputs)
});
/**
* | output |
* | --- |
* | "MCP clients" |
*
* @param {Local_McpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp = /** @type {((inputs?: Local_McpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_McpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp(inputs)
	return __ja.local_mcp(inputs)
});
/**
* | output |
* | --- |
* | "Run it in a terminal." |
*
* @param {Local_Mcp_Claude_Code_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_claude_code_note = /** @type {((inputs?: Local_Mcp_Claude_Code_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_Claude_Code_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_claude_code_note(inputs)
	return __ja.local_mcp_claude_code_note(inputs)
});
/**
* | output |
* | --- |
* | "Add it to mcpServers in claude_desktop_config.json (Settings → Developer → Edit Config)." |
*
* @param {Local_Mcp_Claude_Desktop_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_claude_desktop_note = /** @type {((inputs?: Local_Mcp_Claude_Desktop_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_Claude_Desktop_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_claude_desktop_note(inputs)
	return __ja.local_mcp_claude_desktop_note(inputs)
});
/**
* | output |
* | --- |
* | "Add it to ~/.codex/config.toml." |
*
* @param {Local_Mcp_Codex_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_codex_note = /** @type {((inputs?: Local_Mcp_Codex_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_Codex_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_codex_note(inputs)
	return __ja.local_mcp_codex_note(inputs)
});
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Local_Mcp_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_copied = /** @type {((inputs?: Local_Mcp_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_copied(inputs)
	return __ja.local_mcp_copied(inputs)
});
/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Local_Mcp_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_copy = /** @type {((inputs?: Local_Mcp_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_copy(inputs)
	return __ja.local_mcp_copy(inputs)
});
/**
* | output |
* | --- |
* | "Could not copy" |
*
* @param {Local_Mcp_Copy_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_copy_failed = /** @type {((inputs?: Local_Mcp_Copy_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_Copy_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_copy_failed(inputs)
	return __ja.local_mcp_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "Let Claude Code, Codex and Claude Desktop read and write the Cases, People and documents on this PC. They connect only while this app is open." |
*
* @param {Local_Mcp_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_description = /** @type {((inputs?: Local_Mcp_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_description(inputs)
	return __ja.local_mcp_description(inputs)
});
/**
* | output |
* | --- |
* | "Could not load" |
*
* @param {Local_Mcp_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_load_failed = /** @type {((inputs?: Local_Mcp_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_load_failed(inputs)
	return __ja.local_mcp_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Local_Mcp_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_retry = /** @type {((inputs?: Local_Mcp_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_retry(inputs)
	return __ja.local_mcp_retry(inputs)
});
/**
* | output |
* | --- |
* | "MCP clients cannot connect from here." |
*
* @param {Local_Mcp_UnavailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_mcp_unavailable = /** @type {((inputs?: Local_Mcp_UnavailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Mcp_UnavailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_mcp_unavailable(inputs)
	return __ja.local_mcp_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Local_Me_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_cancel = /** @type {((inputs?: Local_Me_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_cancel(inputs)
	return __ja.local_me_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Personal data goes back where it was and can be changed again." |
*
* @param {Local_Me_Cancel_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_cancel_body = /** @type {((inputs?: Local_Me_Cancel_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Cancel_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_cancel_body(inputs)
	return __ja.local_me_cancel_body(inputs)
});
/**
* | output |
* | --- |
* | "Cancel moving personal data?" |
*
* @param {Local_Me_Cancel_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_cancel_title = /** @type {((inputs?: Local_Me_Cancel_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Cancel_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_cancel_title(inputs)
	return __ja.local_me_cancel_title(inputs)
});
/**
* | output |
* | --- |
* | "Moving personal data was cancelled" |
*
* @param {Local_Me_CancelledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_cancelled = /** @type {((inputs?: Local_Me_CancelledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_CancelledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_cancelled(inputs)
	return __ja.local_me_cancelled(inputs)
});
/**
* | output |
* | --- |
* | "What changes" |
*
* @param {Local_Me_ChangesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_changes = /** @type {((inputs?: Local_Me_ChangesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_ChangesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_changes(inputs)
	return __ja.local_me_changes(inputs)
});
/**
* | output |
* | --- |
* | "Places that cannot reach this Vault can no longer read or change it." |
*
* @param {Local_Me_Check_Far_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_far_note = /** @type {((inputs?: Local_Me_Check_Far_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Far_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_far_note(inputs)
	return __ja.local_me_check_far_note(inputs)
});
/**
* | output |
* | --- |
* | "Outside apps' MCP and agents elsewhere" |
*
* @param {Local_Me_Check_Far_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_far_title = /** @type {((inputs?: Local_Me_Check_Far_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Far_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_far_title(inputs)
	return __ja.local_me_check_far_title(inputs)
});
/**
* | output |
* | --- |
* | "Connect it again after the move." |
*
* @param {Local_Me_Check_Google_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_google_note = /** @type {((inputs?: Local_Me_Check_Google_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Google_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_google_note(inputs)
	return __ja.local_me_check_google_note(inputs)
});
/**
* | output |
* | --- |
* | "Google Calendar" |
*
* @param {Local_Me_Check_Google_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_google_title = /** @type {((inputs?: Local_Me_Check_Google_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Google_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_google_title(inputs)
	return __ja.local_me_check_google_title(inputs)
});
/**
* | output |
* | --- |
* | "It gets no Personal data until it reconnects to Cloud." |
*
* @param {Local_Me_Check_Hub_Agents_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_hub_agents_note = /** @type {((inputs?: Local_Me_Check_Hub_Agents_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Hub_Agents_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_hub_agents_note(inputs)
	return __ja.local_me_check_hub_agents_note(inputs)
});
/**
* | output |
* | --- |
* | "This Vault's Agent" |
*
* @param {Local_Me_Check_Hub_Agents_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_hub_agents_title = /** @type {((inputs?: Local_Me_Check_Hub_Agents_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Hub_Agents_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_hub_agents_title(inputs)
	return __ja.local_me_check_hub_agents_title(inputs)
});
/**
* | output |
* | --- |
* | "Notifications of personal data stop. The workspaces' still come." |
*
* @param {Local_Me_Check_Phone_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_phone_note = /** @type {((inputs?: Local_Me_Check_Phone_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Phone_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_phone_note(inputs)
	return __ja.local_me_check_phone_note(inputs)
});
/**
* | output |
* | --- |
* | "Notifications on the phone" |
*
* @param {Local_Me_Check_Phone_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_phone_title = /** @type {((inputs?: Local_Me_Check_Phone_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Phone_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_phone_title(inputs)
	return __ja.local_me_check_phone_title(inputs)
});
/**
* | output |
* | --- |
* | "Publishing stops when it moves (it does not come back if you move back to the cloud)." |
*
* @param {Local_Me_Check_Published_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_published_note = /** @type {((inputs?: Local_Me_Check_Published_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Published_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_published_note(inputs)
	return __ja.local_me_check_published_note(inputs)
});
/**
* | output |
* | --- |
* | "Published personal documents" |
*
* @param {Local_Me_Check_Published_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_published_title = /** @type {((inputs?: Local_Me_Check_Published_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Published_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_published_title(inputs)
	return __ja.local_me_check_published_title(inputs)
});
/**
* | output |
* | --- |
* | "Sandbox agents stop." |
*
* @param {Local_Me_Check_Sandbox_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_sandbox_note = /** @type {((inputs?: Local_Me_Check_Sandbox_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Sandbox_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_sandbox_note(inputs)
	return __ja.local_me_check_sandbox_note(inputs)
});
/**
* | output |
* | --- |
* | "Cloud sandboxes" |
*
* @param {Local_Me_Check_Sandbox_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_sandbox_title = /** @type {((inputs?: Local_Me_Check_Sandbox_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Sandbox_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_sandbox_title(inputs)
	return __ja.local_me_check_sandbox_title(inputs)
});
/**
* | output |
* | --- |
* | "Personal data can be opened there too." |
*
* @param {Local_Me_Check_Web_GetsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_web_gets = /** @type {((inputs?: Local_Me_Check_Web_GetsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Web_GetsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_web_gets(inputs)
	return __ja.local_me_check_web_gets(inputs)
});
/**
* | output |
* | --- |
* | "Personal data can no longer be opened there. The workspaces work as before." |
*
* @param {Local_Me_Check_Web_LosesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_web_loses = /** @type {((inputs?: Local_Me_Check_Web_LosesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Web_LosesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_web_loses(inputs)
	return __ja.local_me_check_web_loses(inputs)
});
/**
* | output |
* | --- |
* | "The web and the phone app (PWA)" |
*
* @param {Local_Me_Check_Web_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_check_web_title = /** @type {((inputs?: Local_Me_Check_Web_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Check_Web_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_check_web_title(inputs)
	return __ja.local_me_check_web_title(inputs)
});
/**
* | output |
* | --- |
* | "Personal data moved to the cloud. This Vault keeps only a copy. Open it on the web or in a desktop connected to the cloud." |
*
* @param {Local_Me_Elsewhere_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_elsewhere_body = /** @type {((inputs?: Local_Me_Elsewhere_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Elsewhere_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_elsewhere_body(inputs)
	return __ja.local_me_elsewhere_body(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives in the cloud" |
*
* @param {Local_Me_Elsewhere_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_elsewhere_title = /** @type {((inputs?: Local_Me_Elsewhere_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Elsewhere_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_elsewhere_title(inputs)
	return __ja.local_me_elsewhere_title(inputs)
});
/**
* | output |
* | --- |
* | "About how long: {length}" |
*
* @param {Local_Me_EstimateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_estimate = /** @type {((inputs: Local_Me_EstimateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_EstimateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_estimate(inputs)
	return __ja.local_me_estimate(inputs)
});
/**
* | output |
* | --- |
* | "over ten minutes" |
*
* @param {Local_Me_Estimate_LongInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_estimate_long = /** @type {((inputs?: Local_Me_Estimate_LongInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Estimate_LongInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_estimate_long(inputs)
	return __ja.local_me_estimate_long(inputs)
});
/**
* | output |
* | --- |
* | "about a minute" |
*
* @param {Local_Me_Estimate_MinuteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_estimate_minute = /** @type {((inputs?: Local_Me_Estimate_MinuteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Estimate_MinuteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_estimate_minute(inputs)
	return __ja.local_me_estimate_minute(inputs)
});
/**
* | output |
* | --- |
* | "a few minutes" |
*
* @param {Local_Me_Estimate_MinutesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_estimate_minutes = /** @type {((inputs?: Local_Me_Estimate_MinutesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Estimate_MinutesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_estimate_minutes(inputs)
	return __ja.local_me_estimate_minutes(inputs)
});
/**
* | output |
* | --- |
* | "a few seconds" |
*
* @param {Local_Me_Estimate_SecondsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_estimate_seconds = /** @type {((inputs?: Local_Me_Estimate_SecondsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Estimate_SecondsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_estimate_seconds(inputs)
	return __ja.local_me_estimate_seconds(inputs)
});
/**
* | output |
* | --- |
* | "Stopped: {message}" |
*
* @param {Local_Me_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_failed = /** @type {((inputs: Local_Me_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_failed(inputs)
	return __ja.local_me_failed(inputs)
});
/**
* | output |
* | --- |
* | "It stopped because personal data changed while it moved (an agent's run ended, for example). Continue sends only what changed." |
*
* @param {Local_Me_Failed_ChangedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_failed_changed = /** @type {((inputs?: Local_Me_Failed_ChangedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Failed_ChangedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_failed_changed(inputs)
	return __ja.local_me_failed_changed(inputs)
});
/**
* | output |
* | --- |
* | "It stopped at the limit of switches. Continue a little later." |
*
* @param {Local_Me_Failed_LimitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_failed_limit = /** @type {((inputs?: Local_Me_Failed_LimitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Failed_LimitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_failed_limit(inputs)
	return __ja.local_me_failed_limit(inputs)
});
/**
* | output |
* | --- |
* | "It stopped because the cloud or the file storage was out of reach. Continue once you are connected." |
*
* @param {Local_Me_Failed_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_failed_unreachable = /** @type {((inputs?: Local_Me_Failed_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Failed_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_failed_unreachable(inputs)
	return __ja.local_me_failed_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "Moved to {place} in {time}." |
*
* @param {Local_Me_FinishedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_finished = /** @type {((inputs: Local_Me_FinishedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_FinishedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_finished(inputs)
	return __ja.local_me_finished(inputs)
});
/**
* | output |
* | --- |
* | "Added {what} to {place} in {time}." |
*
* @param {Local_Me_Finished_MergeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_finished_merge = /** @type {((inputs: Local_Me_Finished_MergeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Finished_MergeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_finished_merge(inputs)
	return __ja.local_me_finished_merge(inputs)
});
/**
* | output |
* | --- |
* | "the cloud" |
*
* @param {Local_Me_Finished_Place_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_finished_place_cloud = /** @type {((inputs?: Local_Me_Finished_Place_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Finished_Place_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_finished_place_cloud(inputs)
	return __ja.local_me_finished_place_cloud(inputs)
});
/**
* | output |
* | --- |
* | "this Vault" |
*
* @param {Local_Me_Finished_Place_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_finished_place_hub = /** @type {((inputs?: Local_Me_Finished_Place_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Finished_Place_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_finished_place_hub(inputs)
	return __ja.local_me_finished_place_hub(inputs)
});
/**
* | output |
* | --- |
* | "{count} {name}" |
*
* @param {Local_Me_Finished_WhatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_finished_what = /** @type {((inputs: Local_Me_Finished_WhatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Finished_WhatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_finished_what(inputs)
	return __ja.local_me_finished_what(inputs)
});
/**
* | output |
* | --- |
* | "{count} {name} and more" |
*
* @param {Local_Me_Finished_What_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_finished_what_more = /** @type {((inputs: Local_Me_Finished_What_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Finished_What_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_finished_what_more(inputs)
	return __ja.local_me_finished_what_more(inputs)
});
/**
* | output |
* | --- |
* | "made {date}" |
*
* @param {Local_Me_Item_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_item_created = /** @type {((inputs: Local_Me_Item_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Item_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_item_created(inputs)
	return __ja.local_me_item_created(inputs)
});
/**
* | output |
* | --- |
* | "What is added" |
*
* @param {Local_Me_MergeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge = /** @type {((inputs?: Local_Me_MergeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_MergeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge(inputs)
	return __ja.local_me_merge(inputs)
});
/**
* | output |
* | --- |
* | "The personal data in the cloud and on this Vault are added together. The side you choose holds it from then on; the other keeps the same as a copy for 30 day..." |
*
* @param {Local_Me_Merge_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_body = /** @type {((inputs?: Local_Me_Merge_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_body(inputs)
	return __ja.local_me_merge_body(inputs)
});
/**
* | output |
* | --- |
* | "Only in the cloud" |
*
* @param {Local_Me_Merge_From_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_from_cloud = /** @type {((inputs?: Local_Me_Merge_From_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_From_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_from_cloud(inputs)
	return __ja.local_me_merge_from_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Only on this Vault" |
*
* @param {Local_Me_Merge_From_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_from_hub = /** @type {((inputs?: Local_Me_Merge_From_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_From_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_from_hub(inputs)
	return __ja.local_me_merge_from_hub(inputs)
});
/**
* | output |
* | --- |
* | "What both already have stays as one." |
*
* @param {Local_Me_Merge_KeptInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_kept = /** @type {((inputs?: Local_Me_Merge_KeptInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_KeptInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_kept(inputs)
	return __ja.local_me_merge_kept(inputs)
});
/**
* | output |
* | --- |
* | "Labels with the same name become one" |
*
* @param {Local_Me_Merge_LabelsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_labels = /** @type {((inputs?: Local_Me_Merge_LabelsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_LabelsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_labels(inputs)
	return __ja.local_me_merge_labels(inputs)
});
/**
* | output |
* | --- |
* | "Nothing" |
*
* @param {Local_Me_Merge_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_none = /** @type {((inputs?: Local_Me_Merge_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_none(inputs)
	return __ja.local_me_merge_none(inputs)
});
/**
* | output |
* | --- |
* | "The same person becomes one" |
*
* @param {Local_Me_Merge_PersonsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_persons = /** @type {((inputs?: Local_Me_Merge_PersonsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_PersonsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_persons(inputs)
	return __ja.local_me_merge_persons(inputs)
});
/**
* | output |
* | --- |
* | "People with the same Slack or email id, or the same trameria user" |
*
* @param {Local_Me_Merge_Persons_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_persons_note = /** @type {((inputs?: Local_Me_Merge_Persons_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_Persons_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_persons_note(inputs)
	return __ja.local_me_merge_persons_note(inputs)
});
/**
* | output |
* | --- |
* | "Combine in the cloud" |
*
* @param {Local_Me_Merge_To_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_to_cloud = /** @type {((inputs?: Local_Me_Merge_To_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_To_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_to_cloud(inputs)
	return __ja.local_me_merge_to_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Combine your personal data and keep it in the cloud?" |
*
* @param {Local_Me_Merge_To_Cloud_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_to_cloud_title = /** @type {((inputs?: Local_Me_Merge_To_Cloud_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_To_Cloud_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_to_cloud_title(inputs)
	return __ja.local_me_merge_to_cloud_title(inputs)
});
/**
* | output |
* | --- |
* | "Combine on the Vault" |
*
* @param {Local_Me_Merge_To_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_to_hub = /** @type {((inputs?: Local_Me_Merge_To_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_To_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_to_hub(inputs)
	return __ja.local_me_merge_to_hub(inputs)
});
/**
* | output |
* | --- |
* | "Combine your personal data and keep it on this Vault?" |
*
* @param {Local_Me_Merge_To_Hub_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_merge_to_hub_title = /** @type {((inputs?: Local_Me_Merge_To_Hub_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Merge_To_Hub_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_merge_to_hub_title(inputs)
	return __ja.local_me_merge_to_hub_title(inputs)
});
/**
* | output |
* | --- |
* | "While it moves, it is read-only. Afterwards the side it left keeps a copy for 30 days (moving back sends only what differs)." |
*
* @param {Local_Me_Move_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_move_body = /** @type {((inputs?: Local_Me_Move_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Move_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_move_body(inputs)
	return __ja.local_me_move_body(inputs)
});
/**
* | output |
* | --- |
* | "What moves" |
*
* @param {Local_Me_MovesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moves = /** @type {((inputs?: Local_Me_MovesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_MovesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moves(inputs)
	return __ja.local_me_moves(inputs)
});
/**
* | output |
* | --- |
* | "Moving personal data (finding what differs)…" |
*
* @param {Local_Me_Moving_DigestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moving_digest = /** @type {((inputs?: Local_Me_Moving_DigestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Moving_DigestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moving_digest(inputs)
	return __ja.local_me_moving_digest(inputs)
});
/**
* | output |
* | --- |
* | "Moving personal data (finding what differs, {done}/{total})…" |
*
* @param {Local_Me_Moving_Digest_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moving_digest_of = /** @type {((inputs: Local_Me_Moving_Digest_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Moving_Digest_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moving_digest_of(inputs)
	return __ja.local_me_moving_digest_of(inputs)
});
/**
* | output |
* | --- |
* | "Moving personal data (sending files)…" |
*
* @param {Local_Me_Moving_FilesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moving_files = /** @type {((inputs?: Local_Me_Moving_FilesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Moving_FilesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moving_files(inputs)
	return __ja.local_me_moving_files(inputs)
});
/**
* | output |
* | --- |
* | "Putting personal data together (adding)…" |
*
* @param {Local_Me_Moving_MergeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moving_merge = /** @type {((inputs?: Local_Me_Moving_MergeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Moving_MergeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moving_merge(inputs)
	return __ja.local_me_moving_merge(inputs)
});
/**
* | output |
* | --- |
* | "Personal data is moving. It cannot be changed until it is done." |
*
* @param {Local_Me_Moving_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moving_note = /** @type {((inputs?: Local_Me_Moving_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Moving_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moving_note(inputs)
	return __ja.local_me_moving_note(inputs)
});
/**
* | output |
* | --- |
* | "Moving personal data (sending)…" |
*
* @param {Local_Me_Moving_SendInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moving_send = /** @type {((inputs?: Local_Me_Moving_SendInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Moving_SendInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moving_send(inputs)
	return __ja.local_me_moving_send(inputs)
});
/**
* | output |
* | --- |
* | "Moving personal data (checking)…" |
*
* @param {Local_Me_Moving_VerifyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_moving_verify = /** @type {((inputs?: Local_Me_Moving_VerifyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Moving_VerifyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_moving_verify(inputs)
	return __ja.local_me_moving_verify(inputs)
});
/**
* | output |
* | --- |
* | "Where personal data lives" |
*
* @param {Local_Me_PlaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place = /** @type {((inputs?: Local_Me_PlaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_PlaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place(inputs)
	return __ja.local_me_place(inputs)
});
/**
* | output |
* | --- |
* | "Both the cloud and this Vault hold personal data." |
*
* @param {Local_Me_Place_Both_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_both_now = /** @type {((inputs?: Local_Me_Place_Both_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_Both_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_both_now(inputs)
	return __ja.local_me_place_both_now(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives in the cloud." |
*
* @param {Local_Me_Place_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_cloud = /** @type {((inputs?: Local_Me_Place_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_cloud(inputs)
	return __ja.local_me_place_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives in the cloud. This Vault keeps a copy until {date} (it cannot be read or changed)." |
*
* @param {Local_Me_Place_Cloud_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_cloud_copy = /** @type {((inputs: Local_Me_Place_Cloud_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_Cloud_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_cloud_copy(inputs)
	return __ja.local_me_place_cloud_copy(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives in the cloud. Moved to this Vault, the web and the phone app show only the workspaces." |
*
* @param {Local_Me_Place_Cloud_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_cloud_only = /** @type {((inputs?: Local_Me_Place_Cloud_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_Cloud_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_cloud_only(inputs)
	return __ja.local_me_place_cloud_only(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives on this Vault. The workspaces live in the cloud." |
*
* @param {Local_Me_Place_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_hub = /** @type {((inputs?: Local_Me_Place_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_hub(inputs)
	return __ja.local_me_place_hub(inputs)
});
/**
* | output |
* | --- |
* | "Personal data lives on another Vault." |
*
* @param {Local_Me_Place_Other_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_other_hub = /** @type {((inputs?: Local_Me_Place_Other_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_Other_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_other_hub(inputs)
	return __ja.local_me_place_other_hub(inputs)
});
/**
* | output |
* | --- |
* | "The cloud is out of reach." |
*
* @param {Local_Me_Place_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_unreachable = /** @type {((inputs?: Local_Me_Place_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_unreachable(inputs)
	return __ja.local_me_place_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "The cloud and this Vault run different versions. Update the Vault before moving." |
*
* @param {Local_Me_Place_UpdateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_place_update = /** @type {((inputs?: Local_Me_Place_UpdateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Place_UpdateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_place_update(inputs)
	return __ja.local_me_place_update(inputs)
});
/**
* | output |
* | --- |
* | "Stop waiting" |
*
* @param {Local_Me_Queue_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_queue_cancel = /** @type {((inputs?: Local_Me_Queue_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Queue_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_queue_cancel(inputs)
	return __ja.local_me_queue_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Waiting in line ({ahead} ahead, starts in about {minutes} min). It starts by itself when its turn comes." |
*
* @param {Local_Me_QueuedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_queued = /** @type {((inputs: Local_Me_QueuedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_QueuedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_queued(inputs)
	return __ja.local_me_queued(inputs)
});
/**
* | output |
* | --- |
* | "Personal data can be used as usual while it waits." |
*
* @param {Local_Me_Queued_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_queued_note = /** @type {((inputs?: Local_Me_Queued_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Queued_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_queued_note(inputs)
	return __ja.local_me_queued_note(inputs)
});
/**
* | output |
* | --- |
* | "Waiting in line ({ahead} ahead, starts soon). It starts by itself when its turn comes." |
*
* @param {Local_Me_Queued_SoonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_queued_soon = /** @type {((inputs: Local_Me_Queued_SoonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Queued_SoonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_queued_soon(inputs)
	return __ja.local_me_queued_soon(inputs)
});
/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Local_Me_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_retry = /** @type {((inputs?: Local_Me_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_retry(inputs)
	return __ja.local_me_retry(inputs)
});
/**
* | output |
* | --- |
* | "Cloud" |
*
* @param {Local_Me_Side_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_side_cloud = /** @type {((inputs?: Local_Me_Side_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Side_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_side_cloud(inputs)
	return __ja.local_me_side_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Vault" |
*
* @param {Local_Me_Side_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_side_hub = /** @type {((inputs?: Local_Me_Side_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Side_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_side_hub(inputs)
	return __ja.local_me_side_hub(inputs)
});
/**
* | output |
* | --- |
* | "Moving personal data stopped half way. Continue to go on from where it was, or cancel to put it back." |
*
* @param {Local_Me_StoppedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_stopped = /** @type {((inputs?: Local_Me_StoppedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_StoppedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_stopped(inputs)
	return __ja.local_me_stopped(inputs)
});
/**
* | output |
* | --- |
* | "{minutes} min {seconds} s" |
*
* @param {Local_Me_Time_MinutesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_time_minutes = /** @type {((inputs: Local_Me_Time_MinutesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Time_MinutesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_time_minutes(inputs)
	return __ja.local_me_time_minutes(inputs)
});
/**
* | output |
* | --- |
* | "{seconds} s" |
*
* @param {Local_Me_Time_SecondsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_time_seconds = /** @type {((inputs: Local_Me_Time_SecondsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_Time_SecondsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_time_seconds(inputs)
	return __ja.local_me_time_seconds(inputs)
});
/**
* | output |
* | --- |
* | "Move to the cloud" |
*
* @param {Local_Me_To_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_to_cloud = /** @type {((inputs?: Local_Me_To_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_To_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_to_cloud(inputs)
	return __ja.local_me_to_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Move personal data to the cloud?" |
*
* @param {Local_Me_To_Cloud_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_to_cloud_title = /** @type {((inputs?: Local_Me_To_Cloud_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_To_Cloud_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_to_cloud_title(inputs)
	return __ja.local_me_to_cloud_title(inputs)
});
/**
* | output |
* | --- |
* | "Move to this Vault" |
*
* @param {Local_Me_To_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_to_hub = /** @type {((inputs?: Local_Me_To_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_To_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_to_hub(inputs)
	return __ja.local_me_to_hub(inputs)
});
/**
* | output |
* | --- |
* | "Move personal data to this Vault?" |
*
* @param {Local_Me_To_Hub_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_to_hub_title = /** @type {((inputs?: Local_Me_To_Hub_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_To_Hub_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_to_hub_title(inputs)
	return __ja.local_me_to_hub_title(inputs)
});
/**
* | output |
* | --- |
* | "(untitled)" |
*
* @param {Local_Me_UntitledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_me_untitled = /** @type {((inputs?: Local_Me_UntitledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Me_UntitledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_me_untitled(inputs)
	return __ja.local_me_untitled(inputs)
});
/**
* | output |
* | --- |
* | "Menu bar" |
*
* @param {Local_MenubarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar = /** @type {((inputs?: Local_MenubarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_MenubarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar(inputs)
	return __ja.local_menubar(inputs)
});
/**
* | output |
* | --- |
* | "Agent: {name}" |
*
* @param {Local_Menubar_AgentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_agent = /** @type {((inputs: Local_Menubar_AgentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_AgentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_agent(inputs)
	return __ja.local_menubar_agent(inputs)
});
/**
* | output |
* | --- |
* | "Can't reach Cloud" |
*
* @param {Local_Menubar_Agent_Cloud_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_agent_cloud_off = /** @type {((inputs?: Local_Menubar_Agent_Cloud_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Agent_Cloud_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_agent_cloud_off(inputs)
	return __ja.local_menubar_agent_cloud_off(inputs)
});
/**
* | output |
* | --- |
* | "Taking work from Cloud" |
*
* @param {Local_Menubar_Agent_Cloud_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_agent_cloud_on = /** @type {((inputs?: Local_Menubar_Agent_Cloud_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Agent_Cloud_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_agent_cloud_on(inputs)
	return __ja.local_menubar_agent_cloud_on(inputs)
});
/**
* | output |
* | --- |
* | "Taking work from Vault ({main})" |
*
* @param {Local_Menubar_Agent_Hub_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_agent_hub_on = /** @type {((inputs: Local_Menubar_Agent_Hub_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Agent_Hub_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_agent_hub_on(inputs)
	return __ja.local_menubar_agent_hub_on(inputs)
});
/**
* | output |
* | --- |
* | "“Use this PC's Agent” is off" |
*
* @param {Local_Menubar_Agent_UnusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_agent_unused = /** @type {((inputs?: Local_Menubar_Agent_UnusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Agent_UnusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_agent_unused(inputs)
	return __ja.local_menubar_agent_unused(inputs)
});
/**
* | output |
* | --- |
* | "Signed in to Cloud" |
*
* @param {Local_Menubar_Cloud_Signed_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_cloud_signed_in = /** @type {((inputs?: Local_Menubar_Cloud_Signed_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Cloud_Signed_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_cloud_signed_in(inputs)
	return __ja.local_menubar_cloud_signed_in(inputs)
});
/**
* | output |
* | --- |
* | "The icon in the mac menu bar. Kept on this Mac." |
*
* @param {Local_Menubar_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_description = /** @type {((inputs?: Local_Menubar_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_description(inputs)
	return __ja.local_menubar_description(inputs)
});
/**
* | output |
* | --- |
* | "Vault, waiting for devices · {count} connected" |
*
* @param {Local_Menubar_Hub_DevicesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_hub_devices = /** @type {((inputs: Local_Menubar_Hub_DevicesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Hub_DevicesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_hub_devices(inputs)
	return __ja.local_menubar_hub_devices(inputs)
});
/**
* | output |
* | --- |
* | "Vault, waiting for devices (none connected)" |
*
* @param {Local_Menubar_Hub_ListeningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_hub_listening = /** @type {((inputs?: Local_Menubar_Hub_ListeningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Hub_ListeningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_hub_listening(inputs)
	return __ja.local_menubar_hub_listening(inputs)
});
/**
* | output |
* | --- |
* | "Can't connect to Vault ({main})" |
*
* @param {Local_Menubar_Hub_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_hub_off = /** @type {((inputs: Local_Menubar_Hub_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Hub_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_hub_off(inputs)
	return __ja.local_menubar_hub_off(inputs)
});
/**
* | output |
* | --- |
* | "Connected to Vault ({main})" |
*
* @param {Local_Menubar_Hub_OnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_hub_on = /** @type {((inputs: Local_Menubar_Hub_OnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Hub_OnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_hub_on(inputs)
	return __ja.local_menubar_hub_on(inputs)
});
/**
* | output |
* | --- |
* | "Connected to Vault ({main}) via Cloud" |
*
* @param {Local_Menubar_Hub_On_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_hub_on_cloud = /** @type {((inputs: Local_Menubar_Hub_On_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Hub_On_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_hub_on_cloud(inputs)
	return __ja.local_menubar_hub_on_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Connected to Vault ({main}) · {where}" |
*
* @param {Local_Menubar_Hub_On_WhereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_hub_on_where = /** @type {((inputs: Local_Menubar_Hub_On_WhereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Hub_On_WhereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_hub_on_where(inputs)
	return __ja.local_menubar_hub_on_where(inputs)
});
/**
* | output |
* | --- |
* | "Another program uses the Vault's port, so no device can connect" |
*
* @param {Local_Menubar_Hub_Port_In_UseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_hub_port_in_use = /** @type {((inputs?: Local_Menubar_Hub_Port_In_UseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Hub_Port_In_UseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_hub_port_in_use(inputs)
	return __ja.local_menubar_hub_port_in_use(inputs)
});
/**
* | output |
* | --- |
* | "Menu bar icon" |
*
* @param {Local_Menubar_IconInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_icon = /** @type {((inputs?: Local_Menubar_IconInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_IconInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_icon(inputs)
	return __ja.local_menubar_icon(inputs)
});
/**
* | output |
* | --- |
* | "trameria logo" |
*
* @param {Local_Menubar_Icon_LogoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_icon_logo = /** @type {((inputs?: Local_Menubar_Icon_LogoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Icon_LogoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_icon_logo(inputs)
	return __ja.local_menubar_icon_logo(inputs)
});
/**
* | output |
* | --- |
* | "Usage limits shows how much of Claude Code's or Codex's 5-hour and weekly limits you have used, as horizontal bars." |
*
* @param {Local_Menubar_Icon_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_icon_note = /** @type {((inputs?: Local_Menubar_Icon_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Icon_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_icon_note(inputs)
	return __ja.local_menubar_icon_note(inputs)
});
/**
* | output |
* | --- |
* | "Usage limits" |
*
* @param {Local_Menubar_Icon_UsageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_icon_usage = /** @type {((inputs?: Local_Menubar_Icon_UsageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Icon_UsageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_icon_usage(inputs)
	return __ja.local_menubar_icon_usage(inputs)
});
/**
* | output |
* | --- |
* | "Usage limits of" |
*
* @param {Local_Menubar_ProviderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_provider = /** @type {((inputs?: Local_Menubar_ProviderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_ProviderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_provider(inputs)
	return __ja.local_menubar_provider(inputs)
});
/**
* | output |
* | --- |
* | "Whose usage limits the icon's bars show." |
*
* @param {Local_Menubar_Provider_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_provider_note = /** @type {((inputs?: Local_Menubar_Provider_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Provider_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_provider_note(inputs)
	return __ja.local_menubar_provider_note(inputs)
});
/**
* | output |
* | --- |
* | "Whose usage limits the icon's bars show. A CLI this PC does not use cannot be chosen." |
*
* @param {Local_Menubar_Provider_Note_UnusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_provider_note_unused = /** @type {((inputs?: Local_Menubar_Provider_Note_UnusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Provider_Note_UnusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_provider_note_unused(inputs)
	return __ja.local_menubar_provider_note_unused(inputs)
});
/**
* | output |
* | --- |
* | "Show the icon in the menu bar" |
*
* @param {Local_Menubar_ShowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_show = /** @type {((inputs?: Local_Menubar_ShowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_ShowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_show(inputs)
	return __ja.local_menubar_show(inputs)
});
/**
* | output |
* | --- |
* | "When off, the app shows in the Dock instead. It keeps running after you close the window (the Agent keeps working); click the Dock icon to open the window ag..." |
*
* @param {Local_Menubar_Show_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_menubar_show_note = /** @type {((inputs?: Local_Menubar_Show_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Menubar_Show_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_menubar_show_note(inputs)
	return __ja.local_menubar_show_note(inputs)
});
/**
* | output |
* | --- |
* | "Signed in to Cloud" |
*
* @param {Local_Notice_Cloud_LoginInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_notice_cloud_login = /** @type {((inputs?: Local_Notice_Cloud_LoginInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Notice_Cloud_LoginInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_notice_cloud_login(inputs)
	return __ja.local_notice_cloud_login(inputs)
});
/**
* | output |
* | --- |
* | "This PC was added to your device list on {from}, so it signed in as {name} automatically. If you do not need it, sign out in Settings." |
*
* @param {Local_Notice_Cloud_Login_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_notice_cloud_login_body = /** @type {((inputs: Local_Notice_Cloud_Login_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Notice_Cloud_Login_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_notice_cloud_login_body(inputs)
	return __ja.local_notice_cloud_login_body(inputs)
});
/**
* | output |
* | --- |
* | "{chat} stopped with an error" |
*
* @param {Local_Notice_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_notice_failed = /** @type {((inputs: Local_Notice_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Notice_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_notice_failed(inputs)
	return __ja.local_notice_failed(inputs)
});
/**
* | output |
* | --- |
* | "The reply could not be written." |
*
* @param {Local_Notice_Failed_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_notice_failed_body = /** @type {((inputs?: Local_Notice_Failed_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Notice_Failed_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_notice_failed_body(inputs)
	return __ja.local_notice_failed_body(inputs)
});
/**
* | output |
* | --- |
* | "{chat} replied" |
*
* @param {Local_Notice_ReplyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_notice_reply = /** @type {((inputs: Local_Notice_ReplyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Notice_ReplyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_notice_reply(inputs)
	return __ja.local_notice_reply(inputs)
});
/**
* | output |
* | --- |
* | "{chat} is waiting for you" |
*
* @param {Local_Notice_TurnInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_notice_turn = /** @type {((inputs: Local_Notice_TurnInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Notice_TurnInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_notice_turn(inputs)
	return __ja.local_notice_turn(inputs)
});
/**
* | output |
* | --- |
* | "Open in New Window" |
*
* @param {Local_Open_In_New_WindowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_open_in_new_window = /** @type {((inputs?: Local_Open_In_New_WindowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Open_In_New_WindowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_open_in_new_window(inputs)
	return __ja.local_open_in_new_window(inputs)
});
/**
* | output |
* | --- |
* | "Workspaces" |
*
* @param {Local_RailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_rail = /** @type {((inputs?: Local_RailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_RailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_rail(inputs)
	return __ja.local_rail(inputs)
});
/**
* | output |
* | --- |
* | "Create a workspace" |
*
* @param {Local_Rail_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_rail_new = /** @type {((inputs?: Local_Rail_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Rail_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_rail_new(inputs)
	return __ja.local_rail_new(inputs)
});
/**
* | output |
* | --- |
* | "Move to a workspace" |
*
* @param {Local_ReleaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release = /** @type {((inputs?: Local_ReleaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_ReleaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release(inputs)
	return __ja.local_release(inputs)
});
/**
* | output |
* | --- |
* | "Move" |
*
* @param {Local_Release_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_action = /** @type {((inputs?: Local_Release_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_action(inputs)
	return __ja.local_release_action(inputs)
});
/**
* | output |
* | --- |
* | "The document becomes the workspace's, in the cloud. People who see the space can read it, and those who may write documents there can write it. It leaves thi..." |
*
* @param {Local_Release_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_body = /** @type {((inputs?: Local_Release_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_body(inputs)
	return __ja.local_release_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not move “{title}”" |
*
* @param {Local_Release_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_failed = /** @type {((inputs: Local_Release_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_failed(inputs)
	return __ja.local_release_failed(inputs)
});
/**
* | output |
* | --- |
* | "This workspace has no space where you may write documents." |
*
* @param {Local_Release_No_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_no_space = /** @type {((inputs?: Local_Release_No_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_No_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_no_space(inputs)
	return __ja.local_release_no_space(inputs)
});
/**
* | output |
* | --- |
* | "There is no workspace to move it to." |
*
* @param {Local_Release_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_none = /** @type {((inputs?: Local_Release_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_none(inputs)
	return __ja.local_release_none(inputs)
});
/**
* | output |
* | --- |
* | "Space" |
*
* @param {Local_Release_SpaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_space = /** @type {((inputs?: Local_Release_SpaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_SpaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_space(inputs)
	return __ja.local_release_space(inputs)
});
/**
* | output |
* | --- |
* | "Move “{title}” to a workspace" |
*
* @param {Local_Release_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_title = /** @type {((inputs: Local_Release_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_title(inputs)
	return __ja.local_release_title(inputs)
});
/**
* | output |
* | --- |
* | "It can be moved only while your personal data is on this Vault and the cloud is in reach." |
*
* @param {Local_Release_UnavailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_unavailable = /** @type {((inputs?: Local_Release_UnavailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_UnavailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_unavailable(inputs)
	return __ja.local_release_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "Workspace" |
*
* @param {Local_Release_WorkspaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_release_workspace = /** @type {((inputs?: Local_Release_WorkspaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Release_WorkspaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_release_workspace(inputs)
	return __ja.local_release_workspace(inputs)
});
/**
* | output |
* | --- |
* | "Moved “{title}” to {workspace}" |
*
* @param {Local_ReleasedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_released = /** @type {((inputs: Local_ReleasedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_ReleasedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_released(inputs)
	return __ja.local_released(inputs)
});
/**
* | output |
* | --- |
* | "Vault" |
*
* @param {Local_RemoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote = /** @type {((inputs?: Local_RemoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_RemoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote(inputs)
	return __ja.local_remote(inputs)
});
/**
* | output |
* | --- |
* | "Connect a device" |
*
* @param {Local_Remote_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_add = /** @type {((inputs?: Local_Remote_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_add(inputs)
	return __ja.local_remote_add(inputs)
});
/**
* | output |
* | --- |
* | "In trameria on the device to connect, scan this QR or enter the code. It works once, for 10 minutes." |
*
* @param {Local_Remote_Add_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_add_note = /** @type {((inputs?: Local_Remote_Add_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Add_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_add_note(inputs)
	return __ja.local_remote_add_note(inputs)
});
/**
* | output |
* | --- |
* | "Also accept connections via Cloud" |
*
* @param {Local_Remote_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_cloud = /** @type {((inputs?: Local_Remote_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_cloud(inputs)
	return __ja.local_remote_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Connecting to Cloud…" |
*
* @param {Local_Remote_Cloud_ConnectingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_cloud_connecting = /** @type {((inputs?: Local_Remote_Cloud_ConnectingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Cloud_ConnectingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_cloud_connecting(inputs)
	return __ja.local_remote_cloud_connecting(inputs)
});
/**
* | output |
* | --- |
* | "Available once this PC is linked to Cloud." |
*
* @param {Local_Remote_Cloud_Needs_TieInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_cloud_needs_tie = /** @type {((inputs?: Local_Remote_Cloud_Needs_TieInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Cloud_Needs_TieInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_cloud_needs_tie(inputs)
	return __ja.local_remote_cloud_needs_tie(inputs)
});
/**
* | output |
* | --- |
* | "Devices outside the network can connect to this Vault via Cloud. The connection stays encrypted, and Cloud cannot read it." |
*
* @param {Local_Remote_Cloud_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_cloud_note = /** @type {((inputs?: Local_Remote_Cloud_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Cloud_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_cloud_note(inputs)
	return __ja.local_remote_cloud_note(inputs)
});
/**
* | output |
* | --- |
* | "Accepting connections via Cloud." |
*
* @param {Local_Remote_Cloud_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_cloud_open = /** @type {((inputs?: Local_Remote_Cloud_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Cloud_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_cloud_open(inputs)
	return __ja.local_remote_cloud_open(inputs)
});
/**
* | output |
* | --- |
* | "Could not connect to Cloud. Sign in again under “Cloud”." |
*
* @param {Local_Remote_Cloud_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_cloud_refused = /** @type {((inputs?: Local_Remote_Cloud_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Cloud_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_cloud_refused(inputs)
	return __ja.local_remote_cloud_refused(inputs)
});
/**
* | output |
* | --- |
* | "Code" |
*
* @param {Local_Remote_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_code = /** @type {((inputs?: Local_Remote_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_code(inputs)
	return __ja.local_remote_code(inputs)
});
/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Local_Remote_ConnectedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_connected = /** @type {((inputs?: Local_Remote_ConnectedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_ConnectedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_connected(inputs)
	return __ja.local_remote_connected(inputs)
});
/**
* | output |
* | --- |
* | "Connected · {where}" |
*
* @param {Local_Remote_Connected_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_connected_from = /** @type {((inputs: Local_Remote_Connected_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Connected_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_connected_from(inputs)
	return __ja.local_remote_connected_from(inputs)
});
/**
* | output |
* | --- |
* | "Connect trameria on your other devices to this PC, to use the same data and Agent. Only paired devices can connect." |
*
* @param {Local_Remote_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_description = /** @type {((inputs?: Local_Remote_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_description(inputs)
	return __ja.local_remote_description(inputs)
});
/**
* | output |
* | --- |
* | "Connected devices" |
*
* @param {Local_Remote_DevicesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_devices = /** @type {((inputs?: Local_Remote_DevicesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_DevicesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_devices(inputs)
	return __ja.local_remote_devices(inputs)
});
/**
* | output |
* | --- |
* | "None yet." |
*
* @param {Local_Remote_Devices_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_devices_none = /** @type {((inputs?: Local_Remote_Devices_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Devices_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_devices_none(inputs)
	return __ja.local_remote_devices_none(inputs)
});
/**
* | output |
* | --- |
* | "Could not load." |
*
* @param {Local_Remote_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_failed = /** @type {((inputs?: Local_Remote_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_failed(inputs)
	return __ja.local_remote_failed(inputs)
});
/**
* | output |
* | --- |
* | "This PC uses a Vault, so it cannot be one." |
*
* @param {Local_Remote_LinkedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_linked = /** @type {((inputs?: Local_Remote_LinkedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_LinkedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_linked(inputs)
	return __ja.local_remote_linked(inputs)
});
/**
* | output |
* | --- |
* | "Accept connections from other devices" |
*
* @param {Local_Remote_ListenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_listen = /** @type {((inputs?: Local_Remote_ListenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_ListenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_listen(inputs)
	return __ja.local_remote_listen(inputs)
});
/**
* | output |
* | --- |
* | "When on, this PC is the one other devices join (the Vault). It opens one port on this PC while on." |
*
* @param {Local_Remote_Listen_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_listen_note = /** @type {((inputs?: Local_Remote_Listen_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Listen_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_listen_note(inputs)
	return __ja.local_remote_listen_note(inputs)
});
/**
* | output |
* | --- |
* | "Port {port} is used by another app and cannot be opened." |
*
* @param {Local_Remote_Port_In_UseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_port_in_use = /** @type {((inputs: Local_Remote_Port_In_UseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Port_In_UseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_port_in_use(inputs)
	return __ja.local_remote_port_in_use(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Local_Remote_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_remove = /** @type {((inputs?: Local_Remote_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_remove(inputs)
	return __ja.local_remote_remove(inputs)
});
/**
* | output |
* | --- |
* | "It can no longer connect to this PC. To use it again, pair it again." |
*
* @param {Local_Remote_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_remove_body = /** @type {((inputs?: Local_Remote_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_remove_body(inputs)
	return __ja.local_remote_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "Remove {name}?" |
*
* @param {Local_Remote_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_remove_title = /** @type {((inputs: Local_Remote_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_remove_title(inputs)
	return __ja.local_remote_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Local_Remote_RetryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_remote_retry = /** @type {((inputs?: Local_Remote_RetryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Remote_RetryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_remote_retry(inputs)
	return __ja.local_remote_retry(inputs)
});
/**
* | output |
* | --- |
* | "Anywhere" |
*
* @param {Local_Route_AnywhereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_anywhere = /** @type {((inputs?: Local_Route_AnywhereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_AnywhereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_anywhere(inputs)
	return __ja.local_route_anywhere(inputs)
});
/**
* | output |
* | --- |
* | "Personal data is in Cloud, so this PC connects to Cloud directly. This setting is used while Personal data is on the Vault." |
*
* @param {Local_Route_Client_Cloud_HomeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_client_cloud_home = /** @type {((inputs?: Local_Route_Client_Cloud_HomeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Client_Cloud_HomeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_client_cloud_home(inputs)
	return __ja.local_route_client_cloud_home(inputs)
});
/**
* | output |
* | --- |
* | "This PC's connection to the Vault" |
*
* @param {Local_Route_Client_DiagramInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_client_diagram = /** @type {((inputs?: Local_Route_Client_DiagramInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Client_DiagramInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_client_diagram(inputs)
	return __ja.local_route_client_diagram(inputs)
});
/**
* | output |
* | --- |
* | "Available when this PC and the Vault are signed in to Cloud with the same account and the Vault accepts connections via Cloud." |
*
* @param {Local_Route_Client_NeedsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_client_needs = /** @type {((inputs?: Local_Route_Client_NeedsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Client_NeedsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_client_needs(inputs)
	return __ja.local_route_client_needs(inputs)
});
/**
* | output |
* | --- |
* | "Connecting to the Vault from outside the network" |
*
* @param {Local_Route_Client_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_client_title = /** @type {((inputs?: Local_Route_Client_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Client_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_client_title(inputs)
	return __ja.local_route_client_title(inputs)
});
/**
* | output |
* | --- |
* | "PC, smartphone" |
*
* @param {Local_Route_DevicesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_devices = /** @type {((inputs?: Local_Route_DevicesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_DevicesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_devices(inputs)
	return __ja.local_route_devices(inputs)
});
/**
* | output |
* | --- |
* | "Direct" |
*
* @param {Local_Route_DirectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_direct = /** @type {((inputs?: Local_Route_DirectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_DirectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_direct(inputs)
	return __ja.local_route_direct(inputs)
});
/**
* | output |
* | --- |
* | "When you can connect to the Vault, it is used directly. Cloud is used only while you are outside the network." |
*
* @param {Local_Route_Direct_FirstInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_direct_first = /** @type {((inputs?: Local_Route_Direct_FirstInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Direct_FirstInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_direct_first(inputs)
	return __ja.local_route_direct_first(inputs)
});
/**
* | output |
* | --- |
* | "Show a diagram" |
*
* @param {Local_Route_HelpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_help = /** @type {((inputs?: Local_Route_HelpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_HelpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_help(inputs)
	return __ja.local_route_help(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Local_Route_Help_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_help_close = /** @type {((inputs?: Local_Route_Help_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Help_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_help_close(inputs)
	return __ja.local_route_help_close(inputs)
});
/**
* | output |
* | --- |
* | "Vault" |
*
* @param {Local_Route_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_hub = /** @type {((inputs?: Local_Route_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_hub(inputs)
	return __ja.local_route_hub(inputs)
});
/**
* | output |
* | --- |
* | "Connections via Cloud are used only while Personal data is on this Vault. Personal data is in Cloud now, so other devices connect to Cloud directly." |
*
* @param {Local_Route_Hub_Cloud_HomeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_hub_cloud_home = /** @type {((inputs?: Local_Route_Hub_Cloud_HomeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Hub_Cloud_HomeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_hub_cloud_home(inputs)
	return __ja.local_route_hub_cloud_home(inputs)
});
/**
* | output |
* | --- |
* | "A copy of Personal data" |
*
* @param {Local_Route_Hub_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_hub_copy = /** @type {((inputs?: Local_Route_Hub_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Hub_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_hub_copy(inputs)
	return __ja.local_route_hub_copy(inputs)
});
/**
* | output |
* | --- |
* | "Connecting to this Vault via Cloud" |
*
* @param {Local_Route_Hub_DiagramInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_hub_diagram = /** @type {((inputs?: Local_Route_Hub_DiagramInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Hub_DiagramInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_hub_diagram(inputs)
	return __ja.local_route_hub_diagram(inputs)
});
/**
* | output |
* | --- |
* | "Connect a new device on the same network or over Tailscale first." |
*
* @param {Local_Route_Hub_First_DirectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_hub_first_direct = /** @type {((inputs?: Local_Route_Hub_First_DirectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Hub_First_DirectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_hub_first_direct(inputs)
	return __ja.local_route_hub_first_direct(inputs)
});
/**
* | output |
* | --- |
* | "Only devices that have connected to this Vault directly once (paired) can connect via Cloud." |
*
* @param {Local_Route_Hub_Paired_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_hub_paired_only = /** @type {((inputs?: Local_Route_Hub_Paired_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Hub_Paired_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_hub_paired_only(inputs)
	return __ja.local_route_hub_paired_only(inputs)
});
/**
* | output |
* | --- |
* | "Connections via Cloud" |
*
* @param {Local_Route_Hub_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_hub_title = /** @type {((inputs?: Local_Route_Hub_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Hub_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_hub_title(inputs)
	return __ja.local_route_hub_title(inputs)
});
/**
* | output |
* | --- |
* | "Same network" |
*
* @param {Local_Route_NetworkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_network = /** @type {((inputs?: Local_Route_NetworkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_NetworkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_network(inputs)
	return __ja.local_route_network(inputs)
});
/**
* | output |
* | --- |
* | "Same Wi-Fi or Tailscale" |
*
* @param {Local_Route_Network_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_network_note = /** @type {((inputs?: Local_Route_Network_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Network_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_network_note(inputs)
	return __ja.local_route_network_note(inputs)
});
/**
* | output |
* | --- |
* | "Off" |
*
* @param {Local_Route_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_off = /** @type {((inputs?: Local_Route_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_off(inputs)
	return __ja.local_route_off(inputs)
});
/**
* | output |
* | --- |
* | "Outside the network" |
*
* @param {Local_Route_OutsideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_outside = /** @type {((inputs?: Local_Route_OutsideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_OutsideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_outside(inputs)
	return __ja.local_route_outside(inputs)
});
/**
* | output |
* | --- |
* | "Personal data" |
*
* @param {Local_Route_Personal_DataInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_personal_data = /** @type {((inputs?: Local_Route_Personal_DataInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Personal_DataInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_personal_data(inputs)
	return __ja.local_route_personal_data(inputs)
});
/**
* | output |
* | --- |
* | "Relay" |
*
* @param {Local_Route_RelayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_relay = /** @type {((inputs?: Local_Route_RelayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_RelayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_relay(inputs)
	return __ja.local_route_relay(inputs)
});
/**
* | output |
* | --- |
* | "Can't read the contents" |
*
* @param {Local_Route_Relay_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_relay_note = /** @type {((inputs?: Local_Route_Relay_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_Relay_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_relay_note(inputs)
	return __ja.local_route_relay_note(inputs)
});
/**
* | output |
* | --- |
* | "Encrypted" |
*
* @param {Local_Route_SealedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_sealed = /** @type {((inputs?: Local_Route_SealedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_SealedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_sealed(inputs)
	return __ja.local_route_sealed(inputs)
});
/**
* | output |
* | --- |
* | "This PC's Agent" |
*
* @param {Local_Route_This_AgentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_this_agent = /** @type {((inputs?: Local_Route_This_AgentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_This_AgentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_this_agent(inputs)
	return __ja.local_route_this_agent(inputs)
});
/**
* | output |
* | --- |
* | "This Vault" |
*
* @param {Local_Route_This_HubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_this_hub = /** @type {((inputs?: Local_Route_This_HubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_This_HubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_this_hub(inputs)
	return __ja.local_route_this_hub(inputs)
});
/**
* | output |
* | --- |
* | "Personal data, chats" |
*
* @param {Local_Route_This_Hub_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_this_hub_note = /** @type {((inputs?: Local_Route_This_Hub_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_This_Hub_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_this_hub_note(inputs)
	return __ja.local_route_this_hub_note(inputs)
});
/**
* | output |
* | --- |
* | "This PC" |
*
* @param {Local_Route_This_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_route_this_pc = /** @type {((inputs?: Local_Route_This_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Route_This_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_route_this_pc(inputs)
	return __ja.local_route_this_pc(inputs)
});
/**
* | output |
* | --- |
* | "Could not change this. Please try again." |
*
* @param {Local_Setting_Change_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_setting_change_failed = /** @type {((inputs?: Local_Setting_Change_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Setting_Change_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_setting_change_failed(inputs)
	return __ja.local_setting_change_failed(inputs)
});
/**
* | output |
* | --- |
* | "Device list" |
*
* @param {Local_TrustInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust = /** @type {((inputs?: Local_TrustInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_TrustInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust(inputs)
	return __ja.local_trust(inputs)
});
/**
* | output |
* | --- |
* | "Accept a list" |
*
* @param {Local_Trust_AcceptInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_accept = /** @type {((inputs?: Local_Trust_AcceptInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_AcceptInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_accept(inputs)
	return __ja.local_trust_accept(inputs)
});
/**
* | output |
* | --- |
* | "Check that the device ID on {name} is {fingerprint}. Once accepted, the devices in this list may instruct this PC's Agent." |
*
* @param {Local_Trust_Accept_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_accept_body = /** @type {((inputs: Local_Trust_Accept_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Accept_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_accept_body(inputs)
	return __ja.local_trust_accept_body(inputs)
});
/**
* | output |
* | --- |
* | "Accept" |
*
* @param {Local_Trust_Accept_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_accept_button = /** @type {((inputs?: Local_Trust_Accept_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Accept_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_accept_button(inputs)
	return __ja.local_trust_accept_button(inputs)
});
/**
* | output |
* | --- |
* | "First device: {name}" |
*
* @param {Local_Trust_Accept_FirstInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_accept_first = /** @type {((inputs: Local_Trust_Accept_FirstInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Accept_FirstInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_accept_first(inputs)
	return __ja.local_trust_accept_first(inputs)
});
/**
* | output |
* | --- |
* | "Lists made on another device. Accept one only if the device ID matches the one on its first device's screen." |
*
* @param {Local_Trust_Accept_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_accept_note = /** @type {((inputs?: Local_Trust_Accept_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Accept_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_accept_note(inputs)
	return __ja.local_trust_accept_note(inputs)
});
/**
* | output |
* | --- |
* | "Accept this list?" |
*
* @param {Local_Trust_Accept_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_accept_title = /** @type {((inputs?: Local_Trust_Accept_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Accept_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_accept_title(inputs)
	return __ja.local_trust_accept_title(inputs)
});
/**
* | output |
* | --- |
* | "Add a device" |
*
* @param {Local_Trust_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_add = /** @type {((inputs?: Local_Trust_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_add(inputs)
	return __ja.local_trust_add(inputs)
});
/**
* | output |
* | --- |
* | "Add another" |
*
* @param {Local_Trust_Add_AnotherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_add_another = /** @type {((inputs?: Local_Trust_Add_AnotherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Add_AnotherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_add_another(inputs)
	return __ja.local_trust_add_another(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Local_Trust_Add_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_add_button = /** @type {((inputs?: Local_Trust_Add_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Add_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_add_button(inputs)
	return __ja.local_trust_add_button(inputs)
});
/**
* | output |
* | --- |
* | "Type the code shown under \"Get added\" on that device." |
*
* @param {Local_Trust_Add_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_add_note = /** @type {((inputs?: Local_Trust_Add_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Add_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_add_note(inputs)
	return __ja.local_trust_add_note(inputs)
});
/**
* | output |
* | --- |
* | "The device list does not match the one saved on this PC, so this PC's agent has stopped running instructions." |
*
* @param {Local_Trust_Agent_ProblemInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_agent_problem = /** @type {((inputs?: Local_Trust_Agent_ProblemInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Agent_ProblemInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_agent_problem(inputs)
	return __ja.local_trust_agent_problem(inputs)
});
/**
* | output |
* | --- |
* | "{name}'s Agent settings" |
*
* @param {Local_Trust_Agent_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_agent_settings = /** @type {((inputs: Local_Trust_Agent_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Agent_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_agent_settings(inputs)
	return __ja.local_trust_agent_settings(inputs)
});
/**
* | output |
* | --- |
* | "That device is in the list already." |
*
* @param {Local_Trust_Already_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_already_member = /** @type {((inputs?: Local_Trust_Already_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Already_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_already_member(inputs)
	return __ja.local_trust_already_member(inputs)
});
/**
* | output |
* | --- |
* | "Adding…" |
*
* @param {Local_Trust_Approve_AddingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_approve_adding = /** @type {((inputs?: Local_Trust_Approve_AddingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Approve_AddingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_approve_adding(inputs)
	return __ja.local_trust_approve_adding(inputs)
});
/**
* | output |
* | --- |
* | "Check" |
*
* @param {Local_Trust_Approve_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_approve_button = /** @type {((inputs?: Local_Trust_Approve_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Approve_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_approve_button(inputs)
	return __ja.local_trust_approve_button(inputs)
});
/**
* | output |
* | --- |
* | "Add it if this matches the device ID on its screen." |
*
* @param {Local_Trust_Approve_CompareInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_approve_compare = /** @type {((inputs?: Local_Trust_Approve_CompareInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Approve_CompareInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_approve_compare(inputs)
	return __ja.local_trust_approve_compare(inputs)
});
/**
* | output |
* | --- |
* | "Added {name} to the list." |
*
* @param {Local_Trust_Approve_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_approve_done = /** @type {((inputs: Local_Trust_Approve_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Approve_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_approve_done(inputs)
	return __ja.local_trust_approve_done(inputs)
});
/**
* | output |
* | --- |
* | "Looking for the device showing the code…" |
*
* @param {Local_Trust_Approve_FindingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_approve_finding = /** @type {((inputs?: Local_Trust_Approve_FindingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Approve_FindingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_approve_finding(inputs)
	return __ja.local_trust_approve_finding(inputs)
});
/**
* | output |
* | --- |
* | "Devices waiting to be added" |
*
* @param {Local_Trust_CandidatesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_candidates = /** @type {((inputs?: Local_Trust_CandidatesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_CandidatesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_candidates(inputs)
	return __ja.local_trust_candidates(inputs)
});
/**
* | output |
* | --- |
* | "They paired with this Vault. Add one if its device ID matches the one on its screen." |
*
* @param {Local_Trust_Candidates_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_candidates_note = /** @type {((inputs?: Local_Trust_Candidates_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Candidates_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_candidates_note(inputs)
	return __ja.local_trust_candidates_note(inputs)
});
/**
* | output |
* | --- |
* | "Accepted the list." |
*
* @param {Local_Trust_Cli_AcceptedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_accepted = /** @type {((inputs?: Local_Trust_Cli_AcceptedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_AcceptedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_accepted(inputs)
	return __ja.local_trust_cli_accepted(inputs)
});
/**
* | output |
* | --- |
* | "The device list does not match the one saved on this PC, so this PC's agent has stopped running instructions." |
*
* @param {Local_Trust_Cli_Agent_ProblemInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_agent_problem = /** @type {((inputs?: Local_Trust_Cli_Agent_ProblemInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Agent_ProblemInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_agent_problem(inputs)
	return __ja.local_trust_cli_agent_problem(inputs)
});
/**
* | output |
* | --- |
* | "Added {name} to the list." |
*
* @param {Local_Trust_Cli_Approve_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_approve_done = /** @type {((inputs: Local_Trust_Cli_Approve_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Approve_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_approve_done(inputs)
	return __ja.local_trust_cli_approve_done(inputs)
});
/**
* | output |
* | --- |
* | "Looking for the device showing the code…" |
*
* @param {Local_Trust_Cli_Approve_FindingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_approve_finding = /** @type {((inputs?: Local_Trust_Cli_Approve_FindingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Approve_FindingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_approve_finding(inputs)
	return __ja.local_trust_cli_approve_finding(inputs)
});
/**
* | output |
* | --- |
* | "Adding {name} ({kind}, device ID: {fingerprint}). If it matches the device ID on that device, type the passphrase (empty to decline)." |
*
* @param {Local_Trust_Cli_Approve_PeerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_approve_peer = /** @type {((inputs: Local_Trust_Cli_Approve_PeerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Approve_PeerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_approve_peer(inputs)
	return __ja.local_trust_cli_approve_peer(inputs)
});
/**
* | output |
* | --- |
* | "List {list} (first device: {name}, device ID: {fingerprint})" |
*
* @param {Local_Trust_Cli_AvailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_available = /** @type {((inputs: Local_Trust_Cli_AvailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_AvailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_available(inputs)
	return __ja.local_trust_cli_available(inputs)
});
/**
* | output |
* | --- |
* | "Check that the device ID shown on the first device is {fingerprint}. If it is, type the passphrase to accept." |
*
* @param {Local_Trust_Cli_CompareInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_compare = /** @type {((inputs: Local_Trust_Cli_CompareInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_CompareInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_compare(inputs)
	return __ja.local_trust_cli_compare(inputs)
});
/**
* | output |
* | --- |
* | "Made the list. This PC is its first device." |
*
* @param {Local_Trust_Cli_CreatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_created = /** @type {((inputs?: Local_Trust_Cli_CreatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_CreatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_created(inputs)
	return __ja.local_trust_cli_created(inputs)
});
/**
* | output |
* | --- |
* | "That did not work ({error})." |
*
* @param {Local_Trust_Cli_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_failed = /** @type {((inputs: Local_Trust_Cli_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_failed(inputs)
	return __ja.local_trust_cli_failed(inputs)
});
/**
* | output |
* | --- |
* | "This PC's device ID: {fingerprint}" |
*
* @param {Local_Trust_Cli_FingerprintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_fingerprint = /** @type {((inputs: Local_Trust_Cli_FingerprintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_FingerprintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_fingerprint(inputs)
	return __ja.local_trust_cli_fingerprint(inputs)
});
/**
* | output |
* | --- |
* | "Approval code (works once, for {minutes} more minutes): {code} Type it on the approving device, or scan the QR." |
*
* @param {Local_Trust_Cli_InviteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_invite = /** @type {((inputs: Local_Trust_Cli_InviteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_InviteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_invite(inputs)
	return __ja.local_trust_cli_invite(inputs)
});
/**
* | output |
* | --- |
* | "This PC joined the list." |
*
* @param {Local_Trust_Cli_Invite_ApprovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_invite_approved = /** @type {((inputs?: Local_Trust_Cli_Invite_ApprovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Invite_ApprovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_invite_approved(inputs)
	return __ja.local_trust_cli_invite_approved(inputs)
});
/**
* | output |
* | --- |
* | "It was declined." |
*
* @param {Local_Trust_Cli_Invite_DeclinedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_invite_declined = /** @type {((inputs?: Local_Trust_Cli_Invite_DeclinedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Invite_DeclinedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_invite_declined(inputs)
	return __ja.local_trust_cli_invite_declined(inputs)
});
/**
* | output |
* | --- |
* | "The code expired." |
*
* @param {Local_Trust_Cli_Invite_ExpiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_invite_expired = /** @type {((inputs?: Local_Trust_Cli_Invite_ExpiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Invite_ExpiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_invite_expired(inputs)
	return __ja.local_trust_cli_invite_expired(inputs)
});
/**
* | output |
* | --- |
* | "Checked the code with {name}. Waiting for {name} to approve…" |
*
* @param {Local_Trust_Cli_Invite_ProvedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_invite_proved = /** @type {((inputs: Local_Trust_Cli_Invite_ProvedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Invite_ProvedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_invite_proved(inputs)
	return __ja.local_trust_cli_invite_proved(inputs)
});
/**
* | output |
* | --- |
* | "The code did not check. It no longer works." |
*
* @param {Local_Trust_Cli_Invite_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_invite_refused = /** @type {((inputs?: Local_Trust_Cli_Invite_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Invite_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_invite_refused(inputs)
	return __ja.local_trust_cli_invite_refused(inputs)
});
/**
* | output |
* | --- |
* | "Made this PC's keys." |
*
* @param {Local_Trust_Cli_Keys_MadeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_keys_made = /** @type {((inputs?: Local_Trust_Cli_Keys_MadeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Keys_MadeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_keys_made(inputs)
	return __ja.local_trust_cli_keys_made(inputs)
});
/**
* | output |
* | --- |
* | "Device list (version {n}):" |
*
* @param {Local_Trust_Cli_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_list = /** @type {((inputs: Local_Trust_Cli_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_list(inputs)
	return __ja.local_trust_cli_list(inputs)
});
/**
* | output |
* | --- |
* | "Created {date}" |
*
* @param {Local_Trust_Cli_MadeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_made = /** @type {((inputs: Local_Trust_Cli_MadeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_MadeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_made(inputs)
	return __ja.local_trust_cli_made(inputs)
});
/**
* | output |
* | --- |
* | "No device list accepted yet." |
*
* @param {Local_Trust_Cli_No_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_no_list = /** @type {((inputs?: Local_Trust_Cli_No_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_No_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_no_list(inputs)
	return __ja.local_trust_cli_no_list(inputs)
});
/**
* | output |
* | --- |
* | "There is no list to accept." |
*
* @param {Local_Trust_Cli_No_ListsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_no_lists = /** @type {((inputs?: Local_Trust_Cli_No_ListsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_No_ListsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_no_lists(inputs)
	return __ja.local_trust_cli_no_lists(inputs)
});
/**
* | output |
* | --- |
* | "Not found: {what}" |
*
* @param {Local_Trust_Cli_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_not_found = /** @type {((inputs: Local_Trust_Cli_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_not_found(inputs)
	return __ja.local_trust_cli_not_found(inputs)
});
/**
* | output |
* | --- |
* | "{app} is not running on {dir}. Start it first ({app} --headless, or the service), then run this again." |
*
* @param {Local_Trust_Cli_Not_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_not_running = /** @type {((inputs: Local_Trust_Cli_Not_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Not_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_not_running(inputs)
	return __ja.local_trust_cli_not_running(inputs)
});
/**
* | output |
* | --- |
* | "The storage has a device list created on another device. See it with {app} --headless --trust lists." |
*
* @param {Local_Trust_Cli_OthersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_others = /** @type {((inputs: Local_Trust_Cli_OthersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_OthersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_others(inputs)
	return __ja.local_trust_cli_others(inputs)
});
/**
* | output |
* | --- |
* | "The device that pairs with this code joins the device list too." |
*
* @param {Local_Trust_Cli_Pair_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_pair_note = /** @type {((inputs?: Local_Trust_Cli_Pair_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Pair_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_pair_note(inputs)
	return __ja.local_trust_cli_pair_note(inputs)
});
/**
* | output |
* | --- |
* | "Passphrase:" |
*
* @param {Local_Trust_Cli_PassphraseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_passphrase = /** @type {((inputs?: Local_Trust_Cli_PassphraseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_PassphraseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_passphrase(inputs)
	return __ja.local_trust_cli_passphrase(inputs)
});
/**
* | output |
* | --- |
* | "Again:" |
*
* @param {Local_Trust_Cli_Passphrase_AgainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_passphrase_again = /** @type {((inputs?: Local_Trust_Cli_Passphrase_AgainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Passphrase_AgainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_passphrase_again(inputs)
	return __ja.local_trust_cli_passphrase_again(inputs)
});
/**
* | output |
* | --- |
* | "The two did not match." |
*
* @param {Local_Trust_Cli_Passphrase_MismatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_passphrase_mismatch = /** @type {((inputs?: Local_Trust_Cli_Passphrase_MismatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Passphrase_MismatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_passphrase_mismatch(inputs)
	return __ja.local_trust_cli_passphrase_mismatch(inputs)
});
/**
* | output |
* | --- |
* | "Choose a passphrase. You type it when adding or removing devices on this PC; if you forget it, this PC can no longer change the device list ({min} characters..." |
*
* @param {Local_Trust_Cli_Passphrase_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_passphrase_new = /** @type {((inputs: Local_Trust_Cli_Passphrase_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Passphrase_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_passphrase_new(inputs)
	return __ja.local_trust_cli_passphrase_new(inputs)
});
/**
* | output |
* | --- |
* | "The storage ({place}) hands out a list that disagrees with this PC's." |
*
* @param {Local_Trust_Cli_ProblemInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_problem = /** @type {((inputs: Local_Trust_Cli_ProblemInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_ProblemInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_problem(inputs)
	return __ja.local_trust_cli_problem(inputs)
});
/**
* | output |
* | --- |
* | "Removed {name} from the list." |
*
* @param {Local_Trust_Cli_Remove_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_remove_done = /** @type {((inputs: Local_Trust_Cli_Remove_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Remove_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_remove_done(inputs)
	return __ja.local_trust_cli_remove_done(inputs)
});
/**
* | output |
* | --- |
* | "This switches from the current device list to this one. The devices in the current list can no longer instruct this PC's Agent, and you cannot switch back." |
*
* @param {Local_Trust_Cli_SwitchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_switch = /** @type {((inputs?: Local_Trust_Cli_SwitchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_SwitchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_switch(inputs)
	return __ja.local_trust_cli_switch(inputs)
});
/**
* | output |
* | --- |
* | "Switched device lists." |
*
* @param {Local_Trust_Cli_SwitchedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_switched = /** @type {((inputs?: Local_Trust_Cli_SwitchedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_SwitchedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_switched(inputs)
	return __ja.local_trust_cli_switched(inputs)
});
/**
* | output |
* | --- |
* | "Usage: {app} --headless --trust [status \| init \| create \| lists \| accept <list> \| invite [vault\|cloud] \| approve <code> \| remove <device> \| pair]" |
*
* @param {Local_Trust_Cli_UsageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_usage = /** @type {((inputs: Local_Trust_Cli_UsageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_UsageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_usage(inputs)
	return __ja.local_trust_cli_usage(inputs)
});
/**
* | output |
* | --- |
* | "Waiting…" |
*
* @param {Local_Trust_Cli_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_waiting = /** @type {((inputs?: Local_Trust_Cli_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_waiting(inputs)
	return __ja.local_trust_cli_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Wrong passphrase." |
*
* @param {Local_Trust_Cli_Wrong_PassphraseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cli_wrong_passphrase = /** @type {((inputs?: Local_Trust_Cli_Wrong_PassphraseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cli_Wrong_PassphraseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cli_wrong_passphrase(inputs)
	return __ja.local_trust_cli_wrong_passphrase(inputs)
});
/**
* | output |
* | --- |
* | "trameria cloud" |
*
* @param {Local_Trust_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud = /** @type {((inputs?: Local_Trust_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud(inputs)
	return __ja.local_trust_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Local_Trust_Cloud_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_add = /** @type {((inputs?: Local_Trust_Cloud_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_add(inputs)
	return __ja.local_trust_cloud_add(inputs)
});
/**
* | output |
* | --- |
* | "You can add it once it is ready." |
*
* @param {Local_Trust_Cloud_Add_When_ReadyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_add_when_ready = /** @type {((inputs?: Local_Trust_Cloud_Add_When_ReadyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Add_When_ReadyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_add_when_ready(inputs)
	return __ja.local_trust_cloud_add_when_ready(inputs)
});
/**
* | output |
* | --- |
* | "It is added to the list once it is ready." |
*
* @param {Local_Trust_Cloud_AddingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_adding = /** @type {((inputs?: Local_Trust_Cloud_AddingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_AddingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_adding(inputs)
	return __ja.local_trust_cloud_adding(inputs)
});
/**
* | output |
* | --- |
* | "Create" |
*
* @param {Local_Trust_Cloud_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_create = /** @type {((inputs?: Local_Trust_Cloud_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_create(inputs)
	return __ja.local_trust_cloud_create(inputs)
});
/**
* | output |
* | --- |
* | "You can create one up to 3 times a day." |
*
* @param {Local_Trust_Cloud_Create_LimitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_create_limit = /** @type {((inputs?: Local_Trust_Cloud_Create_LimitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Create_LimitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_create_limit(inputs)
	return __ja.local_trust_cloud_create_limit(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Local_Trust_Cloud_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_delete = /** @type {((inputs?: Local_Trust_Cloud_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_delete(inputs)
	return __ja.local_trust_cloud_delete(inputs)
});
/**
* | output |
* | --- |
* | "It is removed from the list, and all its files in Cloud are deleted." |
*
* @param {Local_Trust_Cloud_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_delete_body = /** @type {((inputs?: Local_Trust_Cloud_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_delete_body(inputs)
	return __ja.local_trust_cloud_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Delete {name}?" |
*
* @param {Local_Trust_Cloud_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_delete_title = /** @type {((inputs: Local_Trust_Cloud_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_delete_title(inputs)
	return __ja.local_trust_cloud_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "Cloud could not do it." |
*
* @param {Local_Trust_Cloud_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_failed = /** @type {((inputs?: Local_Trust_Cloud_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_failed(inputs)
	return __ja.local_trust_cloud_failed(inputs)
});
/**
* | output |
* | --- |
* | "trameria cloud (dev)" |
*
* @param {Local_Trust_Cloud_Name_DevInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_name_dev = /** @type {((inputs?: Local_Trust_Cloud_Name_DevInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Name_DevInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_name_dev(inputs)
	return __ja.local_trust_cloud_name_dev(inputs)
});
/**
* | output |
* | --- |
* | "trameria cloud" |
*
* @param {Local_Trust_Cloud_Name_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_name_general = /** @type {((inputs?: Local_Trust_Cloud_Name_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Name_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_name_general(inputs)
	return __ja.local_trust_cloud_name_general(inputs)
});
/**
* | output |
* | --- |
* | "Not created yet" |
*
* @param {Local_Trust_Cloud_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_none = /** @type {((inputs?: Local_Trust_Cloud_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_none(inputs)
	return __ja.local_trust_cloud_none(inputs)
});
/**
* | output |
* | --- |
* | "Devices that run an Agent in Cloud. They take instructions from the devices in the list." |
*
* @param {Local_Trust_Cloud_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_note = /** @type {((inputs?: Local_Trust_Cloud_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_note(inputs)
	return __ja.local_trust_cloud_note(inputs)
});
/**
* | output |
* | --- |
* | "It belongs to an earlier device list. Remake it to add it to this one." |
*
* @param {Local_Trust_Cloud_Other_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_other_list = /** @type {((inputs?: Local_Trust_Cloud_Other_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Other_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_other_list(inputs)
	return __ja.local_trust_cloud_other_list(inputs)
});
/**
* | output |
* | --- |
* | "Asleep" |
*
* @param {Local_Trust_Cloud_Phase_AsleepInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_asleep = /** @type {((inputs?: Local_Trust_Cloud_Phase_AsleepInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_AsleepInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_asleep(inputs)
	return __ja.local_trust_cloud_phase_asleep(inputs)
});
/**
* | output |
* | --- |
* | "Deleting" |
*
* @param {Local_Trust_Cloud_Phase_DeletingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_deleting = /** @type {((inputs?: Local_Trust_Cloud_Phase_DeletingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_DeletingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_deleting(inputs)
	return __ja.local_trust_cloud_phase_deleting(inputs)
});
/**
* | output |
* | --- |
* | "Error" |
*
* @param {Local_Trust_Cloud_Phase_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_error = /** @type {((inputs?: Local_Trust_Cloud_Phase_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_error(inputs)
	return __ja.local_trust_cloud_phase_error(inputs)
});
/**
* | output |
* | --- |
* | "Getting ready" |
*
* @param {Local_Trust_Cloud_Phase_PreparingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_preparing = /** @type {((inputs?: Local_Trust_Cloud_Phase_PreparingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_PreparingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_preparing(inputs)
	return __ja.local_trust_cloud_phase_preparing(inputs)
});
/**
* | output |
* | --- |
* | "Waiting for room" |
*
* @param {Local_Trust_Cloud_Phase_QueuedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_queued = /** @type {((inputs?: Local_Trust_Cloud_Phase_QueuedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_QueuedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_queued(inputs)
	return __ja.local_trust_cloud_phase_queued(inputs)
});
/**
* | output |
* | --- |
* | "Waiting for room · {n}" |
*
* @param {Local_Trust_Cloud_Phase_Queued_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_queued_at = /** @type {((inputs: Local_Trust_Cloud_Phase_Queued_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_Queued_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_queued_at(inputs)
	return __ja.local_trust_cloud_phase_queued_at(inputs)
});
/**
* | output |
* | --- |
* | "Remaking" |
*
* @param {Local_Trust_Cloud_Phase_RemakingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_remaking = /** @type {((inputs?: Local_Trust_Cloud_Phase_RemakingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_RemakingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_remaking(inputs)
	return __ja.local_trust_cloud_phase_remaking(inputs)
});
/**
* | output |
* | --- |
* | "Running" |
*
* @param {Local_Trust_Cloud_Phase_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_running = /** @type {((inputs?: Local_Trust_Cloud_Phase_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_running(inputs)
	return __ja.local_trust_cloud_phase_running(inputs)
});
/**
* | output |
* | --- |
* | "Starting" |
*
* @param {Local_Trust_Cloud_Phase_StartingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_phase_starting = /** @type {((inputs?: Local_Trust_Cloud_Phase_StartingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Phase_StartingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_phase_starting(inputs)
	return __ja.local_trust_cloud_phase_starting(inputs)
});
/**
* | output |
* | --- |
* | "Remake" |
*
* @param {Local_Trust_Cloud_RemakeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_remake = /** @type {((inputs?: Local_Trust_Cloud_RemakeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_RemakeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_remake(inputs)
	return __ja.local_trust_cloud_remake(inputs)
});
/**
* | output |
* | --- |
* | "{name} is deleted, then created again and added to this list. All its files are deleted." |
*
* @param {Local_Trust_Cloud_Remake_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_remake_body = /** @type {((inputs: Local_Trust_Cloud_Remake_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Remake_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_remake_body(inputs)
	return __ja.local_trust_cloud_remake_body(inputs)
});
/**
* | output |
* | --- |
* | "Remake {name}?" |
*
* @param {Local_Trust_Cloud_Remake_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_remake_title = /** @type {((inputs: Local_Trust_Cloud_Remake_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Remake_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_remake_title(inputs)
	return __ja.local_trust_cloud_remake_title(inputs)
});
/**
* | output |
* | --- |
* | "It takes no instructions until it is added to the list." |
*
* @param {Local_Trust_Cloud_UnlistedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_unlisted = /** @type {((inputs?: Local_Trust_Cloud_UnlistedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_UnlistedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_unlisted(inputs)
	return __ja.local_trust_cloud_unlisted(inputs)
});
/**
* | output |
* | --- |
* | "Update CLIs" |
*
* @param {Local_Trust_Cloud_Update_ClisInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_update_clis = /** @type {((inputs?: Local_Trust_Cloud_Update_ClisInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Update_ClisInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_update_clis(inputs)
	return __ja.local_trust_cloud_update_clis(inputs)
});
/**
* | output |
* | --- |
* | "Updating CLIs" |
*
* @param {Local_Trust_Cloud_UpdatingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_updating = /** @type {((inputs?: Local_Trust_Cloud_UpdatingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_UpdatingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_updating(inputs)
	return __ja.local_trust_cloud_updating(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Local_Trust_Cloud_WakeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_wake = /** @type {((inputs?: Local_Trust_Cloud_WakeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_WakeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_wake(inputs)
	return __ja.local_trust_cloud_wake(inputs)
});
/**
* | output |
* | --- |
* | "Start it to add it to the list." |
*
* @param {Local_Trust_Cloud_Wake_To_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_cloud_wake_to_add = /** @type {((inputs?: Local_Trust_Cloud_Wake_To_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Cloud_Wake_To_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_cloud_wake_to_add(inputs)
	return __ja.local_trust_cloud_wake_to_add(inputs)
});
/**
* | output |
* | --- |
* | "Code" |
*
* @param {Local_Trust_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_code = /** @type {((inputs?: Local_Trust_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_code(inputs)
	return __ja.local_trust_code(inputs)
});
/**
* | output |
* | --- |
* | "The code expired." |
*
* @param {Local_Trust_Code_ExpiredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_code_expired = /** @type {((inputs?: Local_Trust_Code_ExpiredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Code_ExpiredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_code_expired(inputs)
	return __ja.local_trust_code_expired(inputs)
});
/**
* | output |
* | --- |
* | "Make a list" |
*
* @param {Local_Trust_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_create = /** @type {((inputs?: Local_Trust_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_create(inputs)
	return __ja.local_trust_create(inputs)
});
/**
* | output |
* | --- |
* | "A device list created on {name} exists already. If you create a new one, the devices in that list cannot instruct this PC's Agent. Create one only if you los..." |
*
* @param {Local_Trust_Create_Again_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_create_again_body = /** @type {((inputs: Local_Trust_Create_Again_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Create_Again_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_create_again_body(inputs)
	return __ja.local_trust_create_again_body(inputs)
});
/**
* | output |
* | --- |
* | "Only for when you lost every device in the device list found. If you still have one of them, use \"Get added\" or \"Accept a list\" above." |
*
* @param {Local_Trust_Create_Again_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_create_again_note = /** @type {((inputs?: Local_Trust_Create_Again_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Create_Again_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_create_again_note(inputs)
	return __ja.local_trust_create_again_note(inputs)
});
/**
* | output |
* | --- |
* | "Create a new device list?" |
*
* @param {Local_Trust_Create_Again_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_create_again_title = /** @type {((inputs?: Local_Trust_Create_Again_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Create_Again_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_create_again_title(inputs)
	return __ja.local_trust_create_again_title(inputs)
});
/**
* | output |
* | --- |
* | "Make" |
*
* @param {Local_Trust_Create_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_create_button = /** @type {((inputs?: Local_Trust_Create_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Create_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_create_button(inputs)
	return __ja.local_trust_create_button(inputs)
});
/**
* | output |
* | --- |
* | "Make a new list with this device as its first." |
*
* @param {Local_Trust_Create_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_create_note = /** @type {((inputs?: Local_Trust_Create_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Create_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_create_note(inputs)
	return __ja.local_trust_create_note(inputs)
});
/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Local_Trust_DeclineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_decline = /** @type {((inputs?: Local_Trust_DeclineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_DeclineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_decline(inputs)
	return __ja.local_trust_decline(inputs)
});
/**
* | output |
* | --- |
* | "The devices that may instruct your Agents. Choose a device to change its Agent's settings." |
*
* @param {Local_Trust_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_description = /** @type {((inputs?: Local_Trust_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_description(inputs)
	return __ja.local_trust_description(inputs)
});
/**
* | output |
* | --- |
* | "This device is not in the device list. It may have been removed." |
*
* @param {Local_Trust_Device_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_device_not_found = /** @type {((inputs?: Local_Trust_Device_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Device_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_device_not_found(inputs)
	return __ja.local_trust_device_not_found(inputs)
});
/**
* | output |
* | --- |
* | "That did not work." |
*
* @param {Local_Trust_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_failed = /** @type {((inputs?: Local_Trust_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_failed(inputs)
	return __ja.local_trust_failed(inputs)
});
/**
* | output |
* | --- |
* | "How to add a device" |
*
* @param {Local_Trust_GuideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide = /** @type {((inputs?: Local_Trust_GuideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_GuideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide(inputs)
	return __ja.local_trust_guide(inputs)
});
/**
* | output |
* | --- |
* | "Add a device" |
*
* @param {Local_Trust_Guide_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_add = /** @type {((inputs?: Local_Trust_Guide_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_add(inputs)
	return __ja.local_trust_guide_add(inputs)
});
/**
* | output |
* | --- |
* | "Add this device" |
*
* @param {Local_Trust_Guide_Add_ThisInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_add_this = /** @type {((inputs?: Local_Trust_Guide_Add_ThisInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Add_ThisInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_add_this(inputs)
	return __ja.local_trust_guide_add_this(inputs)
});
/**
* | output |
* | --- |
* | "Each PC's Agent" |
*
* @param {Local_Trust_Guide_AgentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_agent = /** @type {((inputs?: Local_Trust_Guide_AgentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_AgentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_agent(inputs)
	return __ja.local_trust_guide_agent(inputs)
});
/**
* | output |
* | --- |
* | "Checks that the sending device is in the device list" |
*
* @param {Local_Trust_Guide_Agent_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_agent_note = /** @type {((inputs?: Local_Trust_Guide_Agent_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Agent_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_agent_note(inputs)
	return __ja.local_trust_guide_agent_note(inputs)
});
/**
* | output |
* | --- |
* | "You can also add a PC by connecting it to a Vault" |
*
* @param {Local_Trust_Guide_By_VaultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_by_vault = /** @type {((inputs?: Local_Trust_Guide_By_VaultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_By_VaultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_by_vault(inputs)
	return __ja.local_trust_guide_by_vault(inputs)
});
/**
* | output |
* | --- |
* | "When the PC connects to the Vault, it shows under the Vault's \"Devices waiting to be added\". Compare the device ID and press \"Add\"." |
*
* @param {Local_Trust_Guide_By_Vault_LinkedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_by_vault_linked = /** @type {((inputs?: Local_Trust_Guide_By_Vault_LinkedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_By_Vault_LinkedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_by_vault_linked(inputs)
	return __ja.local_trust_guide_by_vault_linked(inputs)
});
/**
* | output |
* | --- |
* | "When the PC connects to {name}, it shows under {name}'s \"Devices waiting to be added\". Compare the device ID and press \"Add\"." |
*
* @param {Local_Trust_Guide_By_Vault_SelfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_by_vault_self = /** @type {((inputs: Local_Trust_Guide_By_Vault_SelfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_By_Vault_SelfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_by_vault_self(inputs)
	return __ja.local_trust_guide_by_vault_self(inputs)
});
/**
* | output |
* | --- |
* | "Code" |
*
* @param {Local_Trust_Guide_Code_GoesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_code_goes = /** @type {((inputs?: Local_Trust_Guide_Code_GoesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Code_GoesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_code_goes(inputs)
	return __ja.local_trust_guide_code_goes(inputs)
});
/**
* | output |
* | --- |
* | "A device list with only this PC in it is made. This PC is its first device." |
*
* @param {Local_Trust_Guide_Create_MadeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_create_made = /** @type {((inputs?: Local_Trust_Guide_Create_MadeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Create_MadeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_create_made(inputs)
	return __ja.local_trust_guide_create_made(inputs)
});
/**
* | output |
* | --- |
* | "Add other devices from this PC under \"Add a device\". The steps to add one then show here too." |
*
* @param {Local_Trust_Guide_Create_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_create_next = /** @type {((inputs?: Local_Trust_Guide_Create_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Create_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_create_next(inputs)
	return __ja.local_trust_guide_create_next(inputs)
});
/**
* | output |
* | --- |
* | "Make only one device list. If another device has made one, do not make one here: it would be a separate list, and this PC's Agent would no longer take instru..." |
*
* @param {Local_Trust_Guide_Create_OnceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_create_once = /** @type {((inputs?: Local_Trust_Guide_Create_OnceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Create_OnceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_create_once(inputs)
	return __ja.local_trust_guide_create_once(inputs)
});
/**
* | output |
* | --- |
* | "This PC has no keychain, so you set a passphrase. You type it each time the device list changes." |
*
* @param {Local_Trust_Guide_Create_PassphraseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_create_passphrase = /** @type {((inputs?: Local_Trust_Guide_Create_PassphraseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Create_PassphraseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_create_passphrase(inputs)
	return __ja.local_trust_guide_create_passphrase(inputs)
});
/**
* | output |
* | --- |
* | "Under \"Make a list\" below, press \"Make\"." |
*
* @param {Local_Trust_Guide_Create_PressInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_create_press = /** @type {((inputs?: Local_Trust_Guide_Create_PressInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Create_PressInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_create_press(inputs)
	return __ja.local_trust_guide_create_press(inputs)
});
/**
* | output |
* | --- |
* | "MacBook" |
*
* @param {Local_Trust_Guide_Example_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_example_pc = /** @type {((inputs?: Local_Trust_Guide_Example_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Example_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_example_pc(inputs)
	return __ja.local_trust_guide_example_pc(inputs)
});
/**
* | output |
* | --- |
* | "iPhone" |
*
* @param {Local_Trust_Guide_Example_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_example_phone = /** @type {((inputs?: Local_Trust_Guide_Example_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Example_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_example_phone(inputs)
	return __ja.local_trust_guide_example_phone(inputs)
});
/**
* | output |
* | --- |
* | "The PC receiving it" |
*
* @param {Local_Trust_Guide_Flow_CheckInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_flow_check = /** @type {((inputs?: Local_Trust_Guide_Flow_CheckInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Flow_CheckInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_flow_check(inputs)
	return __ja.local_trust_guide_flow_check(inputs)
});
/**
* | output |
* | --- |
* | "Sent from" |
*
* @param {Local_Trust_Guide_Flow_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_flow_from = /** @type {((inputs?: Local_Trust_Guide_Flow_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Flow_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_flow_from(inputs)
	return __ja.local_trust_guide_flow_from(inputs)
});
/**
* | output |
* | --- |
* | "Result" |
*
* @param {Local_Trust_Guide_Flow_ResultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_flow_result = /** @type {((inputs?: Local_Trust_Guide_Flow_ResultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Flow_ResultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_flow_result(inputs)
	return __ja.local_trust_guide_flow_result(inputs)
});
/**
* | output |
* | --- |
* | "A device list made on another device was found. Add this PC from that device." |
*
* @param {Local_Trust_Guide_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_found = /** @type {((inputs?: Local_Trust_Guide_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_found(inputs)
	return __ja.local_trust_guide_found(inputs)
});
/**
* | output |
* | --- |
* | "\"Accept a list\" also shows below. Adding this PC as above accepts the list too, so you need not press it." |
*
* @param {Local_Trust_Guide_Found_TrustInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_found_trust = /** @type {((inputs?: Local_Trust_Guide_Found_TrustInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Found_TrustInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_found_trust(inputs)
	return __ja.local_trust_guide_found_trust(inputs)
});
/**
* | output |
* | --- |
* | "This PC's screen" |
*
* @param {Local_Trust_Guide_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_here = /** @type {((inputs?: Local_Trust_Guide_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_here(inputs)
	return __ja.local_trust_guide_here(inputs)
});
/**
* | output |
* | --- |
* | "This PC's name" |
*
* @param {Local_Trust_Guide_Here_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_here_name = /** @type {((inputs?: Local_Trust_Guide_Here_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Here_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_here_name(inputs)
	return __ja.local_trust_guide_here_name(inputs)
});
/**
* | output |
* | --- |
* | "Devices in the device list" |
*
* @param {Local_Trust_Guide_In_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_in_list = /** @type {((inputs?: Local_Trust_Guide_In_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_In_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_in_list(inputs)
	return __ja.local_trust_guide_in_list(inputs)
});
/**
* | output |
* | --- |
* | "First sign in to the same Cloud account as a device in the device list, or connect to the same Vault. Then a code can be shown." |
*
* @param {Local_Trust_Guide_Join_FirstInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_join_first = /** @type {((inputs?: Local_Trust_Guide_Join_FirstInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Join_FirstInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_join_first(inputs)
	return __ja.local_trust_guide_join_first(inputs)
});
/**
* | output |
* | --- |
* | "PC with no screen" |
*
* @param {Local_Trust_Guide_Kind_HeadlessInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_kind_headless = /** @type {((inputs?: Local_Trust_Guide_Kind_HeadlessInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Kind_HeadlessInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_kind_headless(inputs)
	return __ja.local_trust_guide_kind_headless(inputs)
});
/**
* | output |
* | --- |
* | "A PC such as a server that runs trameria from a command" |
*
* @param {Local_Trust_Guide_Kind_Headless_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_kind_headless_note = /** @type {((inputs?: Local_Trust_Guide_Kind_Headless_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Kind_Headless_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_kind_headless_note(inputs)
	return __ja.local_trust_guide_kind_headless_note(inputs)
});
/**
* | output |
* | --- |
* | "PC with a screen" |
*
* @param {Local_Trust_Guide_Kind_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_kind_pc = /** @type {((inputs?: Local_Trust_Guide_Kind_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Kind_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_kind_pc(inputs)
	return __ja.local_trust_guide_kind_pc(inputs)
});
/**
* | output |
* | --- |
* | "A Mac, Windows or Linux PC using the trameria app on its screen" |
*
* @param {Local_Trust_Guide_Kind_Pc_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_kind_pc_note = /** @type {((inputs?: Local_Trust_Guide_Kind_Pc_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Kind_Pc_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_kind_pc_note(inputs)
	return __ja.local_trust_guide_kind_pc_note(inputs)
});
/**
* | output |
* | --- |
* | "iPhone" |
*
* @param {Local_Trust_Guide_Kind_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_kind_phone = /** @type {((inputs?: Local_Trust_Guide_Kind_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Kind_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_kind_phone(inputs)
	return __ja.local_trust_guide_kind_phone(inputs)
});
/**
* | output |
* | --- |
* | "The trameria app on an iPhone" |
*
* @param {Local_Trust_Guide_Kind_Phone_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_kind_phone_note = /** @type {((inputs?: Local_Trust_Guide_Kind_Phone_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Kind_Phone_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_kind_phone_note(inputs)
	return __ja.local_trust_guide_kind_phone_note(inputs)
});
/**
* | output |
* | --- |
* | "Which device do you want to add?" |
*
* @param {Local_Trust_Guide_Kind_QuestionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_kind_question = /** @type {((inputs?: Local_Trust_Guide_Kind_QuestionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Kind_QuestionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_kind_question(inputs)
	return __ja.local_trust_guide_kind_question(inputs)
});
/**
* | output |
* | --- |
* | "The screen of a PC in the device list" |
*
* @param {Local_Trust_Guide_Member_ScreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_member_screen = /** @type {((inputs?: Local_Trust_Guide_Member_ScreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Member_ScreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_member_screen(inputs)
	return __ja.local_trust_guide_member_screen(inputs)
});
/**
* | output |
* | --- |
* | "See how to add a device" |
*
* @param {Local_Trust_Guide_More_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_more_add = /** @type {((inputs?: Local_Trust_Guide_More_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_More_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_more_add(inputs)
	return __ja.local_trust_guide_more_add(inputs)
});
/**
* | output |
* | --- |
* | "See how to add this device" |
*
* @param {Local_Trust_Guide_More_Add_ThisInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_more_add_this = /** @type {((inputs?: Local_Trust_Guide_More_Add_ThisInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_More_Add_ThisInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_more_add_this(inputs)
	return __ja.local_trust_guide_more_add_this(inputs)
});
/**
* | output |
* | --- |
* | "See how to start a device list" |
*
* @param {Local_Trust_Guide_More_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_more_start = /** @type {((inputs?: Local_Trust_Guide_More_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_More_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_more_start(inputs)
	return __ja.local_trust_guide_more_start(inputs)
});
/**
* | output |
* | --- |
* | "The screen of the PC to add" |
*
* @param {Local_Trust_Guide_New_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_new_pc = /** @type {((inputs?: Local_Trust_Guide_New_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_New_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_new_pc(inputs)
	return __ja.local_trust_guide_new_pc(inputs)
});
/**
* | output |
* | --- |
* | "The screen of the iPhone to add" |
*
* @param {Local_Trust_Guide_New_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_new_phone = /** @type {((inputs?: Local_Trust_Guide_New_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_New_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_new_phone(inputs)
	return __ja.local_trust_guide_new_phone(inputs)
});
/**
* | output |
* | --- |
* | "Devices not in the list, a Cloud or Vault taken over" |
*
* @param {Local_Trust_Guide_OthersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_others = /** @type {((inputs?: Local_Trust_Guide_OthersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_OthersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_others(inputs)
	return __ja.local_trust_guide_others(inputs)
});
/**
* | output |
* | --- |
* | "You can add a device signed in to the same Cloud account as {name}." |
*
* @param {Local_Trust_Guide_Reach_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_reach_cloud = /** @type {((inputs: Local_Trust_Guide_Reach_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Reach_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_reach_cloud(inputs)
	return __ja.local_trust_guide_reach_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Connect to a Vault or sign in to Cloud to add devices." |
*
* @param {Local_Trust_Guide_Reach_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_reach_none = /** @type {((inputs?: Local_Trust_Guide_Reach_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Reach_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_reach_none(inputs)
	return __ja.local_trust_guide_reach_none(inputs)
});
/**
* | output |
* | --- |
* | "This works when it is connected to the same Vault as a device in the device list, or signed in to the same Cloud account." |
*
* @param {Local_Trust_Guide_Reach_OutsideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_reach_outside = /** @type {((inputs?: Local_Trust_Guide_Reach_OutsideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Reach_OutsideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_reach_outside(inputs)
	return __ja.local_trust_guide_reach_outside(inputs)
});
/**
* | output |
* | --- |
* | "You can add a device connected to {name}. Sign in to Cloud to add devices on other networks too." |
*
* @param {Local_Trust_Guide_Reach_SelfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_reach_self = /** @type {((inputs: Local_Trust_Guide_Reach_SelfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Reach_SelfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_reach_self(inputs)
	return __ja.local_trust_guide_reach_self(inputs)
});
/**
* | output |
* | --- |
* | "You can add a device connected to {name}, or signed in to the same Cloud account as {name}." |
*
* @param {Local_Trust_Guide_Reach_Self_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_reach_self_cloud = /** @type {((inputs: Local_Trust_Guide_Reach_Self_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Reach_Self_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_reach_self_cloud(inputs)
	return __ja.local_trust_guide_reach_self_cloud(inputs)
});
/**
* | output |
* | --- |
* | "You can add a device connected to the same Vault as {name}. Sign in to Cloud to add devices on other networks too." |
*
* @param {Local_Trust_Guide_Reach_VaultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_reach_vault = /** @type {((inputs: Local_Trust_Guide_Reach_VaultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Reach_VaultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_reach_vault(inputs)
	return __ja.local_trust_guide_reach_vault(inputs)
});
/**
* | output |
* | --- |
* | "You can add a device connected to the same Vault as {name}, or signed in to the same Cloud account." |
*
* @param {Local_Trust_Guide_Reach_Vault_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_reach_vault_cloud = /** @type {((inputs: Local_Trust_Guide_Reach_Vault_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Reach_Vault_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_reach_vault_cloud(inputs)
	return __ja.local_trust_guide_reach_vault_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Not run" |
*
* @param {Local_Trust_Guide_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_refused = /** @type {((inputs?: Local_Trust_Guide_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_refused(inputs)
	return __ja.local_trust_guide_refused(inputs)
});
/**
* | output |
* | --- |
* | "Runs" |
*
* @param {Local_Trust_Guide_RunsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_runs = /** @type {((inputs?: Local_Trust_Guide_RunsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_RunsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_runs(inputs)
	return __ja.local_trust_guide_runs(inputs)
});
/**
* | output |
* | --- |
* | "{name}'s screen" |
*
* @param {Local_Trust_Guide_Screen_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_screen_of = /** @type {((inputs: Local_Trust_Guide_Screen_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Screen_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_screen_of(inputs)
	return __ja.local_trust_guide_screen_of(inputs)
});
/**
* | output |
* | --- |
* | "Start a device list" |
*
* @param {Local_Trust_Guide_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start = /** @type {((inputs?: Local_Trust_Guide_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start(inputs)
	return __ja.local_trust_guide_start(inputs)
});
/**
* | output |
* | --- |
* | "Make a new device list" |
*
* @param {Local_Trust_Guide_Start_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start_create = /** @type {((inputs?: Local_Trust_Guide_Start_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Start_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start_create(inputs)
	return __ja.local_trust_guide_start_create(inputs)
});
/**
* | output |
* | --- |
* | "When there is none yet. This PC becomes its first device" |
*
* @param {Local_Trust_Guide_Start_Create_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start_create_note = /** @type {((inputs?: Local_Trust_Guide_Start_Create_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Start_Create_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start_create_note(inputs)
	return __ja.local_trust_guide_start_create_note(inputs)
});
/**
* | output |
* | --- |
* | "Add it to an existing device list" |
*
* @param {Local_Trust_Guide_Start_JoinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start_join = /** @type {((inputs?: Local_Trust_Guide_Start_JoinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Start_JoinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start_join(inputs)
	return __ja.local_trust_guide_start_join(inputs)
});
/**
* | output |
* | --- |
* | "Put this PC in a device list made on another device" |
*
* @param {Local_Trust_Guide_Start_Join_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start_join_note = /** @type {((inputs?: Local_Trust_Guide_Start_Join_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Start_Join_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start_join_note(inputs)
	return __ja.local_trust_guide_start_join_note(inputs)
});
/**
* | output |
* | --- |
* | "No device list made on another device was found in the Vault or in Cloud. It may be kept in another Vault or Cloud account." |
*
* @param {Local_Trust_Guide_Start_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start_none = /** @type {((inputs?: Local_Trust_Guide_Start_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Start_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start_none(inputs)
	return __ja.local_trust_guide_start_none(inputs)
});
/**
* | output |
* | --- |
* | "What do you want to do with this PC?" |
*
* @param {Local_Trust_Guide_Start_QuestionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start_question = /** @type {((inputs?: Local_Trust_Guide_Start_QuestionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Start_QuestionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start_question(inputs)
	return __ja.local_trust_guide_start_question(inputs)
});
/**
* | output |
* | --- |
* | "This PC is not signed in to Cloud nor connected to a Vault, so it cannot look for a device list made on another device." |
*
* @param {Local_Trust_Guide_Start_UnreachedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_start_unreached = /** @type {((inputs?: Local_Trust_Guide_Start_UnreachedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Start_UnreachedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_start_unreached(inputs)
	return __ja.local_trust_guide_start_unreached(inputs)
});
/**
* | output |
* | --- |
* | "If they match, press \"Add\". The added device may then instruct Agents too." |
*
* @param {Local_Trust_Guide_Step_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_add = /** @type {((inputs?: Local_Trust_Guide_Step_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_add(inputs)
	return __ja.local_trust_guide_step_add(inputs)
});
/**
* | output |
* | --- |
* | "Check that the device ID {name} shows is the same as \"This device's ID\" on the other screen. If not, press \"Decline\"." |
*
* @param {Local_Trust_Guide_Step_CompareInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_compare = /** @type {((inputs: Local_Trust_Guide_Step_CompareInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_CompareInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_compare(inputs)
	return __ja.local_trust_guide_step_compare(inputs)
});
/**
* | output |
* | --- |
* | "Check that the device ID {name} shows is the same as the one in the terminal. If not, press \"Decline\"." |
*
* @param {Local_Trust_Guide_Step_Compare_HeadlessInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_compare_headless = /** @type {((inputs: Local_Trust_Guide_Step_Compare_HeadlessInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_Compare_HeadlessInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_compare_headless(inputs)
	return __ja.local_trust_guide_step_compare_headless(inputs)
});
/**
* | output |
* | --- |
* | "Check that the device ID that PC shows is the same as \"This device's ID\" on this PC. If not, press \"Decline\"." |
*
* @param {Local_Trust_Guide_Step_Compare_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_compare_member = /** @type {((inputs?: Local_Trust_Guide_Step_Compare_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_Compare_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_compare_member(inputs)
	return __ja.local_trust_guide_step_compare_member(inputs)
});
/**
* | output |
* | --- |
* | "On {name}, in Settings › Device list, type the code in \"Add a device\" and press \"Check\"." |
*
* @param {Local_Trust_Guide_Step_EnterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_enter = /** @type {((inputs: Local_Trust_Guide_Step_EnterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_EnterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_enter(inputs)
	return __ja.local_trust_guide_step_enter(inputs)
});
/**
* | output |
* | --- |
* | "On a PC in the device list, in Settings › Device list, type the code in \"Add a device\" and press \"Check\"." |
*
* @param {Local_Trust_Guide_Step_Enter_MemberInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_enter_member = /** @type {((inputs?: Local_Trust_Guide_Step_Enter_MemberInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_Enter_MemberInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_enter_member(inputs)
	return __ja.local_trust_guide_step_enter_member(inputs)
});
/**
* | output |
* | --- |
* | "Run the command in the PC's terminal. A code and that PC's device ID show." |
*
* @param {Local_Trust_Guide_Step_Show_HeadlessInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_show_headless = /** @type {((inputs?: Local_Trust_Guide_Step_Show_HeadlessInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_Show_HeadlessInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_show_headless(inputs)
	return __ja.local_trust_guide_step_show_headless(inputs)
});
/**
* | output |
* | --- |
* | "On this PC, under \"Get added\" below, press \"Show a code\"." |
*
* @param {Local_Trust_Guide_Step_Show_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_show_here = /** @type {((inputs?: Local_Trust_Guide_Step_Show_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_Show_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_show_here(inputs)
	return __ja.local_trust_guide_step_show_here(inputs)
});
/**
* | output |
* | --- |
* | "On the PC to add, in Settings › Device list, under \"Get added\", press \"Show a code\". A code and that PC's device ID show." |
*
* @param {Local_Trust_Guide_Step_Show_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_show_pc = /** @type {((inputs?: Local_Trust_Guide_Step_Show_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_Show_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_show_pc(inputs)
	return __ja.local_trust_guide_step_show_pc(inputs)
});
/**
* | output |
* | --- |
* | "On the iPhone, in Settings › Device list, under \"Get added\", press \"Show a code\". A code and the iPhone's device ID show." |
*
* @param {Local_Trust_Guide_Step_Show_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_step_show_phone = /** @type {((inputs?: Local_Trust_Guide_Step_Show_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Step_Show_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_step_show_phone(inputs)
	return __ja.local_trust_guide_step_show_phone(inputs)
});
/**
* | output |
* | --- |
* | "Approval code: {code}" |
*
* @param {Local_Trust_Guide_Term_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_term_code = /** @type {((inputs: Local_Trust_Guide_Term_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_Term_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_term_code(inputs)
	return __ja.local_trust_guide_term_code(inputs)
});
/**
* | output |
* | --- |
* | "What the device list is" |
*
* @param {Local_Trust_Guide_WhatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_what = /** @type {((inputs?: Local_Trust_Guide_WhatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_WhatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_what(inputs)
	return __ja.local_trust_guide_what(inputs)
});
/**
* | output |
* | --- |
* | "The devices that may instruct your Agents. Each PC's Agent runs only instructions sent from a device in the device list. Even if Cloud or a Vault is taken ov..." |
*
* @param {Local_Trust_Guide_What_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_what_body = /** @type {((inputs?: Local_Trust_Guide_What_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_What_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_what_body(inputs)
	return __ja.local_trust_guide_what_body(inputs)
});
/**
* | output |
* | --- |
* | "Settings › Device list" |
*
* @param {Local_Trust_Guide_WhereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_guide_where = /** @type {((inputs?: Local_Trust_Guide_WhereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Guide_WhereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_guide_where(inputs)
	return __ja.local_trust_guide_where(inputs)
});
/**
* | output |
* | --- |
* | "That is not a code." |
*
* @param {Local_Trust_Invalid_CodeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invalid_code = /** @type {((inputs?: Local_Trust_Invalid_CodeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invalid_CodeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invalid_code(inputs)
	return __ja.local_trust_invalid_code(inputs)
});
/**
* | output |
* | --- |
* | "Get added" |
*
* @param {Local_Trust_InviteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite = /** @type {((inputs?: Local_Trust_InviteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_InviteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite(inputs)
	return __ja.local_trust_invite(inputs)
});
/**
* | output |
* | --- |
* | "This device joined the list." |
*
* @param {Local_Trust_Invite_ApprovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite_approved = /** @type {((inputs?: Local_Trust_Invite_ApprovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invite_ApprovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite_approved(inputs)
	return __ja.local_trust_invite_approved(inputs)
});
/**
* | output |
* | --- |
* | "Show a code" |
*
* @param {Local_Trust_Invite_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite_button = /** @type {((inputs?: Local_Trust_Invite_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invite_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite_button(inputs)
	return __ja.local_trust_invite_button(inputs)
});
/**
* | output |
* | --- |
* | "It was declined." |
*
* @param {Local_Trust_Invite_DeclinedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite_declined = /** @type {((inputs?: Local_Trust_Invite_DeclinedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invite_DeclinedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite_declined(inputs)
	return __ja.local_trust_invite_declined(inputs)
});
/**
* | output |
* | --- |
* | "Have a device in the list add this one." |
*
* @param {Local_Trust_Invite_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite_note = /** @type {((inputs?: Local_Trust_Invite_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invite_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite_note(inputs)
	return __ja.local_trust_invite_note(inputs)
});
/**
* | output |
* | --- |
* | "Checked the code with {name}. Waiting for {name} to add this device." |
*
* @param {Local_Trust_Invite_ProvedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite_proved = /** @type {((inputs: Local_Trust_Invite_ProvedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invite_ProvedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite_proved(inputs)
	return __ja.local_trust_invite_proved(inputs)
});
/**
* | output |
* | --- |
* | "The code did not check, so it no longer works." |
*
* @param {Local_Trust_Invite_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite_refused = /** @type {((inputs?: Local_Trust_Invite_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invite_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite_refused(inputs)
	return __ja.local_trust_invite_refused(inputs)
});
/**
* | output |
* | --- |
* | "Type this code under \"Add a device\" on a device in the list. It works once." |
*
* @param {Local_Trust_Invite_WaitingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_invite_waiting = /** @type {((inputs?: Local_Trust_Invite_WaitingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Invite_WaitingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_invite_waiting(inputs)
	return __ja.local_trust_invite_waiting(inputs)
});
/**
* | output |
* | --- |
* | "Cloud" |
*
* @param {Local_Trust_Kind_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_kind_cloud = /** @type {((inputs?: Local_Trust_Kind_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Kind_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_kind_cloud(inputs)
	return __ja.local_trust_kind_cloud(inputs)
});
/**
* | output |
* | --- |
* | "PC" |
*
* @param {Local_Trust_Kind_PcInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_kind_pc = /** @type {((inputs?: Local_Trust_Kind_PcInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Kind_PcInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_kind_pc(inputs)
	return __ja.local_trust_kind_pc(inputs)
});
/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Local_Trust_Kind_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_kind_phone = /** @type {((inputs?: Local_Trust_Kind_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Kind_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_kind_phone(inputs)
	return __ja.local_trust_kind_phone(inputs)
});
/**
* | output |
* | --- |
* | "The last device that can change the list cannot be removed." |
*
* @param {Local_Trust_Last_ApproverInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_last_approver = /** @type {((inputs?: Local_Trust_Last_ApproverInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Last_ApproverInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_last_approver(inputs)
	return __ja.local_trust_last_approver(inputs)
});
/**
* | output |
* | --- |
* | "You cannot go back to a device list you switched from." |
*
* @param {Local_Trust_LeftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_left = /** @type {((inputs?: Local_Trust_LeftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_LeftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_left(inputs)
	return __ja.local_trust_left(inputs)
});
/**
* | output |
* | --- |
* | "Created {date}" |
*
* @param {Local_Trust_List_MadeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_list_made = /** @type {((inputs: Local_Trust_List_MadeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_List_MadeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_list_made(inputs)
	return __ja.local_trust_list_made(inputs)
});
/**
* | output |
* | --- |
* | "Devices" |
*
* @param {Local_Trust_MembersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_members = /** @type {((inputs?: Local_Trust_MembersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_MembersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_members(inputs)
	return __ja.local_trust_members(inputs)
});
/**
* | output |
* | --- |
* | "This device can change the list." |
*
* @param {Local_Trust_Members_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_members_note = /** @type {((inputs?: Local_Trust_Members_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Members_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_members_note(inputs)
	return __ja.local_trust_members_note(inputs)
});
/**
* | output |
* | --- |
* | "This device is not in the list." |
*
* @param {Local_Trust_Members_Note_OutsideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_members_note_outside = /** @type {((inputs?: Local_Trust_Members_Note_OutsideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Members_Note_OutsideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_members_note_outside(inputs)
	return __ja.local_trust_members_note_outside(inputs)
});
/**
* | output |
* | --- |
* | "This device cannot change the list." |
*
* @param {Local_Trust_Members_Note_ReceiverInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_members_note_receiver = /** @type {((inputs?: Local_Trust_Members_Note_ReceiverInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Members_Note_ReceiverInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_members_note_receiver(inputs)
	return __ja.local_trust_members_note_receiver(inputs)
});
/**
* | output |
* | --- |
* | "No keys yet" |
*
* @param {Local_Trust_No_KeysInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_no_keys = /** @type {((inputs?: Local_Trust_No_KeysInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_No_KeysInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_no_keys(inputs)
	return __ja.local_trust_no_keys(inputs)
});
/**
* | output |
* | --- |
* | "Connect to a Vault or sign in to Cloud to show a code." |
*
* @param {Local_Trust_No_PlaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_no_place = /** @type {((inputs?: Local_Trust_No_PlaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_No_PlaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_no_place(inputs)
	return __ja.local_trust_no_place(inputs)
});
/**
* | output |
* | --- |
* | "Connect to a Vault or sign in to Cloud." |
*
* @param {Local_Trust_No_Place_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_no_place_failed = /** @type {((inputs?: Local_Trust_No_Place_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_No_Place_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_no_place_failed(inputs)
	return __ja.local_trust_no_place_failed(inputs)
});
/**
* | output |
* | --- |
* | "Devices not in the device list" |
*
* @param {Local_Trust_OutsideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_outside = /** @type {((inputs?: Local_Trust_OutsideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_OutsideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_outside(inputs)
	return __ja.local_trust_outside(inputs)
});
/**
* | output |
* | --- |
* | "Takes no instructions: it does not trust the device list." |
*
* @param {Local_Trust_Outside_Not_TakingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_outside_not_taking = /** @type {((inputs?: Local_Trust_Outside_Not_TakingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Outside_Not_TakingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_outside_not_taking(inputs)
	return __ja.local_trust_outside_not_taking(inputs)
});
/**
* | output |
* | --- |
* | "They take instructions from devices in the device list, but cannot give any. To add one, show a code on it and type the code in \"Add a device\"." |
*
* @param {Local_Trust_Outside_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_outside_note = /** @type {((inputs?: Local_Trust_Outside_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Outside_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_outside_note(inputs)
	return __ja.local_trust_outside_note(inputs)
});
/**
* | output |
* | --- |
* | "This device is not in the device list. Its Agent takes instructions from devices in the device list." |
*
* @param {Local_Trust_Outside_Page_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_outside_page_note = /** @type {((inputs?: Local_Trust_Outside_Page_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Outside_Page_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_outside_page_note(inputs)
	return __ja.local_trust_outside_page_note(inputs)
});
/**
* | output |
* | --- |
* | "Passphrase" |
*
* @param {Local_Trust_PassphraseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase = /** @type {((inputs?: Local_Trust_PassphraseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_PassphraseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase(inputs)
	return __ja.local_trust_passphrase(inputs)
});
/**
* | output |
* | --- |
* | "Type it again" |
*
* @param {Local_Trust_Passphrase_AgainInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_again = /** @type {((inputs?: Local_Trust_Passphrase_AgainInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_AgainInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_again(inputs)
	return __ja.local_trust_passphrase_again(inputs)
});
/**
* | output |
* | --- |
* | "To change the device list on this PC, enter its passphrase." |
*
* @param {Local_Trust_Passphrase_Ask_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_ask_body = /** @type {((inputs?: Local_Trust_Passphrase_Ask_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_Ask_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_ask_body(inputs)
	return __ja.local_trust_passphrase_ask_body(inputs)
});
/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Local_Trust_Passphrase_Ask_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_ask_button = /** @type {((inputs?: Local_Trust_Passphrase_Ask_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_Ask_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_ask_button(inputs)
	return __ja.local_trust_passphrase_ask_button(inputs)
});
/**
* | output |
* | --- |
* | "Enter the passphrase" |
*
* @param {Local_Trust_Passphrase_Ask_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_ask_title = /** @type {((inputs?: Local_Trust_Passphrase_Ask_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_Ask_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_ask_title(inputs)
	return __ja.local_trust_passphrase_ask_title(inputs)
});
/**
* | output |
* | --- |
* | "The two entries differ." |
*
* @param {Local_Trust_Passphrase_MismatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_mismatch = /** @type {((inputs?: Local_Trust_Passphrase_MismatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_MismatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_mismatch(inputs)
	return __ja.local_trust_passphrase_mismatch(inputs)
});
/**
* | output |
* | --- |
* | "This PC has no keychain, so you type a passphrase when adding or removing devices. Choose one of 8 characters or more. If you forget it, this PC can no longe..." |
*
* @param {Local_Trust_Passphrase_New_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_new_note = /** @type {((inputs?: Local_Trust_Passphrase_New_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_New_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_new_note(inputs)
	return __ja.local_trust_passphrase_new_note(inputs)
});
/**
* | output |
* | --- |
* | "Set a passphrase" |
*
* @param {Local_Trust_Passphrase_Set_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_set_title = /** @type {((inputs?: Local_Trust_Passphrase_Set_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_Set_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_set_title(inputs)
	return __ja.local_trust_passphrase_set_title(inputs)
});
/**
* | output |
* | --- |
* | "Use 8 characters or more." |
*
* @param {Local_Trust_Passphrase_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_passphrase_short = /** @type {((inputs?: Local_Trust_Passphrase_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Passphrase_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_passphrase_short(inputs)
	return __ja.local_trust_passphrase_short(inputs)
});
/**
* | output |
* | --- |
* | "A storage hands out a list that disagrees with this device's. Someone may be trying to change it." |
*
* @param {Local_Trust_ProblemInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_problem = /** @type {((inputs?: Local_Trust_ProblemInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_ProblemInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_problem(inputs)
	return __ja.local_trust_problem(inputs)
});
/**
* | output |
* | --- |
* | "takes instructions only" |
*
* @param {Local_Trust_Receiver_MarkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_receiver_mark = /** @type {((inputs?: Local_Trust_Receiver_MarkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Receiver_MarkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_receiver_mark(inputs)
	return __ja.local_trust_receiver_mark(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Local_Trust_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_remove = /** @type {((inputs?: Local_Trust_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_remove(inputs)
	return __ja.local_trust_remove(inputs)
});
/**
* | output |
* | --- |
* | "The removed device can no longer instruct your Agents. To bring it back, add it again." |
*
* @param {Local_Trust_Remove_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_remove_body = /** @type {((inputs?: Local_Trust_Remove_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Remove_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_remove_body(inputs)
	return __ja.local_trust_remove_body(inputs)
});
/**
* | output |
* | --- |
* | "This device will no longer instruct your Agents or change the list. To come back, another device adds it again." |
*
* @param {Local_Trust_Remove_Self_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_remove_self_body = /** @type {((inputs?: Local_Trust_Remove_Self_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Remove_Self_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_remove_self_body(inputs)
	return __ja.local_trust_remove_self_body(inputs)
});
/**
* | output |
* | --- |
* | "Remove {name} from the list?" |
*
* @param {Local_Trust_Remove_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_remove_title = /** @type {((inputs: Local_Trust_Remove_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Remove_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_remove_title(inputs)
	return __ja.local_trust_remove_title(inputs)
});
/**
* | output |
* | --- |
* | "Switch device lists" |
*
* @param {Local_Trust_SwitchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_switch = /** @type {((inputs?: Local_Trust_SwitchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_SwitchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_switch(inputs)
	return __ja.local_trust_switch(inputs)
});
/**
* | output |
* | --- |
* | "Check that the device ID on {name} is {fingerprint}. Once you switch, the devices in the current list can no longer instruct this PC's Agent. You cannot swit..." |
*
* @param {Local_Trust_Switch_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_switch_body = /** @type {((inputs: Local_Trust_Switch_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Switch_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_switch_body(inputs)
	return __ja.local_trust_switch_body(inputs)
});
/**
* | output |
* | --- |
* | "Switch" |
*
* @param {Local_Trust_Switch_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_switch_button = /** @type {((inputs?: Local_Trust_Switch_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Switch_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_switch_button(inputs)
	return __ja.local_trust_switch_button(inputs)
});
/**
* | output |
* | --- |
* | "A new device list created on another device. Switch only if you lost all your devices and created the list again, and only if the device ID matches the one o..." |
*
* @param {Local_Trust_Switch_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_switch_note = /** @type {((inputs?: Local_Trust_Switch_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Switch_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_switch_note(inputs)
	return __ja.local_trust_switch_note(inputs)
});
/**
* | output |
* | --- |
* | "Switch to this device list?" |
*
* @param {Local_Trust_Switch_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_switch_title = /** @type {((inputs?: Local_Trust_Switch_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Switch_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_switch_title(inputs)
	return __ja.local_trust_switch_title(inputs)
});
/**
* | output |
* | --- |
* | "This device's ID" |
*
* @param {Local_Trust_This_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_this_device = /** @type {((inputs?: Local_Trust_This_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_This_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_this_device(inputs)
	return __ja.local_trust_this_device(inputs)
});
/**
* | output |
* | --- |
* | "this device" |
*
* @param {Local_Trust_This_Device_MarkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_this_device_mark = /** @type {((inputs?: Local_Trust_This_Device_MarkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_This_Device_MarkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_this_device_mark(inputs)
	return __ja.local_trust_this_device_mark(inputs)
});
/**
* | output |
* | --- |
* | "Compare it when another device adds this one, or accepts a list." |
*
* @param {Local_Trust_This_Device_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_this_device_note = /** @type {((inputs?: Local_Trust_This_Device_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_This_Device_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_this_device_note(inputs)
	return __ja.local_trust_this_device_note(inputs)
});
/**
* | output |
* | --- |
* | "Could not reach the storage." |
*
* @param {Local_Trust_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_unreachable = /** @type {((inputs?: Local_Trust_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_unreachable(inputs)
	return __ja.local_trust_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "Wrong passphrase." |
*
* @param {Local_Trust_Wrong_PassphraseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_wrong_passphrase = /** @type {((inputs?: Local_Trust_Wrong_PassphraseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Wrong_PassphraseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_wrong_passphrase(inputs)
	return __ja.local_trust_wrong_passphrase(inputs)
});
/**
* | output |
* | --- |
* | "The code did not check." |
*
* @param {Local_Trust_Wrong_ProofInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_trust_wrong_proof = /** @type {((inputs?: Local_Trust_Wrong_ProofInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Trust_Wrong_ProofInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_trust_wrong_proof(inputs)
	return __ja.local_trust_wrong_proof(inputs)
});
/**
* | output |
* | --- |
* | "The Vault's settings can't be changed from outside the network. Change them when you can connect to the Vault." |
*
* @param {Local_Via_Cloud_RefusedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_via_cloud_refused = /** @type {((inputs?: Local_Via_Cloud_RefusedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Via_Cloud_RefusedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_via_cloud_refused(inputs)
	return __ja.local_via_cloud_refused(inputs)
});
/**
* | output |
* | --- |
* | "Cloud" |
*
* @param {Local_Where_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const local_where_cloud = /** @type {((inputs?: Local_Where_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Local_Where_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.local_where_cloud(inputs)
	return __ja.local_where_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Media_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_close = /** @type {((inputs?: Media_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_close(inputs)
	return __ja.media_close(inputs)
});
/**
* | output |
* | --- |
* | "Download" |
*
* @param {Media_DownloadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_download = /** @type {((inputs?: Media_DownloadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_DownloadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_download(inputs)
	return __ja.media_download(inputs)
});
/**
* | output |
* | --- |
* | "Image actions" |
*
* @param {Media_Image_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_image_actions = /** @type {((inputs?: Media_Image_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Image_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_image_actions(inputs)
	return __ja.media_image_actions(inputs)
});
/**
* | output |
* | --- |
* | "Next image" |
*
* @param {Media_Image_NextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_image_next = /** @type {((inputs?: Media_Image_NextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Image_NextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_image_next(inputs)
	return __ja.media_image_next(inputs)
});
/**
* | output |
* | --- |
* | "Image {n} of {count}" |
*
* @param {Media_Image_PositionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_image_position = /** @type {((inputs: Media_Image_PositionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Image_PositionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_image_position(inputs)
	return __ja.media_image_position(inputs)
});
/**
* | output |
* | --- |
* | "Previous image" |
*
* @param {Media_Image_PreviousInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_image_previous = /** @type {((inputs?: Media_Image_PreviousInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Image_PreviousInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_image_previous(inputs)
	return __ja.media_image_previous(inputs)
});
/**
* | output |
* | --- |
* | "More actions" |
*
* @param {Media_More_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_more_actions = /** @type {((inputs?: Media_More_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_More_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_more_actions(inputs)
	return __ja.media_more_actions(inputs)
});
/**
* | output |
* | --- |
* | "Open in new tab" |
*
* @param {Media_Open_In_TabInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_open_in_tab = /** @type {((inputs?: Media_Open_In_TabInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Open_In_TabInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_open_in_tab(inputs)
	return __ja.media_open_in_tab(inputs)
});
/**
* | output |
* | --- |
* | "Exit full screen" |
*
* @param {Media_Video_Exit_FullscreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_exit_fullscreen = /** @type {((inputs?: Media_Video_Exit_FullscreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_Exit_FullscreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_exit_fullscreen(inputs)
	return __ja.media_video_exit_fullscreen(inputs)
});
/**
* | output |
* | --- |
* | "Full screen" |
*
* @param {Media_Video_FullscreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_fullscreen = /** @type {((inputs?: Media_Video_FullscreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_FullscreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_fullscreen(inputs)
	return __ja.media_video_fullscreen(inputs)
});
/**
* | output |
* | --- |
* | "Video: {name}" |
*
* @param {Media_Video_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_label = /** @type {((inputs: Media_Video_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_label(inputs)
	return __ja.media_video_label(inputs)
});
/**
* | output |
* | --- |
* | "Mute" |
*
* @param {Media_Video_MuteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_mute = /** @type {((inputs?: Media_Video_MuteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_MuteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_mute(inputs)
	return __ja.media_video_mute(inputs)
});
/**
* | output |
* | --- |
* | "Full screen in the native player" |
*
* @param {Media_Video_Native_FullscreenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_native_fullscreen = /** @type {((inputs?: Media_Video_Native_FullscreenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_Native_FullscreenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_native_fullscreen(inputs)
	return __ja.media_video_native_fullscreen(inputs)
});
/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Media_Video_PauseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_pause = /** @type {((inputs?: Media_Video_PauseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_PauseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_pause(inputs)
	return __ja.media_video_pause(inputs)
});
/**
* | output |
* | --- |
* | "Play" |
*
* @param {Media_Video_PlayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_play = /** @type {((inputs?: Media_Video_PlayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_PlayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_play(inputs)
	return __ja.media_video_play(inputs)
});
/**
* | output |
* | --- |
* | "Play {name}" |
*
* @param {Media_Video_Play_NamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_play_named = /** @type {((inputs: Media_Video_Play_NamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_Play_NamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_play_named(inputs)
	return __ja.media_video_play_named(inputs)
});
/**
* | output |
* | --- |
* | "{n} sec" |
*
* @param {Media_Video_SecondsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_seconds = /** @type {((inputs: Media_Video_SecondsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_SecondsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_seconds(inputs)
	return __ja.media_video_seconds(inputs)
});
/**
* | output |
* | --- |
* | "Seek" |
*
* @param {Media_Video_SeekInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_seek = /** @type {((inputs?: Media_Video_SeekInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_SeekInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_seek(inputs)
	return __ja.media_video_seek(inputs)
});
/**
* | output |
* | --- |
* | "Playback speed" |
*
* @param {Media_Video_SpeedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_speed = /** @type {((inputs?: Media_Video_SpeedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_SpeedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_speed(inputs)
	return __ja.media_video_speed(inputs)
});
/**
* | output |
* | --- |
* | "Normal" |
*
* @param {Media_Video_Speed_NormalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_speed_normal = /** @type {((inputs?: Media_Video_Speed_NormalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_Speed_NormalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_speed_normal(inputs)
	return __ja.media_video_speed_normal(inputs)
});
/**
* | output |
* | --- |
* | "Unmute" |
*
* @param {Media_Video_UnmuteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_unmute = /** @type {((inputs?: Media_Video_UnmuteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_UnmuteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_unmute(inputs)
	return __ja.media_video_unmute(inputs)
});
/**
* | output |
* | --- |
* | "This video can't be played" |
*
* @param {Media_Video_UnplayableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_unplayable = /** @type {((inputs?: Media_Video_UnplayableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_UnplayableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_unplayable(inputs)
	return __ja.media_video_unplayable(inputs)
});
/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Media_Video_VolumeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_video_volume = /** @type {((inputs?: Media_Video_VolumeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Video_VolumeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_video_volume(inputs)
	return __ja.media_video_volume(inputs)
});
/**
* | output |
* | --- |
* | "Zoom in" |
*
* @param {Media_Zoom_InInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_zoom_in = /** @type {((inputs?: Media_Zoom_InInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Zoom_InInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_zoom_in(inputs)
	return __ja.media_zoom_in(inputs)
});
/**
* | output |
* | --- |
* | "Zoom out" |
*
* @param {Media_Zoom_OutInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const media_zoom_out = /** @type {((inputs?: Media_Zoom_OutInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Zoom_OutInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.media_zoom_out(inputs)
	return __ja.media_zoom_out(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Memos_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_close = /** @type {((inputs?: Memos_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_close(inputs)
	return __ja.memos_close(inputs)
});
/**
* | output |
* | --- |
* | "Handover" |
*
* @param {Memos_HandoverInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_handover = /** @type {((inputs?: Memos_HandoverInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_HandoverInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_handover(inputs)
	return __ja.memos_handover(inputs)
});
/**
* | output |
* | --- |
* | "A handover to the next AI (where things stand)" |
*
* @param {Memos_Handover_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_handover_placeholder = /** @type {((inputs?: Memos_Handover_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_Handover_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_handover_placeholder(inputs)
	return __ja.memos_handover_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Could not load" |
*
* @param {Memos_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_load_failed = /** @type {((inputs?: Memos_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_load_failed(inputs)
	return __ja.memos_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Log" |
*
* @param {Memos_LogInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_log = /** @type {((inputs?: Memos_LogInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_LogInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_log(inputs)
	return __ja.memos_log(inputs)
});
/**
* | output |
* | --- |
* | "Delete this entry" |
*
* @param {Memos_Log_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_log_delete = /** @type {((inputs?: Memos_Log_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_Log_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_log_delete(inputs)
	return __ja.memos_log_delete(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete the entry" |
*
* @param {Memos_Log_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_log_delete_failed = /** @type {((inputs?: Memos_Log_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_Log_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_log_delete_failed(inputs)
	return __ja.memos_log_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "No log yet" |
*
* @param {Memos_Log_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_log_empty = /** @type {((inputs?: Memos_Log_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_Log_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_log_empty(inputs)
	return __ja.memos_log_empty(inputs)
});
/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Memos_Log_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_log_more = /** @type {((inputs?: Memos_Log_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_Log_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_log_more(inputs)
	return __ja.memos_log_more(inputs)
});
/**
* | output |
* | --- |
* | "Could not save (what you wrote is kept)" |
*
* @param {Memos_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_save_failed = /** @type {((inputs?: Memos_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_save_failed(inputs)
	return __ja.memos_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "AI memo" |
*
* @param {Memos_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const memos_title = /** @type {((inputs?: Memos_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memos_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.memos_title(inputs)
	return __ja.memos_title(inputs)
});
/**
* | output |
* | --- |
* | "Agent · {name}" |
*
* @param {Notices_Agent_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_agent_title = /** @type {((inputs: Notices_Agent_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Agent_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_agent_title(inputs)
	return __ja.notices_agent_title(inputs)
});
/**
* | output |
* | --- |
* | "Notifications are not allowed in the {device}'s Settings" |
*
* @param {Notices_App_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_denied = /** @type {((inputs: Notices_App_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_denied(inputs)
	return __ja.notices_app_denied(inputs)
});
/**
* | output |
* | --- |
* | "Destinations" |
*
* @param {Notices_App_DestinationsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_destinations = /** @type {((inputs?: Notices_App_DestinationsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_DestinationsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_destinations(inputs)
	return __ja.notices_app_destinations(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't change receiving" |
*
* @param {Notices_App_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_failed = /** @type {((inputs?: Notices_App_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_failed(inputs)
	return __ja.notices_app_failed(inputs)
});
/**
* | output |
* | --- |
* | "{device} (app)" |
*
* @param {Notices_App_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_label = /** @type {((inputs: Notices_App_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_label(inputs)
	return __ja.notices_app_label(inputs)
});
/**
* | output |
* | --- |
* | "Open Settings" |
*
* @param {Notices_App_Open_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_open_settings = /** @type {((inputs?: Notices_App_Open_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_Open_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_open_settings(inputs)
	return __ja.notices_app_open_settings(inputs)
});
/**
* | output |
* | --- |
* | "Receive on this device" |
*
* @param {Notices_App_ReceiveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_receive = /** @type {((inputs?: Notices_App_ReceiveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_ReceiveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_receive(inputs)
	return __ja.notices_app_receive(inputs)
});
/**
* | output |
* | --- |
* | "This device" |
*
* @param {Notices_App_This_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_this_device = /** @type {((inputs?: Notices_App_This_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_This_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_this_device(inputs)
	return __ja.notices_app_this_device(inputs)
});
/**
* | output |
* | --- |
* | "This Vault is not linked with Cloud, so nothing arrives while the app is closed" |
*
* @param {Notices_App_UntiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_app_untied = /** @type {((inputs?: Notices_App_UntiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_App_UntiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_app_untied(inputs)
	return __ja.notices_app_untied(inputs)
});
/**
* | output |
* | --- |
* | "File" |
*
* @param {Notices_File_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_file_only = /** @type {((inputs?: Notices_File_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_File_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_file_only(inputs)
	return __ja.notices_file_only(inputs)
});
/**
* | output |
* | --- |
* | "Notifications are not allowed. Allow them in the browser or OS settings, then turn them on here" |
*
* @param {Notices_Settings_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_denied = /** @type {((inputs?: Notices_Settings_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_denied(inputs)
	return __ja.notices_settings_denied(inputs)
});
/**
* | output |
* | --- |
* | "Tells you about Agent replies and items waiting for you, with OS notifications and the app's badge" |
*
* @param {Notices_Settings_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_description = /** @type {((inputs?: Notices_Settings_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_description(inputs)
	return __ja.notices_settings_description(inputs)
});
/**
* | output |
* | --- |
* | "Show OS notifications" |
*
* @param {Notices_Settings_OsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_os = /** @type {((inputs?: Notices_Settings_OsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_OsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_os(inputs)
	return __ja.notices_settings_os(inputs)
});
/**
* | output |
* | --- |
* | "Notifications are not allowed on this Mac" |
*
* @param {Notices_Settings_Os_BlockedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_os_blocked = /** @type {((inputs?: Notices_Settings_Os_BlockedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_Os_BlockedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_os_blocked(inputs)
	return __ja.notices_settings_os_blocked(inputs)
});
/**
* | output |
* | --- |
* | "Agent replies and items waiting for you appear as OS notifications when the window is not in front" |
*
* @param {Notices_Settings_Os_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_os_description = /** @type {((inputs?: Notices_Settings_Os_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_Os_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_os_description(inputs)
	return __ja.notices_settings_os_description(inputs)
});
/**
* | output |
* | --- |
* | "Open System Settings" |
*
* @param {Notices_Settings_Os_Open_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_os_open_settings = /** @type {((inputs?: Notices_Settings_Os_Open_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_Os_Open_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_os_open_settings(inputs)
	return __ja.notices_settings_os_open_settings(inputs)
});
/**
* | output |
* | --- |
* | "An unsigned build cannot show Mac notifications" |
*
* @param {Notices_Settings_Os_UnsignedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_os_unsigned = /** @type {((inputs?: Notices_Settings_Os_UnsignedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_Os_UnsignedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_os_unsigned(inputs)
	return __ja.notices_settings_os_unsigned(inputs)
});
/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Notices_Settings_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_title = /** @type {((inputs?: Notices_Settings_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_title(inputs)
	return __ja.notices_settings_title(inputs)
});
/**
* | output |
* | --- |
* | "This browser does not support notifications" |
*
* @param {Notices_Settings_UnsupportedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_settings_unsupported = /** @type {((inputs?: Notices_Settings_UnsupportedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Settings_UnsupportedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_settings_unsupported(inputs)
	return __ja.notices_settings_unsupported(inputs)
});
/**
* | output |
* | --- |
* | "This is a test notification" |
*
* @param {Notices_Test_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_test_body = /** @type {((inputs?: Notices_Test_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Test_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_test_body(inputs)
	return __ja.notices_test_body(inputs)
});
/**
* | output |
* | --- |
* | "trameria" |
*
* @param {Notices_Test_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_test_title = /** @type {((inputs?: Notices_Test_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Test_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_test_title(inputs)
	return __ja.notices_test_title(inputs)
});
/**
* | output |
* | --- |
* | "{name} was added to your device list. If you did not add it, remove it from the list." |
*
* @param {Notices_Trust_Added_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_trust_added_body = /** @type {((inputs: Notices_Trust_Added_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Trust_Added_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_trust_added_body(inputs)
	return __ja.notices_trust_added_body(inputs)
});
/**
* | output |
* | --- |
* | "A device was added to your device list" |
*
* @param {Notices_Trust_Added_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_trust_added_title = /** @type {((inputs?: Notices_Trust_Added_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Trust_Added_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_trust_added_title(inputs)
	return __ja.notices_trust_added_title(inputs)
});
/**
* | output |
* | --- |
* | "Edited:" |
*
* @param {Notices_Turn_Edited_PrefixInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_turn_edited_prefix = /** @type {((inputs?: Notices_Turn_Edited_PrefixInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Turn_Edited_PrefixInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_turn_edited_prefix(inputs)
	return __ja.notices_turn_edited_prefix(inputs)
});
/**
* | output |
* | --- |
* | "Wants to change:" |
*
* @param {Notices_Turn_Proposal_PrefixInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const notices_turn_proposal_prefix = /** @type {((inputs?: Notices_Turn_Proposal_PrefixInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notices_Turn_Proposal_PrefixInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.notices_turn_proposal_prefix(inputs)
	return __ja.notices_turn_proposal_prefix(inputs)
});
/**
* | output |
* | --- |
* | "AI memo" |
*
* @param {Persons_Agent_MemoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_agent_memo = /** @type {((inputs?: Persons_Agent_MemoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Agent_MemoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_agent_memo(inputs)
	return __ja.persons_agent_memo(inputs)
});
/**
* | output |
* | --- |
* | "Add an alias" |
*
* @param {Persons_Alias_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_alias_add = /** @type {((inputs?: Persons_Alias_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Alias_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_alias_add(inputs)
	return __ja.persons_alias_add(inputs)
});
/**
* | output |
* | --- |
* | "Could not add the alias \"{alias}\"" |
*
* @param {Persons_Alias_Add_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_alias_add_failed = /** @type {((inputs: Persons_Alias_Add_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Alias_Add_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_alias_add_failed(inputs)
	return __ja.persons_alias_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "Reading, nickname" |
*
* @param {Persons_Alias_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_alias_placeholder = /** @type {((inputs?: Persons_Alias_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Alias_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_alias_placeholder(inputs)
	return __ja.persons_alias_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Remove the alias \"{alias}\"" |
*
* @param {Persons_Alias_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_alias_remove = /** @type {((inputs: Persons_Alias_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Alias_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_alias_remove(inputs)
	return __ja.persons_alias_remove(inputs)
});
/**
* | output |
* | --- |
* | "Could not remove the alias \"{alias}\"" |
*
* @param {Persons_Alias_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_alias_remove_failed = /** @type {((inputs: Persons_Alias_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Alias_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_alias_remove_failed(inputs)
	return __ja.persons_alias_remove_failed(inputs)
});
/**
* | output |
* | --- |
* | "Aliases" |
*
* @param {Persons_AliasesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_aliases = /** @type {((inputs?: Persons_AliasesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_AliasesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_aliases(inputs)
	return __ja.persons_aliases(inputs)
});
/**
* | output |
* | --- |
* | "Aliases and ids" |
*
* @param {Persons_Aliases_IdsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_aliases_ids = /** @type {((inputs?: Persons_Aliases_IdsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Aliases_IdsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_aliases_ids(inputs)
	return __ja.persons_aliases_ids(inputs)
});
/**
* | output |
* | --- |
* | "Context" |
*
* @param {Persons_ContextInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_context = /** @type {((inputs?: Persons_ContextInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_ContextInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_context(inputs)
	return __ja.persons_context(inputs)
});
/**
* | output |
* | --- |
* | "Who they are, how you know them, what to keep in mind" |
*
* @param {Persons_Context_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_context_placeholder = /** @type {((inputs?: Persons_Context_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Context_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_context_placeholder(inputs)
	return __ja.persons_context_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Create Person" |
*
* @param {Persons_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_create = /** @type {((inputs?: Persons_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_create(inputs)
	return __ja.persons_create(inputs)
});
/**
* | output |
* | --- |
* | "Could not create the person" |
*
* @param {Persons_Create_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_create_failed = /** @type {((inputs?: Persons_Create_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Create_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_create_failed(inputs)
	return __ja.persons_create_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not create them (what you wrote is kept)" |
*
* @param {Persons_Create_Failed_KeptInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_create_failed_kept = /** @type {((inputs?: Persons_Create_Failed_KeptInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Create_Failed_KeptInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_create_failed_kept(inputs)
	return __ja.persons_create_failed_kept(inputs)
});
/**
* | output |
* | --- |
* | "Create \"{name}\"" |
*
* @param {Persons_Create_NamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_create_named = /** @type {((inputs: Persons_Create_NamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Create_NamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_create_named(inputs)
	return __ja.persons_create_named(inputs)
});
/**
* | output |
* | --- |
* | "Creating" |
*
* @param {Persons_CreatingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_creating = /** @type {((inputs?: Persons_CreatingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_CreatingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_creating(inputs)
	return __ja.persons_creating(inputs)
});
/**
* | output |
* | --- |
* | "Their external ids and AI memo go too. Cases keep showing the name {name}" |
*
* @param {Persons_Delete_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_delete_body = /** @type {((inputs: Persons_Delete_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Delete_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_delete_body(inputs)
	return __ja.persons_delete_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete {name}" |
*
* @param {Persons_Delete_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_delete_failed = /** @type {((inputs: Persons_Delete_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Delete_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_delete_failed(inputs)
	return __ja.persons_delete_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete {name}" |
*
* @param {Persons_Delete_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_delete_title = /** @type {((inputs: Persons_Delete_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Delete_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_delete_title(inputs)
	return __ja.persons_delete_title(inputs)
});
/**
* | output |
* | --- |
* | "No people yet" |
*
* @param {Persons_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_empty = /** @type {((inputs?: Persons_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_empty(inputs)
	return __ja.persons_empty(inputs)
});
/**
* | output |
* | --- |
* | "External ids" |
*
* @param {Persons_External_IdsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_external_ids = /** @type {((inputs?: Persons_External_IdsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_External_IdsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_external_ids(inputs)
	return __ja.persons_external_ids(inputs)
});
/**
* | output |
* | --- |
* | "Go to People" |
*
* @param {Persons_GoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_go = /** @type {((inputs?: Persons_GoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_GoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_go(inputs)
	return __ja.persons_go(inputs)
});
/**
* | output |
* | --- |
* | "Before" |
*
* @param {Persons_HistoryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_history = /** @type {((inputs?: Persons_HistoryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_HistoryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_history(inputs)
	return __ja.persons_history(inputs)
});
/**
* | output |
* | --- |
* | "Add an id" |
*
* @param {Persons_Id_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_id_add = /** @type {((inputs?: Persons_Id_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Id_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_id_add(inputs)
	return __ja.persons_id_add(inputs)
});
/**
* | output |
* | --- |
* | "Could not add \"{value}\"" |
*
* @param {Persons_Id_Add_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_id_add_failed = /** @type {((inputs: Persons_Id_Add_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Id_Add_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_id_add_failed(inputs)
	return __ja.persons_id_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "Kind of id" |
*
* @param {Persons_Id_KindInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_id_kind = /** @type {((inputs?: Persons_Id_KindInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Id_KindInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_id_kind(inputs)
	return __ja.persons_id_kind(inputs)
});
/**
* | output |
* | --- |
* | "Remove \"{value}\"" |
*
* @param {Persons_Id_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_id_remove = /** @type {((inputs: Persons_Id_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Id_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_id_remove(inputs)
	return __ja.persons_id_remove(inputs)
});
/**
* | output |
* | --- |
* | "Could not remove \"{value}\"" |
*
* @param {Persons_Id_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_id_remove_failed = /** @type {((inputs: Persons_Id_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Id_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_id_remove_failed(inputs)
	return __ja.persons_id_remove_failed(inputs)
});
/**
* | output |
* | --- |
* | "Id" |
*
* @param {Persons_Id_ValueInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_id_value = /** @type {((inputs?: Persons_Id_ValueInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Id_ValueInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_id_value(inputs)
	return __ja.persons_id_value(inputs)
});
/**
* | output |
* | --- |
* | "Email, user name, phone number or URL" |
*
* @param {Persons_Id_Value_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_id_value_placeholder = /** @type {((inputs?: Persons_Id_Value_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Id_Value_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_id_value_placeholder(inputs)
	return __ja.persons_id_value_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Email" |
*
* @param {Persons_Kind_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_kind_email = /** @type {((inputs?: Persons_Kind_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Kind_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_kind_email(inputs)
	return __ja.persons_kind_email(inputs)
});
/**
* | output |
* | --- |
* | "GitHub" |
*
* @param {Persons_Kind_GithubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_kind_github = /** @type {((inputs?: Persons_Kind_GithubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Kind_GithubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_kind_github(inputs)
	return __ja.persons_kind_github(inputs)
});
/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Persons_Kind_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_kind_phone = /** @type {((inputs?: Persons_Kind_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Kind_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_kind_phone(inputs)
	return __ja.persons_kind_phone(inputs)
});
/**
* | output |
* | --- |
* | "Slack" |
*
* @param {Persons_Kind_SlackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_kind_slack = /** @type {((inputs?: Persons_Kind_SlackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Kind_SlackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_kind_slack(inputs)
	return __ja.persons_kind_slack(inputs)
});
/**
* | output |
* | --- |
* | "URL" |
*
* @param {Persons_Kind_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_kind_url = /** @type {((inputs?: Persons_Kind_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Kind_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_kind_url(inputs)
	return __ja.persons_kind_url(inputs)
});
/**
* | output |
* | --- |
* | "No members to link (you and members linked to other people aren't shown)" |
*
* @param {Persons_Link_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_link_empty = /** @type {((inputs?: Persons_Link_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Link_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_link_empty(inputs)
	return __ja.persons_link_empty(inputs)
});
/**
* | output |
* | --- |
* | "Could not link {name}" |
*
* @param {Persons_Link_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_link_failed = /** @type {((inputs: Persons_Link_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Link_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_link_failed(inputs)
	return __ja.persons_link_failed(inputs)
});
/**
* | output |
* | --- |
* | "Link to member" |
*
* @param {Persons_Link_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_link_label = /** @type {((inputs?: Persons_Link_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Link_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_link_label(inputs)
	return __ja.persons_link_label(inputs)
});
/**
* | output |
* | --- |
* | "Link to member…" |
*
* @param {Persons_Link_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_link_menu = /** @type {((inputs?: Persons_Link_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Link_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_link_menu(inputs)
	return __ja.persons_link_menu(inputs)
});
/**
* | output |
* | --- |
* | "Search members to link" |
*
* @param {Persons_Link_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_link_search = /** @type {((inputs?: Persons_Link_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Link_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_link_search(inputs)
	return __ja.persons_link_search(inputs)
});
/**
* | output |
* | --- |
* | "Search by name" |
*
* @param {Persons_Link_Search_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_link_search_placeholder = /** @type {((inputs?: Persons_Link_Search_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Link_Search_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_link_search_placeholder(inputs)
	return __ja.persons_link_search_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Member to link with {name}" |
*
* @param {Persons_Link_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_link_title = /** @type {((inputs: Persons_Link_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Link_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_link_title(inputs)
	return __ja.persons_link_title(inputs)
});
/**
* | output |
* | --- |
* | "Former member" |
*
* @param {Persons_Linked_FormerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_linked_former = /** @type {((inputs?: Persons_Linked_FormerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Linked_FormerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_linked_former(inputs)
	return __ja.persons_linked_former(inputs)
});
/**
* | output |
* | --- |
* | "People" |
*
* @param {Persons_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_list = /** @type {((inputs?: Persons_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_list(inputs)
	return __ja.persons_list(inputs)
});
/**
* | output |
* | --- |
* | "Could not load" |
*
* @param {Persons_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_load_failed = /** @type {((inputs?: Persons_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_load_failed(inputs)
	return __ja.persons_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Actions for \"{name}\"" |
*
* @param {Persons_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_menu = /** @type {((inputs: Persons_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_menu(inputs)
	return __ja.persons_menu(inputs)
});
/**
* | output |
* | --- |
* | "Merge" |
*
* @param {Persons_Merge_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_action = /** @type {((inputs?: Persons_Merge_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_action(inputs)
	return __ja.persons_merge_action(inputs)
});
/**
* | output |
* | --- |
* | "Waits, links, references, external ids, aliases and the AI memo move to {keep}, and {from} goes away" |
*
* @param {Persons_Merge_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_body = /** @type {((inputs: Persons_Merge_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_body(inputs)
	return __ja.persons_merge_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not merge {from} into {keep}" |
*
* @param {Persons_Merge_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_failed = /** @type {((inputs: Persons_Merge_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_failed(inputs)
	return __ja.persons_merge_failed(inputs)
});
/**
* | output |
* | --- |
* | "Merge with the same person" |
*
* @param {Persons_Merge_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_label = /** @type {((inputs?: Persons_Merge_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_label(inputs)
	return __ja.persons_merge_label(inputs)
});
/**
* | output |
* | --- |
* | "Merge with the same person…" |
*
* @param {Persons_Merge_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_menu = /** @type {((inputs?: Persons_Merge_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_menu(inputs)
	return __ja.persons_merge_menu(inputs)
});
/**
* | output |
* | --- |
* | "Pick the other record of the same person. They are merged into {name} and go away" |
*
* @param {Persons_Merge_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_note = /** @type {((inputs: Persons_Merge_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_note(inputs)
	return __ja.persons_merge_note(inputs)
});
/**
* | output |
* | --- |
* | "Who to merge into {name}" |
*
* @param {Persons_Merge_Pick_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_pick_title = /** @type {((inputs: Persons_Merge_Pick_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_Pick_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_pick_title(inputs)
	return __ja.persons_merge_pick_title(inputs)
});
/**
* | output |
* | --- |
* | "Search the person to merge" |
*
* @param {Persons_Merge_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_search = /** @type {((inputs?: Persons_Merge_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_search(inputs)
	return __ja.persons_merge_search(inputs)
});
/**
* | output |
* | --- |
* | "Merge {from} into {keep}" |
*
* @param {Persons_Merge_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_merge_title = /** @type {((inputs: Persons_Merge_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Merge_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_merge_title(inputs)
	return __ja.persons_merge_title(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Persons_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_name = /** @type {((inputs?: Persons_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_name(inputs)
	return __ja.persons_name(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the name" |
*
* @param {Persons_Name_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_name_failed = /** @type {((inputs?: Persons_Name_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Name_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_name_failed(inputs)
	return __ja.persons_name_failed(inputs)
});
/**
* | output |
* | --- |
* | "Narrow" |
*
* @param {Persons_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_narrow = /** @type {((inputs?: Persons_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_narrow(inputs)
	return __ja.persons_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Narrow by name, note or id" |
*
* @param {Persons_Narrow_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_narrow_placeholder = /** @type {((inputs?: Persons_Narrow_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Narrow_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_narrow_placeholder(inputs)
	return __ja.persons_narrow_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "New person" |
*
* @param {Persons_NewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_new = /** @type {((inputs?: Persons_NewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_NewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_new(inputs)
	return __ja.persons_new(inputs)
});
/**
* | output |
* | --- |
* | "No one matches" |
*
* @param {Persons_No_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_no_match = /** @type {((inputs?: Persons_No_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_No_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_no_match(inputs)
	return __ja.persons_no_match(inputs)
});
/**
* | output |
* | --- |
* | "This person was not found" |
*
* @param {Persons_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_not_found = /** @type {((inputs?: Persons_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_not_found(inputs)
	return __ja.persons_not_found(inputs)
});
/**
* | output |
* | --- |
* | "Now" |
*
* @param {Persons_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_now = /** @type {((inputs?: Persons_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_now(inputs)
	return __ja.persons_now(inputs)
});
/**
* | output |
* | --- |
* | "Nothing is waiting on them" |
*
* @param {Persons_Now_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_now_empty = /** @type {((inputs?: Persons_Now_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Now_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_now_empty(inputs)
	return __ja.persons_now_empty(inputs)
});
/**
* | output |
* | --- |
* | "Write an email" |
*
* @param {Persons_Open_EmailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_open_email = /** @type {((inputs?: Persons_Open_EmailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Open_EmailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_open_email(inputs)
	return __ja.persons_open_email(inputs)
});
/**
* | output |
* | --- |
* | "Open on GitHub" |
*
* @param {Persons_Open_GithubInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_open_github = /** @type {((inputs?: Persons_Open_GithubInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Open_GithubInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_open_github(inputs)
	return __ja.persons_open_github(inputs)
});
/**
* | output |
* | --- |
* | "Call" |
*
* @param {Persons_Open_PhoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_open_phone = /** @type {((inputs?: Persons_Open_PhoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Open_PhoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_open_phone(inputs)
	return __ja.persons_open_phone(inputs)
});
/**
* | output |
* | --- |
* | "Open in Slack" |
*
* @param {Persons_Open_SlackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_open_slack = /** @type {((inputs?: Persons_Open_SlackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Open_SlackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_open_slack(inputs)
	return __ja.persons_open_slack(inputs)
});
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Persons_Open_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_open_url = /** @type {((inputs?: Persons_Open_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Open_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_open_url(inputs)
	return __ja.persons_open_url(inputs)
});
/**
* | output |
* | --- |
* | "Choose who" |
*
* @param {Persons_Pick_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_action = /** @type {((inputs?: Persons_Pick_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_action(inputs)
	return __ja.persons_pick_action(inputs)
});
/**
* | output |
* | --- |
* | "Suggestions" |
*
* @param {Persons_Pick_CandidatesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_candidates = /** @type {((inputs?: Persons_Pick_CandidatesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_CandidatesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_candidates(inputs)
	return __ja.persons_pick_candidates(inputs)
});
/**
* | output |
* | --- |
* | "Take the person off" |
*
* @param {Persons_Pick_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_clear = /** @type {((inputs?: Persons_Pick_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_clear(inputs)
	return __ja.persons_pick_clear(inputs)
});
/**
* | output |
* | --- |
* | "Nothing found" |
*
* @param {Persons_Pick_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_none = /** @type {((inputs?: Persons_Pick_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_none(inputs)
	return __ja.persons_pick_none(inputs)
});
/**
* | output |
* | --- |
* | "Who" |
*
* @param {Persons_Pick_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_placeholder = /** @type {((inputs?: Persons_Pick_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_placeholder(inputs)
	return __ja.persons_pick_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Search people" |
*
* @param {Persons_Pick_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_search = /** @type {((inputs?: Persons_Pick_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_search(inputs)
	return __ja.persons_pick_search(inputs)
});
/**
* | output |
* | --- |
* | "Search by name or alias / a new person's name" |
*
* @param {Persons_Pick_Search_Or_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_search_or_create = /** @type {((inputs?: Persons_Pick_Search_Or_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_Search_Or_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_search_or_create(inputs)
	return __ja.persons_pick_search_or_create(inputs)
});
/**
* | output |
* | --- |
* | "Search by name or alias" |
*
* @param {Persons_Pick_Search_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_pick_search_placeholder = /** @type {((inputs?: Persons_Pick_Search_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Pick_Search_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_pick_search_placeholder(inputs)
	return __ja.persons_pick_search_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "Workspace id" |
*
* @param {Persons_Slack_WorkspaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_slack_workspace = /** @type {((inputs?: Persons_Slack_WorkspaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Slack_WorkspaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_slack_workspace(inputs)
	return __ja.persons_slack_workspace(inputs)
});
/**
* | output |
* | --- |
* | "Workspace id (T…)" |
*
* @param {Persons_Slack_Workspace_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_slack_workspace_placeholder = /** @type {((inputs?: Persons_Slack_Workspace_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Slack_Workspace_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_slack_workspace_placeholder(inputs)
	return __ja.persons_slack_workspace_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "One line" |
*
* @param {Persons_SummaryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_summary = /** @type {((inputs?: Persons_SummaryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_SummaryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_summary(inputs)
	return __ja.persons_summary(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the line" |
*
* @param {Persons_Summary_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_summary_failed = /** @type {((inputs?: Persons_Summary_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Summary_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_summary_failed(inputs)
	return __ja.persons_summary_failed(inputs)
});
/**
* | output |
* | --- |
* | "Who they are to you, in one line" |
*
* @param {Persons_Summary_PlaceholderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_summary_placeholder = /** @type {((inputs?: Persons_Summary_PlaceholderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Summary_PlaceholderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_summary_placeholder(inputs)
	return __ja.persons_summary_placeholder(inputs)
});
/**
* | output |
* | --- |
* | "People" |
*
* @param {Persons_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_title = /** @type {((inputs?: Persons_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_title(inputs)
	return __ja.persons_title(inputs)
});
/**
* | output |
* | --- |
* | "Unlink member" |
*
* @param {Persons_UnlinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_unlink = /** @type {((inputs?: Persons_UnlinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_UnlinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_unlink(inputs)
	return __ja.persons_unlink(inputs)
});
/**
* | output |
* | --- |
* | "Could not unlink the member" |
*
* @param {Persons_Unlink_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_unlink_failed = /** @type {((inputs?: Persons_Unlink_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Unlink_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_unlink_failed(inputs)
	return __ja.persons_unlink_failed(inputs)
});
/**
* | output |
* | --- |
* | "Waiting {count}" |
*
* @param {Persons_Waiting_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const persons_waiting_count = /** @type {((inputs: Persons_Waiting_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Persons_Waiting_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.persons_waiting_count(inputs)
	return __ja.persons_waiting_count(inputs)
});
/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Phone_Doc_RedoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_doc_redo = /** @type {((inputs?: Phone_Doc_RedoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Doc_RedoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_doc_redo(inputs)
	return __ja.phone_doc_redo(inputs)
});
/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Phone_Doc_UndoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_doc_undo = /** @type {((inputs?: Phone_Doc_UndoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Doc_UndoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_doc_undo(inputs)
	return __ja.phone_doc_undo(inputs)
});
/**
* | output |
* | --- |
* | "Phone Dock" |
*
* @param {Phone_Dock_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings = /** @type {((inputs?: Phone_Dock_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings(inputs)
	return __ja.phone_dock_settings(inputs)
});
/**
* | output |
* | --- |
* | "Places above this line go in the bottom bar" |
*
* @param {Phone_Dock_Settings_CutoffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings_cutoff = /** @type {((inputs?: Phone_Dock_Settings_CutoffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_Settings_CutoffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings_cutoff(inputs)
	return __ja.phone_dock_settings_cutoff(inputs)
});
/**
* | output |
* | --- |
* | "The places in the bar at the bottom of a phone, and their order. Kept on this device." |
*
* @param {Phone_Dock_Settings_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings_description = /** @type {((inputs?: Phone_Dock_Settings_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_Settings_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings_description(inputs)
	return __ja.phone_dock_settings_description(inputs)
});
/**
* | output |
* | --- |
* | "Me" |
*
* @param {Phone_Dock_Settings_MeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings_me = /** @type {((inputs?: Phone_Dock_Settings_MeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_Settings_MeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings_me(inputs)
	return __ja.phone_dock_settings_me(inputs)
});
/**
* | output |
* | --- |
* | "Move {label}" |
*
* @param {Phone_Dock_Settings_MoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings_move = /** @type {((inputs: Phone_Dock_Settings_MoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_Settings_MoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings_move(inputs)
	return __ja.phone_dock_settings_move(inputs)
});
/**
* | output |
* | --- |
* | "In a workspace, its places are listed here too." |
*
* @param {Phone_Dock_Settings_No_PlaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings_no_place = /** @type {((inputs?: Phone_Dock_Settings_No_PlaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_Settings_No_PlaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings_no_place(inputs)
	return __ja.phone_dock_settings_no_place(inputs)
});
/**
* | output |
* | --- |
* | "From the top, as many as fit the screen's width go in the bottom bar. Me's places and the workspace's are kept apart in the bar." |
*
* @param {Phone_Dock_Settings_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings_note = /** @type {((inputs?: Phone_Dock_Settings_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_Settings_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings_note(inputs)
	return __ja.phone_dock_settings_note(inputs)
});
/**
* | output |
* | --- |
* | "Show {label} in the Dock and the menu" |
*
* @param {Phone_Dock_Settings_ShowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_dock_settings_show = /** @type {((inputs: Phone_Dock_Settings_ShowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Dock_Settings_ShowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_dock_settings_show(inputs)
	return __ja.phone_dock_settings_show(inputs)
});
/**
* | output |
* | --- |
* | "Menu" |
*
* @param {Phone_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_menu = /** @type {((inputs?: Phone_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_menu(inputs)
	return __ja.phone_menu(inputs)
});
/**
* | output |
* | --- |
* | "All places" |
*
* @param {Phone_Menu_AllInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_menu_all = /** @type {((inputs?: Phone_Menu_AllInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Menu_AllInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_menu_all(inputs)
	return __ja.phone_menu_all(inputs)
});
/**
* | output |
* | --- |
* | "Arrange the Dock" |
*
* @param {Phone_Menu_ArrangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_menu_arrange = /** @type {((inputs?: Phone_Menu_ArrangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Menu_ArrangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_menu_arrange(inputs)
	return __ja.phone_menu_arrange(inputs)
});
/**
* | output |
* | --- |
* | "Open menu" |
*
* @param {Phone_Menu_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_menu_open = /** @type {((inputs?: Phone_Menu_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Menu_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_menu_open(inputs)
	return __ja.phone_menu_open(inputs)
});
/**
* | output |
* | --- |
* | "More" |
*
* @param {Phone_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_more = /** @type {((inputs?: Phone_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_more(inputs)
	return __ja.phone_more(inputs)
});
/**
* | output |
* | --- |
* | "More (current: {label})" |
*
* @param {Phone_More_CurrentInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_more_current = /** @type {((inputs: Phone_More_CurrentInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_More_CurrentInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_more_current(inputs)
	return __ja.phone_more_current(inputs)
});
/**
* | output |
* | --- |
* | "Menu of {name}" |
*
* @param {Phone_Place_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_place_menu = /** @type {((inputs: Phone_Place_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Place_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_place_menu(inputs)
	return __ja.phone_place_menu(inputs)
});
/**
* | output |
* | --- |
* | "{label} (something new)" |
*
* @param {Phone_Unread_NamedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const phone_unread_named = /** @type {((inputs: Phone_Unread_NamedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phone_Unread_NamedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.phone_unread_named(inputs)
	return __ja.phone_unread_named(inputs)
});
/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Publishing_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_action = /** @type {((inputs?: Publishing_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_action(inputs)
	return __ja.publishing_action(inputs)
});
/**
* | output |
* | --- |
* | "Published. It takes a few seconds until the link can be read." |
*
* @param {Publishing_BuildingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_building = /** @type {((inputs?: Publishing_BuildingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_BuildingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_building(inputs)
	return __ja.publishing_building(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Publishing_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_close = /** @type {((inputs?: Publishing_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_close(inputs)
	return __ja.publishing_close(inputs)
});
/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Publishing_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_copied = /** @type {((inputs?: Publishing_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_copied(inputs)
	return __ja.publishing_copied(inputs)
});
/**
* | output |
* | --- |
* | "Copy" |
*
* @param {Publishing_CopyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_copy = /** @type {((inputs?: Publishing_CopyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_CopyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_copy(inputs)
	return __ja.publishing_copy(inputs)
});
/**
* | output |
* | --- |
* | "Could not copy" |
*
* @param {Publishing_Copy_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_copy_failed = /** @type {((inputs?: Publishing_Copy_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Copy_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_copy_failed(inputs)
	return __ja.publishing_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "{count} more" |
*
* @param {Publishing_Dataset_More_FieldsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_dataset_more_fields = /** @type {((inputs: Publishing_Dataset_More_FieldsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Dataset_More_FieldsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_dataset_more_fields(inputs)
	return __ja.publishing_dataset_more_fields(inputs)
});
/**
* | output |
* | --- |
* | "This workspace doesn't allow publishing by link" |
*
* @param {Publishing_Dataset_Not_AllowedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_dataset_not_allowed = /** @type {((inputs?: Publishing_Dataset_Not_AllowedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Dataset_Not_AllowedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_dataset_not_allowed(inputs)
	return __ja.publishing_dataset_not_allowed(inputs)
});
/**
* | output |
* | --- |
* | "You don't have permission to write this dataset" |
*
* @param {Publishing_Dataset_Not_WritableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_dataset_not_writable = /** @type {((inputs?: Publishing_Dataset_Not_WritableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Dataset_Not_WritableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_dataset_not_writable(inputs)
	return __ja.publishing_dataset_not_writable(inputs)
});
/**
* | output |
* | --- |
* | "{count} rows" |
*
* @param {Publishing_Dataset_RowsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_dataset_rows = /** @type {((inputs: Publishing_Dataset_RowsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Dataset_RowsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_dataset_rows(inputs)
	return __ja.publishing_dataset_rows(inputs)
});
/**
* | output |
* | --- |
* | "{count} datasets can't be published. Their UI shows no data on the published page." |
*
* @param {Publishing_Datasets_BlockedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_blocked = /** @type {((inputs: Publishing_Datasets_BlockedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_BlockedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_blocked(inputs)
	return __ja.publishing_datasets_blocked(inputs)
});
/**
* | output |
* | --- |
* | "Anyone with the link will be able to read all their rows and fields." |
*
* @param {Publishing_Datasets_Confirm_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_confirm_body = /** @type {((inputs?: Publishing_Datasets_Confirm_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_Confirm_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_confirm_body(inputs)
	return __ja.publishing_datasets_confirm_body(inputs)
});
/**
* | output |
* | --- |
* | "Publish {count} datasets" |
*
* @param {Publishing_Datasets_Confirm_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_confirm_title = /** @type {((inputs: Publishing_Datasets_Confirm_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_Confirm_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_confirm_title(inputs)
	return __ja.publishing_datasets_confirm_title(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't publish the datasets" |
*
* @param {Publishing_Datasets_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_failed = /** @type {((inputs?: Publishing_Datasets_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_failed(inputs)
	return __ja.publishing_datasets_failed(inputs)
});
/**
* | output |
* | --- |
* | "{count} datasets weren't found" |
*
* @param {Publishing_Datasets_HiddenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_hidden = /** @type {((inputs: Publishing_Datasets_HiddenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_HiddenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_hidden(inputs)
	return __ja.publishing_datasets_hidden(inputs)
});
/**
* | output |
* | --- |
* | "The datasets this document's UI reads. Anyone with the link will be able to read all their rows and fields." |
*
* @param {Publishing_Datasets_IntroInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_intro = /** @type {((inputs?: Publishing_Datasets_IntroInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_IntroInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_intro(inputs)
	return __ja.publishing_datasets_intro(inputs)
});
/**
* | output |
* | --- |
* | "This document reads datasets that aren't published. Their UI shows no data on the published page." |
*
* @param {Publishing_Datasets_PendingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_pending = /** @type {((inputs?: Publishing_Datasets_PendingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_PendingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_pending(inputs)
	return __ja.publishing_datasets_pending(inputs)
});
/**
* | output |
* | --- |
* | "Publish datasets" |
*
* @param {Publishing_Datasets_PublishInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_publish = /** @type {((inputs?: Publishing_Datasets_PublishInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_PublishInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_publish(inputs)
	return __ja.publishing_datasets_publish(inputs)
});
/**
* | output |
* | --- |
* | "Published datasets" |
*
* @param {Publishing_Datasets_PublishedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_published = /** @type {((inputs?: Publishing_Datasets_PublishedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_PublishedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_published(inputs)
	return __ja.publishing_datasets_published(inputs)
});
/**
* | output |
* | --- |
* | "Datasets published with it" |
*
* @param {Publishing_Datasets_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_datasets_title = /** @type {((inputs?: Publishing_Datasets_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Datasets_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_datasets_title(inputs)
	return __ja.publishing_datasets_title(inputs)
});
/**
* | output |
* | --- |
* | "Could not publish" |
*
* @param {Publishing_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_failed = /** @type {((inputs?: Publishing_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_failed(inputs)
	return __ja.publishing_failed(inputs)
});
/**
* | output |
* | --- |
* | "The published page could not be put again. It is being retried." |
*
* @param {Publishing_FailingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_failing = /** @type {((inputs?: Publishing_FailingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_FailingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_failing(inputs)
	return __ja.publishing_failing(inputs)
});
/**
* | output |
* | --- |
* | "The scripts of an HTML document run on the published page too." |
*
* @param {Publishing_Html_ScriptsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_html_scripts = /** @type {((inputs?: Publishing_Html_ScriptsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Html_ScriptsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_html_scripts(inputs)
	return __ja.publishing_html_scripts(inputs)
});
/**
* | output |
* | --- |
* | "Anyone with the unguessable URL can read it without signing in. When you change the text, the published page follows a little later." |
*
* @param {Publishing_IntroInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_intro = /** @type {((inputs?: Publishing_IntroInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_IntroInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_intro(inputs)
	return __ja.publishing_intro(inputs)
});
/**
* | output |
* | --- |
* | "Publish by link" |
*
* @param {Publishing_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_menu = /** @type {((inputs?: Publishing_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_menu(inputs)
	return __ja.publishing_menu(inputs)
});
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Publishing_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_open = /** @type {((inputs?: Publishing_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_open(inputs)
	return __ja.publishing_open(inputs)
});
/**
* | output |
* | --- |
* | "Preview of the published page" |
*
* @param {Publishing_PreviewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_preview = /** @type {((inputs?: Publishing_PreviewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_PreviewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_preview(inputs)
	return __ja.publishing_preview(inputs)
});
/**
* | output |
* | --- |
* | "Could not make the preview" |
*
* @param {Publishing_Preview_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_preview_failed = /** @type {((inputs?: Publishing_Preview_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Preview_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_preview_failed(inputs)
	return __ja.publishing_preview_failed(inputs)
});
/**
* | output |
* | --- |
* | "Published by link" |
*
* @param {Publishing_PublishedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_published = /** @type {((inputs?: Publishing_PublishedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_PublishedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_published(inputs)
	return __ja.publishing_published(inputs)
});
/**
* | output |
* | --- |
* | "Published {date}" |
*
* @param {Publishing_Published_AtInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_published_at = /** @type {((inputs: Publishing_Published_AtInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Published_AtInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_published_at(inputs)
	return __ja.publishing_published_at(inputs)
});
/**
* | output |
* | --- |
* | "Published by link (some datasets aren't published)" |
*
* @param {Publishing_Published_PendingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_published_pending = /** @type {((inputs?: Publishing_Published_PendingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Published_PendingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_published_pending(inputs)
	return __ja.publishing_published_pending(inputs)
});
/**
* | output |
* | --- |
* | "Stop publishing" |
*
* @param {Publishing_StopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_stop = /** @type {((inputs?: Publishing_StopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_StopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_stop(inputs)
	return __ja.publishing_stop(inputs)
});
/**
* | output |
* | --- |
* | "The link will no longer open it. Publishing again gives another URL." |
*
* @param {Publishing_Stop_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_stop_body = /** @type {((inputs?: Publishing_Stop_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Stop_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_stop_body(inputs)
	return __ja.publishing_stop_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not stop publishing" |
*
* @param {Publishing_Stop_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_stop_failed = /** @type {((inputs?: Publishing_Stop_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Stop_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_stop_failed(inputs)
	return __ja.publishing_stop_failed(inputs)
});
/**
* | output |
* | --- |
* | "Stop publishing “{title}”" |
*
* @param {Publishing_Stop_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_stop_title = /** @type {((inputs: Publishing_Stop_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Stop_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_stop_title(inputs)
	return __ja.publishing_stop_title(inputs)
});
/**
* | output |
* | --- |
* | "Publish by link" |
*
* @param {Publishing_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_title = /** @type {((inputs?: Publishing_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_title(inputs)
	return __ja.publishing_title(inputs)
});
/**
* | output |
* | --- |
* | "{count} links point at documents that are not published. The published page takes those links off." |
*
* @param {Publishing_Unpublished_LinksInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_unpublished_links = /** @type {((inputs: Publishing_Unpublished_LinksInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Unpublished_LinksInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_unpublished_links(inputs)
	return __ja.publishing_unpublished_links(inputs)
});
/**
* | output |
* | --- |
* | "{count} references point at things that are not published. The published page shows only their kind." |
*
* @param {Publishing_Unpublished_RefsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_unpublished_refs = /** @type {((inputs: Publishing_Unpublished_RefsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_Unpublished_RefsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_unpublished_refs(inputs)
	return __ja.publishing_unpublished_refs(inputs)
});
/**
* | output |
* | --- |
* | "Published URL" |
*
* @param {Publishing_UrlInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const publishing_url = /** @type {((inputs?: Publishing_UrlInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishing_UrlInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.publishing_url(inputs)
	return __ja.publishing_url(inputs)
});
/**
* | output |
* | --- |
* | "This app cannot open it" |
*
* @param {Refs_Cannot_Open_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_cannot_open_here = /** @type {((inputs?: Refs_Cannot_Open_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Cannot_Open_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_cannot_open_here(inputs)
	return __ja.refs_cannot_open_here(inputs)
});
/**
* | output |
* | --- |
* | "In a Workspace on the Cloud (cannot open it here)" |
*
* @param {Refs_In_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_in_cloud = /** @type {((inputs?: Refs_In_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_In_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_in_cloud(inputs)
	return __ja.refs_in_cloud(inputs)
});
/**
* | output |
* | --- |
* | "{label} ({why})" |
*
* @param {Refs_Missing_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_missing_label = /** @type {((inputs: Refs_Missing_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Missing_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_missing_label(inputs)
	return __ja.refs_missing_label(inputs)
});
/**
* | output |
* | --- |
* | "Not found" |
*
* @param {Refs_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_not_found = /** @type {((inputs?: Refs_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_not_found(inputs)
	return __ja.refs_not_found(inputs)
});
/**
* | output |
* | --- |
* | "It was changed somewhere else, so this was not saved. The text above is the current one." |
*
* @param {Refs_Note_ConflictInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_note_conflict = /** @type {((inputs?: Refs_Note_ConflictInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Note_ConflictInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_note_conflict(inputs)
	return __ja.refs_note_conflict(inputs)
});
/**
* | output |
* | --- |
* | "Drop what you wrote" |
*
* @param {Refs_Note_Conflict_DropInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_note_conflict_drop = /** @type {((inputs?: Refs_Note_Conflict_DropInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Note_Conflict_DropInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_note_conflict_drop(inputs)
	return __ja.refs_note_conflict_drop(inputs)
});
/**
* | output |
* | --- |
* | "Replace with what you wrote" |
*
* @param {Refs_Note_Conflict_Use_MineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_note_conflict_use_mine = /** @type {((inputs?: Refs_Note_Conflict_Use_MineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Note_Conflict_Use_MineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_note_conflict_use_mine(inputs)
	return __ja.refs_note_conflict_use_mine(inputs)
});
/**
* | output |
* | --- |
* | "What you wrote" |
*
* @param {Refs_Note_Conflict_YoursInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_note_conflict_yours = /** @type {((inputs?: Refs_Note_Conflict_YoursInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Note_Conflict_YoursInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_note_conflict_yours(inputs)
	return __ja.refs_note_conflict_yours(inputs)
});
/**
* | output |
* | --- |
* | "Could not save (what you wrote is kept)" |
*
* @param {Refs_Save_Failed_KeptInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_save_failed_kept = /** @type {((inputs?: Refs_Save_Failed_KeptInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_Save_Failed_KeptInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_save_failed_kept(inputs)
	return __ja.refs_save_failed_kept(inputs)
});
/**
* | output |
* | --- |
* | "Could not be read: the Cloud is not connected. It shows once it is" |
*
* @param {Refs_UnreachableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const refs_unreachable = /** @type {((inputs?: Refs_UnreachableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refs_UnreachableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.refs_unreachable(inputs)
	return __ja.refs_unreachable(inputs)
});
/**
* | output |
* | --- |
* | "App settings" |
*
* @param {Settings_App_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_app_open = /** @type {((inputs?: Settings_App_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_App_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_app_open(inputs)
	return __ja.settings_app_open(inputs)
});
/**
* | output |
* | --- |
* | "Opens the settings of trameria on this PC (Cloud, Vault, backups, appearance and more) in a window of their own." |
*
* @param {Settings_App_Open_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_app_open_description = /** @type {((inputs?: Settings_App_Open_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_App_Open_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_app_open_description(inputs)
	return __ja.settings_app_open_description(inputs)
});
/**
* | output |
* | --- |
* | "Opens the settings of the trameria app on this device (appearance, notifications, Cloud, Vault)." |
*
* @param {Settings_App_Open_Description_DeviceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_app_open_description_device = /** @type {((inputs?: Settings_App_Open_Description_DeviceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_App_Open_Description_DeviceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_app_open_description_device(inputs)
	return __ja.settings_app_open_description_device(inputs)
});
/**
* | output |
* | --- |
* | "The settings of trameria on this PC. They apply to Cloud's screen too." |
*
* @param {Settings_App_Window_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_app_window_description = /** @type {((inputs?: Settings_App_Window_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_App_Window_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_app_window_description(inputs)
	return __ja.settings_app_window_description(inputs)
});
/**
* | output |
* | --- |
* | "Appearance" |
*
* @param {Settings_AppearanceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_appearance = /** @type {((inputs?: Settings_AppearanceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_AppearanceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_appearance(inputs)
	return __ja.settings_appearance(inputs)
});
/**
* | output |
* | --- |
* | "Kept on this device." |
*
* @param {Settings_Appearance_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_appearance_description = /** @type {((inputs?: Settings_Appearance_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Appearance_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_appearance_description(inputs)
	return __ja.settings_appearance_description(inputs)
});
/**
* | output |
* | --- |
* | "Back to settings" |
*
* @param {Settings_Back_To_IndexInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_back_to_index = /** @type {((inputs?: Settings_Back_To_IndexInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Back_To_IndexInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_back_to_index(inputs)
	return __ja.settings_back_to_index(inputs)
});
/**
* | output |
* | --- |
* | "General" |
*
* @param {Settings_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_general = /** @type {((inputs?: Settings_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_general(inputs)
	return __ja.settings_general(inputs)
});
/**
* | output |
* | --- |
* | "Language and time zone. The same on every device." |
*
* @param {Settings_General_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_general_description = /** @type {((inputs?: Settings_General_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_General_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_general_description(inputs)
	return __ja.settings_general_description(inputs)
});
/**
* | output |
* | --- |
* | "Picture, name, language and time zone. The same on every device." |
*
* @param {Settings_General_Description_AccountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_general_description_account = /** @type {((inputs?: Settings_General_Description_AccountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_General_Description_AccountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_general_description_account(inputs)
	return __ja.settings_general_description_account(inputs)
});
/**
* | output |
* | --- |
* | "This app" |
*
* @param {Settings_Group_AppInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_group_app = /** @type {((inputs?: Settings_Group_AppInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Group_AppInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_group_app(inputs)
	return __ja.settings_group_app(inputs)
});
/**
* | output |
* | --- |
* | "Input" |
*
* @param {Settings_InputInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_input = /** @type {((inputs?: Settings_InputInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_InputInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_input(inputs)
	return __ja.settings_input(inputs)
});
/**
* | output |
* | --- |
* | "Kept on this device, since keyboards differ between devices." |
*
* @param {Settings_Input_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_input_description = /** @type {((inputs?: Settings_Input_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Input_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_input_description(inputs)
	return __ja.settings_input_description(inputs)
});
/**
* | output |
* | --- |
* | "Language" |
*
* @param {Settings_LanguageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_language = /** @type {((inputs?: Settings_LanguageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_LanguageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_language(inputs)
	return __ja.settings_language(inputs)
});
/**
* | output |
* | --- |
* | "Match the browser" |
*
* @param {Settings_Language_BrowserInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_language_browser = /** @type {((inputs?: Settings_Language_BrowserInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Language_BrowserInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_language_browser(inputs)
	return __ja.settings_language_browser(inputs)
});
/**
* | output |
* | --- |
* | "Changing it reloads the screen." |
*
* @param {Settings_Language_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_language_note = /** @type {((inputs?: Settings_Language_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Language_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_language_note(inputs)
	return __ja.settings_language_note(inputs)
});
/**
* | output |
* | --- |
* | "Name" |
*
* @param {Settings_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_name = /** @type {((inputs?: Settings_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_name(inputs)
	return __ja.settings_name(inputs)
});
/**
* | output |
* | --- |
* | "Picture" |
*
* @param {Settings_PictureInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_picture = /** @type {((inputs?: Settings_PictureInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_PictureInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_picture(inputs)
	return __ja.settings_picture(inputs)
});
/**
* | output |
* | --- |
* | "Could not save" |
*
* @param {Settings_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_save_failed = /** @type {((inputs?: Settings_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_save_failed(inputs)
	return __ja.settings_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "Send key" |
*
* @param {Settings_Send_KeyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_send_key = /** @type {((inputs?: Settings_Send_KeyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Send_KeyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_send_key(inputs)
	return __ja.settings_send_key(inputs)
});
/**
* | output |
* | --- |
* | "Enter sends" |
*
* @param {Settings_Send_Key_EnterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_send_key_enter = /** @type {((inputs?: Settings_Send_Key_EnterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Send_Key_EnterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_send_key_enter(inputs)
	return __ja.settings_send_key_enter(inputs)
});
/**
* | output |
* | --- |
* | "⌘/Ctrl+Enter sends" |
*
* @param {Settings_Send_Key_ModInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_send_key_mod = /** @type {((inputs?: Settings_Send_Key_ModInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Send_Key_ModInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_send_key_mod(inputs)
	return __ja.settings_send_key_mod(inputs)
});
/**
* | output |
* | --- |
* | "The other one breaks the line." |
*
* @param {Settings_Send_Key_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_send_key_note = /** @type {((inputs?: Settings_Send_Key_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Send_Key_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_send_key_note(inputs)
	return __ja.settings_send_key_note(inputs)
});
/**
* | output |
* | --- |
* | "Theme" |
*
* @param {Settings_ThemeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme = /** @type {((inputs?: Settings_ThemeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_ThemeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_theme(inputs)
	return __ja.settings_theme(inputs)
});
/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Settings_Theme_AutoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme_auto = /** @type {((inputs?: Settings_Theme_AutoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_AutoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_theme_auto(inputs)
	return __ja.settings_theme_auto(inputs)
});
/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Settings_Theme_DarkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme_dark = /** @type {((inputs?: Settings_Theme_DarkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_DarkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_theme_dark(inputs)
	return __ja.settings_theme_dark(inputs)
});
/**
* | output |
* | --- |
* | "Light" |
*
* @param {Settings_Theme_LightInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme_light = /** @type {((inputs?: Settings_Theme_LightInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_LightInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_theme_light(inputs)
	return __ja.settings_theme_light(inputs)
});
/**
* | output |
* | --- |
* | "Auto follows the system." |
*
* @param {Settings_Theme_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_theme_note = /** @type {((inputs?: Settings_Theme_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_theme_note(inputs)
	return __ja.settings_theme_note(inputs)
});
/**
* | output |
* | --- |
* | "Time zone" |
*
* @param {Settings_Time_ZoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_time_zone = /** @type {((inputs?: Settings_Time_ZoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Time_ZoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_time_zone(inputs)
	return __ja.settings_time_zone(inputs)
});
/**
* | output |
* | --- |
* | "Match this device ({zone})" |
*
* @param {Settings_Time_Zone_BrowserInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_time_zone_browser = /** @type {((inputs: Settings_Time_Zone_BrowserInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Time_Zone_BrowserInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_time_zone_browser(inputs)
	return __ja.settings_time_zone_browser(inputs)
});
/**
* | output |
* | --- |
* | "Used to show dates and for due dates and the secretary's jobs." |
*
* @param {Settings_Time_Zone_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_time_zone_note = /** @type {((inputs?: Settings_Time_Zone_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Time_Zone_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.settings_time_zone_note(inputs)
	return __ja.settings_time_zone_note(inputs)
});
/**
* | output |
* | --- |
* | "Account menu" |
*
* @param {Shell_Account_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_account_menu = /** @type {((inputs?: Shell_Account_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Account_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_account_menu(inputs)
	return __ja.shell_account_menu(inputs)
});
/**
* | output |
* | --- |
* | "Back" |
*
* @param {Shell_BackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_back = /** @type {((inputs?: Shell_BackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_BackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_back(inputs)
	return __ja.shell_back(inputs)
});
/**
* | output |
* | --- |
* | "Back to the list" |
*
* @param {Shell_Back_To_ListInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_back_to_list = /** @type {((inputs?: Shell_Back_To_ListInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Back_To_ListInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_back_to_list(inputs)
	return __ja.shell_back_to_list(inputs)
});
/**
* | output |
* | --- |
* | "Clear selection" |
*
* @param {Shell_Clear_PicksInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_clear_picks = /** @type {((inputs?: Shell_Clear_PicksInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Clear_PicksInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_clear_picks(inputs)
	return __ja.shell_clear_picks(inputs)
});
/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Shell_CopiedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_copied = /** @type {((inputs?: Shell_CopiedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_CopiedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_copied(inputs)
	return __ja.shell_copied(inputs)
});
/**
* | output |
* | --- |
* | "Could not copy" |
*
* @param {Shell_Copy_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_copy_failed = /** @type {((inputs?: Shell_Copy_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Copy_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_copy_failed(inputs)
	return __ja.shell_copy_failed(inputs)
});
/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Shell_Copy_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_copy_link = /** @type {((inputs?: Shell_Copy_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Copy_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_copy_link(inputs)
	return __ja.shell_copy_link(inputs)
});
/**
* | output |
* | --- |
* | "If reloading does not help, report it with the line below." |
*
* @param {Shell_Error_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_error_body = /** @type {((inputs?: Shell_Error_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Error_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_error_body(inputs)
	return __ja.shell_error_body(inputs)
});
/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Shell_Error_ReloadInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_error_reload = /** @type {((inputs?: Shell_Error_ReloadInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Error_ReloadInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_error_reload(inputs)
	return __ja.shell_error_reload(inputs)
});
/**
* | output |
* | --- |
* | "This screen could not be shown" |
*
* @param {Shell_Error_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_error_title = /** @type {((inputs?: Shell_Error_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Error_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_error_title(inputs)
	return __ja.shell_error_title(inputs)
});
/**
* | output |
* | --- |
* | "Favorites" |
*
* @param {Shell_FavoritesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites = /** @type {((inputs?: Shell_FavoritesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_FavoritesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites(inputs)
	return __ja.shell_favorites(inputs)
});
/**
* | output |
* | --- |
* | "Add to favorites" |
*
* @param {Shell_Favorites_AddInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_add = /** @type {((inputs?: Shell_Favorites_AddInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_AddInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_add(inputs)
	return __ja.shell_favorites_add(inputs)
});
/**
* | output |
* | --- |
* | "Could not add {title} to favorites" |
*
* @param {Shell_Favorites_Add_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_add_failed = /** @type {((inputs: Shell_Favorites_Add_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Add_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_add_failed(inputs)
	return __ja.shell_favorites_add_failed(inputs)
});
/**
* | output |
* | --- |
* | "Could not create the folder {name}" |
*
* @param {Shell_Favorites_Create_Folder_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_create_folder_failed = /** @type {((inputs: Shell_Favorites_Create_Folder_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Create_Folder_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_create_folder_failed(inputs)
	return __ja.shell_favorites_create_folder_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete folder" |
*
* @param {Shell_Favorites_Delete_FolderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_delete_folder = /** @type {((inputs?: Shell_Favorites_Delete_FolderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Delete_FolderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_delete_folder(inputs)
	return __ja.shell_favorites_delete_folder(inputs)
});
/**
* | output |
* | --- |
* | "The favorites in it move out of the folder." |
*
* @param {Shell_Favorites_Delete_Folder_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_delete_folder_body = /** @type {((inputs?: Shell_Favorites_Delete_Folder_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Delete_Folder_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_delete_folder_body(inputs)
	return __ja.shell_favorites_delete_folder_body(inputs)
});
/**
* | output |
* | --- |
* | "Could not delete the folder {name}" |
*
* @param {Shell_Favorites_Delete_Folder_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_delete_folder_failed = /** @type {((inputs: Shell_Favorites_Delete_Folder_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Delete_Folder_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_delete_folder_failed(inputs)
	return __ja.shell_favorites_delete_folder_failed(inputs)
});
/**
* | output |
* | --- |
* | "Delete the folder {name}" |
*
* @param {Shell_Favorites_Delete_Folder_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_delete_folder_title = /** @type {((inputs: Shell_Favorites_Delete_Folder_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Delete_Folder_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_delete_folder_title(inputs)
	return __ja.shell_favorites_delete_folder_title(inputs)
});
/**
* | output |
* | --- |
* | "Press a star to keep things here" |
*
* @param {Shell_Favorites_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_empty = /** @type {((inputs?: Shell_Favorites_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_empty(inputs)
	return __ja.shell_favorites_empty(inputs)
});
/**
* | output |
* | --- |
* | "Menu of {name}" |
*
* @param {Shell_Favorites_Folder_MenuInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_folder_menu = /** @type {((inputs: Shell_Favorites_Folder_MenuInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Folder_MenuInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_folder_menu(inputs)
	return __ja.shell_favorites_folder_menu(inputs)
});
/**
* | output |
* | --- |
* | "Folder name" |
*
* @param {Shell_Favorites_Folder_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_folder_name = /** @type {((inputs?: Shell_Favorites_Folder_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Folder_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_folder_name(inputs)
	return __ja.shell_favorites_folder_name(inputs)
});
/**
* | output |
* | --- |
* | "Could not move the favorite" |
*
* @param {Shell_Favorites_Move_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_move_failed = /** @type {((inputs?: Shell_Favorites_Move_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Move_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_move_failed(inputs)
	return __ja.shell_favorites_move_failed(inputs)
});
/**
* | output |
* | --- |
* | "New folder" |
*
* @param {Shell_Favorites_New_FolderInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_new_folder = /** @type {((inputs?: Shell_Favorites_New_FolderInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_New_FolderInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_new_folder(inputs)
	return __ja.shell_favorites_new_folder(inputs)
});
/**
* | output |
* | --- |
* | "Remove from favorites" |
*
* @param {Shell_Favorites_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_remove = /** @type {((inputs?: Shell_Favorites_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_remove(inputs)
	return __ja.shell_favorites_remove(inputs)
});
/**
* | output |
* | --- |
* | "Could not remove {title} from favorites" |
*
* @param {Shell_Favorites_Remove_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_remove_failed = /** @type {((inputs: Shell_Favorites_Remove_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Remove_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_remove_failed(inputs)
	return __ja.shell_favorites_remove_failed(inputs)
});
/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Shell_Favorites_RenameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_rename = /** @type {((inputs?: Shell_Favorites_RenameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_RenameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_rename(inputs)
	return __ja.shell_favorites_rename(inputs)
});
/**
* | output |
* | --- |
* | "Could not rename the folder {name}" |
*
* @param {Shell_Favorites_Rename_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_favorites_rename_failed = /** @type {((inputs: Shell_Favorites_Rename_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Favorites_Rename_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_favorites_rename_failed(inputs)
	return __ja.shell_favorites_rename_failed(inputs)
});
/**
* | output |
* | --- |
* | "Fold the sidebar" |
*
* @param {Shell_Fold_SidebarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_fold_sidebar = /** @type {((inputs?: Shell_Fold_SidebarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Fold_SidebarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_fold_sidebar(inputs)
	return __ja.shell_fold_sidebar(inputs)
});
/**
* | output |
* | --- |
* | "Can't connect to the Vault. Your changes will be applied when it reconnects" |
*
* @param {Shell_Hub_AwayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_hub_away = /** @type {((inputs?: Shell_Hub_AwayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Hub_AwayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_hub_away(inputs)
	return __ja.shell_hub_away(inputs)
});
/**
* | output |
* | --- |
* | "Keep the sidebar open" |
*
* @param {Shell_Keep_Sidebar_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_keep_sidebar_open = /** @type {((inputs?: Shell_Keep_Sidebar_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Keep_Sidebar_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_keep_sidebar_open(inputs)
	return __ja.shell_keep_sidebar_open(inputs)
});
/**
* | output |
* | --- |
* | "Auto" |
*
* @param {Shell_Language_AutoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_language_auto = /** @type {((inputs?: Shell_Language_AutoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Language_AutoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_language_auto(inputs)
	return __ja.shell_language_auto(inputs)
});
/**
* | output |
* | --- |
* | "Collapse" |
*
* @param {Shell_List_FoldInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_list_fold = /** @type {((inputs?: Shell_List_FoldInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_List_FoldInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_list_fold(inputs)
	return __ja.shell_list_fold(inputs)
});
/**
* | output |
* | --- |
* | "{count} more" |
*
* @param {Shell_List_Fold_RestInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_list_fold_rest = /** @type {((inputs: Shell_List_Fold_RestInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_List_Fold_RestInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_list_fold_rest(inputs)
	return __ja.shell_list_fold_rest(inputs)
});
/**
* | output |
* | --- |
* | "Narrow the list" |
*
* @param {Shell_List_NarrowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_list_narrow = /** @type {((inputs?: Shell_List_NarrowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_List_NarrowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_list_narrow(inputs)
	return __ja.shell_list_narrow(inputs)
});
/**
* | output |
* | --- |
* | "Narrow by title" |
*
* @param {Shell_List_Narrow_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_list_narrow_title = /** @type {((inputs?: Shell_List_Narrow_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_List_Narrow_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_list_narrow_title(inputs)
	return __ja.shell_list_narrow_title(inputs)
});
/**
* | output |
* | --- |
* | "Nothing matches" |
*
* @param {Shell_List_No_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_list_no_match = /** @type {((inputs?: Shell_List_No_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_List_No_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_list_no_match(inputs)
	return __ja.shell_list_no_match(inputs)
});
/**
* | output |
* | --- |
* | "Me" |
*
* @param {Shell_MeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me = /** @type {((inputs?: Shell_MeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_MeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me(inputs)
	return __ja.shell_me(inputs)
});
/**
* | output |
* | --- |
* | "Open settings" |
*
* @param {Shell_Me_Away_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_away_settings = /** @type {((inputs?: Shell_Me_Away_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_Away_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_away_settings(inputs)
	return __ja.shell_me_away_settings(inputs)
});
/**
* | output |
* | --- |
* | "Inbox, Cases, People, Agents and Documents will be listed here." |
*
* @param {Shell_Me_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_empty = /** @type {((inputs?: Shell_Me_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_empty(inputs)
	return __ja.shell_me_empty(inputs)
});
/**
* | output |
* | --- |
* | "Almost done" |
*
* @param {Shell_Me_Moving_AlmostInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_moving_almost = /** @type {((inputs?: Shell_Me_Moving_AlmostInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_Moving_AlmostInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_moving_almost(inputs)
	return __ja.shell_me_moving_almost(inputs)
});
/**
* | output |
* | --- |
* | "{percent}% · {left}" |
*
* @param {Shell_Me_Moving_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_moving_done = /** @type {((inputs: Shell_Me_Moving_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_Moving_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_moving_done(inputs)
	return __ja.shell_me_moving_done(inputs)
});
/**
* | output |
* | --- |
* | "Working out the time left" |
*
* @param {Shell_Me_Moving_MeasuringInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_moving_measuring = /** @type {((inputs?: Shell_Me_Moving_MeasuringInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_Moving_MeasuringInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_moving_measuring(inputs)
	return __ja.shell_me_moving_measuring(inputs)
});
/**
* | output |
* | --- |
* | "About {minutes} minutes left" |
*
* @param {Shell_Me_Moving_MinutesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_moving_minutes = /** @type {((inputs: Shell_Me_Moving_MinutesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_Moving_MinutesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_moving_minutes(inputs)
	return __ja.shell_me_moving_minutes(inputs)
});
/**
* | output |
* | --- |
* | "How far personal data has moved" |
*
* @param {Shell_Me_Moving_ProgressInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_moving_progress = /** @type {((inputs?: Shell_Me_Moving_ProgressInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_Moving_ProgressInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_moving_progress(inputs)
	return __ja.shell_me_moving_progress(inputs)
});
/**
* | output |
* | --- |
* | "About a minute left" |
*
* @param {Shell_Me_Moving_Under_MinuteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_me_moving_under_minute = /** @type {((inputs?: Shell_Me_Moving_Under_MinuteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Me_Moving_Under_MinuteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_me_moving_under_minute(inputs)
	return __ja.shell_me_moving_under_minute(inputs)
});
/**
* | output |
* | --- |
* | "The URL is wrong, or it was deleted." |
*
* @param {Shell_Not_Found_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_not_found_body = /** @type {((inputs?: Shell_Not_Found_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Not_Found_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_not_found_body(inputs)
	return __ja.shell_not_found_body(inputs)
});
/**
* | output |
* | --- |
* | "Not found" |
*
* @param {Shell_Not_Found_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_not_found_title = /** @type {((inputs?: Shell_Not_Found_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Not_Found_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_not_found_title(inputs)
	return __ja.shell_not_found_title(inputs)
});
/**
* | output |
* | --- |
* | "Open the sidebar" |
*
* @param {Shell_Open_SidebarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_open_sidebar = /** @type {((inputs?: Shell_Open_SidebarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Open_SidebarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_open_sidebar(inputs)
	return __ja.shell_open_sidebar(inputs)
});
/**
* | output |
* | --- |
* | "The workspaces' documents, spaces, DMs and issues are not included." |
*
* @param {Shell_Personal_Data_Not_WorkspaceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_personal_data_not_workspace = /** @type {((inputs?: Shell_Personal_Data_Not_WorkspaceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Personal_Data_Not_WorkspaceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_personal_data_not_workspace(inputs)
	return __ja.shell_personal_data_not_workspace(inputs)
});
/**
* | output |
* | --- |
* | "Personal documents" |
*
* @param {Shell_Personal_DocumentsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_personal_documents = /** @type {((inputs?: Shell_Personal_DocumentsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Personal_DocumentsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_personal_documents(inputs)
	return __ja.shell_personal_documents(inputs)
});
/**
* | output |
* | --- |
* | "Saved in Cloud. Only you can see the items here" |
*
* @param {Shell_Personal_In_CloudInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_personal_in_cloud = /** @type {((inputs?: Shell_Personal_In_CloudInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Personal_In_CloudInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_personal_in_cloud(inputs)
	return __ja.shell_personal_in_cloud(inputs)
});
/**
* | output |
* | --- |
* | "Saved in Vault. Only you can see the items here" |
*
* @param {Shell_Personal_In_VaultInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_personal_in_vault = /** @type {((inputs?: Shell_Personal_In_VaultInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Personal_In_VaultInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_personal_in_vault(inputs)
	return __ja.shell_personal_in_vault(inputs)
});
/**
* | output |
* | --- |
* | "Only you can see the items here" |
*
* @param {Shell_Personal_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_personal_only = /** @type {((inputs?: Shell_Personal_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Personal_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_personal_only(inputs)
	return __ja.shell_personal_only(inputs)
});
/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Shell_Pick_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_pick_actions = /** @type {((inputs?: Shell_Pick_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Pick_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_pick_actions(inputs)
	return __ja.shell_pick_actions(inputs)
});
/**
* | output |
* | --- |
* | "{base} ({n})" |
*
* @param {Shell_Pick_Count_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_pick_count_label = /** @type {((inputs: Shell_Pick_Count_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Pick_Count_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_pick_count_label(inputs)
	return __ja.shell_pick_count_label(inputs)
});
/**
* | output |
* | --- |
* | "," |
*
* @param {Shell_Pick_Names_JoinInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_pick_names_join = /** @type {((inputs?: Shell_Pick_Names_JoinInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Pick_Names_JoinInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_pick_names_join(inputs)
	return __ja.shell_pick_names_join(inputs)
});
/**
* | output |
* | --- |
* | "{head}, and {rest} more" |
*
* @param {Shell_Pick_Names_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_pick_names_more = /** @type {((inputs: Shell_Pick_Names_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Pick_Names_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_pick_names_more(inputs)
	return __ja.shell_pick_names_more(inputs)
});
/**
* | output |
* | --- |
* | "\"{title}\"" |
*
* @param {Shell_Pick_QuotedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_pick_quoted = /** @type {((inputs: Shell_Pick_QuotedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Pick_QuotedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_pick_quoted(inputs)
	return __ja.shell_pick_quoted(inputs)
});
/**
* | output |
* | --- |
* | "Select {title}" |
*
* @param {Shell_Pick_RowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_pick_row = /** @type {((inputs: Shell_Pick_RowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Pick_RowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_pick_row(inputs)
	return __ja.shell_pick_row(inputs)
});
/**
* | output |
* | --- |
* | "Actions for selection" |
*
* @param {Shell_Picked_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_picked_actions = /** @type {((inputs?: Shell_Picked_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Picked_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_picked_actions(inputs)
	return __ja.shell_picked_actions(inputs)
});
/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Shell_Picked_CountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_picked_count = /** @type {((inputs: Shell_Picked_CountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Picked_CountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_picked_count(inputs)
	return __ja.shell_picked_count(inputs)
});
/**
* | output |
* | --- |
* | "Personal data" |
*
* @param {Shell_Rail_PersonalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_rail_personal = /** @type {((inputs?: Shell_Rail_PersonalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Rail_PersonalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_rail_personal(inputs)
	return __ja.shell_rail_personal(inputs)
});
/**
* | output |
* | --- |
* | "Sidebar width" |
*
* @param {Shell_Resize_SidebarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_resize_sidebar = /** @type {((inputs?: Shell_Resize_SidebarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Resize_SidebarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_resize_sidebar(inputs)
	return __ja.shell_resize_sidebar(inputs)
});
/**
* | output |
* | --- |
* | "Weaving…" |
*
* @param {Shell_Route_PendingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_route_pending = /** @type {((inputs?: Shell_Route_PendingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Route_PendingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_route_pending(inputs)
	return __ja.shell_route_pending(inputs)
});
/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Shell_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_settings = /** @type {((inputs?: Shell_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_settings(inputs)
	return __ja.shell_settings(inputs)
});
/**
* | output |
* | --- |
* | "Close settings" |
*
* @param {Shell_Settings_BackInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_settings_back = /** @type {((inputs?: Shell_Settings_BackInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Settings_BackInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_settings_back(inputs)
	return __ja.shell_settings_back(inputs)
});
/**
* | output |
* | --- |
* | "Your own settings, for every screen." |
*
* @param {Shell_Settings_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_settings_description = /** @type {((inputs?: Shell_Settings_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Settings_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_settings_description(inputs)
	return __ja.shell_settings_description(inputs)
});
/**
* | output |
* | --- |
* | "No settings match" |
*
* @param {Shell_Settings_No_MatchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_settings_no_match = /** @type {((inputs?: Shell_Settings_No_MatchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Settings_No_MatchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_settings_no_match(inputs)
	return __ja.shell_settings_no_match(inputs)
});
/**
* | output |
* | --- |
* | "Search settings" |
*
* @param {Shell_Settings_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_settings_search = /** @type {((inputs?: Shell_Settings_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Settings_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_settings_search(inputs)
	return __ja.shell_settings_search(inputs)
});
/**
* | output |
* | --- |
* | "Keyboard shortcuts" |
*
* @param {Shell_ShortcutsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_shortcuts = /** @type {((inputs?: Shell_ShortcutsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_ShortcutsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_shortcuts(inputs)
	return __ja.shell_shortcuts(inputs)
});
/**
* | output |
* | --- |
* | "Create" |
*
* @param {Shell_Shortcuts_Group_CreateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_shortcuts_group_create = /** @type {((inputs?: Shell_Shortcuts_Group_CreateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Shortcuts_Group_CreateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_shortcuts_group_create(inputs)
	return __ja.shell_shortcuts_group_create(inputs)
});
/**
* | output |
* | --- |
* | "General" |
*
* @param {Shell_Shortcuts_Group_GeneralInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_shortcuts_group_general = /** @type {((inputs?: Shell_Shortcuts_Group_GeneralInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Shortcuts_Group_GeneralInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_shortcuts_group_general(inputs)
	return __ja.shell_shortcuts_group_general(inputs)
});
/**
* | output |
* | --- |
* | "Navigate" |
*
* @param {Shell_Shortcuts_Group_NavigateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_shortcuts_group_navigate = /** @type {((inputs?: Shell_Shortcuts_Group_NavigateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Shortcuts_Group_NavigateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_shortcuts_group_navigate(inputs)
	return __ja.shell_shortcuts_group_navigate(inputs)
});
/**
* | output |
* | --- |
* | "View" |
*
* @param {Shell_Shortcuts_Group_ViewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_shortcuts_group_view = /** @type {((inputs?: Shell_Shortcuts_Group_ViewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Shortcuts_Group_ViewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_shortcuts_group_view(inputs)
	return __ja.shell_shortcuts_group_view(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Shell_Side_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_side_close = /** @type {((inputs?: Shell_Side_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Side_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_side_close(inputs)
	return __ja.shell_side_close(inputs)
});
/**
* | output |
* | --- |
* | "Open on its own screen" |
*
* @param {Shell_Side_Open_FullInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_side_open_full = /** @type {((inputs?: Shell_Side_Open_FullInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Side_Open_FullInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_side_open_full(inputs)
	return __ja.shell_side_open_full(inputs)
});
/**
* | output |
* | --- |
* | "Fold or expand the sidebar" |
*
* @param {Shell_Toggle_SidebarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_toggle_sidebar = /** @type {((inputs?: Shell_Toggle_SidebarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Toggle_SidebarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_toggle_sidebar(inputs)
	return __ja.shell_toggle_sidebar(inputs)
});
/**
* | output |
* | --- |
* | "Can't connect to the Vault. Only screens opened before can be shown" |
*
* @param {Shell_Unreachable_Cannot_OpenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_unreachable_cannot_open = /** @type {((inputs?: Shell_Unreachable_Cannot_OpenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Unreachable_Cannot_OpenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_unreachable_cannot_open(inputs)
	return __ja.shell_unreachable_cannot_open(inputs)
});
/**
* | output |
* | --- |
* | "Full width" |
*
* @param {Shell_WideInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_wide = /** @type {((inputs?: Shell_WideInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_WideInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_wide(inputs)
	return __ja.shell_wide(inputs)
});
/**
* | output |
* | --- |
* | "Exit full width" |
*
* @param {Shell_Wide_OffInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_wide_off = /** @type {((inputs?: Shell_Wide_OffInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Wide_OffInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_wide_off(inputs)
	return __ja.shell_wide_off(inputs)
});
/**
* | output |
* | --- |
* | "Toggle full width" |
*
* @param {Shell_Wide_ToggleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_wide_toggle = /** @type {((inputs?: Shell_Wide_ToggleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Wide_ToggleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_wide_toggle(inputs)
	return __ja.shell_wide_toggle(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Shell_Window_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_window_close = /** @type {((inputs?: Shell_Window_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Window_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_window_close(inputs)
	return __ja.shell_window_close(inputs)
});
/**
* | output |
* | --- |
* | "Maximize" |
*
* @param {Shell_Window_MaximizeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_window_maximize = /** @type {((inputs?: Shell_Window_MaximizeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Window_MaximizeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_window_maximize(inputs)
	return __ja.shell_window_maximize(inputs)
});
/**
* | output |
* | --- |
* | "Minimize" |
*
* @param {Shell_Window_MinimizeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_window_minimize = /** @type {((inputs?: Shell_Window_MinimizeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Window_MinimizeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_window_minimize(inputs)
	return __ja.shell_window_minimize(inputs)
});
/**
* | output |
* | --- |
* | "Restore" |
*
* @param {Shell_Window_RestoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_window_restore = /** @type {((inputs?: Shell_Window_RestoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Window_RestoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_window_restore(inputs)
	return __ja.shell_window_restore(inputs)
});
/**
* | output |
* | --- |
* | "Change workspace ({name})" |
*
* @param {Shell_Workspace_ChangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_change = /** @type {((inputs: Shell_Workspace_ChangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_ChangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_change(inputs)
	return __ja.shell_workspace_change(inputs)
});
/**
* | output |
* | --- |
* | "Change workspaces ({names})" |
*
* @param {Shell_Workspace_Change_ManyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_change_many = /** @type {((inputs: Shell_Workspace_Change_ManyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_Change_ManyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_change_many(inputs)
	return __ja.shell_workspace_change_many(inputs)
});
/**
* | output |
* | --- |
* | "WS" |
*
* @param {Shell_Workspace_ColInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_col = /** @type {((inputs?: Shell_Workspace_ColInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_ColInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_col(inputs)
	return __ja.shell_workspace_col(inputs)
});
/**
* | output |
* | --- |
* | "Could not change the workspace" |
*
* @param {Shell_Workspace_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_failed = /** @type {((inputs?: Shell_Workspace_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_failed(inputs)
	return __ja.shell_workspace_failed(inputs)
});
/**
* | output |
* | --- |
* | "{name} (left workspace)" |
*
* @param {Shell_Workspace_LeftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_left = /** @type {((inputs: Shell_Workspace_LeftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_LeftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_left(inputs)
	return __ja.shell_workspace_left(inputs)
});
/**
* | output |
* | --- |
* | "Not connected to Cloud, so it cannot be changed" |
*
* @param {Shell_Workspace_OfflineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_offline = /** @type {((inputs?: Shell_Workspace_OfflineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_OfflineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_offline(inputs)
	return __ja.shell_workspace_offline(inputs)
});
/**
* | output |
* | --- |
* | "Take out of workspace" |
*
* @param {Shell_Workspace_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_remove = /** @type {((inputs?: Shell_Workspace_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_remove(inputs)
	return __ja.shell_workspace_remove(inputs)
});
/**
* | output |
* | --- |
* | "Choose a workspace" |
*
* @param {Shell_Workspace_SetInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const shell_workspace_set = /** @type {((inputs?: Shell_Workspace_SetInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Workspace_SetInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.shell_workspace_set(inputs)
	return __ja.shell_workspace_set(inputs)
});
/**
* | output |
* | --- |
* | "Connected accounts" |
*
* @param {Timeblocker_AccountsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_accounts = /** @type {((inputs?: Timeblocker_AccountsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_AccountsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_accounts(inputs)
	return __ja.timeblocker_accounts(inputs)
});
/**
* | output |
* | --- |
* | "Chat ran" |
*
* @param {Timeblocker_Activity_Agent_RunInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_activity_agent_run = /** @type {((inputs?: Timeblocker_Activity_Agent_RunInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Activity_Agent_RunInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_activity_agent_run(inputs)
	return __ja.timeblocker_activity_agent_run(inputs)
});
/**
* | output |
* | --- |
* | "Case done" |
*
* @param {Timeblocker_Activity_Case_ClosedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_activity_case_closed = /** @type {((inputs?: Timeblocker_Activity_Case_ClosedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Activity_Case_ClosedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_activity_case_closed(inputs)
	return __ja.timeblocker_activity_case_closed(inputs)
});
/**
* | output |
* | --- |
* | "Action done" |
*
* @param {Timeblocker_Activity_Step_ClosedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_activity_step_closed = /** @type {((inputs?: Timeblocker_Activity_Step_ClosedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Activity_Step_ClosedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_activity_step_closed(inputs)
	return __ja.timeblocker_activity_step_closed(inputs)
});
/**
* | output |
* | --- |
* | "Add Block" |
*
* @param {Timeblocker_Add_BlockInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_add_block = /** @type {((inputs?: Timeblocker_Add_BlockInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Add_BlockInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_add_block(inputs)
	return __ja.timeblocker_add_block(inputs)
});
/**
* | output |
* | --- |
* | "Add lane" |
*
* @param {Timeblocker_Add_LaneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_add_lane = /** @type {((inputs?: Timeblocker_Add_LaneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Add_LaneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_add_lane(inputs)
	return __ja.timeblocker_add_lane(inputs)
});
/**
* | output |
* | --- |
* | "All day" |
*
* @param {Timeblocker_All_DayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_all_day = /** @type {((inputs?: Timeblocker_All_DayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_All_DayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_all_day(inputs)
	return __ja.timeblocker_all_day(inputs)
});
/**
* | output |
* | --- |
* | "Ended" |
*
* @param {Timeblocker_Block_EndedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_block_ended = /** @type {((inputs?: Timeblocker_Block_EndedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Block_EndedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_block_ended(inputs)
	return __ja.timeblocker_block_ended(inputs)
});
/**
* | output |
* | --- |
* | "{title} ({start}–{end})" |
*
* @param {Timeblocker_Block_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_block_label = /** @type {((inputs: Timeblocker_Block_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Block_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_block_label(inputs)
	return __ja.timeblocker_block_label(inputs)
});
/**
* | output |
* | --- |
* | "Delete Block" |
*
* @param {Timeblocker_Block_RemoveInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_block_remove = /** @type {((inputs?: Timeblocker_Block_RemoveInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Block_RemoveInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_block_remove(inputs)
	return __ja.timeblocker_block_remove(inputs)
});
/**
* | output |
* | --- |
* | "Calendar" |
*
* @param {Timeblocker_CalendarInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_calendar = /** @type {((inputs?: Timeblocker_CalendarInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_CalendarInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_calendar(inputs)
	return __ja.timeblocker_calendar(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't read {name}" |
*
* @param {Timeblocker_Calendar_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_calendar_error = /** @type {((inputs: Timeblocker_Calendar_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Calendar_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_calendar_error(inputs)
	return __ja.timeblocker_calendar_error(inputs)
});
/**
* | output |
* | --- |
* | "Calendar settings" |
*
* @param {Timeblocker_Calendar_SettingsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_calendar_settings = /** @type {((inputs?: Timeblocker_Calendar_SettingsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Calendar_SettingsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_calendar_settings(inputs)
	return __ja.timeblocker_calendar_settings(inputs)
});
/**
* | output |
* | --- |
* | "Calendars" |
*
* @param {Timeblocker_CalendarsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_calendars = /** @type {((inputs?: Timeblocker_CalendarsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_CalendarsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_calendars(inputs)
	return __ja.timeblocker_calendars(inputs)
});
/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Timeblocker_CancelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_cancel = /** @type {((inputs?: Timeblocker_CancelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_CancelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_cancel(inputs)
	return __ja.timeblocker_cancel(inputs)
});
/**
* | output |
* | --- |
* | "Add whole Case" |
*
* @param {Timeblocker_Case_Add_WholeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_case_add_whole = /** @type {((inputs?: Timeblocker_Case_Add_WholeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Case_Add_WholeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_case_add_whole(inputs)
	return __ja.timeblocker_case_add_whole(inputs)
});
/**
* | output |
* | --- |
* | "Whole Case" |
*
* @param {Timeblocker_Case_WholeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_case_whole = /** @type {((inputs?: Timeblocker_Case_WholeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Case_WholeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_case_whole(inputs)
	return __ja.timeblocker_case_whole(inputs)
});
/**
* | output |
* | --- |
* | "Cases" |
*
* @param {Timeblocker_CasesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_cases = /** @type {((inputs?: Timeblocker_CasesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_CasesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_cases(inputs)
	return __ja.timeblocker_cases(inputs)
});
/**
* | output |
* | --- |
* | "Put off" |
*
* @param {Timeblocker_Change_DeferredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_change_deferred = /** @type {((inputs?: Timeblocker_Change_DeferredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Change_DeferredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_change_deferred(inputs)
	return __ja.timeblocker_change_deferred(inputs)
});
/**
* | output |
* | --- |
* | "Changed" |
*
* @param {Timeblocker_Change_MovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_change_moved = /** @type {((inputs?: Timeblocker_Change_MovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Change_MovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_change_moved(inputs)
	return __ja.timeblocker_change_moved(inputs)
});
/**
* | output |
* | --- |
* | "Close" |
*
* @param {Timeblocker_CloseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_close = /** @type {((inputs?: Timeblocker_CloseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_CloseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_close(inputs)
	return __ja.timeblocker_close(inputs)
});
/**
* | output |
* | --- |
* | "Color" |
*
* @param {Timeblocker_ColorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_color = /** @type {((inputs?: Timeblocker_ColorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_ColorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_color(inputs)
	return __ja.timeblocker_color(inputs)
});
/**
* | output |
* | --- |
* | "Color of {name}" |
*
* @param {Timeblocker_Color_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_color_of = /** @type {((inputs: Timeblocker_Color_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Color_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_color_of(inputs)
	return __ja.timeblocker_color_of(inputs)
});
/**
* | output |
* | --- |
* | "Choose a Google account on the consent screen. It doesn't have to be the one you sign in with" |
*
* @param {Timeblocker_Connect_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_connect_description = /** @type {((inputs?: Timeblocker_Connect_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Connect_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_connect_description(inputs)
	return __ja.timeblocker_connect_description(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't connect Google Calendar" |
*
* @param {Timeblocker_Connect_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_connect_failed = /** @type {((inputs?: Timeblocker_Connect_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Connect_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_connect_failed(inputs)
	return __ja.timeblocker_connect_failed(inputs)
});
/**
* | output |
* | --- |
* | "Connect Google Calendar" |
*
* @param {Timeblocker_Connect_GoogleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_connect_google = /** @type {((inputs?: Timeblocker_Connect_GoogleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Connect_GoogleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_connect_google(inputs)
	return __ja.timeblocker_connect_google(inputs)
});
/**
* | output |
* | --- |
* | "Connect another account" |
*
* @param {Timeblocker_Connect_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_connect_more = /** @type {((inputs?: Timeblocker_Connect_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Connect_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_connect_more(inputs)
	return __ja.timeblocker_connect_more(inputs)
});
/**
* | output |
* | --- |
* | "Add" |
*
* @param {Timeblocker_Create_EventInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_create_event = /** @type {((inputs?: Timeblocker_Create_EventInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Create_EventInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_create_event(inputs)
	return __ja.timeblocker_create_event(inputs)
});
/**
* | output |
* | --- |
* | "Date" |
*
* @param {Timeblocker_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_date = /** @type {((inputs?: Timeblocker_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_date(inputs)
	return __ja.timeblocker_date(inputs)
});
/**
* | output |
* | --- |
* | "Delete event" |
*
* @param {Timeblocker_Delete_EventInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_delete_event = /** @type {((inputs?: Timeblocker_Delete_EventInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Delete_EventInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_delete_event(inputs)
	return __ja.timeblocker_delete_event(inputs)
});
/**
* | output |
* | --- |
* | "Delete \"{title}\" from Google Calendar?" |
*
* @param {Timeblocker_Delete_Event_ConfirmInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_delete_event_confirm = /** @type {((inputs: Timeblocker_Delete_Event_ConfirmInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Delete_Event_ConfirmInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_delete_event_confirm(inputs)
	return __ja.timeblocker_delete_event_confirm(inputs)
});
/**
* | output |
* | --- |
* | "Delete lane" |
*
* @param {Timeblocker_Delete_LaneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_delete_lane = /** @type {((inputs?: Timeblocker_Delete_LaneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Delete_LaneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_delete_lane(inputs)
	return __ja.timeblocker_delete_lane(inputs)
});
/**
* | output |
* | --- |
* | "Block" |
*
* @param {Timeblocker_DetailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_detail = /** @type {((inputs?: Timeblocker_DetailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_DetailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_detail(inputs)
	return __ja.timeblocker_detail(inputs)
});
/**
* | output |
* | --- |
* | "Moved" |
*
* @param {Timeblocker_Did_ActivityInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_did_activity = /** @type {((inputs?: Timeblocker_Did_ActivityInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Did_ActivityInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_did_activity(inputs)
	return __ja.timeblocker_did_activity(inputs)
});
/**
* | output |
* | --- |
* | "Nothing" |
*
* @param {Timeblocker_Did_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_did_none = /** @type {((inputs?: Timeblocker_Did_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Did_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_did_none(inputs)
	return __ja.timeblocker_did_none(inputs)
});
/**
* | output |
* | --- |
* | "Started" |
*
* @param {Timeblocker_Did_StartedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_did_started = /** @type {((inputs?: Timeblocker_Did_StartedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Did_StartedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_did_started(inputs)
	return __ja.timeblocker_did_started(inputs)
});
/**
* | output |
* | --- |
* | "Upcoming" |
*
* @param {Timeblocker_Did_UpcomingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_did_upcoming = /** @type {((inputs?: Timeblocker_Did_UpcomingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Did_UpcomingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_did_upcoming(inputs)
	return __ja.timeblocker_did_upcoming(inputs)
});
/**
* | output |
* | --- |
* | "Disconnect" |
*
* @param {Timeblocker_DisconnectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_disconnect = /** @type {((inputs?: Timeblocker_DisconnectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_DisconnectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_disconnect(inputs)
	return __ja.timeblocker_disconnect(inputs)
});
/**
* | output |
* | --- |
* | "Its calendars no longer show in TimeBlocker." |
*
* @param {Timeblocker_Disconnect_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_disconnect_body = /** @type {((inputs?: Timeblocker_Disconnect_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Disconnect_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_disconnect_body(inputs)
	return __ja.timeblocker_disconnect_body(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't disconnect \"{email}\"" |
*
* @param {Timeblocker_Disconnect_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_disconnect_failed = /** @type {((inputs: Timeblocker_Disconnect_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Disconnect_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_disconnect_failed(inputs)
	return __ja.timeblocker_disconnect_failed(inputs)
});
/**
* | output |
* | --- |
* | "Disconnect \"{email}\"" |
*
* @param {Timeblocker_Disconnect_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_disconnect_title = /** @type {((inputs: Timeblocker_Disconnect_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Disconnect_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_disconnect_title(inputs)
	return __ja.timeblocker_disconnect_title(inputs)
});
/**
* | output |
* | --- |
* | "Done" |
*
* @param {Timeblocker_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_done = /** @type {((inputs?: Timeblocker_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_done(inputs)
	return __ja.timeblocker_done(inputs)
});
/**
* | output |
* | --- |
* | "No Actions finished on this day" |
*
* @param {Timeblocker_Empty_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_empty_done = /** @type {((inputs?: Timeblocker_Empty_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Empty_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_empty_done(inputs)
	return __ja.timeblocker_empty_done(inputs)
});
/**
* | output |
* | --- |
* | "No Actions planned for this day" |
*
* @param {Timeblocker_Empty_TodoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_empty_todo = /** @type {((inputs?: Timeblocker_Empty_TodoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Empty_TodoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_empty_todo(inputs)
	return __ja.timeblocker_empty_todo(inputs)
});
/**
* | output |
* | --- |
* | "End" |
*
* @param {Timeblocker_EndInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_end = /** @type {((inputs?: Timeblocker_EndInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_EndInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_end(inputs)
	return __ja.timeblocker_end(inputs)
});
/**
* | output |
* | --- |
* | "End" |
*
* @param {Timeblocker_End_BlockInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_end_block = /** @type {((inputs?: Timeblocker_End_BlockInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_End_BlockInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_end_block(inputs)
	return __ja.timeblocker_end_block(inputs)
});
/**
* | output |
* | --- |
* | "End date" |
*
* @param {Timeblocker_End_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_end_date = /** @type {((inputs?: Timeblocker_End_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_End_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_end_date(inputs)
	return __ja.timeblocker_end_date(inputs)
});
/**
* | output |
* | --- |
* | "The end date must be on or after the start date" |
*
* @param {Timeblocker_Event_Bad_DatesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_event_bad_dates = /** @type {((inputs?: Timeblocker_Event_Bad_DatesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Event_Bad_DatesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_event_bad_dates(inputs)
	return __ja.timeblocker_event_bad_dates(inputs)
});
/**
* | output |
* | --- |
* | "The event was changed in the calendar, so the latest is shown" |
*
* @param {Timeblocker_Event_ConflictInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_event_conflict = /** @type {((inputs?: Timeblocker_Event_ConflictInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Event_ConflictInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_event_conflict(inputs)
	return __ja.timeblocker_event_conflict(inputs)
});
/**
* | output |
* | --- |
* | "Event details" |
*
* @param {Timeblocker_Event_DetailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_event_detail = /** @type {((inputs?: Timeblocker_Event_DetailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Event_DetailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_event_detail(inputs)
	return __ja.timeblocker_event_detail(inputs)
});
/**
* | output |
* | --- |
* | "Event name" |
*
* @param {Timeblocker_Event_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_event_title = /** @type {((inputs?: Timeblocker_Event_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Event_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_event_title(inputs)
	return __ja.timeblocker_event_title(inputs)
});
/**
* | output |
* | --- |
* | "Events must be at least 15 minutes long" |
*
* @param {Timeblocker_Event_Too_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_event_too_short = /** @type {((inputs?: Timeblocker_Event_Too_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Event_Too_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_event_too_short(inputs)
	return __ja.timeblocker_event_too_short(inputs)
});
/**
* | output |
* | --- |
* | "Go to TimeBlocker" |
*
* @param {Timeblocker_GoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_go = /** @type {((inputs?: Timeblocker_GoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_GoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_go(inputs)
	return __ja.timeblocker_go(inputs)
});
/**
* | output |
* | --- |
* | "Today" |
*
* @param {Timeblocker_Go_TodayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_go_today = /** @type {((inputs?: Timeblocker_Go_TodayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Go_TodayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_go_today(inputs)
	return __ja.timeblocker_go_today(inputs)
});
/**
* | output |
* | --- |
* | "Connected Google Calendar" |
*
* @param {Timeblocker_Google_ConnectedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_google_connected = /** @type {((inputs?: Timeblocker_Google_ConnectedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Google_ConnectedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_google_connected(inputs)
	return __ja.timeblocker_google_connected(inputs)
});
/**
* | output |
* | --- |
* | "Google didn't grant access, so nothing was connected" |
*
* @param {Timeblocker_Google_DeniedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_google_denied = /** @type {((inputs?: Timeblocker_Google_DeniedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Google_DeniedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_google_denied(inputs)
	return __ja.timeblocker_google_denied(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't connect Google Calendar. Please try again" |
*
* @param {Timeblocker_Google_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_google_failed = /** @type {((inputs?: Timeblocker_Google_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Google_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_google_failed(inputs)
	return __ja.timeblocker_google_failed(inputs)
});
/**
* | output |
* | --- |
* | "Access to the calendar wasn't granted. Connect again and check the calendar items on the consent screen" |
*
* @param {Timeblocker_Google_Not_GrantedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_google_not_granted = /** @type {((inputs?: Timeblocker_Google_Not_GrantedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Google_Not_GrantedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_google_not_granted(inputs)
	return __ja.timeblocker_google_not_granted(inputs)
});
/**
* | output |
* | --- |
* | "Google Calendar isn't available on this server" |
*
* @param {Timeblocker_Google_UnavailableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_google_unavailable = /** @type {((inputs?: Timeblocker_Google_UnavailableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Google_UnavailableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_google_unavailable(inputs)
	return __ja.timeblocker_google_unavailable(inputs)
});
/**
* | output |
* | --- |
* | "A different Google account was chosen on the consent screen. Choose the account to connect again" |
*
* @param {Timeblocker_Google_Wrong_AccountInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_google_wrong_account = /** @type {((inputs?: Timeblocker_Google_Wrong_AccountInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Google_Wrong_AccountInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_google_wrong_account(inputs)
	return __ja.timeblocker_google_wrong_account(inputs)
});
/**
* | output |
* | --- |
* | "After {date}" |
*
* @param {Timeblocker_Group_AfterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_group_after = /** @type {((inputs: Timeblocker_Group_AfterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Group_AfterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_group_after(inputs)
	return __ja.timeblocker_group_after(inputs)
});
/**
* | output |
* | --- |
* | "Tomorrow and later" |
*
* @param {Timeblocker_Group_After_TodayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_group_after_today = /** @type {((inputs?: Timeblocker_Group_After_TodayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Group_After_TodayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_group_after_today(inputs)
	return __ja.timeblocker_group_after_today(inputs)
});
/**
* | output |
* | --- |
* | "Before {date}" |
*
* @param {Timeblocker_Group_BeforeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_group_before = /** @type {((inputs: Timeblocker_Group_BeforeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Group_BeforeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_group_before(inputs)
	return __ja.timeblocker_group_before(inputs)
});
/**
* | output |
* | --- |
* | "Before today" |
*
* @param {Timeblocker_Group_Before_TodayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_group_before_today = /** @type {((inputs?: Timeblocker_Group_Before_TodayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Group_Before_TodayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_group_before_today(inputs)
	return __ja.timeblocker_group_before_today(inputs)
});
/**
* | output |
* | --- |
* | "Today" |
*
* @param {Timeblocker_Group_TodayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_group_today = /** @type {((inputs?: Timeblocker_Group_TodayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Group_TodayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_group_today(inputs)
	return __ja.timeblocker_group_today(inputs)
});
/**
* | output |
* | --- |
* | "No date" |
*
* @param {Timeblocker_Group_UndatedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_group_undated = /** @type {((inputs?: Timeblocker_Group_UndatedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Group_UndatedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_group_undated(inputs)
	return __ja.timeblocker_group_undated(inputs)
});
/**
* | output |
* | --- |
* | "Start “{title}”" |
*
* @param {Timeblocker_Item_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_item_start = /** @type {((inputs: Timeblocker_Item_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Item_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_item_start(inputs)
	return __ja.timeblocker_item_start(inputs)
});
/**
* | output |
* | --- |
* | "Stop “{title}”" |
*
* @param {Timeblocker_Item_StopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_item_stop = /** @type {((inputs: Timeblocker_Item_StopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Item_StopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_item_stop(inputs)
	return __ja.timeblocker_item_stop(inputs)
});
/**
* | output |
* | --- |
* | "Working" |
*
* @param {Timeblocker_Item_WorkingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_item_working = /** @type {((inputs?: Timeblocker_Item_WorkingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Item_WorkingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_item_working(inputs)
	return __ja.timeblocker_item_working(inputs)
});
/**
* | output |
* | --- |
* | "Put it in this Block" |
*
* @param {Timeblocker_Join_HereInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_join_here = /** @type {((inputs?: Timeblocker_Join_HereInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Join_HereInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_join_here(inputs)
	return __ja.timeblocker_join_here(inputs)
});
/**
* | output |
* | --- |
* | "Join meeting" |
*
* @param {Timeblocker_Join_MeetingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_join_meeting = /** @type {((inputs?: Timeblocker_Join_MeetingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Join_MeetingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_join_meeting(inputs)
	return __ja.timeblocker_join_meeting(inputs)
});
/**
* | output |
* | --- |
* | "Action" |
*
* @param {Timeblocker_Kind_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_kind_action = /** @type {((inputs?: Timeblocker_Kind_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Kind_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_kind_action(inputs)
	return __ja.timeblocker_kind_action(inputs)
});
/**
* | output |
* | --- |
* | "Case" |
*
* @param {Timeblocker_Kind_CaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_kind_case = /** @type {((inputs?: Timeblocker_Kind_CaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Kind_CaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_kind_case(inputs)
	return __ja.timeblocker_kind_case(inputs)
});
/**
* | output |
* | --- |
* | "Me" |
*
* @param {Timeblocker_Lane_MeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_lane_me = /** @type {((inputs?: Timeblocker_Lane_MeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Lane_MeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_lane_me(inputs)
	return __ja.timeblocker_lane_me(inputs)
});
/**
* | output |
* | --- |
* | "Lane name" |
*
* @param {Timeblocker_Lane_NameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_lane_name = /** @type {((inputs?: Timeblocker_Lane_NameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Lane_NameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_lane_name(inputs)
	return __ja.timeblocker_lane_name(inputs)
});
/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Timeblocker_Lane_NoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_lane_none = /** @type {((inputs?: Timeblocker_Lane_NoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Lane_NoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_lane_none(inputs)
	return __ja.timeblocker_lane_none(inputs)
});
/**
* | output |
* | --- |
* | "Lane for {name}" |
*
* @param {Timeblocker_Lane_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_lane_of = /** @type {((inputs: Timeblocker_Lane_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Lane_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_lane_of(inputs)
	return __ja.timeblocker_lane_of(inputs)
});
/**
* | output |
* | --- |
* | "Lanes" |
*
* @param {Timeblocker_LanesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_lanes = /** @type {((inputs?: Timeblocker_LanesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_LanesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_lanes(inputs)
	return __ja.timeblocker_lanes(inputs)
});
/**
* | output |
* | --- |
* | "\"Me\" comes first, with the time blocks. Lanes you add sit beside it" |
*
* @param {Timeblocker_Lanes_NoteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_lanes_note = /** @type {((inputs?: Timeblocker_Lanes_NoteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Lanes_NoteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_lanes_note(inputs)
	return __ja.timeblocker_lanes_note(inputs)
});
/**
* | output |
* | --- |
* | "No matches" |
*
* @param {Timeblocker_Link_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_link_empty = /** @type {((inputs?: Timeblocker_Link_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Link_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_link_empty(inputs)
	return __ja.timeblocker_link_empty(inputs)
});
/**
* | output |
* | --- |
* | "Find a Case or Action to add" |
*
* @param {Timeblocker_Link_SearchInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_link_search = /** @type {((inputs?: Timeblocker_Link_SearchInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Link_SearchInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_link_search(inputs)
	return __ja.timeblocker_link_search(inputs)
});
/**
* | output |
* | --- |
* | "Cases and Actions" |
*
* @param {Timeblocker_ListsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_lists = /** @type {((inputs?: Timeblocker_ListsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_ListsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_lists(inputs)
	return __ja.timeblocker_lists(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't load" |
*
* @param {Timeblocker_Load_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_load_failed = /** @type {((inputs?: Timeblocker_Load_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Load_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_load_failed(inputs)
	return __ja.timeblocker_load_failed(inputs)
});
/**
* | output |
* | --- |
* | "Mark as done" |
*
* @param {Timeblocker_Mark_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_mark_done = /** @type {((inputs?: Timeblocker_Mark_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Mark_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_mark_done(inputs)
	return __ja.timeblocker_mark_done(inputs)
});
/**
* | output |
* | --- |
* | "Mark \"{title}\" as done" |
*
* @param {Timeblocker_Mark_Done_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_mark_done_of = /** @type {((inputs: Timeblocker_Mark_Done_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Mark_Done_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_mark_done_of(inputs)
	return __ja.timeblocker_mark_done_of(inputs)
});
/**
* | output |
* | --- |
* | "{count} more" |
*
* @param {Timeblocker_MoreInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_more = /** @type {((inputs: Timeblocker_MoreInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_MoreInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_more(inputs)
	return __ja.timeblocker_more(inputs)
});
/**
* | output |
* | --- |
* | "New event" |
*
* @param {Timeblocker_New_EventInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_new_event = /** @type {((inputs?: Timeblocker_New_EventInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_New_EventInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_new_event(inputs)
	return __ja.timeblocker_new_event(inputs)
});
/**
* | output |
* | --- |
* | "Next day" |
*
* @param {Timeblocker_Next_DayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_next_day = /** @type {((inputs?: Timeblocker_Next_DayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Next_DayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_next_day(inputs)
	return __ja.timeblocker_next_day(inputs)
});
/**
* | output |
* | --- |
* | "Next week" |
*
* @param {Timeblocker_Next_WeekInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_next_week = /** @type {((inputs?: Timeblocker_Next_WeekInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Next_WeekInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_next_week(inputs)
	return __ja.timeblocker_next_week(inputs)
});
/**
* | output |
* | --- |
* | "Not connected yet. Google will ask for your permission" |
*
* @param {Timeblocker_No_AccountsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_no_accounts = /** @type {((inputs?: Timeblocker_No_AccountsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_No_AccountsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_no_accounts(inputs)
	return __ja.timeblocker_no_accounts(inputs)
});
/**
* | output |
* | --- |
* | "No Actions" |
*
* @param {Timeblocker_No_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_no_actions = /** @type {((inputs?: Timeblocker_No_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_No_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_no_actions(inputs)
	return __ja.timeblocker_no_actions(inputs)
});
/**
* | output |
* | --- |
* | "No calendar you can write to. Show one of your calendars in a lane in Calendar settings" |
*
* @param {Timeblocker_No_WritableInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_no_writable = /** @type {((inputs?: Timeblocker_No_WritableInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_No_WritableInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_no_writable(inputs)
	return __ja.timeblocker_no_writable(inputs)
});
/**
* | output |
* | --- |
* | "Open Case" |
*
* @param {Timeblocker_Open_CaseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_open_case = /** @type {((inputs?: Timeblocker_Open_CaseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Open_CaseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_open_case(inputs)
	return __ja.timeblocker_open_case(inputs)
});
/**
* | output |
* | --- |
* | "Open in Google Calendar" |
*
* @param {Timeblocker_Open_GoogleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_open_google = /** @type {((inputs?: Timeblocker_Open_GoogleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Open_GoogleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_open_google(inputs)
	return __ja.timeblocker_open_google(inputs)
});
/**
* | output |
* | --- |
* | "Choose an Action" |
*
* @param {Timeblocker_Pick_ActionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_pick_action = /** @type {((inputs?: Timeblocker_Pick_ActionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Pick_ActionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_pick_action(inputs)
	return __ja.timeblocker_pick_action(inputs)
});
/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Timeblocker_Pick_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_pick_date = /** @type {((inputs?: Timeblocker_Pick_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Pick_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_pick_date(inputs)
	return __ja.timeblocker_pick_date(inputs)
});
/**
* | output |
* | --- |
* | "Do on" |
*
* @param {Timeblocker_PlanInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_plan = /** @type {((inputs?: Timeblocker_PlanInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_PlanInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_plan(inputs)
	return __ja.timeblocker_plan(inputs)
});
/**
* | output |
* | --- |
* | "Previous day" |
*
* @param {Timeblocker_Prev_DayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_prev_day = /** @type {((inputs?: Timeblocker_Prev_DayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Prev_DayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_prev_day(inputs)
	return __ja.timeblocker_prev_day(inputs)
});
/**
* | output |
* | --- |
* | "Previous week" |
*
* @param {Timeblocker_Prev_WeekInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_prev_week = /** @type {((inputs?: Timeblocker_Prev_WeekInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Prev_WeekInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_prev_week(inputs)
	return __ja.timeblocker_prev_week(inputs)
});
/**
* | output |
* | --- |
* | "View only" |
*
* @param {Timeblocker_Read_OnlyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_read_only = /** @type {((inputs?: Timeblocker_Read_OnlyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Read_OnlyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_read_only(inputs)
	return __ja.timeblocker_read_only(inputs)
});
/**
* | output |
* | --- |
* | "For a recurring event, only this occurrence changes" |
*
* @param {Timeblocker_Recurring_OneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_recurring_one = /** @type {((inputs?: Timeblocker_Recurring_OneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Recurring_OneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_recurring_one(inputs)
	return __ja.timeblocker_recurring_one(inputs)
});
/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Timeblocker_RedoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_redo = /** @type {((inputs?: Timeblocker_RedoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_RedoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_redo(inputs)
	return __ja.timeblocker_redo(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't redo" |
*
* @param {Timeblocker_Redo_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_redo_failed = /** @type {((inputs?: Timeblocker_Redo_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Redo_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_redo_failed(inputs)
	return __ja.timeblocker_redo_failed(inputs)
});
/**
* | output |
* | --- |
* | "Mark as not done" |
*
* @param {Timeblocker_ReopenInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_reopen = /** @type {((inputs?: Timeblocker_ReopenInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_ReopenInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_reopen(inputs)
	return __ja.timeblocker_reopen(inputs)
});
/**
* | output |
* | --- |
* | "Use Google's color" |
*
* @param {Timeblocker_Reset_ColorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_reset_color = /** @type {((inputs?: Timeblocker_Reset_ColorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Reset_ColorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_reset_color(inputs)
	return __ja.timeblocker_reset_color(inputs)
});
/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Timeblocker_Resume_BlockInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_resume_block = /** @type {((inputs?: Timeblocker_Resume_BlockInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Resume_BlockInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_resume_block(inputs)
	return __ja.timeblocker_resume_block(inputs)
});
/**
* | output |
* | --- |
* | "Refresh list" |
*
* @param {Timeblocker_ResyncInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_resync = /** @type {((inputs?: Timeblocker_ResyncInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_ResyncInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_resync(inputs)
	return __ja.timeblocker_resync(inputs)
});
/**
* | output |
* | --- |
* | "Review" |
*
* @param {Timeblocker_ReviewInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review = /** @type {((inputs?: Timeblocker_ReviewInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_ReviewInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review(inputs)
	return __ja.timeblocker_review(inputs)
});
/**
* | output |
* | --- |
* | "Actual" |
*
* @param {Timeblocker_Review_ActualInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_actual = /** @type {((inputs?: Timeblocker_Review_ActualInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_ActualInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_actual(inputs)
	return __ja.timeblocker_review_actual(inputs)
});
/**
* | output |
* | --- |
* | "Changed after start" |
*
* @param {Timeblocker_Review_ChangesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_changes = /** @type {((inputs?: Timeblocker_Review_ChangesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_ChangesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_changes(inputs)
	return __ja.timeblocker_review_changes(inputs)
});
/**
* | output |
* | --- |
* | "Put off to another day {count}" |
*
* @param {Timeblocker_Review_Changes_DeferredInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_changes_deferred = /** @type {((inputs: Timeblocker_Review_Changes_DeferredInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Changes_DeferredInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_changes_deferred(inputs)
	return __ja.timeblocker_review_changes_deferred(inputs)
});
/**
* | output |
* | --- |
* | "Moved {count}" |
*
* @param {Timeblocker_Review_Changes_MovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_changes_moved = /** @type {((inputs: Timeblocker_Review_Changes_MovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Changes_MovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_changes_moved(inputs)
	return __ja.timeblocker_review_changes_moved(inputs)
});
/**
* | output |
* | --- |
* | "Shortened {count}" |
*
* @param {Timeblocker_Review_Changes_ShortenedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_changes_shortened = /** @type {((inputs: Timeblocker_Review_Changes_ShortenedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Changes_ShortenedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_changes_shortened(inputs)
	return __ja.timeblocker_review_changes_shortened(inputs)
});
/**
* | output |
* | --- |
* | "Put off from {day} {time}" |
*
* @param {Timeblocker_Review_Deferred_FromInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_deferred_from = /** @type {((inputs: Timeblocker_Review_Deferred_FromInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Deferred_FromInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_deferred_from(inputs)
	return __ja.timeblocker_review_deferred_from(inputs)
});
/**
* | output |
* | --- |
* | "→ {day} {time}" |
*
* @param {Timeblocker_Review_Deferred_ToInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_deferred_to = /** @type {((inputs: Timeblocker_Review_Deferred_ToInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Deferred_ToInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_deferred_to(inputs)
	return __ja.timeblocker_review_deferred_to(inputs)
});
/**
* | output |
* | --- |
* | "Done" |
*
* @param {Timeblocker_Review_DoneInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_done = /** @type {((inputs?: Timeblocker_Review_DoneInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_DoneInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_done(inputs)
	return __ja.timeblocker_review_done(inputs)
});
/**
* | output |
* | --- |
* | "Linked Cases and Actions" |
*
* @param {Timeblocker_Review_Done_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_done_of = /** @type {((inputs?: Timeblocker_Review_Done_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Done_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_done_of(inputs)
	return __ja.timeblocker_review_done_of(inputs)
});
/**
* | output |
* | --- |
* | "No Blocks this week" |
*
* @param {Timeblocker_Review_EmptyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_empty = /** @type {((inputs?: Timeblocker_Review_EmptyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_EmptyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_empty(inputs)
	return __ja.timeblocker_review_empty(inputs)
});
/**
* | output |
* | --- |
* | "Link" |
*
* @param {Timeblocker_Review_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_link = /** @type {((inputs?: Timeblocker_Review_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_link(inputs)
	return __ja.timeblocker_review_link(inputs)
});
/**
* | output |
* | --- |
* | "Linked" |
*
* @param {Timeblocker_Review_LinkedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_linked = /** @type {((inputs?: Timeblocker_Review_LinkedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_LinkedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_linked(inputs)
	return __ja.timeblocker_review_linked(inputs)
});
/**
* | output |
* | --- |
* | "What moved {count}" |
*
* @param {Timeblocker_Review_MovedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_moved = /** @type {((inputs: Timeblocker_Review_MovedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_MovedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_moved(inputs)
	return __ja.timeblocker_review_moved(inputs)
});
/**
* | output |
* | --- |
* | "→ {time}" |
*
* @param {Timeblocker_Review_Moved_ToInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_moved_to = /** @type {((inputs: Timeblocker_Review_Moved_ToInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Moved_ToInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_moved_to(inputs)
	return __ja.timeblocker_review_moved_to(inputs)
});
/**
* | output |
* | --- |
* | "Review of {range}" |
*
* @param {Timeblocker_Review_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_of = /** @type {((inputs: Timeblocker_Review_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_of(inputs)
	return __ja.timeblocker_review_of(inputs)
});
/**
* | output |
* | --- |
* | "Planned" |
*
* @param {Timeblocker_Review_PlannedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_planned = /** @type {((inputs?: Timeblocker_Review_PlannedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_PlannedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_planned(inputs)
	return __ja.timeblocker_review_planned(inputs)
});
/**
* | output |
* | --- |
* | "Committed plans" |
*
* @param {Timeblocker_Review_Planned_CommittedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_planned_committed = /** @type {((inputs?: Timeblocker_Review_Planned_CommittedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Planned_CommittedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_planned_committed(inputs)
	return __ja.timeblocker_review_planned_committed(inputs)
});
/**
* | output |
* | --- |
* | "Including what is still to come" |
*
* @param {Timeblocker_Review_Planned_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_planned_of = /** @type {((inputs?: Timeblocker_Review_Planned_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Planned_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_planned_of(inputs)
	return __ja.timeblocker_review_planned_of(inputs)
});
/**
* | output |
* | --- |
* | "Kept" |
*
* @param {Timeblocker_Review_RateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_rate = /** @type {((inputs?: Timeblocker_Review_RateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_RateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_rate(inputs)
	return __ja.timeblocker_review_rate(inputs)
});
/**
* | output |
* | --- |
* | "{did} of {all} past Blocks" |
*
* @param {Timeblocker_Review_Rate_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_rate_of = /** @type {((inputs: Timeblocker_Review_Rate_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Rate_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_rate_of(inputs)
	return __ja.timeblocker_review_rate_of(inputs)
});
/**
* | output |
* | --- |
* | "Actual ÷ planned" |
*
* @param {Timeblocker_Review_RatioInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_ratio = /** @type {((inputs?: Timeblocker_Review_RatioInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_RatioInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_ratio(inputs)
	return __ja.timeblocker_review_ratio(inputs)
});
/**
* | output |
* | --- |
* | "Of {planned} past" |
*
* @param {Timeblocker_Review_Ratio_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_ratio_of = /** @type {((inputs: Timeblocker_Review_Ratio_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Ratio_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_ratio_of(inputs)
	return __ja.timeblocker_review_ratio_of(inputs)
});
/**
* | output |
* | --- |
* | "Not linked" |
*
* @param {Timeblocker_Review_Unlinked_BlockInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_unlinked_block = /** @type {((inputs?: Timeblocker_Review_Unlinked_BlockInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Unlinked_BlockInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_unlinked_block(inputs)
	return __ja.timeblocker_review_unlinked_block(inputs)
});
/**
* | output |
* | --- |
* | "Untitled chat" |
*
* @param {Timeblocker_Review_Untitled_ChatInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_review_untitled_chat = /** @type {((inputs?: Timeblocker_Review_Untitled_ChatInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Review_Untitled_ChatInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_review_untitled_chat(inputs)
	return __ja.timeblocker_review_untitled_chat(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't save" |
*
* @param {Timeblocker_Save_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_save_failed = /** @type {((inputs?: Timeblocker_Save_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Save_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_save_failed(inputs)
	return __ja.timeblocker_save_failed(inputs)
});
/**
* | output |
* | --- |
* | "Connect Google accounts and choose which calendars show in which lane of TimeBlocker. Separate from the account you sign in with." |
*
* @param {Timeblocker_Settings_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_settings_description = /** @type {((inputs?: Timeblocker_Settings_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Settings_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_settings_description(inputs)
	return __ja.timeblocker_settings_description(inputs)
});
/**
* | output |
* | --- |
* | "Google Calendar" |
*
* @param {Timeblocker_Settings_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_settings_title = /** @type {((inputs?: Timeblocker_Settings_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Settings_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_settings_title(inputs)
	return __ja.timeblocker_settings_title(inputs)
});
/**
* | output |
* | --- |
* | "Show Actions" |
*
* @param {Timeblocker_Show_ActionsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_show_actions = /** @type {((inputs?: Timeblocker_Show_ActionsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Show_ActionsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_show_actions(inputs)
	return __ja.timeblocker_show_actions(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Timeblocker_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_start = /** @type {((inputs?: Timeblocker_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_start(inputs)
	return __ja.timeblocker_start(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Timeblocker_Start_BlockInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_start_block = /** @type {((inputs?: Timeblocker_Start_BlockInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Start_BlockInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_start_block(inputs)
	return __ja.timeblocker_start_block(inputs)
});
/**
* | output |
* | --- |
* | "Start date" |
*
* @param {Timeblocker_Start_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_start_date = /** @type {((inputs?: Timeblocker_Start_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Start_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_start_date(inputs)
	return __ja.timeblocker_start_date(inputs)
});
/**
* | output |
* | --- |
* | "Items to show" |
*
* @param {Timeblocker_TabsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_tabs = /** @type {((inputs?: Timeblocker_TabsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_TabsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_tabs(inputs)
	return __ja.timeblocker_tabs(inputs)
});
/**
* | output |
* | --- |
* | "This week" |
*
* @param {Timeblocker_This_WeekInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_this_week = /** @type {((inputs?: Timeblocker_This_WeekInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_This_WeekInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_this_week(inputs)
	return __ja.timeblocker_this_week(inputs)
});
/**
* | output |
* | --- |
* | "Time" |
*
* @param {Timeblocker_TimeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_time = /** @type {((inputs?: Timeblocker_TimeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_TimeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_time(inputs)
	return __ja.timeblocker_time(inputs)
});
/**
* | output |
* | --- |
* | "Timeline for {date}" |
*
* @param {Timeblocker_TimelineInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_timeline = /** @type {((inputs: Timeblocker_TimelineInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_TimelineInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_timeline(inputs)
	return __ja.timeblocker_timeline(inputs)
});
/**
* | output |
* | --- |
* | "TimeBlocker" |
*
* @param {Timeblocker_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_title = /** @type {((inputs?: Timeblocker_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_title(inputs)
	return __ja.timeblocker_title(inputs)
});
/**
* | output |
* | --- |
* | "Title" |
*
* @param {Timeblocker_Title_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_title_label = /** @type {((inputs?: Timeblocker_Title_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Title_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_title_label(inputs)
	return __ja.timeblocker_title_label(inputs)
});
/**
* | output |
* | --- |
* | "To do" |
*
* @param {Timeblocker_TodoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_todo = /** @type {((inputs?: Timeblocker_TodoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_TodoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_todo(inputs)
	return __ja.timeblocker_todo(inputs)
});
/**
* | output |
* | --- |
* | "Drop here to make it undated and take it off its Blocks" |
*
* @param {Timeblocker_Undated_DropInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_undated_drop = /** @type {((inputs?: Timeblocker_Undated_DropInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Undated_DropInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_undated_drop(inputs)
	return __ja.timeblocker_undated_drop(inputs)
});
/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Timeblocker_UndoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_undo = /** @type {((inputs?: Timeblocker_UndoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_UndoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_undo(inputs)
	return __ja.timeblocker_undo(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't undo" |
*
* @param {Timeblocker_Undo_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_undo_failed = /** @type {((inputs?: Timeblocker_Undo_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Undo_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_undo_failed(inputs)
	return __ja.timeblocker_undo_failed(inputs)
});
/**
* | output |
* | --- |
* | "Unlink" |
*
* @param {Timeblocker_UnlinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_unlink = /** @type {((inputs?: Timeblocker_UnlinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_UnlinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_unlink(inputs)
	return __ja.timeblocker_unlink(inputs)
});
/**
* | output |
* | --- |
* | "(No title)" |
*
* @param {Timeblocker_UntitledInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_untitled = /** @type {((inputs?: Timeblocker_UntitledInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_UntitledInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_untitled(inputs)
	return __ja.timeblocker_untitled(inputs)
});
/**
* | output |
* | --- |
* | "{from} – {to}" |
*
* @param {Timeblocker_Week_RangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_week_range = /** @type {((inputs: Timeblocker_Week_RangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Week_RangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_week_range(inputs)
	return __ja.timeblocker_week_range(inputs)
});
/**
* | output |
* | --- |
* | "Work" |
*
* @param {Timeblocker_Work_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_label = /** @type {((inputs?: Timeblocker_Work_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_label(inputs)
	return __ja.timeblocker_work_label(inputs)
});
/**
* | output |
* | --- |
* | "Work log" |
*
* @param {Timeblocker_Work_LogInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_log = /** @type {((inputs?: Timeblocker_Work_LogInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_LogInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_log(inputs)
	return __ja.timeblocker_work_log(inputs)
});
/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Timeblocker_Work_Log_DeleteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_log_delete = /** @type {((inputs?: Timeblocker_Work_Log_DeleteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_Log_DeleteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_log_delete(inputs)
	return __ja.timeblocker_work_log_delete(inputs)
});
/**
* | output |
* | --- |
* | "Work log {start}–{end}" |
*
* @param {Timeblocker_Work_Log_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_log_label = /** @type {((inputs: Timeblocker_Work_Log_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_Log_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_log_label(inputs)
	return __ja.timeblocker_work_log_label(inputs)
});
/**
* | output |
* | --- |
* | "now" |
*
* @param {Timeblocker_Work_Log_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_log_now = /** @type {((inputs?: Timeblocker_Work_Log_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_Log_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_log_now(inputs)
	return __ja.timeblocker_work_log_now(inputs)
});
/**
* | output |
* | --- |
* | "Working {elapsed}" |
*
* @param {Timeblocker_Work_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_running = /** @type {((inputs: Timeblocker_Work_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_running(inputs)
	return __ja.timeblocker_work_running(inputs)
});
/**
* | output |
* | --- |
* | "Working on {title} ({elapsed})" |
*
* @param {Timeblocker_Work_Running_OfInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_running_of = /** @type {((inputs: Timeblocker_Work_Running_OfInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_Running_OfInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_running_of(inputs)
	return __ja.timeblocker_work_running_of(inputs)
});
/**
* | output |
* | --- |
* | "Start working" |
*
* @param {Timeblocker_Work_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_start = /** @type {((inputs?: Timeblocker_Work_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_start(inputs)
	return __ja.timeblocker_work_start(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Timeblocker_Work_Start_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_start_short = /** @type {((inputs?: Timeblocker_Work_Start_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_Start_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_start_short(inputs)
	return __ja.timeblocker_work_start_short(inputs)
});
/**
* | output |
* | --- |
* | "Stop working" |
*
* @param {Timeblocker_Work_StopInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_stop = /** @type {((inputs?: Timeblocker_Work_StopInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_StopInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_stop(inputs)
	return __ja.timeblocker_work_stop(inputs)
});
/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Timeblocker_Work_Stop_ShortInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_stop_short = /** @type {((inputs?: Timeblocker_Work_Stop_ShortInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_Stop_ShortInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_stop_short(inputs)
	return __ja.timeblocker_work_stop_short(inputs)
});
/**
* | output |
* | --- |
* | "{total} this day" |
*
* @param {Timeblocker_Work_TotalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const timeblocker_work_total = /** @type {((inputs: Timeblocker_Work_TotalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeblocker_Work_TotalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.timeblocker_work_total(inputs)
	return __ja.timeblocker_work_total(inputs)
});
/**
* | output |
* | --- |
* | "Answer" |
*
* @param {Uifence_AnswerInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_answer = /** @type {((inputs?: Uifence_AnswerInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_AnswerInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_answer(inputs)
	return __ja.uifence_answer(inputs)
});
/**
* | output |
* | --- |
* | "The UI in this item wants to send it as your answer. Once sent, the item closes and the agent reads it as your answer." |
*
* @param {Uifence_Answer_DetailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_answer_detail = /** @type {((inputs?: Uifence_Answer_DetailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Answer_DetailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_answer_detail(inputs)
	return __ja.uifence_answer_detail(inputs)
});
/**
* | output |
* | --- |
* | "Send this as your answer?" |
*
* @param {Uifence_Answer_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_answer_title = /** @type {((inputs?: Uifence_Answer_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Answer_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_answer_title(inputs)
	return __ja.uifence_answer_title(inputs)
});
/**
* | output |
* | --- |
* | "Building the UI" |
*
* @param {Uifence_BuildingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_building = /** @type {((inputs?: Uifence_BuildingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_BuildingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_building(inputs)
	return __ja.uifence_building(inputs)
});
/**
* | output |
* | --- |
* | "Next month" |
*
* @param {Uifence_Calendar_Next_MonthInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_calendar_next_month = /** @type {((inputs?: Uifence_Calendar_Next_MonthInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Calendar_Next_MonthInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_calendar_next_month(inputs)
	return __ja.uifence_calendar_next_month(inputs)
});
/**
* | output |
* | --- |
* | "Pick a date" |
*
* @param {Uifence_Calendar_PickInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_calendar_pick = /** @type {((inputs?: Uifence_Calendar_PickInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Calendar_PickInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_calendar_pick(inputs)
	return __ja.uifence_calendar_pick(inputs)
});
/**
* | output |
* | --- |
* | "Previous month" |
*
* @param {Uifence_Calendar_Prev_MonthInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_calendar_prev_month = /** @type {((inputs?: Uifence_Calendar_Prev_MonthInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Calendar_Prev_MonthInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_calendar_prev_month(inputs)
	return __ja.uifence_calendar_prev_month(inputs)
});
/**
* | output |
* | --- |
* | "Set to today" |
*
* @param {Uifence_Calendar_TodayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_calendar_today = /** @type {((inputs?: Uifence_Calendar_TodayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Calendar_TodayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_calendar_today(inputs)
	return __ja.uifence_calendar_today(inputs)
});
/**
* | output |
* | --- |
* | "{count} more" |
*
* @param {Uifence_Chart_OthersInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_chart_others = /** @type {((inputs: Uifence_Chart_OthersInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Chart_OthersInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_chart_others(inputs)
	return __ja.uifence_chart_others(inputs)
});
/**
* | output |
* | --- |
* | "Choose" |
*
* @param {Uifence_ChooseInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_choose = /** @type {((inputs?: Uifence_ChooseInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_ChooseInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_choose(inputs)
	return __ja.uifence_choose(inputs)
});
/**
* | output |
* | --- |
* | "Copy source" |
*
* @param {Uifence_Copy_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_copy_source = /** @type {((inputs?: Uifence_Copy_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Copy_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_copy_source(inputs)
	return __ja.uifence_copy_source(inputs)
});
/**
* | output |
* | --- |
* | "← {count} more" |
*
* @param {Uifence_Count_LeftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_count_left = /** @type {((inputs: Uifence_Count_LeftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Count_LeftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_count_left(inputs)
	return __ja.uifence_count_left(inputs)
});
/**
* | output |
* | --- |
* | "{count} more →" |
*
* @param {Uifence_Count_RightInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_count_right = /** @type {((inputs: Uifence_Count_RightInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Count_RightInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_count_right(inputs)
	return __ja.uifence_count_right(inputs)
});
/**
* | output |
* | --- |
* | "All rows" |
*
* @param {Uifence_Data_All_RowsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_data_all_rows = /** @type {((inputs?: Uifence_Data_All_RowsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Data_All_RowsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_data_all_rows(inputs)
	return __ja.uifence_data_all_rows(inputs)
});
/**
* | output |
* | --- |
* | "Dataset" |
*
* @param {Uifence_Data_ButtonInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_data_button = /** @type {((inputs?: Uifence_Data_ButtonInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Data_ButtonInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_data_button(inputs)
	return __ja.uifence_data_button(inputs)
});
/**
* | output |
* | --- |
* | "Can't open this Dataset" |
*
* @param {Uifence_Data_Not_FoundInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_data_not_found = /** @type {((inputs?: Uifence_Data_Not_FoundInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Data_Not_FoundInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_data_not_found(inputs)
	return __ja.uifence_data_not_found(inputs)
});
/**
* | output |
* | --- |
* | "It was deleted, or you don't have access to it." |
*
* @param {Uifence_Data_Not_Found_DetailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_data_not_found_detail = /** @type {((inputs?: Uifence_Data_Not_Found_DetailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Data_Not_Found_DetailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_data_not_found_detail(inputs)
	return __ja.uifence_data_not_found_detail(inputs)
});
/**
* | output |
* | --- |
* | "Query" |
*
* @param {Uifence_Data_QueryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_data_query = /** @type {((inputs?: Uifence_Data_QueryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Data_QueryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_data_query(inputs)
	return __ja.uifence_data_query(inputs)
});
/**
* | output |
* | --- |
* | "Date" |
*
* @param {Uifence_DateInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_date = /** @type {((inputs?: Uifence_DateInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_DateInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_date(inputs)
	return __ja.uifence_date(inputs)
});
/**
* | output |
* | --- |
* | "End" |
*
* @param {Uifence_EndInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_end = /** @type {((inputs?: Uifence_EndInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_EndInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_end(inputs)
	return __ja.uifence_end(inputs)
});
/**
* | output |
* | --- |
* | "This UI couldn't run" |
*
* @param {Uifence_FailedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_failed = /** @type {((inputs?: Uifence_FailedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_FailedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_failed(inputs)
	return __ja.uifence_failed(inputs)
});
/**
* | output |
* | --- |
* | "From first" |
*
* @param {Uifence_Funnel_From_FirstInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_funnel_from_first = /** @type {((inputs?: Uifence_Funnel_From_FirstInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Funnel_From_FirstInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_funnel_from_first(inputs)
	return __ja.uifence_funnel_from_first(inputs)
});
/**
* | output |
* | --- |
* | "From previous" |
*
* @param {Uifence_Funnel_From_PreviousInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_funnel_from_previous = /** @type {((inputs?: Uifence_Funnel_From_PreviousInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Funnel_From_PreviousInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_funnel_from_previous(inputs)
	return __ja.uifence_funnel_from_previous(inputs)
});
/**
* | output |
* | --- |
* | "Heatmap" |
*
* @param {Uifence_HeatmapInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_heatmap = /** @type {((inputs?: Uifence_HeatmapInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_HeatmapInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_heatmap(inputs)
	return __ja.uifence_heatmap(inputs)
});
/**
* | output |
* | --- |
* | "Hide source" |
*
* @param {Uifence_Hide_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_hide_source = /** @type {((inputs?: Uifence_Hide_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Hide_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_hide_source(inputs)
	return __ja.uifence_hide_source(inputs)
});
/**
* | output |
* | --- |
* | "Interactive UI" |
*
* @param {Uifence_InsertInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_insert = /** @type {((inputs?: Uifence_InsertInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_InsertInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_insert(inputs)
	return __ja.uifence_insert(inputs)
});
/**
* | output |
* | --- |
* | "Interactive UI" |
*
* @param {Uifence_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_label = /** @type {((inputs?: Uifence_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_label(inputs)
	return __ja.uifence_label(inputs)
});
/**
* | output |
* | --- |
* | "← More" |
*
* @param {Uifence_More_LeftInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_more_left = /** @type {((inputs?: Uifence_More_LeftInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_More_LeftInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_more_left(inputs)
	return __ja.uifence_more_left(inputs)
});
/**
* | output |
* | --- |
* | "More →" |
*
* @param {Uifence_More_RightInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_more_right = /** @type {((inputs?: Uifence_More_RightInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_More_RightInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_more_right(inputs)
	return __ja.uifence_more_right(inputs)
});
/**
* | output |
* | --- |
* | "Next image" |
*
* @param {Uifence_Next_ImageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_next_image = /** @type {((inputs?: Uifence_Next_ImageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Next_ImageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_next_image(inputs)
	return __ja.uifence_next_image(inputs)
});
/**
* | output |
* | --- |
* | "No" |
*
* @param {Uifence_NoInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_no = /** @type {((inputs?: Uifence_NoInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_NoInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_no(inputs)
	return __ja.uifence_no(inputs)
});
/**
* | output |
* | --- |
* | "No data" |
*
* @param {Uifence_No_DataInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_no_data = /** @type {((inputs?: Uifence_No_DataInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_No_DataInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_no_data(inputs)
	return __ja.uifence_no_data(inputs)
});
/**
* | output |
* | --- |
* | "No events" |
*
* @param {Uifence_No_EventsInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_no_events = /** @type {((inputs?: Uifence_No_EventsInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_No_EventsInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_no_events(inputs)
	return __ja.uifence_no_events(inputs)
});
/**
* | output |
* | --- |
* | "Open" |
*
* @param {Uifence_Open_LinkInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_open_link = /** @type {((inputs?: Uifence_Open_LinkInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Open_LinkInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_open_link(inputs)
	return __ja.uifence_open_link(inputs)
});
/**
* | output |
* | --- |
* | "This link is inside the UI. Check that it goes where you expect before opening it. It opens in a new tab." |
*
* @param {Uifence_Open_Link_DetailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_open_link_detail = /** @type {((inputs?: Uifence_Open_Link_DetailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Open_Link_DetailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_open_link_detail(inputs)
	return __ja.uifence_open_link_detail(inputs)
});
/**
* | output |
* | --- |
* | "Open an external site?" |
*
* @param {Uifence_Open_Link_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_open_link_title = /** @type {((inputs?: Uifence_Open_Link_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Open_Link_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_open_link_title(inputs)
	return __ja.uifence_open_link_title(inputs)
});
/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Uifence_Picker_ClearInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_picker_clear = /** @type {((inputs?: Uifence_Picker_ClearInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Picker_ClearInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_picker_clear(inputs)
	return __ja.uifence_picker_clear(inputs)
});
/**
* | output |
* | --- |
* | "Previous image" |
*
* @param {Uifence_Prev_ImageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_prev_image = /** @type {((inputs?: Uifence_Prev_ImageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Prev_ImageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_prev_image(inputs)
	return __ja.uifence_prev_image(inputs)
});
/**
* | output |
* | --- |
* | "Correct" |
*
* @param {Uifence_Quiz_CorrectInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_quiz_correct = /** @type {((inputs?: Uifence_Quiz_CorrectInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Quiz_CorrectInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_quiz_correct(inputs)
	return __ja.uifence_quiz_correct(inputs)
});
/**
* | output |
* | --- |
* | "Choose an answer to see the correct one" |
*
* @param {Uifence_Quiz_HintInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_quiz_hint = /** @type {((inputs?: Uifence_Quiz_HintInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Quiz_HintInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_quiz_hint(inputs)
	return __ja.uifence_quiz_hint(inputs)
});
/**
* | output |
* | --- |
* | "Choose an answer to see the correct one and the explanation" |
*
* @param {Uifence_Quiz_Hint_ExplainedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_quiz_hint_explained = /** @type {((inputs?: Uifence_Quiz_Hint_ExplainedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Quiz_Hint_ExplainedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_quiz_hint_explained(inputs)
	return __ja.uifence_quiz_hint_explained(inputs)
});
/**
* | output |
* | --- |
* | "Your answer (incorrect)" |
*
* @param {Uifence_Quiz_Picked_WrongInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_quiz_picked_wrong = /** @type {((inputs?: Uifence_Quiz_Picked_WrongInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Quiz_Picked_WrongInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_quiz_picked_wrong(inputs)
	return __ja.uifence_quiz_picked_wrong(inputs)
});
/**
* | output |
* | --- |
* | "Incorrect" |
*
* @param {Uifence_Quiz_WrongInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_quiz_wrong = /** @type {((inputs?: Uifence_Quiz_WrongInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Quiz_WrongInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_quiz_wrong(inputs)
	return __ja.uifence_quiz_wrong(inputs)
});
/**
* | output |
* | --- |
* | "+1" |
*
* @param {Uifence_Range_Next_DayInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_range_next_day = /** @type {((inputs?: Uifence_Range_Next_DayInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Range_Next_DayInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_range_next_day(inputs)
	return __ja.uifence_range_next_day(inputs)
});
/**
* | output |
* | --- |
* | "End is before start" |
*
* @param {Uifence_Range_ReversedInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_range_reversed = /** @type {((inputs?: Uifence_Range_ReversedInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Range_ReversedInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_range_reversed(inputs)
	return __ja.uifence_range_reversed(inputs)
});
/**
* | output |
* | --- |
* | "Start and end are the same" |
*
* @param {Uifence_Range_SameInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_range_same = /** @type {((inputs?: Uifence_Range_SameInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Range_SameInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_range_same(inputs)
	return __ja.uifence_range_same(inputs)
});
/**
* | output |
* | --- |
* | "–" |
*
* @param {Uifence_Range_SepInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_range_sep = /** @type {((inputs?: Uifence_Range_SepInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Range_SepInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_range_sep(inputs)
	return __ja.uifence_range_sep(inputs)
});
/**
* | output |
* | --- |
* | "Send" |
*
* @param {Uifence_SendInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_send = /** @type {((inputs?: Uifence_SendInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_SendInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_send(inputs)
	return __ja.uifence_send(inputs)
});
/**
* | output |
* | --- |
* | "The UI in the reply wants to send it. Once sent, the agent reads it and replies." |
*
* @param {Uifence_Send_DetailInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_send_detail = /** @type {((inputs?: Uifence_Send_DetailInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Send_DetailInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_send_detail(inputs)
	return __ja.uifence_send_detail(inputs)
});
/**
* | output |
* | --- |
* | "Send this message to the conversation as you?" |
*
* @param {Uifence_Send_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_send_title = /** @type {((inputs?: Uifence_Send_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Send_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_send_title(inputs)
	return __ja.uifence_send_title(inputs)
});
/**
* | output |
* | --- |
* | "Show source" |
*
* @param {Uifence_Show_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_show_source = /** @type {((inputs?: Uifence_Show_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Show_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_show_source(inputs)
	return __ja.uifence_show_source(inputs)
});
/**
* | output |
* | --- |
* | "Source" |
*
* @param {Uifence_SourceInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_source = /** @type {((inputs?: Uifence_SourceInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_SourceInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_source(inputs)
	return __ja.uifence_source(inputs)
});
/**
* | output |
* | --- |
* | "{first} to {last} (min {min}, max {max})" |
*
* @param {Uifence_Spark_RangeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_spark_range = /** @type {((inputs: Uifence_Spark_RangeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Spark_RangeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_spark_range(inputs)
	return __ja.uifence_spark_range(inputs)
});
/**
* | output |
* | --- |
* | "Couldn't apply this action" |
*
* @param {Uifence_StaleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_stale = /** @type {((inputs?: Uifence_StaleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_StaleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_stale(inputs)
	return __ja.uifence_stale(inputs)
});
/**
* | output |
* | --- |
* | "Start" |
*
* @param {Uifence_StartInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_start = /** @type {((inputs?: Uifence_StartInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_StartInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_start(inputs)
	return __ja.uifence_start(inputs)
});
/**
* | output |
* | --- |
* | "Time" |
*
* @param {Uifence_TimeInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_time = /** @type {((inputs?: Uifence_TimeInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_TimeInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_time(inputs)
	return __ja.uifence_time(inputs)
});
/**
* | output |
* | --- |
* | "Hour" |
*
* @param {Uifence_Time_HourInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_time_hour = /** @type {((inputs?: Uifence_Time_HourInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Time_HourInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_time_hour(inputs)
	return __ja.uifence_time_hour(inputs)
});
/**
* | output |
* | --- |
* | "Min" |
*
* @param {Uifence_Time_MinuteInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_time_minute = /** @type {((inputs?: Uifence_Time_MinuteInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Time_MinuteInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_time_minute(inputs)
	return __ja.uifence_time_minute(inputs)
});
/**
* | output |
* | --- |
* | "Set to now" |
*
* @param {Uifence_Time_NowInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_time_now = /** @type {((inputs?: Uifence_Time_NowInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Time_NowInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_time_now(inputs)
	return __ja.uifence_time_now(inputs)
});
/**
* | output |
* | --- |
* | "Pick a time" |
*
* @param {Uifence_Time_PickInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_time_pick = /** @type {((inputs?: Uifence_Time_PickInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Time_PickInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_time_pick(inputs)
	return __ja.uifence_time_pick(inputs)
});
/**
* | output |
* | --- |
* | "Total" |
*
* @param {Uifence_TotalInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_total = /** @type {((inputs?: Uifence_TotalInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_TotalInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_total(inputs)
	return __ja.uifence_total(inputs)
});
/**
* | output |
* | --- |
* | "Decrease" |
*
* @param {Uifence_Waterfall_DownInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_waterfall_down = /** @type {((inputs?: Uifence_Waterfall_DownInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Waterfall_DownInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_waterfall_down(inputs)
	return __ja.uifence_waterfall_down(inputs)
});
/**
* | output |
* | --- |
* | "Running total" |
*
* @param {Uifence_Waterfall_RunningInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_waterfall_running = /** @type {((inputs?: Uifence_Waterfall_RunningInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Waterfall_RunningInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_waterfall_running(inputs)
	return __ja.uifence_waterfall_running(inputs)
});
/**
* | output |
* | --- |
* | "Increase" |
*
* @param {Uifence_Waterfall_UpInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_waterfall_up = /** @type {((inputs?: Uifence_Waterfall_UpInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_Waterfall_UpInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_waterfall_up(inputs)
	return __ja.uifence_waterfall_up(inputs)
});
/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Uifence_YesInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const uifence_yes = /** @type {((inputs?: Uifence_YesInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uifence_YesInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.uifence_yes(inputs)
	return __ja.uifence_yes(inputs)
});